<template>
  <div>
    <!-- select 2 demo -->

    <div>
      <!-- Table Top -->
      <div>
        <b-card>
          <b-row align-h="center" v-if="dataLoading">
            <b-spinner
              class="m-5"
              style="width: 4rem; height: 4rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </b-row>

          <b-row class="mt-1" v-if="!dataLoading">
            <b-col xl="2" lg="2" md="2" sm="12" cols="12">
              <b-form-group
                label="Report type"
                invalid-feedback="Type is required"
                ref="type"
              >
                <v-select
                  v-model="myObj.type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="typeOptions"
                  :clearable="false"
                  ref="type"
                  label="text"
                  placeholder="Select type"
                  @input="setFormat()"
                  @search:blur="CheckType()"
                />
              </b-form-group>
            </b-col>

            <b-col xl="2" lg="2" md="2" sm="12" cols="12">
              <b-form-group
                label="Report format"
                invalid-feedback="format is required."
                ref="format"
              >
                <v-select
                  v-model="myObj.format"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="formatOptions"
                  :clearable="false"
                  ref="format"
                  placeholder="Select format"
                  @input="setDateOption()"
                  @search:blur="CheckFormat()"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="
                ['myskoolaba', 'myskoolspirit'].includes(reportDomain) &&
                (myObj.format == 'Fee projection' ||
                  myObj.format == 'Fees Concession Report' ||
                  myObj.format == 'Class Wise Concession Report' ||
                  myObj.format == 'Sibling Concession Report')
              "
              xl="3"
              lg="3"
              md="6"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Discount Reference"
                invalid-feedback="Discount Reference is required."
              >
                <v-select
                  v-model="selectedDisRef"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="disRefList"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select discount reference"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="
                reportDomain === 'myskoolaba' &&
                myObj.format === 'Fees Concession Report'
              "
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group label="Format">
                <v-select
                  v-model="feeConcessionOrientation"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="feeConcessionOrientationOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="Select format"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="myObj.format == 'Discount Percentage'"
            >
              <b-form-group
                label="Percentage"
                invalid-feedback="Percentage is required."
                ref="perc"
              >
                <b-form-input
                  placeholder="Enter percentage"
                  type="number"
                  v-model="disPerc"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col
              v-if="myObj.format == 'Monthly summary'"
              xl="3"
              lg="3"
              md="6"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Select Department"
                invalid-feedback="Department is required."
                ref="departs"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="myObj.depID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="departments"
                  :clearable="false"
                  ref="departs"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select department"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="singleVisible.includes(myObj.format)"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Select Month"
                invalid-feedback="Month is required."
                ref="sMonth"
              >
                <v-select
                  v-model="singleMonth"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="monthsSOptions"
                  :clearable="false"
                  ref="sMonth"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select month"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="singleVisible.includes(myObj.format)"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Select year"
                invalid-feedback="year is required."
                ref="year"
              >
                <v-select
                  v-model="singleYear"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="yearSOptions"
                  :clearable="false"
                  ref="year"
                  label="title"
                  :reduce="(val) => val.id"
                  placeholder="Select year"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="myObj.format === 'Student turnover'"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Year"
                invalid-feedback="Year is required."
                ref="turnoverYear"
              >
                <v-select
                  v-model="turnoverYear"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="yearSOptions"
                  :clearable="false"
                  ref="turnoverYear"
                  label="title"
                  :reduce="(val) => val.id"
                  placeholder="Select year"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="myObj.format === 'Student turnover'"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Month from"
                invalid-feedback="Month is required."
                ref="turnoverMonthFrom"
              >
                <v-select
                  v-model="turnoverMonthFrom"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="monthsSOptions"
                  :clearable="false"
                  ref="turnoverMonthFrom"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select month"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="myObj.format === 'Student turnover'"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Month to"
                invalid-feedback="Month is required."
                ref="turnoverMonthTo"
              >
                <v-select
                  v-model="turnoverMonthTo"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="monthsSOptions"
                  :clearable="false"
                  ref="turnoverMonthTo"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select month"
                />
              </b-form-group>
            </b-col>

            <template v-if="myObj.format === 'NTN Certificate'">
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="From Month"
                  invalid-feedback="From month is required."
                  ref="ntnFromMonth"
                >
                  <v-select
                    v-model="ntnFromMonth"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="monthsSOptions"
                    :clearable="false"
                    ref="ntnFromMonth"
                    label="name"
                    :reduce="(val) => val.id"
                    placeholder="Select month"
                  />
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="From Year"
                  invalid-feedback="From year is required."
                  ref="ntnFromYear"
                >
                  <v-select
                    v-model="ntnFromYear"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="yearSOptions"
                    :clearable="false"
                    ref="ntnFromYear"
                    label="title"
                    :reduce="(val) => val.id"
                    placeholder="Select year"
                  />
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="To Month"
                  invalid-feedback="To month is required."
                  ref="ntnToMonth"
                >
                  <v-select
                    v-model="ntnToMonth"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="monthsSOptions"
                    :clearable="false"
                    ref="ntnToMonth"
                    label="name"
                    :reduce="(val) => val.id"
                    placeholder="Select month"
                  />
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="To Year"
                  invalid-feedback="To year is required."
                  ref="ntnToYear"
                >
                  <v-select
                    v-model="ntnToYear"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="yearSOptions"
                    :clearable="false"
                    ref="ntnToYear"
                    label="title"
                    :reduce="(val) => val.id"
                    placeholder="Select year"
                  />
                </b-form-group>
              </b-col>
            </template>

            <b-col
              v-if="myObj.format === 'Driver wise students'"
              xl="3"
              lg="3"
              md="4"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Select Driver"
                invalid-feedback="Driver is required."
                ref="driverReportDriver"
              >
                <v-select
                  v-model="driverReportDriverID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[
                    { id: 'all', name: 'All Drivers' },
                    ...driverReportOptions,
                  ]"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  :loading="driverReportOptionsLoading"
                  placeholder="Select driver"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="myObj.format === 'Driver wise students'"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Select Class"
                :invalid-feedback="$t('Class is required')"
                ref="driverReportClass"
              >
                <v-select
                  v-model="classID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="reportClassOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="All Classes"
                  @input="FillSections()"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="myObj.format === 'Driver wise students'"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group
                label="Select Section"
                invalid-feedback="Section is required"
                ref="driverReportSection"
              >
                <v-select
                  v-model="secID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="reportSectionOptions"
                  :clearable="false"
                  label="section"
                  :reduce="(val) => val.id"
                  placeholder="All Sections"
                />
              </b-form-group>
            </b-col>

            <template v-if="myObj.format === 'Driver fees'">
              <b-col xl="3" lg="3" md="4" sm="12" cols="12">
                <b-form-group label="Select Driver" ref="driverFeeDriver">
                  <v-select
                    v-model="driverReportDriverID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="[
                      { id: 'all', name: 'All Drivers' },
                      ...driverReportOptions,
                    ]"
                    :clearable="false"
                    label="name"
                    :reduce="(val) => val.id"
                    :loading="driverReportOptionsLoading"
                    placeholder="All drivers"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="Select Class"
                  :invalid-feedback="$t('Class is required')"
                  ref="driverFeeClass"
                >
                  <v-select
                    v-model="classID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="reportClassOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(val) => val.id"
                    placeholder="All Classes"
                    @input="FillSections()"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="Select Section"
                  invalid-feedback="Section is required"
                  ref="driverFeeSection"
                >
                  <v-select
                    v-model="secID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="reportSectionOptions"
                    :clearable="false"
                    label="section"
                    :reduce="(val) => val.id"
                    placeholder="All Sections"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group label="Month" ref="driverFeeMonth">
                  <v-select
                    v-model="driverFeeMonth"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="[
                      { id: 0, name: 'All Months' },
                      ...monthsSOptions,
                    ]"
                    :clearable="false"
                    label="name"
                    :reduce="(val) => val.id"
                    placeholder="All months"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group label="Year" ref="driverFeeYear">
                  <v-select
                    v-model="driverFeeYear"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="[
                      { id: 0, title: 'All Years' },
                      ...yearSOptions,
                    ]"
                    :clearable="false"
                    label="title"
                    :reduce="(val) => val.id"
                    placeholder="All years"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group label="Fee Status" ref="driverFeeStatus">
                  <v-select
                    v-model="driverFeeStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="driverFeeStatusOptions"
                    :reduce="(opt) => opt.value"
                    label="text"
                    :clearable="false"
                    placeholder="All statuses"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="3" lg="3" md="4" sm="12" cols="12">
                <b-form-group label="Fee Type" ref="driverFeeType">
                  <v-select
                    v-model="driverFeeFeeTypeValue"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="feeTypes"
                    :clearable="false"
                    label="feeType"
                    :reduce="(val) => val.id"
                    placeholder="Select fee type"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="3" lg="3" md="4" sm="12" cols="12">
                <b-form-group
                  label="Receipt Date Range (optional)"
                  ref="driverFeeDate"
                >
                  <flat-pickr
                    :config="config"
                    v-model="driverFeeRange"
                    class="form-control"
                    placeholder="All receipt dates"
                    @on-change="setDriverFeeDate"
                  />
                </b-form-group>
              </b-col>
            </template>

            <b-col
              v-if="myObj.format === 'Event Calendar Report'"
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
            >
              <b-form-group label="Event For">
                <v-select
                  v-model="eventCalendarEventFor"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="eventCalendarEventForOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="Select event for"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                currentReportType == 'dcr' &&
                ![
                  'Exemption',
                  'Fee Summary',
                  'Summary Details',
                  'Fee Revenue',
                  'Reconciliation fees',
                  'Driver fees',
                ].includes(myObj.format)
              "
            >
              <b-form-group
                label="Collection Account"
                invalid-feedback="collection account is required."
                ref="acc"
              >
                <v-select
                  v-model="myObj.account"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="accTypes"
                  :reduce="(opt) => opt.id"
                  label="account"
                  :clearable="false"
                  ref="acc"
                  placeholder="Select account"
                  @input="CheckAccount()"
                />
              </b-form-group>
            </b-col>

            <template v-if="myObj.format == 'Slip range'">
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="Slip From"
                  invalid-feedback="Slip From is required."
                  ref="spFrom"
                >
                  <b-form-input
                    placeholder="Enter slip no."
                    type="number"
                    v-model="slipFrom"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="Slip To"
                  invalid-feedback="Slip To is required."
                  ref="spTo"
                >
                  <b-form-input
                    placeholder="Enter slip no."
                    type="number"
                    v-model="slipTo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </template>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="myObj.format == 'Left Category wise'"
            >
              <b-form-group
                label="Category"
                invalid-feedback="Category is required."
                ref="category"
              >
                <v-select
                  v-model="myObj.leftCategory"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ title: 'All' }, ...leftOptions]"
                  :reduce="(opt) => opt.title"
                  label="title"
                  :clearable="false"
                  placeholder="Select category"
                />
              </b-form-group>
            </b-col>

            <b-col xl="2" lg="2" md="3" v-if="false">
              <b-form-group
                label="Accounts"
                invalid-feedback="accounts is required."
                ref="accounts"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="accList"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="accTypes"
                  :reduce="(opt) => opt.id"
                  label="account"
                  :clearable="false"
                  ref="accounts"
                  placeholder="Select account"
                  @input="setAccounts()"
                  @search:blur="checkMultiAccounts()"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="showLedgerBelongsFilter"
            >
              <b-form-group label="Account type">
                <v-select
                  v-model="ledgerBelongsFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="ledgerBelongsFilterOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="All"
                  @input="onLedgerBelongsFilterChange"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="3"
              lg="3"
              md="4"
              sm="12"
              cols="12"
              v-if="
                (currentReportType == 'Accounts' &&
                  myObj.format !== 'Closing report' &&
                  myObj.format !== 'Cashbook' &&
                  myObj.format !== 'Monthly Fee' &&
                  myObj.format !== 'Estimation' &&
                  myObj.format !== 'NTN Certificate') ||
                myObj.format == 'Ledger' ||
                myObj.format == 'Ledger (reconciled)' ||
                (myObj.type.value == 'Advance Accounts' &&
                  myObj.format == 'Expense Report')
              "
            >
              <b-form-group
                :label="
                  myObj.format == 'Expense Report'
                    ? 'Account'
                    : 'Chart of account'
                "
                invalid-feedback="Chart of account is required."
                ref="acc"
              >
                <!-- :multiple="myObj.format !== 'Ledger (reconciled)'" :closeOnSelect="myObj.format !== 'Ledger (reconciled)' ? false : true" -->
                <v-select
                  v-model="coa"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="filteredCoaTypes"
                  :reduce="(opt) => opt.id"
                  label="title"
                  :clearable="false"
                  ref="acc"
                  :placeholder="
                    myObj.format == 'Expense Report'
                      ? 'Select account'
                      : 'Select chart of account'
                  "
                >
                  <template #option="option">
                    <div
                      v-b-tooltip.hover.topright
                      :title="`${option.title} (${option.code})`"
                    >
                      <div>{{ option.title }}</div>
                      <div class="font-weight-bolder">
                        {{ option.code }}
                      </div>
                    </div>
                  </template>
                  <template #selected-option="option">
                    <div>
                      <div>{{ option.title }}</div>
                      <div class="font-weight-bolder">
                        {{ option.code }}
                      </div>
                    </div>
                  </template>
                </v-select>
                <!-- @input="setAccountsCOA()"  -->
              </b-form-group>
            </b-col>

            <b-col
              xl="3"
              lg="3"
              md="4"
              sm="12"
              cols="12"
              v-if="myObj.format == 'Party Ledger'"
            >
              <b-form-group
                label="Vendor"
                invalid-feedback="Vendor is required."
                ref="vendor"
              >
                <v-select
                  v-model="myObj.vendorID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="vendorList"
                  :reduce="(opt) => opt.id"
                  label="name"
                  :clearable="false"
                  placeholder="Select Vendor"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="3"
              lg="3"
              md="4"
              sm="12"
              cols="12"
              v-if="myObj.format == 'SBU Ledger'"
            >
              <b-form-group
                label="SBU"
                invalid-feedback="SBU is required."
                ref="project"
              >
                <v-select
                  v-model="myObj.projectID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="projectList"
                  :reduce="(opt) => opt.id"
                  label="name"
                  :clearable="false"
                  placeholder="Select SBU"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                statusVisible.includes(myObj.format) ||
                (myObj.type.value == 'defaulters' &&
                  !singleVisible.includes(myObj.format) &&
                  myObj.format != 'Summary' &&
                  myObj.format != 'Challan Statement')
              "
            >
              <b-form-group
                label="Status"
                invalid-feedback="Status is required."
                ref="status"
              >
                <v-select
                  v-model="myObj.status"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="
                    suspendVisible.includes(myObj.format)
                      ? statusOptionsWithSuspend
                      : statusOptions
                  "
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  ref="status"
                  placeholder="Select status"
                  @input="CheckStatus()"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                genderVisible.includes(reportDomain) &&
                myObj.format == 'Class list'
              "
            >
              <b-form-group
                label="Gender"
                invalid-feedback="Gender is required."
                ref="gender"
              >
                <v-select
                  v-model="selectedGender"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="genders"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  :placeholder="$t('Select gender')"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                reportDomain === 'myskooliuss' &&
                myObj.format === 'Class list' &&
                myObj.status === 'registered'
              "
            >
              <b-form-group label="Fee Payment Status">
                <v-select
                  v-model="feePaymentStatus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="feePaymentStatusOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="Select fee status"
                />
              </b-form-group>
            </b-col>

            <!-- Increment list filters -->
            <!-- For Al Hameed domain: show Year dropdown -->
            <b-col
              md="4"
              v-if="
                currentReportType == 'Staff' &&
                myObj.format == 'Increment list' &&
                isAlhameedDomain
              "
            >
              <b-form-group
                label="Select Year"
                :invalid-feedback="'Year is required.'"
                ref="incrementYear"
              >
                <v-select
                  v-model="incrementYear"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="yearOptions"
                  :clearable="false"
                  placeholder="Select year"
                />
              </b-form-group>
            </b-col>

            <!-- For normal domains: show single Date Range input -->
            <b-col
              md="8"
              v-if="
                currentReportType == 'Staff' &&
                myObj.format == 'Increment list' &&
                !isAlhameedDomain
              "
            >
              <b-form-group
                label="Date range"
                :invalid-feedback="'Date range is required.'"
                ref="incrementRangeRef"
              >
                <flat-pickr
                  :config="config"
                  v-model="incrementRange"
                  class="form-control"
                  placeholder="Select date range"
                  @on-change="setIncrementRange()"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              v-if="
                currentReportType == 'Staff' &&
                ![
                  'Staff Allocation',
                  'Organization structure',
                  'New staff list',
                  'New staff left list',
                  'Increment list',
                  'App Stats',
                  'Advance & Loan',
                  'Staff Campus Transfer',
                ].includes(myObj.format)
              "
            >
              <b-form-group
                label="Status"
                invalid-feedback="Status is required."
                ref="stf_status"
              >
                <v-select
                  v-model="myObj.staffStatus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="staffStOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="Select status"
                  @input="onStaffStatusChange"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              v-if="
                currentReportType == 'Staff' &&
                myObj.format === 'Advance & Loan' &&
                reportDomain === 'myskoolaba'
              "
            >
              <b-form-group label="Loan Type" ref="loanReportType">
                <v-select
                  v-model="loanReportType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="loanReportTypeOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="Select type"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="myObj.format === 'App Stats'"
            >
              <b-form-group label="Download Status">
                <v-select
                  v-model="appStatsStatus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="appStatsStatusOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="Select status"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="myObj.format == 'Consents'"
            >
              <b-form-group
                label="Consent"
                invalid-feedback="Consent is required."
                ref="cons"
              >
                <v-select
                  v-model="myObj.consent"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="consentList"
                  :clearable="false"
                  placeholder="Select"
                  @input="CheckCons()"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                myObj.type.value == 'defaulters' &&
                (myObj.format == 'Class wise' || myObj.format == 'Family wise')
              "
            >
              <b-form-group
                label="Balance over"
                invalid-feedback="Balance is required."
                ref="balance"
              >
                <b-form-input
                  placeholder="Enter balance"
                  type="number"
                  v-model="myObj.balance"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="this.myObj.format == 'Admit card'"
            >
              <b-form-group
                label="Exam Type"
                invalid-feedback="Exam type is required."
                ref="exType"
              >
                <v-select
                  v-model="eTypee"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="examType"
                  :reduce="(opt) => opt.examType"
                  label="examType"
                  :clearable="false"
                  ref="exType"
                  placeholder="Select exam type"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                (this.myObj.format == 'Admit card' ||
                  this.myObj.format == 'ID card' ||
                  myObj.format === 'Inquiry' ||
                  myObj.format === 'Visitors' ||
                  (this.myObj.format == 'Attendance list' &&
                    $store.state.currentBranch.organizationType ==
                      'coaching') ||
                  (this.myObj.format == 'Class list' &&
                    $store.state.currentBranch.organizationType ==
                      'coaching') ||
                  (myObj.type.value == 'Students' &&
                    $store.state.currentBranch.organizationType ==
                      'coaching')) &&
                myObj.format !== 'Student Email List' &&
                myObj.format !== 'Subject Wise Fees' &&
                myObj.format !== 'Student turnover' &&
                myObj.format !== 'Driver wise students' &&
                myObj.format !== 'Campus Transfer' &&
                myObj.format !== 'Class list verification report' &&
                myObj.format !== 'App Stats'
              "
            >
              <b-form-group
                label="Session"
                invalid-feedback="Session is required."
                ref="session"
              >
                <v-select
                  v-model="myObj.sessionID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="
                    ['Inquiry', 'Visitors'].includes(myObj.format)
                      ? inquirySessionOptions
                      : sessions
                  "
                  :reduce="(opt) => opt.id"
                  label="session"
                  :clearable="false"
                  ref="session"
                  placeholder="Select session"
                />
              </b-form-group>
            </b-col>

            <!-- Session dropdown for Subject Wise Fees -->
            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="myObj.format === 'Subject Wise Fees'"
            >
              <b-form-group
                label="Session"
                invalid-feedback="Session is required."
                ref="subjectFeeSession"
              >
                <v-select
                  v-model="subjectFeeSessionID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ id: 0, session: 'All' }, ...sessions]"
                  :reduce="(opt) => opt.id"
                  label="session"
                  :clearable="false"
                  ref="subjectFeeSession"
                  placeholder="Select session"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="this.myObj.format == 'Admit card'"
            >
              <b-form-group
                label="Select Date"
                invalid-feedback="Date is required"
              >
                <flat-pickr
                  :config="{
                    altFormat: 'j M, Y',
                    altInput: true,
                    dateFormat: 'd-F-Y',
                  }"
                  v-model="formattedDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <template v-if="myObj.format == 'Barcode'">
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="Prefix"
                  invalid-feedback="Prefix is required."
                  ref="prefix"
                >
                  <b-form-input
                    placeholder="Enter prefix"
                    v-model="barcodeObj.prefix"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="Start"
                  invalid-feedback="Start is required."
                  ref="start"
                >
                  <b-form-input
                    placeholder="Enter start no."
                    type="number"
                    v-model="barcodeObj.start"
                    no-wheel
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="End"
                  invalid-feedback="End is required."
                  ref="end"
                >
                  <b-form-input
                    placeholder="Enter end no."
                    type="number"
                    v-model="barcodeObj.end"
                    no-wheel
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </template>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                myObj.type.value == 'Advance Accounts' &&
                myObj.format == 'Balance Sheet'
              "
            >
              <b-form-group
                label="Fiscal Year"
                invalid-feedback="Fiscal year is required."
                ref="fiscalYear"
              >
                <v-select
                  v-model="selectedFiscalYearID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="fiscalYears"
                  :reduce="(opt) => opt.id"
                  label="title"
                  :clearable="false"
                  placeholder="Select fiscal year"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="singleDtVisible.includes(myObj.format)"
            >
              <b-form-group
                :label="
                  myObj.format === 'Date wise strength'
                    ? 'End Date'
                    : 'Select Date'
                "
                invalid-feedback="Date is required"
                ref="single_date"
              >
                <flat-pickr
                  :config="singleConfig"
                  v-model="singleDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <template v-else-if="showDate">
              <template
                v-if="
                  ['Accounts', 'Advance Accounts'].includes(myObj.type.value) ||
                  myObj.format === 'Event Calendar Report' ||
                  myObj.format === 'Campus Transfer' ||
                  myObj.format === 'Staff Campus Transfer'
                "
              >
                <b-col
                  v-if="!(usesEtbMonthWiseFilter && myObj.format === 'Extended Trial Balance')"
                  xl="2"
                  lg="2"
                  md="3"
                  sm="12"
                  cols="12"
                >
                  <b-form-group
                    label="From Date"
                    invalid-feedback="From date is required"
                    ref="dt_from"
                  >
                    <flat-pickr
                      :config="singleConfig"
                      v-model="myObj.dtfrom"
                      class="form-control"
                      :placeholder="$t('Select Date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="!(usesEtbMonthWiseFilter && myObj.format === 'Extended Trial Balance')"
                  xl="2"
                  lg="2"
                  md="3"
                  sm="12"
                  cols="12"
                >
                  <b-form-group
                    label="Till Date"
                    invalid-feedback="Till date is required"
                    ref="dt_to"
                  >
                    <flat-pickr
                      :config="singleConfig"
                      v-model="myObj.dtto"
                      class="form-control"
                      :placeholder="$t('Select Date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="
                    myObj.format === 'Extended Trial Balance' &&
                    usesEtbMonthWiseFilter
                  "
                  xl="2"
                  lg="2"
                  md="3"
                  sm="12"
                  cols="12"
                >
                  <b-form-group
                    label="Year"
                    invalid-feedback="Year is required."
                    ref="etbYear"
                  >
                    <v-select
                      v-model="etbYear"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="yearSOptions"
                      :clearable="false"
                      ref="etbYear"
                      label="title"
                      :reduce="(val) => val.id"
                      placeholder="Select year"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="
                    myObj.format === 'Extended Trial Balance' &&
                    usesEtbMonthWiseFilter
                  "
                  xl="2"
                  lg="2"
                  md="3"
                  sm="12"
                  cols="12"
                >
                  <b-form-group
                    label="Month from"
                    invalid-feedback="Month is required."
                    ref="etbMonthFrom"
                  >
                    <v-select
                      v-model="etbMonthFrom"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="monthsSOptions"
                      :clearable="false"
                      ref="etbMonthFrom"
                      label="name"
                      :reduce="(val) => val.id"
                      placeholder="Select month"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="
                    myObj.format === 'Extended Trial Balance' &&
                    usesEtbMonthWiseFilter
                  "
                  xl="2"
                  lg="2"
                  md="3"
                  sm="12"
                  cols="12"
                >
                  <b-form-group
                    label="Month to"
                    invalid-feedback="Month is required."
                    ref="etbMonthTo"
                  >
                    <v-select
                      v-model="etbMonthTo"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="monthsSOptions"
                      :clearable="false"
                      ref="etbMonthTo"
                      label="name"
                      :reduce="(val) => val.id"
                      placeholder="Select month"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="
                    myObj.format === 'Extended Trial Balance' &&
                    usesEtbBankCashCategory
                  "
                  xl="2"
                  lg="2"
                  md="3"
                  sm="12"
                  cols="12"
                >
                  <b-form-group label="Category">
                    <v-select
                      v-model="etbCategoryFilter"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="etbCategoryOptions"
                      :reduce="(opt) => opt.value"
                      label="text"
                      :clearable="false"
                      placeholder="Select category"
                    />
                  </b-form-group>
                </b-col>
              </template>
              <b-col v-else xl="2" lg="2" md="3" sm="12" cols="12">
                <b-form-group
                  label="Select Date"
                  invalid-feedback="Date is required"
                  ref="date"
                >
                  <flat-pickr
                    :config="config"
                    v-model="rangeDate"
                    class="form-control"
                    :placeholder="$t('Select Date')"
                    @on-change="setDate"
                  />
                </b-form-group>
              </b-col>
            </template>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              v-if="
                myObj.format == 'Subject List' || myObj.format == 'Timetable'
              "
            >
              <b-form-group
                label="Subject"
                invalid-feedback="Subject is required."
                ref="subject"
              >
                <v-select
                  v-model="myObj.subjectID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="
                    usesSubjectListDomainReport &&
                    myObj.format === 'Subject List'
                      ? subjectList
                      : filteredSubjectList
                  "
                  :reduce="(opt) => opt.id"
                  label="subject"
                  :clearable="false"
                  placeholder="Select subject"
                  @input="onSubjectFilterChange"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              v-if="
                isHeadOffice &&
                ((reportDomain == 'myskooliuss' &&
                  myObj.format == 'Planner Logs') ||
                  myObj.format == 'Timetable')
              "
            >
              <b-form-group
                label="Select Campus"
                invalid-feedback="Campus is required."
                ref="capID"
              >
                <v-select
                  v-model="myObj.campusID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="filteredCampuses"
                  :clearable="false"
                  label="branch"
                  :reduce="(val) => val.id"
                  placeholder="Select campus"
                  @input="onTimetableCampusChange"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              v-if="
                (['myskoolskh'].includes(reportDomain) &&
                  (myObj.format == 'Subject List' ||
                    (['Staff Share', 'Staff Share Summary'].includes(
                      myObj.format
                    ) &&
                      isLocked))) ||
                (reportDomain == 'myskooliuss' &&
                  myObj.format == 'Planner Logs') ||
                myObj.format == 'Timetable'
              "
            >
              <b-form-group
                label="Staff"
                invalid-feedback="Staff is required."
                ref="staff"
              >
                <v-select
                  v-model="myObj.staffID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="filteredStaffList"
                  :reduce="(opt) => opt.id"
                  label="name"
                  :clearable="false"
                  placeholder="Select staff"
                />
              </b-form-group>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                reportDomain == 'myskoolstjacob' &&
                myObj.type.value == 'defaulters' &&
                (myObj.format == 'Class wise' || myObj.format == 'Family wise')
              "
            >
              <b-form-group invalid-feedback="Date is required" ref="jacobdate">
                <div class="d-flex justify-content-between">
                  <label class="bv-no-focus-ring col-form-label pt-0"
                    >Last visit date
                    <!-- <feather-icon
                      class="cursor-pointer ml-50"
                      icon="InfoIcon"
                      size="16"
                      v-b-tooltip.hover.top
                      title="Select the last visit date to hide their data"
                    /> -->
                  </label>
                  <b-badge
                    variant="primary"
                    class="mb-50 cursor-pointer"
                    @click="jDate = null"
                  >
                    Clear
                  </b-badge>
                </div>
                <flat-pickr
                  ref="jacobdate"
                  :config="singleConfig"
                  v-model="jDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <b-col
              md="12"
              v-if="
                // (myObj.type.value == 'dcr' ||
                //   myObj.type.value == 'defaulters') &&
                myObj.type.value == 'dcr' &&
                myObj.format !== 'Reconciliation fees' &&
                myObj.format !== 'Driver fees' &&
                !singleVisible.includes(myObj.format)
              "
            >
              <b-form-group
                label="Select Months"
                invalid-feedback="month is required."
                ref="months"
              >
                <div
                  class="d-flex flex-wrap align-items-center"
                  style="
                    border: 1px solid lightgray;
                    padding: 5px;
                    border-radius: 5px;
                  "
                >
                  <b-button
                    class="btn-icon m-50"
                    v-for="mon in months"
                    :key="mon.id"
                    :variant="
                      variantMonth(mon.id) ? 'primary' : 'outline-primary'
                    "
                    @click="selectMonth(mon.id)"
                  >
                    {{ mon.name }}
                  </b-button>
                  <div
                    class="ml-50"
                    style="width: 120px"
                    v-if="myObj.type.value == 'defaulters'"
                  >
                    <b-form-group
                      label="Year"
                      invalid-feedback="year is required."
                      ref="yearD"
                    >
                      <!-- multiple
                    :closeOnSelect="false" -->
                      <v-select
                        multiple
                        v-model="myObj.year"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="lastYears"
                        :reduce="(val) => val.id"
                        label="title"
                        :clearable="false"
                        ref="yearD"
                        placeholder="Select year"
                        @input="checkAccountYear()"
                      />
                    </b-form-group>
                  </div>
                </div>
              </b-form-group>
            </b-col>

            <!-- month year range -->
            <b-col
              md="12"
              v-if="
                myObj.type.value == 'defaulters' &&
                !singleVisible.includes(myObj.format) &&
                myObj.format != 'Challan Statement'
              "
            >
              <b-form-group
                label="Select Month Range"
                invalid-feedback="month is required."
              >
                <div
                  style="
                    border: 1px solid lightgray;
                    padding: 8px;
                    border-radius: 5px;
                  "
                >
                  <b-row>
                    <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                      <b-form-group
                        label="Month from"
                        invalid-feedback="Month is required."
                        ref="fromMonth"
                      >
                        <v-select
                          v-model="monthFrom"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="monthsSOptions"
                          :clearable="false"
                          ref="fromMonth"
                          label="name"
                          :reduce="(val) => val.id"
                          placeholder="Select month"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                      <b-form-group
                        label="Year from"
                        invalid-feedback="year is required."
                        ref="fromYear"
                      >
                        <v-select
                          v-model="yearFrom"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="yearSOptions"
                          :clearable="false"
                          ref="fromYear"
                          label="title"
                          :reduce="(val) => val.id"
                          placeholder="Select year"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                      <b-form-group
                        label="Month till"
                        invalid-feedback="Month is required."
                        ref="tillMonth"
                      >
                        <v-select
                          v-model="monthTill"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="monthsSOptions"
                          :clearable="false"
                          ref="tillMonth"
                          label="name"
                          :reduce="(val) => val.id"
                          placeholder="Select month"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                      <b-form-group
                        label="Year till"
                        invalid-feedback="year is required."
                        ref="tillYear"
                      >
                        <v-select
                          v-model="yearTill"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="yearSOptions"
                          :clearable="false"
                          ref="tillYear"
                          label="title"
                          :reduce="(val) => val.id"
                          placeholder="Select year"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col xl="2" lg="2" md="3" sm="12" cols="12">
                      <b-button
                        class="mt-lg-2"
                        variant="outline-secondary"
                        @click="clearRange()"
                      >
                        <feather-icon icon="XIcon" />
                        Clear
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-form-group>
            </b-col>

            <b-col
              md="12"
              v-if="
                (myObj.type.value == 'dcr' &&
                  myObj.format !== 'Fee Revenue' &&
                  myObj.format !== 'Reconciliation fees' &&
                  myObj.format !== 'Driver fees') ||
                (myObj.type.value == 'defaulters' &&
                  myObj.format != 'Challan Statement')
              "
            >
              <b-form-group
                label="Select Fee Type"
                invalid-feedback="Fee Type is required."
                ref="feetype"
              >
                <a class="my-buttons font-weight-bold">
                  <span v-if="!showAll" @click="showAll = true">Show More</span>
                  <span v-else @click="showAll = false">Show Less</span>
                </a>
                <!-- <feather-icon
                  v-if="!showAll"
                  v-b-tooltip.hover.left
                  title="Show"
                  class="my-buttons"
                  icon="ArrowDownIcon"
                  size="26"
                  @click="showAll = true"
                />
                <feather-icon
                  v-else
                  v-b-tooltip.hover.left
                  title="Hide"
                  class="my-buttons"
                  icon="ArrowUpIcon"
                  size="26"
                  @click="showAll = false"
                /> -->
                <div
                  :class="{ 'my-collapsing': !showAll }"
                  style="
                    border: 1px solid lightgray;
                    padding: 5px;
                    border-radius: 5px;
                  "
                >
                  <b-button
                    style="margin: 5px"
                    class="btn-icon"
                    v-for="fee in feeTypes"
                    :key="fee.id"
                    :variant="
                      variantFeetype(fee.id) ? 'primary' : 'outline-primary'
                    "
                    @click="selectFeetype(fee.id)"
                  >
                    {{ fee.feeType }}
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!dataLoading">
            <b-col
              v-if="
                isHeadOffice &&
                (campusVisible.includes(myObj.type.value) ||
                  myObj.format === 'Campus Transfer' ||
                  myObj.format === 'Staff Campus Transfer' ||
                  (reportDomain === 'myskooliuss' &&
                    (myObj.format === 'Fee status' ||
                      myObj.format === 'Average fees'))) &&
                myObj.format !== 'Terms & Conditions report' &&
                myObj.format !== 'Terms acknowledge report'
              "
              xl="3"
              lg="3"
              md="4"
              sm="12"
            >
              <b-form-group
                label="Select Campus"
                invalid-feedback="Campus is required."
                ref="campID"
              >
                <v-select
                  v-model="myObj.campusID"
                  @input="getCmapusClasses()"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="
                    myObj.format === 'Campus Transfer' ||
                    myObj.format === 'Staff Campus Transfer'
                      ? filteredCampuses
                      : campuses
                  "
                  :clearable="false"
                  label="branch"
                  :reduce="(val) => val.id"
                  placeholder="Select campus"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="myObj.format === 'Campus Transfer'"
              xl="2"
              lg="2"
              md="4"
              sm="12"
            >
              <b-form-group label="Transfer Type" ref="campusTransferType">
                <v-select
                  v-model="campusTransferType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="campusTransferTypeOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  placeholder="Select transfer type"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="
                reportDomain === 'myskoolaba' &&
                (myObj.format === 'Department-wise Discount Report' ||
                  myObj.format === 'Discount Summary Report')
              "
              xl="2"
              lg="2"
              md="4"
              sm="12"
            >
              <b-form-group
                label="Select Department"
                invalid-feedback="Department is required."
                ref="abaDiscDepID"
              >
                <v-select
                  v-model="selectedDep"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[
                    { id: 0, name: 'All Departments' },
                    ...departments,
                  ]"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select department"
                  @input="setClasses()"
                />
              </b-form-group>
            </b-col>
            <!-- Standard exclusion logic to hide Department for student-related reports that use Campus instead -->
            <b-col
              xl="2"
              lg="2"
              md="4"
              sm="12"
              v-else-if="
                myObj.type.value != 'Accounts' &&
                myObj.format !== 'Monthly summary' &&
                myObj.type.value !== 'challan-report' &&
                myObj.type.value !== 'Advance Accounts' &&
                myObj.type.value != 'Staff' &&
                myObj.format !== 'Terms & Conditions report' &&
                myObj.format !== 'Terms acknowledge report' &&
                myObj.format !== 'Student Email List' &&
                myObj.format !== 'Subject Wise Fees' &&
                myObj.format !== 'Student turnover' &&
                myObj.format !== 'Driver wise students' &&
                myObj.format !== 'Driver fees' &&
                myObj.format !== 'Campus Transfer' &&
                myObj.format !== 'Fee Revenue' &&
                myObj.format !== 'Reconciliation fees' &&
                myObj.format !== 'Class list' &&
                myObj.format !== 'Class list verification' &&
                myObj.format !== 'Fee Reminder' &&
                myObj.format !== 'Fees Concession Report' &&
                myObj.format !== 'Class Wise Concession Report' &&
                myObj.format !== 'Sibling Concession Report' &&
                myObj.format !== 'Department-wise Discount Report' &&
                myObj.format !== 'Discount Summary Report' &&
                myObj.format !== 'Custom Fee Report' &&
                myObj.format !== 'Subject Wise Fees' &&
                myObj.format !== 'Pending Fees' &&
                !(
                  usesSubjectListDomainReport &&
                  myObj.format === 'Subject List'
                ) &&
                !(
                  reportDomain === 'myskoolhappinessfoundation' &&
                  myObj.format === 'ID card'
                ) &&
                myObj.format !== 'Inquiry' &&
                myObj.format !== 'Visitors' &&
                myObj.format !== 'Event Calendar Report' &&
                myObj.format !== 'Driver wise students' &&
                myObj.format !== 'Driver fees' &&
                myObj.format !== 'App Stats' &&
                myObj.format !== 'Barcode'
              "
            >
              <b-form-group
                label="Select Department"
                invalid-feedback="Department is required."
                ref="depID"
              >
                <v-select
                  v-model="selectedDep"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[
                    { id: 0, name: 'All Departments' },
                    ...departments,
                  ]"
                  :clearable="false"
                  ref="depID"
                  label="name"
                  :reduce="(val) => val.id"
                  placeholder="Select department"
                  @input="setClasses()"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="3"
              lg="3"
              md="4"
              sm="12"
              v-if="
                ((myObj.type.value != 'Accounts' &&
                  myObj.format !== 'Monthly summary' &&
                  myObj.type.value !== 'challan-report' &&
                  myObj.type.value !== 'Advance Accounts' &&
                  myObj.type.value != 'Staff' &&
                  myObj.format !== 'Terms & Conditions report' &&
                  myObj.format !== 'Terms acknowledge report' &&
                  myObj.format !== 'Student Email List' &&
                  myObj.format !== 'Student turnover' &&
                  myObj.format !== 'Driver wise students' &&
                  myObj.format !== 'Driver fees' &&
                  myObj.format !== 'Campus Transfer' &&
                  myObj.format !== 'Fee Revenue' &&
                  myObj.format !== 'App Stats' &&
                  myObj.format !== 'Barcode') ||
                  (myObj.type.value == 'Staff' &&
                    myObj.format == 'Timetable')) &&
                (myObj.format !== 'Event Calendar Report' ||
                  eventCalendarEventFor === 'Students')
              "
            >
              <b-form-group
                :label="
                  reportDomain === 'myskoolhappinessfoundation'
                    ? 'Select Group'
                    : 'Select Class'
                "
                :invalid-feedback="$t('Class is required')"
                ref="class"
              >
                <v-select
                  ref="class"
                  :multiple="
                    ![
                      'Inquiry',
                      'Visitors',
                      'Subject Wise Fees',
                      'Driver wise students',
                    ].includes(myObj.format)
                  "
                  :closeOnSelect="
                    [
                      'Inquiry',
                      'Visitors',
                      'Subject Wise Fees',
                      'Driver wise students',
                    ].includes(myObj.format)
                  "
                  v-model="classID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="reportClassOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  :placeholder="
                    reportDomain === 'myskoolhappinessfoundation'
                      ? 'Select group'
                      : 'Select class'
                  "
                  @input="FillSections()"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="3"
              lg="3"
              md="4"
              sm="12"
              v-if="
                ((myObj.type.value != 'Accounts' &&
                  myObj.format !== 'Monthly summary' &&
                  myObj.type.value !== 'challan-report' &&
                  myObj.type.value !== 'Advance Accounts' &&
                  myObj.type.value != 'Staff' &&
                  myObj.format !== 'Terms & Conditions report' &&
                  myObj.format !== 'Terms acknowledge report' &&
                  myObj.format !== 'Student Email List' &&
                  myObj.format !== 'Student turnover' &&
                  myObj.format !== 'Driver wise students' &&
                  myObj.format !== 'Driver fees' &&
                  myObj.format !== 'Campus Transfer' &&
                  myObj.format !== 'Fee Revenue' &&
                  myObj.format !== 'App Stats' &&
                  myObj.format !== 'Barcode') ||
                  (myObj.type.value == 'Staff' &&
                    myObj.format == 'Timetable')) &&
                (myObj.format !== 'Event Calendar Report' ||
                  eventCalendarEventFor === 'Students')
              "
            >
              <b-form-group
                :label="
                  reportDomain === 'myskoolhappinessfoundation'
                    ? 'Select Level'
                    : 'Select Section'
                "
                invalid-feedback="Section is required"
                ref="section"
              >
                <v-select
                  :multiple="
                    ![
                      'Inquiry',
                      'Visitors',
                      'Subject Wise Fees',
                      'Driver wise students',
                    ].includes(myObj.format)
                  "
                  :closeOnSelect="
                    [
                      'Inquiry',
                      'Visitors',
                      'Subject Wise Fees',
                      'Driver wise students',
                    ].includes(myObj.format)
                  "
                  v-model="secID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="reportSectionOptions"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  ref="section"
                  label="section"
                  :placeholder="
                    reportDomain === 'myskoolhappinessfoundation'
                      ? 'Select level'
                      : 'Select section'
                  "
                  @input="setSections()"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="myObj.format == 'Custom Fee Report'"
            >
              <b-form-group label="Select Fee Type">
                <v-select
                  v-model="customFeeTypeID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ feeType: 'All', id: 0 }, ...feeTypes]"
                  label="feeType"
                  :reduce="(opt) => opt.id"
                  :clearable="false"
                  placeholder="Select fee type"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="myObj.format == 'Custom Fee Report'"
            >
              <b-form-group label="Select Month">
                <v-select
                  v-model="customFeeMonth"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ id: 0, name: 'All' }, ...monthsSOptions]"
                  label="name"
                  :reduce="(opt) => opt.id"
                  :clearable="false"
                  placeholder="Select month"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="3"
              lg="3"
              md="4"
              sm="12"
              cols="12"
              v-if="
                myObj.format == 'Custom Fee Report' ||
                myObj.format == 'Terms acknowledge report'
              "
            >
              <b-form-group label="Search" class="student-search-group">
                <div class="search-input-wrapper">
                  <b-form-input
                    v-model="studentSearchQuery"
                    placeholder="Search students..."
                    @input="onStudentSearchChange"
                    autocomplete="off"
                  ></b-form-input>
                  <feather-icon
                    v-if="studentSearchQuery"
                    icon="XIcon"
                    size="14"
                    class="clear-search-icon"
                    @click="clearSelectedStudent"
                  />
                </div>
                <!-- Search Results -->
                <div
                  v-if="
                    studentSearchQuery.length >= 2 &&
                    filteredStudentOptions.length > 0
                  "
                  class="student-search-results"
                >
                  <div
                    v-for="student in filteredStudentOptions"
                    :key="student.id"
                    class="student-search-option"
                    @click="selectStudent(student)"
                  >
                    <div class="student-option-info">
                      <strong>{{ student.name }}</strong>
                      <div class="text-muted small">
                        {{ student.className
                        }}{{
                          student.sectionName ? " - " + student.sectionName : ""
                        }}
                        <span v-if="student.grNo" class="ml-1"
                          >GR: {{ student.grNo }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="studentSearchLoading" class="student-search-loading">
                  <b-spinner small variant="primary" />
                </div>
              </b-form-group>
            </b-col>

            <b-col
              md="4"
              v-if="
                (currentReportType == 'Staff' &&
                  myObj.format !== 'Planner Logs' &&
                  myObj.format !== 'Timetable' &&
                  myObj.format !== 'App Stats' &&
                  myObj.format !== 'Staff Allocation' &&
                  myObj.format !== 'Staff Campus Transfer') ||
                (myObj.format === 'Event Calendar Report' &&
                  eventCalendarEventFor === 'Staff')
              "
            >
              <b-form-group
                label="Select Department"
                :invalid-feedback="
                  myObj.format === 'Organization structure'
                    ? ''
                    : [
                        'Staff List Muster Roll',
                        'Staff List With Salary',
                        'New staff list',
                        'New staff left list',
                        'Increment list',
                      ].includes(myObj.format)
                    ? 'Department is required.'
                    : 'Department is required.'
                "
                ref="staffDep"
              >
                <v-select
                  :multiple="
                    ![
                      'Remaining Leaves',
                      'Leave Encashment',
                      'Advance & Loan',
                      'Organization structure',
                      'Staff List Muster Roll',
                      'Staff List With Salary',
                      'New staff list',
                      'New staff left list',
                      'Increment list',
                      'Event Calendar Report',
                    ].includes(myObj.format)
                  "
                  :closeOnSelect="
                    [
                      'Remaining Leaves',
                      'Leave Encashment',
                      'Advance & Loan',
                      'Staff List Muster Roll',
                      'Staff List With Salary',
                      'New staff list',
                      'New staff left list',
                      'Increment list',
                      'Event Calendar Report',
                    ].includes(myObj.format)
                  "
                  ref="staffDep"
                  v-model="staffDepID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[
                    { name: 'All Departments', id: 0 },
                    ...staffDeparts,
                  ]"
                  label="name"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  placeholder="Select department"
                  @input="setDeps()"
                />
              </b-form-group>
            </b-col>

            <!-- Staff Allocation: filters + actions -->
            <b-col
              cols="12"
              v-if="
                currentReportType == 'Staff' &&
                myObj.format == 'Staff Allocation'
              "
            >
              <div class="staff-allocation-filters">
                <div class="staff-allocation-filter">
                  <b-form-group label="Select Department">
                    <v-select
                      ref="staffDep"
                      v-model="staffDepID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="[
                        { name: 'All Departments', id: 0 },
                        ...staffDeparts,
                      ]"
                      label="name"
                      :reduce="(val) => val.id"
                      :multiple="true"
                      :clearable="false"
                      placeholder="Select department"
                      @input="setDeps()"
                    />
                  </b-form-group>
                </div>
                <div class="staff-allocation-filter">
                  <b-form-group label="Select Class">
                    <v-select
                      v-model="staffAllocClassIDs"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="classesOptions"
                      :multiple="true"
                      :clearable="false"
                      label="name"
                      :reduce="(val) => val.id"
                      placeholder="All Classes"
                      @input="setStaffAllocClasses"
                    />
                  </b-form-group>
                </div>
                <div class="staff-allocation-filter">
                  <b-form-group label="Select Section">
                    <v-select
                      v-model="staffAllocSectionIDs"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="staffAllocSectionOptions"
                      :multiple="true"
                      :clearable="false"
                      label="section"
                      :reduce="(val) => val.id"
                      placeholder="All Sections"
                      @input="setStaffAllocSections"
                    />
                  </b-form-group>
                </div>
                <div class="staff-allocation-filter">
                  <b-form-group label="Select Subject">
                    <v-select
                      v-model="staffAllocSubjectIDs"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="filteredSubjectList"
                      :multiple="true"
                      :clearable="false"
                      label="subject"
                      :reduce="(val) => val.id"
                      placeholder="All Subjects"
                      @input="setStaffAllocSubjects"
                    />
                  </b-form-group>
                </div>
                <div class="staff-allocation-actions">
                  <b-button
                    variant="primary"
                    class="staff-allocation-action-btn"
                    :disabled="stLoading || request || lockChecking"
                    @click="showReport()"
                  >
                    <b-spinner
                      v-if="stLoading"
                      small
                      variant="light"
                      type="grow"
                      label="Spinning"
                    ></b-spinner>
                    <span v-else>Show</span>
                  </b-button>
                  <b-button
                    variant="primary"
                    class="staff-allocation-action-btn"
                    :disabled="staffAllocationExporting || request"
                    @click="exportStaffAllocationReport()"
                  >
                    <b-spinner
                      v-if="staffAllocationExporting"
                      small
                      variant="light"
                      type="grow"
                      label="Spinning"
                    ></b-spinner>
                    <span v-else>Export</span>
                  </b-button>
                </div>
              </div>
            </b-col>

            <!-- Terms & Conditions / Terms acknowledge filters (only for myskooliuss Students) -->
            <template
              v-if="
                (myObj.format === 'Terms & Conditions report' ||
                  myObj.format === 'Terms acknowledge report') &&
                reportDomain === 'myskooliuss'
              "
            >
              <!-- Campus dropdown (no All option) -->
              <b-col xl="2" lg="2" md="2" sm="12" cols="12" v-if="isHeadOffice">
                <b-form-group label="Campus" ref="termsAckCampus">
                  <v-select
                    v-model="appReportCampusID"
                    @input="getAppReportClasses()"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="campuses.filter((c) => c.id !== 0)"
                    :clearable="false"
                    label="branch"
                    :reduce="(val) => val.id"
                    placeholder="Select campus"
                  />
                </b-form-group>
              </b-col>
              <!-- Class dropdown -->
              <b-col xl="2" lg="2" md="2" sm="12" cols="12">
                <b-form-group label="Class" ref="termsAckClass">
                  <v-select
                    v-model="appReportClassID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="classesOptions"
                    :clearable="true"
                    label="name"
                    :reduce="(val) => val.id"
                    placeholder="All Classes"
                    @input="setSections()"
                  />
                </b-form-group>
              </b-col>
              <!-- Section dropdown -->
              <b-col xl="2" lg="2" md="2" sm="12" cols="12">
                <b-form-group label="Section" ref="termsAckSection">
                  <v-select
                    v-model="appReportSectionID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="admittedSections"
                    :clearable="true"
                    label="section"
                    :reduce="(val) => val.id"
                    placeholder="All Sections"
                  />
                </b-form-group>
              </b-col>
              <!-- Only show date+status for T&C report -->
              <b-col xl="2" lg="2" md="2" sm="12" cols="12">
                <b-form-group label="From Date" ref="appFromDate">
                  <flat-pickr
                    :config="singleConfig"
                    v-model="appReportFromDate"
                    class="form-control"
                    placeholder="Select from date"
                  />
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="2" sm="12" cols="12">
                <b-form-group label="To Date" ref="appToDate">
                  <flat-pickr
                    :config="singleConfig"
                    v-model="appReportToDate"
                    class="form-control"
                    placeholder="Select to date"
                  />
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="2" md="2" sm="12" cols="12">
                <b-form-group label="Status" ref="appStatus">
                  <v-select
                    v-model="appReportStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="['Agreed', 'Pending']"
                    :clearable="true"
                    placeholder="All Status"
                  />
                </b-form-group>
              </b-col>
            </template>

            <b-col
              cols="12"
              v-if="myObj.format === 'Class list verification'"
              class="mb-3 mt-1"
            >
              <div
                class="p-2 px-3 border rounded bg-white shadow-sm"
                style="border-left: 5px solid #7367f0 !important"
              >
                <div class="row align-items-start">
                  <!-- Select Columns Column -->
                  <div class="col-md-7">
                    <div class="d-flex align-items-center mb-1">
                      <div class="avatar avatar-sm bg-light-primary mr-50">
                        <div class="avatar-content p-25">
                          <feather-icon icon="GridIcon" size="14" />
                        </div>
                      </div>
                      <h6 class="font-weight-bolder mb-0 text-dark">
                        Data Columns to Show
                      </h6>
                    </div>
                    <div class="d-flex flex-wrap mt-1">
                      <div
                        v-for="opt in columnOptions"
                        :key="opt.value"
                        class="custom-control custom-checkbox mr-2 mb-1"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'col-' + opt.value"
                          :value="opt.value"
                          v-model="selectedCols"
                        />
                        <label
                          class="custom-control-label"
                          :for="'col-' + opt.value"
                          style="font-weight: 600; cursor: pointer"
                          >{{ opt.text }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <!-- Select Signatures Column -->
                  <div class="col-md-5 border-left">
                    <div class="d-flex align-items-center mb-1">
                      <div class="avatar avatar-sm bg-light-success mr-50">
                        <div class="avatar-content p-25">
                          <feather-icon icon="Edit3Icon" size="14" />
                        </div>
                      </div>
                      <h6 class="font-weight-bolder mb-0 text-dark">
                        Signature Lines
                      </h6>
                    </div>
                    <div class="d-flex flex-wrap mt-1">
                      <div
                        v-for="opt in signatureOptions"
                        :key="opt.value"
                        class="custom-control custom-checkbox mr-2 mb-1"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'sign-' + opt.value"
                          :value="opt.value"
                          v-model="selectedSigns"
                        />
                        <label
                          class="custom-control-label"
                          :for="'sign-' + opt.value"
                          style="font-weight: 600; cursor: pointer"
                          >{{ opt.text }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="2"
              sm="12"
              cols="12"
              v-if="
                ![
                  'Remaining Leaves',
                  'Leave Encashment',
                  'Advance & Loan',
                  'Jubilee Insurance',
                  'Staff Allocation',
                ].includes(myObj.format)
              "
            >
              <b-button
                variant="primary"
                class="mt-2"
                @click="showReport()"
                block
                :disabled="
                  stLoading ||
                  request ||
                  lockChecking ||
                  hierarchyLoading ||
                  appStatsLoading
                "
              >
                <b-spinner
                  v-if="stLoading || hierarchyLoading"
                  small
                  variant="light"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
                <span v-else>Show</span>
              </b-button>
            </b-col>

            <!-- New button for Remaining Leaves and Leave Encashment that opens modal directly -->
            <b-col
              xl="2"
              lg="2"
              md="2"
              sm="12"
              cols="12"
              v-if="
                [
                  'Remaining Leaves',
                  'Leave Encashment',
                  'Advance & Loan',
                ].includes(myObj.format)
              "
            >
              <b-button
                variant="primary"
                class="mt-2"
                @click="viewStaffReport()"
                block
                :disabled="leavesDataLoading"
              >
                <b-spinner
                  v-if="leavesDataLoading"
                  small
                  variant="light"
                  type="grow"
                  label="Spinning"
                ></b-spinner>
                <span v-else>View Report</span>
              </b-button>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                ![
                  'Remaining Leaves',
                  'Leave Encashment',
                  'Advance & Loan',
                  'Organization structure',
                  'Staff List Muster Roll',
                  'Staff List With Salary',
                  'Ledger (reconciled)',
                  'Class list verification',
                  'NTN Certificate',
                  'Staff Allocation',
                ].includes(myObj.format)
              "
            >
              <b-button
                variant="primary"
                :disabled="request || stLoading || lockChecking"
                class="mt-2"
                @click="exportReport()"
                block
              >
                <div
                  v-if="
                    request ||
                    (stLoading && myObj.format === 'Jubilee Insurance')
                  "
                >
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>Export</span>
              </b-button>
            </b-col>

            <b-col
              xl="2"
              lg="2"
              md="3"
              sm="12"
              cols="12"
              v-if="
                ['Staff Share', 'Staff Share Summary'].includes(myObj.format)
              "
            >
              <b-button
                variant="success"
                :disabled="
                  request ||
                  stLoading ||
                  lockLoading ||
                  lockChecking ||
                  isLocked
                "
                class="mt-2"
                @click="syncShare(true)"
                block
              >
                <div v-if="lockLoading || lockChecking">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ isLocked ? "Locked" : "Lock" }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>

    <!-- Modal for Remaining Leaves, Leave Encashment, and Advance & Loan -->
    <b-modal
      id="staff-leaves-modal"
      size="xl"
      scrollable
      modal-class="staff-leaves-modal"
      :hide-footer="true"
      :hide-header-close="false"
      body-class="p-0"
    >
      <!-- Custom Header -->
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100">
          <h5 class="mb-0">
            <feather-icon icon="UsersIcon" class="mr-2" />
            {{ modalTitle }} Report
          </h5>
          <div class="d-flex align-items-center">
            <b-button
              variant="outline-primary"
              size="sm"
              @click="printLeavesReport"
              class="mr-2"
              v-if="leavesData && leavesData.length > 0"
            >
              <feather-icon icon="PrinterIcon" class="mr-1" />
              Print Report
            </b-button>
            <b-button variant="outline-secondary" size="sm" @click="close()">
              <feather-icon icon="XIcon" />
            </b-button>
          </div>
        </div>
      </template>

      <!-- Modal Body -->
      <div>
        <!-- Report Header -->
        <div
          class="modal-report-header text-center p-4 mb-3"
          style="
            background-color: #f8f9fa !important;
            color: #212529 !important;
          "
        >
          <h2 class="text-white mb-2" style="color: #212529 !important">
            {{ modalTitle }} Report
          </h2>
          <p class="text-white-75 mb-1" style="color: #6c757d !important">
            Generated on
            {{
              new Date().toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </p>
          <div class="d-flex justify-content-center mt-3">
            <div class="px-3 border-right">
              <small
                class="text-white-75 d-block"
                style="color: #6c757d !important"
                >Total Records</small
              >
              <h4 class="text-white mb-0" style="color: #212529 !important">
                {{ leavesData.length }}
              </h4>
            </div>
            <div class="px-3" v-if="modalTitle === 'Leave Encashment'">
              <small
                class="text-white-75 d-block"
                style="color: #6c757d !important"
                >Total Encashment</small
              >
              <h4 class="text-white mb-0" style="color: #212529 !important">
                {{ formatCurrency(totalEncashment) }}
              </h4>
            </div>
          </div>
        </div>

        <div v-if="leavesDataLoading" class="text-center py-4">
          <b-spinner
            variant="primary"
            label="Loading..."
            class="mb-2"
          ></b-spinner>
          <p class="text-muted mb-0">Loading staff data...</p>
        </div>

        <div v-else-if="leavesData && leavesData.length > 0" class="px-2">
          <!-- Staff Details Table -->
          <div class="table-responsive">
            <!-- Custom table with grouped headers -->
            <table class="table table-striped table-hover table-sm mb-0">
              <thead>
                <tr>
                  <th class="text-center">S.NO</th>
                  <th class="text-center">RFID</th>
                  <th class="text-left">Staff Name</th>
                  <th class="text-left">Father Name</th>
                  <th class="text-left">Designation</th>
                  <th
                    v-if="modalTitle === 'STAFF LIST WITH SALARY'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Appointed On
                  </th>
                  <th
                    v-if="modalTitle === 'STAFF LIST MUSTER ROLL'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Muster Roll
                  </th>
                  <th
                    v-if="modalTitle === 'STAFF LIST WITH SALARY'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Salary
                  </th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    colspan="3"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Casual Leave
                  </th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    colspan="3"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Sick Leave
                  </th>
                  <th
                    v-if="modalTitle === 'Leave Encashment'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Leave Encashment
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    colspan="3"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Advance
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    colspan="3"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Loan
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    CL Allowed
                  </th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    CL
                  </th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Balance CL
                  </th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    SL Allowed
                  </th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    SL
                  </th>
                  <th
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Balance SL
                  </th>
                  <th
                    v-if="modalTitle === 'Leave Encashment'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Amount
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Total Advance
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Advance Returned
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Remaining Advance
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Total Loan
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Loan Returned
                  </th>
                  <th
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center"
                    style="
                      background-color: #e9ecef !important;
                      color: #212529 !important;
                    "
                  >
                    Remaining Loan
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in leavesData"
                  :key="index"
                  :class="index % 2 === 1 ? 'table-light' : ''"
                >
                  <td class="text-center font-weight-semibold">
                    {{ index + 1 }}
                  </td>
                  <td class="text-center font-weight-semibold text-primary">
                    {{ item.employeeCode || item.id || "N/A" }}
                  </td>
                  <td class="text-left font-weight-semibold">
                    {{ item.staffName || item.name }}
                  </td>
                  <td class="text-left text-muted">
                    {{ item.fatherName || item.father_name || "N/A" }}
                  </td>
                  <td class="text-left text-muted">
                    {{ item.designation || "N/A" }}
                  </td>
                  <!-- New Staff Report Columns -->
                  <td
                    v-if="modalTitle === 'STAFF LIST WITH SALARY'"
                    class="text-center font-weight-semibold text-info"
                  >
                    {{ formatDate(item.appointedOn) || "N/A" }}
                  </td>
                  <td
                    v-if="modalTitle === 'STAFF LIST MUSTER ROLL'"
                    class="text-center font-weight-bold text-primary"
                  >
                    {{ item.musterRoll || "Present" }}
                  </td>
                  <td
                    v-if="modalTitle === 'STAFF LIST WITH SALARY'"
                    class="text-center font-weight-bold text-success"
                  >
                    {{ formatCurrency(item.salary || 0) }}
                  </td>
                  <!-- Casual Leave Columns -->
                  <td
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                  >
                    {{ item.clAllowed || 0 }}
                  </td>
                  <td
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center font-weight-bold text-primary"
                  >
                    {{ item.totalLeaves || 0 }}
                  </td>
                  <td
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                  >
                    {{ item.clBalance || 0 }}
                  </td>
                  <!-- Sick Leave Columns -->
                  <td
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                  >
                    {{ item.slAllowed || 0 }}
                  </td>
                  <td
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center font-weight-bold text-warning"
                  >
                    {{ item.sickLeaves || 0 }}
                  </td>
                  <td
                    v-if="
                      modalTitle === 'Remaining Leaves' ||
                      modalTitle === 'Leave Encashment'
                    "
                    class="text-center"
                  >
                    {{ item.slBalance || 0 }}
                  </td>
                  <!-- Leave Encashment Column -->
                  <td
                    v-if="modalTitle === 'Leave Encashment'"
                    class="text-center font-weight-bold text-success"
                  >
                    {{ formatCurrency(item.encashmentAmount || 0) }}
                  </td>
                  <!-- Advance Columns -->
                  <td
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center font-weight-bold text-info"
                  >
                    {{
                      formatCurrency(
                        item.totalAdvance || item.advanceAmount || 0
                      )
                    }}
                  </td>
                  <td
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center font-weight-bold text-success"
                  >
                    {{ formatCurrency(item.advanceReturned || 0) }}
                  </td>
                  <td
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center font-weight-bold text-warning"
                  >
                    {{ formatCurrency(item.remainingAdvance || 0) }}
                  </td>
                  <!-- Loan Columns -->
                  <td
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center font-weight-bold text-secondary"
                  >
                    {{ formatCurrency(item.totalLoan || item.loanAmount || 0) }}
                  </td>
                  <td
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center font-weight-bold text-success"
                  >
                    {{ formatCurrency(item.loanReturned || 0) }}
                  </td>
                  <td
                    v-if="modalTitle === 'Advance & Loan'"
                    class="text-center font-weight-bold text-danger"
                  >
                    {{ formatCurrency(item.remainingLoan || 0) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else class="text-center py-4">
          <feather-icon
            icon="AlertCircleIcon"
            size="32"
            class="text-muted mb-2"
          />
          <h6 class="text-muted mb-1">No Data Available</h6>
          <small class="text-muted"
            >No staff data found for the selected criteria.</small
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
var axios = require("axios");
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BForm,
  BMediaAside,
  BSpinner,
  BSidebar,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
  BModal,
  BAvatar,
  VBTooltip,
  VBToggle,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { avatarText } from "@core/utils/filter";
import flatPickr from "vue-flatpickr-component";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";

import * as XLSX from "xlsx";
import {
  buildCampusTransferExcelRow,
  buildStaffCampusTransferExcelRow,
  buildStaffTransferReportUrl,
} from "@/utils/campusTransferReport";
import {
  buildFeeRevenueExcelRows,
  feeRevenueDateRange,
} from "@/utils/feeRevenueReport";
import {
  buildFeeStatusExcelRows,
  normalizeFeeStatusResponse,
} from "@/utils/feeStatusReport";
import { exportObjectsToExcel } from "@/utils/excelExport";
import {
  DRIVER_FEES_EXPORT_COLUMNS,
  buildDriverFeesExportRows,
} from "@/utils/driverFeesReport";
import {
  STAFF_ALLOCATION_EXPORT_COLUMNS,
  buildStaffAllocationGroups,
  flattenStaffAllocationRows,
} from "@/utils/staffAllocationReport";
import {
  fetchPlannerLogs,
  buildCampusSections,
  exportPlannerLogsWorkbookFile,
  describePlannerLogsRequestError,
} from "@/utils/plannerLogsReport";
import roleCoaAccessMixin from "@/mixins/roleCoaAccessMixin";
import {
  syncAccountCoaRestrictionsToStore,
  getRoleCoaRightsFromStore,
  getRoleAllowedCoaIds,
} from "@/utils/roleCoaAccess";

export default {
  mixins: [roleCoaAccessMixin],
  components: {
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BPagination,
    BSpinner,
    BModal,
    BAvatar,
    BMedia,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    flatPickr,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    syncAccountCoaRestrictionsToStore(
      this.$store,
      this.$store.state.loggedUser?.forms
    );
    const priorRights = { ...(this.$store.state.rights || {}) };
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
          reportTypes: ch.reportTypes,
          coaAccountIDs: ch.coaAccountIDs ||
            priorRights[ch.route]?.coaAccountIDs || [0],
        };
      });
    });
    const resolvedCoa = getRoleCoaRightsFromStore(this.$store);
    if (getRoleAllowedCoaIds(resolvedCoa)) {
      right.accounts = {
        ...(priorRights.accounts || right.accounts || {}),
        coaAccountIDs: resolvedCoa.coaAccountIDs,
      };
    }
    // console.log(right);
    this.$store.commit("setRights", { ...priorRights, ...right });

    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      // restrict for szablc
      if (this.reportDomain == "myskoolszablc") {
        this.typeOptions = this.typeOptions.filter((el) =>
          [
            "dcr",
            "defaulters",
            "Students",
            "Attendance",
            "Certificates",
          ].includes(el.value)
        );
      }

      if (this.rights.reportTypes && this.rights.reportTypes.length > 0) {
        this.typeOptions = this.typeOptions.filter((el) =>
          this.rights.reportTypes.includes(el.value)
        );
      }
      // restrict for szablc
      if (this.reportDomain == "myskoolszablc") {
        let ind = this.typeOptions.findIndex((el) => el.value == "Attendance");
        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Attendance");
          obj.format = ["Student"];
          this.typeOptions.splice(ind, 1, obj);
        }
      }
      // console.log(this.typeOptions, this.rights.reportTypes);

      this.myObj.type = this.typeOptions[0];

      // Initialize myObj with store values
      this.myObj.db = this.$store.state.userData.db;
      this.myObj.campusID = this.$store.state.userData.cId;

      if (["myskoolveritas"].includes(this.reportDomain)) {
        let ind = this.typeOptions.findIndex((el) => el.value == "defaulters");
        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "defaulters");
          obj.format.push("Challan Statement");
          this.typeOptions.splice(ind, 1, obj);
        }
      }

      // for smart pew only
      if (this.reportDomain == "myskoolsmartpew") {
        let ind = this.typeOptions.findIndex((el) => el.value == "Students");

        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Students");
          obj.format.push("Transport List");
          this.typeOptions.splice(ind, 1, obj);
        }
      }

      // for hpgs
      if (this.reportDomain == "myskoolhpgs") {
        let ind = this.typeOptions.findIndex(
          (el) => el.value == "Advance Accounts"
        );

        if (ind != -1) {
          let obj = this.typeOptions.find(
            (el) => el.value == "Advance Accounts"
          );
          obj.format.splice(2, 0, "Party Ledger", "SBU Ledger");
        }
      }

      // for skh
      if (this.reportDomain == "myskoolskh") {
        let ind = this.typeOptions.findIndex((el) => el.value == "dcr");
        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "dcr");
          obj.format.push("Staff Share", "Staff Share Summary");
          this.typeOptions.splice(ind, 1, obj);
        }
      }

      this.ensureCertificatesBarcodeFormat();

      // for ksa
      if (this.reportDomain == "myskoolksa") {
        let ind = this.typeOptions.findIndex((el) => el.value == "Students");

        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Students");
          obj.format.splice(9, 0, "Registration List");
        }
      }

      // for aisha bawani
      if (this.reportDomain == "myskoolaba") {
        this.LoadDiscountReferences();
        let ind = this.typeOptions.findIndex((el) => el.value == "Students");

        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Students");
          obj.format.splice(1, 0, "Class list 2");
          obj.format.splice(
            10,
            0,
            "Admission List - Unpaid",
            "Admission List - Paid",
            "Fees Concession Report",
            "Class Wise Concession Report",
            "Sibling Concession Report",
            "Department-wise Discount Report",
            "Discount Summary Report"
          );
        }
      }

      if (this.reportDomain == "myskoolroyal") {
        let ind = this.typeOptions.findIndex((el) => el.value == "Students");

        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Students");
          obj.format.splice(1, 0, "Student Details");
        }
      }

      if (this.reportDomain == "myskoolalhameed") {
        let ind = this.typeOptions.findIndex(
          (el) => el.value == "Certificates"
        );
        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Certificates");
          obj.format.push("Fee Card", "Acknowledgement Form");
          this.typeOptions.splice(ind, 1, obj);
        }

        let accInd = this.typeOptions.findIndex(
          (el) => el.value == "Advance Accounts"
        );
        if (accInd != -1) {
          let obj = this.typeOptions.find(
            (el) => el.value == "Advance Accounts"
          );
          obj.format.push("Daily Summary", "Monthly Summary", "Expense Report");
          this.typeOptions.splice(accInd, 1, obj);
        }
      }

      // Expense Report under Advance Accounts (same as Al Hameed)
      if (this.reportDomain == "myskoolbeprince") {
        let accInd = this.typeOptions.findIndex(
          (el) => el.value == "Advance Accounts"
        );
        if (accInd != -1) {
          let obj = this.typeOptions.find(
            (el) => el.value == "Advance Accounts"
          );
          if (!obj.format.includes("Expense Report")) {
            obj.format.push("Expense Report");
          }
          this.typeOptions.splice(accInd, 1, obj);
        }
      }

      // for myskool - add Ledger (reconciled) after Ledger
      if (this.reportDomain == "myskool") {
        let ind = this.typeOptions.findIndex(
          (el) => el.value == "Advance Accounts"
        );
        if (ind != -1) {
          let obj = this.typeOptions.find(
            (el) => el.value == "Advance Accounts"
          );
          let ledgerIndex = obj.format.findIndex((el) => el == "Ledger");
          if (ledgerIndex != -1) {
            obj.format.splice(ledgerIndex + 1, 0, "Ledger (reconciled)");
          }
        }
      }

      // for CPLC
      if (this.reportDomain == "myskoolcplc") {
        let ind = this.typeOptions.findIndex(
          (el) => el.value == "Advance Accounts"
        );
        if (ind != -1) {
          let obj = this.typeOptions.find(
            (el) => el.value == "Advance Accounts"
          );
          
          obj.format.push("Cash Flow Statement", "Cash Flow Expenses");
          this.typeOptions.splice(ind, 1, obj);
        }
      }

      // for Everest Gulshan
      if (["myskooleverestgulshan"].includes(this.reportDomain)) {
        let ind = this.typeOptions.findIndex(
          (el) => el.value == "Advance Accounts"
        );
        if (ind != -1) {
          let obj = this.typeOptions.find(
            (el) => el.value == "Advance Accounts"
          );
          obj.format.push("Accounts Summary");
          this.typeOptions.splice(ind, 1, obj);
        }
      }

      // for IUSS
      const isIussDomain =
        String(this.reportDomain || "")
          .replace(/_/g, "")
          .toLowerCase() === "myskooliuss";
      if (isIussDomain) {
        let ind = this.typeOptions.findIndex((el) => el.value == "Students");
        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Students");
          // Insert after Class list
          let classListIndex = obj.format.indexOf("Class list");
          if (classListIndex != -1) {
            obj.format.splice(classListIndex + 1, 0, "Class list verification");
          } else {
            obj.format.push("Class list verification");
          }
          const feeStatusIndex = obj.format.indexOf("Fee status");
          if (feeStatusIndex !== -1 && !obj.format.includes("Average fees")) {
            obj.format.splice(feeStatusIndex + 1, 0, "Average fees");
          }
          this.typeOptions.splice(ind, 1, obj);
        }

        let accInd = this.typeOptions.findIndex((el) => el.value == "Accounts");
        if (accInd != -1) {
          let accObj = this.typeOptions.find((el) => el.value == "Accounts");
          if (!accObj.format.includes("NTN Certificate")) {
            accObj.format.push("NTN Certificate");
          }
          this.typeOptions.splice(accInd, 1, accObj);
        }

        let dcrInd = this.typeOptions.findIndex((el) => el.value == "dcr");
        if (dcrInd != -1) {
          let dcrObj = this.typeOptions.find((el) => el.value == "dcr");
          if (!dcrObj.format.includes("Reconciliation fees")) {
            dcrObj.format.push("Reconciliation fees");
          }
          this.typeOptions.splice(dcrInd, 1, dcrObj);
        }
      }

      // Date wise strength — myskool, myskoolsmartdha, myskooliuss, myskoolprofectus, myskoolhpgs
      if (
        [
          "myskool",
          "myskoolsmartdha",
          "myskooliuss",
          "myskoolprofectus",
          "myskoolhpgs",
        ].includes(this.reportDomain)
      ) {
        let ind = this.typeOptions.findIndex((el) => el.value == "Students");
        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Students");
          if (!obj.format.includes("Date wise strength")) {
            const strengthIndex = obj.format.indexOf("Strength report");
            if (strengthIndex !== -1) {
              obj.format.splice(strengthIndex + 1, 0, "Date wise strength");
            } else {
              obj.format.push("Date wise strength");
            }
          }
          this.typeOptions.splice(ind, 1, obj);
        }
      }

      // Driver wise students — myskool, myskoolelixir, myskooliqradq
      if (this.isDriverReportDomain) {
        const ind = this.typeOptions.findIndex((el) => el.value == "Students");
        if (ind !== -1) {
          const obj = this.typeOptions.find((el) => el.value == "Students");
          if (!obj.format.includes("Driver wise students")) {
            const campusTransferIndex = obj.format.indexOf("Campus Transfer");
            if (campusTransferIndex !== -1) {
              obj.format.splice(
                campusTransferIndex + 1,
                0,
                "Driver wise students"
              );
            } else {
              obj.format.push("Driver wise students");
            }
          }
          this.typeOptions.splice(ind, 1, obj);
        }
      }

      if (["myskoolspirit"].includes(this.reportDomain)) {
        this.LoadDiscountReferences();
      }

      this.setFormat();
      // console.log(this.rights);
      await this.LoadSettings();
      this.LoadData();
      await this.loadAccounts();
      this.LoadCollectionLinks();
      this.loadSessions();
      this.loadExam();
      this.loadDeparts();
      this.loadConsent();
      this.LoadLeftCat();
      this.LoadSubjects();
      if (this.reportDomain == "myskoolhpgs") {
        this.LoadProjects();
        this.LoadVendors();
      } else if (
        this.reportDomain == "myskoolskh" ||
        this.reportDomain == "myskooliuss"
      ) {
        this.LoadStaff();
      }
    }
  },
  computed: {
    isAlhameedDomain() {
      const reportDomain = this.$store.state.report.replace(/_/g, "");
      return reportDomain === "myskoolalhameed";
    },
    isMyskoolstjacobDomain() {
      return (
        this.reportDomain === "myskoolstjacob" ||
        window.location.hostname === "myskoolstjacob.myskool.app"
      );
    },
    supportsStudentTurnoverReport() {
      return String(this.reportDomain || "").toLowerCase() === "myskooliuss";
    },
    dateWiseStrengthReportDomains() {
      return [
        "myskool",
        "myskoolsmartdha",
        "myskooliuss",
        "myskoolprofectus",
        "myskoolhpgs",
      ];
    },
    isDriverReportDomain() {
      return ["myskool", "myskoolelixir", "myskooliqradq"].includes(
        this.reportDomain
      );
    },
    // myskoolskh: Subject List uses report domain (List/Show) — see skh rpt / filter commits
    usesSubjectListDomainReport() {
      const domain = String(this.reportDomain || "")
        .replace(/_/g, "")
        .toLowerCase();
      const fromStore = String(this.$store.state.report || "")
        .replace(/_/g, "")
        .toLowerCase();
      return domain === "myskoolskh" || fromStore === "myskoolskh";
    },
    driverFeeFeeTypeValue: {
      get() {
        const selectedId = Number(this.driverFeeFeeTypeID) || 0;
        if (selectedId > 0) return selectedId;
        return this.getDefaultDriverFeeTypeID();
      },
      set(value) {
        this.driverFeeFeeTypeID = value;
      },
    },
    currentReportType() {
      return this.myObj && this.myObj.type ? this.myObj.type.value : "";
    },
    inquirySessionOptions() {
      const list = Array.isArray(this.sessions) ? this.sessions : [];
      const withoutAll = list.filter((s) => Number(s.id) !== 0);
      return [{ id: 0, session: "All Session" }, ...withoutAll];
    },
    // Filtered coaTypes - all accounts for Expense Report, no All for Ledger (reconciled)
    usesEtbBankCashCategory() {
      const domain = String(this.reportDomain || "")
        .replace(/_/g, "")
        .toLowerCase();
      return domain === "myskool" || domain === "myskoolfgs";
    },
    usesEtbMonthWiseFilter() {
      const domain = String(this.reportDomain || "")
        .replace(/_/g, "")
        .toLowerCase();
      return domain === "myskoolfgs";
    },
    filteredCoaTypes() {
      if (this.myObj.format === "Expense Report") {
        return [{ title: "All", id: 0, code: "" }, ...this.coaTypes];
      }
      let list = this.coaTypes;
      if (
        this.showLedgerBelongsFilter &&
        this.ledgerBelongsFilter !== "all" &&
        (this.myObj.format === "Ledger" ||
          this.myObj.format === "Ledger (reconciled)")
      ) {
        list = list.filter(
          (opt) =>
            opt.id !== 0 &&
            this.getAccountBelongsTo(opt) === this.ledgerBelongsFilter
        );
      }
      if (this.myObj.format === "Ledger (reconciled)") {
        return list.filter((opt) => opt.id !== 0);
      }
      return list;
    },
    coaReceivablePayableEnabled() {
      return this.isTruthySetting(this.coaReceivablePayableSetting);
    },
    showLedgerBelongsFilter() {
      if (!this.coaReceivablePayableEnabled) return false;
      if (this.myObj.type.value !== "Advance Accounts") return false;
      return (
        this.myObj.format === "Ledger" ||
        this.myObj.format === "Ledger (reconciled)"
      );
    },
    filteredCampuses() {
      // For Timetable report, remove the "All" (id: 0) option
      if (this.myObj.format === "Timetable") {
        return this.campuses.filter((c) => c.id !== 0);
      }
      return [{ id: 0, branch: "All" }, ...this.campuses];
    },
    filteredSubjectList() {
      const list = Array.isArray(this.subjectList) ? this.subjectList : [];
      const subjects = list.filter((item) => {
        const id = Number(item.id);
        const label = String(item.subject || item.name || "")
          .trim()
          .toLowerCase();
        return id !== 0 && label !== "all subjects";
      });
      return [{ subject: "All Subjects", id: 0 }, ...subjects];
    },
    staffAllocSectionOptions() {
      const classIDs = (this.staffAllocClassIDs || [])
        .filter((id) => id && id != 0)
        .map((id) => Number(id));
      const seen = new Set();
      const sections = [];

      (this.classes || []).forEach((entry) => {
        if (!entry || !entry.cls) return;
        if (classIDs.length && !classIDs.includes(Number(entry.cls.id))) return;
        (entry.sections || []).forEach((section) => {
          const name = String(section.section || section.name || "").trim();
          if (!name || seen.has(name.toLowerCase())) return;
          seen.add(name.toLowerCase());
          sections.push({ id: section.id, section: name });
        });
      });

      return [{ id: 0, section: "All Sections" }, ...sections];
    },
    filteredStaffList() {
      if (!["Subject List", "Timetable"].includes(this.myObj.format)) {
        return this.staffList;
      }
      const list = Array.isArray(this.staffList) ? this.staffList : [];
      const staff = list.filter((item) => {
        const id = Number(item.id);
        const label = String(item.name || item.staffName || "")
          .trim()
          .toLowerCase();
        return id !== 0 && label !== "all staff";
      });
      return [{ name: "All Staff", id: 0 }, ...staff];
    },
    filteredClasses() {
      if (
        this.myObj.format === "Student Email List" ||
        this.myObj.format === "Class list verification" ||
        this.myObj.format === "Subject Wise Fees"
      ) {
        return this.classesOptions.filter((c) => c.id !== 0);
      }
      return this.classesOptions;
    },
    filteredSections() {
      if (
        this.myObj.format === "Student Email List" ||
        this.myObj.format === "Class list verification" ||
        this.myObj.format === "Subject Wise Fees"
      ) {
        return this.admittedSections.filter((s) => s.id !== 0);
      }
      return this.admittedSections;
    },
    reportClassOptions() {
      return this.filteredClasses;
    },
    reportSectionOptions() {
      return this.filteredSections;
    },
    appStatsUserTypeLabel() {
      return this.resolvedAppStatsUserType === "staff" ? "Staff" : "Student";
    },
    appStatsStatusLabel() {
      const opt = this.appStatsStatusOptions.find(
        (item) => item.value === this.appStatsStatus
      );
      return opt ? opt.text : "—";
    },
    /** App Stats user type comes from report type: Students → student, Staff → staff */
    resolvedAppStatsUserType() {
      return this.currentReportType === "Staff" ? "staff" : "student";
    },
    appStatsListItems() {
      if (!this.downloadStats) return [];

      const isStaff = this.resolvedAppStatsUserType === "staff";
      const isActive = this.appStatsStatus === "active";

      if (isStaff) {
        return isActive
          ? this.downloadStats.activeStaffList || []
          : this.downloadStats.inactiveStaffList || [];
      }

      return isActive
        ? this.downloadStats.activeStudentsList || []
        : this.downloadStats.inactiveStudentsList || [];
    },
  },
  data() {
    return {
      rights: {},
      eTypee: "",
      formattedDate: new Date().toLocaleDateString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "long",
      }),
      accList: [],
      request: false,
      stLoading: false,
      lockLoading: false,
      dataLoading: false,
      showDate: false,
      typeOptions: [
        {
          text: "Collection Report",
          value: "dcr",
          format: [
            "Slip wise",
            "Slip range",
            "Class wise",
            "Fee categories wise",
            "Department wise",
            "Family wise",
            "Month wise",
            "Class and month wise",
            "Summary",
            // "Summary Details",
            "Exemption",
            "Fee Summary",
            "Fee Revenue",
          ],
        },
        {
          text: "Outstanding Report",
          value: "defaulters",
          format: [
            "Class wise",
            "Family wise",
            "Family head wise",
            "Family summary",
            "Department wise",
            "Summary",
            "Outstanding summary",
            "Monthly summary",
            "Deleted receipts",
            "Holded fees",
          ],
        },
        {
          text: "Students",
          value: "Students",
          format: [
            "Class list",
            "Fee status",
            "Fee projection",
            "Family wise fees status",
            "Free ship",
            "Discount Percentage",
            "GR Registered",
            "Strength report",
            "New admission",
            "Left students",
            "Fee Reminder",
            "Custom Fee Report",
            "Left Category wise",
            "Attendance list",
            "Housewise List",
            "Family List",
            "Discount list",
            "Missing contacts",
            "Consents",
            "Subject List",
            "Subject Wise Fees",
            "Student Email List",
            "Inquiry",
            "Visitors",
            "Event Calendar Report",
            "Campus Transfer",
            "App Stats",
          ],
        },
        {
          text: "Staff",
          value: "Staff",
          format: [
            "Staff List",
            "Staff List Date wise",
            "Staff List Muster Roll",
            "Staff List With Salary",
            "New staff list",
            "New staff left list",
            "Increment list",
            "File cover",
            "Staff Allocation",
            "Deposit List",
            "Remaining Leaves",
            "Leave Encashment",
            "Advance & Loan",
            "Organization structure",
            "Timetable",
            "Staff Campus Transfer",
            "App Stats",
          ],
        },
        {
          text: "Attendance",
          value: "Attendance",
          format: ["Student", "Staff"],
        },
        {
          text: "Accounts",
          value: "Accounts",
          format: [
            "Expense report",
            "Income report",
            "Closing report",
            "Cashbook",
            "Monthly Fee",
            "Estimation",
          ],
        },
        {
          text: "Advance Accounts",
          value: "Advance Accounts",
          format: [
            "General Journal",
            "Ledger",
            "Trial Balance",
            "Extended Trial Balance",
            "Income Statement",
            "Cash Flow",
            "Cheque Summary",
            "Balance Sheet",
          ],
        },
        {
          text: "Certificates",
          value: "Certificates",
          format: [
            "Admit card",
            "ID card",
            "Gate Pass",
            "Transfer",
            "Leaving",
            "Character",
            "Provisional",
            "Pickup card (Parent)",
            "Pickup card (Driver)",
          ],
        },
      ],

      statusOptions: [
        { text: "Present", value: "present" },
        { text: "Registered", value: "registered" },
        { text: "Left", value: "left" },
      ],
      statusOptionsWithSuspend: [
        { text: "Present", value: "present" },
        { text: "Registered", value: "registered" },
        { text: "Left", value: "left" },
        { text: "Suspended", value: "suspended" },
      ],
      feePaymentStatus: "",
      feePaymentStatusOptions: [
        { text: "All", value: "" },
        { text: "Paid", value: "paid" },
        { text: "Unpaid", value: "unpaid" },
      ],
      staffStOptions: [
        { text: "Working", value: "present" },
        { text: "Applicant", value: "applicant" },
        { text: "Left", value: "left" },
      ],
      classID: [0],
      secID: [0],
      feeTypes: [],
      classes: [],
      classesOptions: [{ name: "All Classes", id: 0 }],
      admittedSections: [{ section: "All Sections", id: 0 }],
      dClasses: [],
      dClassOptions: [],
      fields: [
        { label: "Name", key: "name" },
        { key: "actions", label: "actions" },
      ],
      studentSearchQuery: "",
      filteredStudentOptions: [],
      studentSearchLoading: false,
      searchTimeout: null,
      rangeDate: null,
      singleDate: new Date().toJSON().split("T")[0],
      myObj: {
        id: 0,
        type: { value: "", text: "" },
        dtfrom: "",
        dtto: "",
        classIDs: [],
        secIDs: [],
        db: "",
        campusID: 0,
        format: "",
        months: [],
        feesTypeIDs: [],
        status: "present",
        accIDs: [],
        year: 0,
        account: 0,
        sessionID: 0,
        depID: [],
        balance: 0,
        consent: "",
        leftCategory: "All",
        staffStatus: "present",
        vendorID: 0,
        projectID: 0,
        subjectID: 0,
        staffID: 0,
        search: "",
      },
      disPerc: 0,
      staffDeparts: [],
      staffDepID: [0],
      // Staff Allocation filters (passed to the custom report page)
      staffAllocClassIDs: [0],
      staffAllocSectionIDs: [0],
      staffAllocSubjectIDs: [0],
      staffAllocationExporting: false,
      loanReportType: "loan",
      loanReportTypeOptions: [
        { text: "Loan", value: "loan" },
        { text: "Advance", value: "advance" },
        { text: "All (Loan & Advance)", value: "all" },
      ],
      campusTransferType: "",
      campusTransferTypeOptions: [
        { text: "All", value: "" },
        { text: "Campus", value: "campus" },
        { text: "Inner", value: "inner" },
      ],
      eventCalendarEventFor: "Students",
      eventCalendarEventForOptions: [
        { text: "Students", value: "Students" },
        { text: "Staff", value: "Staff" },
      ],
      incrementYear: null,
      incrementFrom: "",
      incrementTo: "",
      incrementRange: [],
      yearOptions: [
        2030, 2029, 2028, 2027, 2026, 2025, 2024, 2023, 2022, 2021, 2020,
        2019, 2018, 2017, 2016, 2015,
      ],
      formatOptions: [],
      slipFrom: 0,
      slipTo: 0,
      fiscalYears: [],
      selectedFiscalYearID: null,
      customFeeTypeID: 0,
      customFeeMonth: 0,

      // Modal data for remaining leaves and leave encashment
      modalTitle: "",
      leavesData: [],
      leavesDataLoading: false,

      // Hierarchy data
      hierarchyLoading: false,
      hierarchyData: [],

      appStatsUserType: "student",
      appStatsStatus: "active",
      appStatsUserTypeOptions: [
        { text: "Student", value: "student" },
        { text: "Staff", value: "staff" },
      ],
      appStatsStatusOptions: [
        { text: "Active", value: "active" },
        { text: "Inactive", value: "inactive" },
      ],
      downloadStats: null,
      appStatsLoading: false,

      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      singleConfig: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "single",
      },
      jDate: null,
      accTypes: [],
      coaTypes: [],
      coaReceivablePayableSetting: null,
      ledgerBelongsFilter: "all",
      ledgerBelongsFilterOptions: [
        { text: "All", value: "all" },
        { text: "Receivable", value: "accounts_receivable" },
        { text: "Payable", value: "accounts_payable" },
      ],
      coa: 0,
      etbCategoryFilter: "all",
      etbCategoryOptions: [
        { text: "All", value: "all" },
        { text: "Bank Account", value: "bank_account" },
        { text: "Cash Account", value: "cash_account" },
      ],
      etbMonthFrom: 1,
      etbMonthTo: new Date().getMonth() + 1,
      etbYear: new Date().getFullYear(),
      dateVisible: [
        "Staff",
        "Student",
        "Inquiry",
        "Visitors",
        "Discount report",
        "Cancelled slips",
        "Deleted fee",
        "New admission",
        "Registration List",
        "Admission List - Unpaid",
        "Admission List - Paid",
        "Left students",
        "Expense report",
        "Expense Report",
        "Income report",
        "Closing report",
        "Cashbook",
        "General Journal",
        "Ledger",
        "Ledger (reconciled)",
        "Trial Balance",
        "Extended Trial Balance",
        "Income Statement",
        "Cash Flow",
        "Outstanding summary",
        "Cheque Summary",
        "Staff List Date wise",
        "Party Ledger",
        "SBU Ledger",
        "SBU Ledger",
        "Cash Flow Statement",
        "Cash Flow Expenses",
        "Planner Logs",
        "Monthly Summary",
        "Accounts Summary",
        "Left Category wise",
        "Event Calendar Report",
        "Campus Transfer",
        "Staff Campus Transfer",
      ],
      statusVisible: [
        "Class list",
        "Student Details",
        "Housewise List",
        "Family List",
        "Subject List",
        "Student Email List",
        "Class list verification",
        "Class list 2",
        "Transport List",
      ],
      singleVisible: [
        "Outstanding summary",
        "Monthly summary",
        "Monthly Fee",
        "Estimation",
        "Challan Issued",
        "Monthly Issued",
        "Annual Issued",
        "Fee Summary",
        "Fee Revenue",
      ],
      singleDtVisible: ["Daily Summary", "Date wise strength"],
      campusVisible: ["challan-report", "Students"],
      suspendVisible: ["Class list"],
      genderVisible: ["myskoolalhameed"],
      genders: [
        { text: "All", value: "" },
        { text: "Male", value: "male" },
        { text: "Female", value: "female" },
      ],
      selectedGender: "",
      examType: [],
      sessions: [],
      subjectFeeSessionID: 0,
      departments: [],
      selectedDep: 0,
      reconciliationReportStatus: "all",
      reconciliationReportStatusOptions: [{ text: "All", value: "all" }],
      singleMonth: new Date().getMonth() + 1,
      monthsSOptions: [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" },
      ],
      singleYear: new Date().getFullYear(),
      turnoverYear: new Date().getFullYear(),
      turnoverMonthFrom: 1,
      turnoverMonthTo: new Date().getMonth() + 1,
      driverReportDriverID: "all",
      driverReportOptions: [],
      driverReportOptionsLoading: false,
      driverFeeMonth: 0,
      driverFeeYear: 0,
      driverFeeStatus: "all",
      driverFeeStatusOptions: [
        { text: "All", value: "all" },
        { text: "Paid", value: "paid" },
        { text: "Unpaid", value: "unpaid" },
      ],
      driverFeeFeeTypeID: 0,
      driverFeeRange: null,
      driverFeeFrom: "",
      driverFeeTo: "",
      ntnFromMonth: 7,
      ntnFromYear:
        new Date().getMonth() + 1 >= 7
          ? new Date().getFullYear()
          : new Date().getFullYear() - 1,
      ntnToMonth: 6,
      ntnToYear:
        new Date().getMonth() + 1 >= 7
          ? new Date().getFullYear() + 1
          : new Date().getFullYear(),
      yearSOptions: [
        { id: 2020, title: "2020" },
        { id: 2021, title: "2021" },
        { id: 2022, title: "2022" },
        { id: 2023, title: "2023" },
        { id: 2024, title: "2024" },
        { id: 2025, title: "2025" },
        { id: 2026, title: "2026" },
        { id: 2027, title: "2027" },
        { id: 2028, title: "2028" },
        { id: 2029, title: "2029" },
        { id: 2030, title: "2030" },
      ],
      lastYears: [
        { id: 0, title: "All" },
        { id: 2020, title: "2020" },
        { id: 2021, title: "2021" },
        { id: 2022, title: "2022" },
        { id: 2023, title: "2023" },
        { id: 2024, title: "2024" },
        { id: 2025, title: "2025" },
        { id: 2026, title: "2026" },
        { id: 2027, title: "2027" },
        { id: 2028, title: "2028" },
        { id: 2029, title: "2029" },
        { id: 2030, title: "2030" },
      ],
      showAll: false,
      months: [
        { id: 1, name: "Jan" },
        { id: 2, name: "Feb" },
        { id: 3, name: "Mar" },
        { id: 4, name: "Apr" },
        { id: 5, name: "May" },
        { id: 6, name: "Jun" },
        { id: 7, name: "Jul" },
        { id: 8, name: "Aug" },
        { id: 9, name: "Sep" },
        { id: 10, name: "Oct" },
        { id: 11, name: "Nov" },
        { id: 12, name: "Dec" },
      ],
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      monthFrom: 0,
      yearFrom: 0,
      monthTill: 0,
      yearTill: 0,
      dateRange: [],
      consentList: [],
      leftOptions: [],
      subjectList: [],
      dueObj: null,
      campuses: [],
      showBankReport: null,
      isHeadOffice: null,
      isDistinct: false,
      projectList: [],
      vendorList: [],
      staffList: [],
      selectedCols: ["Sr#", "GR#", "Student Name", "Father Name", "Remarks"],
      selectedSigns: ["Admission Officer", "Class Teacher", "Campus Head"],
      columnOptions: [
        { text: "Sr#", value: "Sr#" },
        { text: "GR#", value: "GR#" },
        { text: "Student Name", value: "Student Name" },
        { text: "Father Name", value: "Father Name" },
        { text: "Remarks", value: "Remarks" },
      ],
      signatureOptions: [
        { text: "Admission Officer", value: "Admission Officer" },
        { text: "Class Teacher", value: "Class Teacher" },
        { text: "Campus Head", value: "Campus Head" },
      ],
      lockChecking: false,
      isLocked: false,
      collectionLinks: [],
      newLedgerSetting: null,
      // App report / Terms filters for myskooliuss
      appReportFromDate: "",
      appReportToDate: "",
      appReportClassID: null,
      appReportSectionID: null,
      appReportCampusID: null,
      appReportStatus: "",
      disRefList: [],
      selectedDisRef: 0,
      feeConcessionOrientation: "landscape",
      feeConcessionOrientationOptions: [
        { text: "Landscape", value: "landscape" },
        { text: "Portrait", value: "portrait" },
      ],
      barcodeObj: {
        prefix: "",
        start: 0,
        end: 0,
      },
    };
  },
  watch: {
    modalTitle: {
      handler(newTitle, oldTitle) {
        // Force table re-render by updating a reactive property
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      immediate: true,
    },
    // "myObj.format"(newVal) {
    //   // Reset coa when format changes to "Ledger (reconciled)"
    //   if (newVal === "Ledger (reconciled)") {
    //     // If coa is an array (from multiple select), take first value or reset
    //     if (Array.isArray(this.coa)) {
    //       this.coa =
    //         this.coa.length > 0 && this.coa[0] !== 0 ? this.coa[0] : null;
    //     }
    //     // If coa is "All" (id: 0), reset it
    //     if (this.coa === 0) {
    //       this.coa = null;
    //     }
    //   }
    // },
  },
  methods: {
    ensureCertificatesBarcodeFormat() {
      const domains = ["myskoolskh", "myskoolstjacob", "myskool"];
      if (!domains.includes(this.reportDomain)) return;
      const ind = this.typeOptions.findIndex((el) => el.value === "Certificates");
      if (ind === -1) return;
      const obj = this.typeOptions.find((el) => el.value === "Certificates");
      if (!obj || !Array.isArray(obj.format)) return;
      if (!obj.format.includes("Barcode")) {
        obj.format.push("Barcode");
      }
      this.typeOptions.splice(ind, 1, obj);
    },

    setIncrementRange() {
      try {
        if (!this.incrementRange) return;
        // Support both array [from, to] and string "YYYY-MM-DD to YYYY-MM-DD"
        if (Array.isArray(this.incrementRange)) {
          this.incrementFrom =
            this.formatYMD(this.incrementRange[0]) || this.incrementFrom;
          this.incrementTo =
            this.formatYMD(this.incrementRange[1]) || this.incrementTo;
        } else if (typeof this.incrementRange === "string") {
          const d = this.incrementRange.split(" to ");
          this.incrementFrom = d[0] || this.incrementFrom;
          this.incrementTo = d[1] || this.incrementTo;
        }
      } catch (e) {
        // fail silently
      }
    },
    formatYMD(val) {
      if (!val) return "";
      if (typeof val === "string") return val;
      try {
        const d = new Date(val);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      } catch (_) {
        return "";
      }
    },
    getYearRange() {
      if (!this.incrementFrom || !this.incrementTo) return "";
      try {
        const fromYear = new Date(this.incrementFrom).getFullYear();
        const toYear = new Date(this.incrementTo).getFullYear();
        if (fromYear === toYear) {
          return `${fromYear}`;
        } else {
          return `${fromYear}-${String(toYear).slice(-2)}`;
        }
      } catch (_) {
        return "";
      }
    },
    ...mapActions({
      get: "get",
      post: "post",
      postObj: "postObj",
      put: "put",
      delete: "delete",
    }),

    generateDateRange() {
      // Parse the start and end dates
      const start = new Date(
        `${this.yearFrom}-${String(this.monthFrom).padStart(
          2,
          "0"
        )}-01T10:30:00`
      );
      // const start = new Date("2024-02-20T10:30:00");
      const end = new Date(
        `${this.yearTill}-${String(this.monthTill).padStart(
          2,
          "0"
        )}-01T10:30:00`
      );
      // console.log(start, end);

      // Initialize the result array
      this.dateRange = [];
      // Loop through each month and year within the range
      let currentDate = new Date(start);
      while (currentDate <= end) {
        // Format the current date as "Month-Year" with a hyphen
        const formattedDate = `${currentDate.toLocaleString("en-US", {
          month: "short",
        })}-${currentDate.getFullYear()}`;

        // Add the formatted date to the result array
        this.dateRange.push(formattedDate);

        // Move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
      }
      // console.log(this.dateRange);
    },
    clearRange() {
      this.monthFrom = 0;
      this.yearFrom = 0;
      this.monthTill = 0;
      this.yearTill = 0;
      this.dateRange = [];
    },

    checkYear() {
      if (
        this.myObj.type.value == "defaulters" ||
        this.myObj.type.value == "dcr"
      ) {
        // var elem = this.$refs["yearD"];
        // if (this.myObj.year == "") {
        //   return (elem.state = false);
        // } else {
        //   return (elem.state = true);
        // }
      } else return true;
    },
    checkSingleMonth() {
      if (this.singleVisible.includes(this.myObj.format)) {
        var elem = this.$refs["sMonth"];
        if (this.singleMonth == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkSingleYear() {
      if (this.singleVisible.includes(this.myObj.format)) {
        var elem = this.$refs["year"];
        if (!this.singleYear) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckDepartment() {
      if (this.myObj.format == "Monthly summary") {
        var elem = this.$refs["departs"];
        if (this.myObj.depID.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckFee() {
      if (this.myObj.format == "Monthly summary") {
        var elem = this.$refs["feetype"];
        if (this.myObj.feesTypeIDs.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkBalance() {
      if (
        this.myObj.type.value == "defaulters" &&
        (this.myObj.format == "Class wise" ||
          this.myObj.format == "Family wise")
      ) {
        var elem = this.$refs["balance"];
        var re = /^[0-9]+$/;
        let x = parseInt(this.myObj.balance);
        if (!re.test(this.myObj.balance) || isNaN(x) || x < 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkPerc() {
      if (this.myObj.format == "Discount Percentage") {
        var elem = this.$refs["perc"];
        var re = /^[0-9]+$/;
        let x = parseInt(this.disPerc);
        if (!re.test(this.disPerc) || isNaN(x) || x < 0 || x > 100) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckType() {
      var elem = this.$refs["type"];
      if (this.myObj.type == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    syncAppStatsUserTypeFromReport() {
      this.appStatsUserType =
        this.currentReportType === "Staff" ? "staff" : "student";
    },
    setFormat() {
      // console.log(this.myObj.type);
      if (this.myObj.type.format.length > 0) {
        this.formatOptions = this.myObj.type.format;
        this.myObj.format = this.formatOptions[0];
      } else {
        this.formatOptions = [];
        this.myObj.format = "";
      }

      // Add Jubilee Insurance and Planner Logs format for myskooliuss domain when Staff type is selected
      if (
        this.reportDomain.toLowerCase() === "myskooliuss" &&
        this.myObj.type.value === "Staff"
      ) {
        if (!this.formatOptions.includes("Jubilee Insurance")) {
          this.formatOptions.push("Jubilee Insurance");
        }
        if (!this.formatOptions.includes("Planner Logs")) {
          this.formatOptions.push("Planner Logs");
        }
      }

      // NTN Certificate — myskooliuss Accounts
      if (
        this.reportDomain.toLowerCase() === "myskooliuss" &&
        this.myObj.type.value === "Accounts"
      ) {
        if (!this.formatOptions.includes("NTN Certificate")) {
          this.formatOptions.push("NTN Certificate");
        }
      } else if (this.myObj.format === "NTN Certificate") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      // Reconciliation fees — myskooliuss Collection Report
      if (
        this.reportDomain.toLowerCase() === "myskooliuss" &&
        this.myObj.type.value === "dcr"
      ) {
        if (!this.formatOptions.includes("Reconciliation fees")) {
          this.formatOptions.push("Reconciliation fees");
        }
      } else if (this.myObj.format === "Reconciliation fees") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      // Add Terms & Conditions report format for myskooliuss domain when Students type is selected
      if (
        this.reportDomain.toLowerCase() === "myskooliuss" &&
        this.myObj.type.value === "Students"
      ) {
        if (!this.formatOptions.includes("Terms & Conditions report")) {
          this.formatOptions.push("Terms & Conditions report");
        }
        if (!this.formatOptions.includes("Terms acknowledge report")) {
          this.formatOptions.push("Terms acknowledge report");
        }
        const feeStatusIdx = this.formatOptions.indexOf("Fee status");
        if (
          feeStatusIdx !== -1 &&
          !this.formatOptions.includes("Average fees")
        ) {
          this.formatOptions.splice(feeStatusIdx + 1, 0, "Average fees");
        } else if (
          feeStatusIdx === -1 &&
          !this.formatOptions.includes("Average fees")
        ) {
          this.formatOptions.push("Average fees");
        }
      } else if (this.myObj.format === "Average fees") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      // Student turnover — myskooliuss only
      if (
        this.supportsStudentTurnoverReport &&
        this.myObj.type.value === "Students"
      ) {
        if (!this.formatOptions.includes("Student turnover")) {
          this.formatOptions.push("Student turnover");
        }
      } else if (this.myObj.format === "Student turnover") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      // Event Calendar Report — all domains (Students report type)
      if (this.myObj.type.value === "Students") {
        if (!this.formatOptions.includes("Event Calendar Report")) {
          this.formatOptions.push("Event Calendar Report");
        }
      }

      // Date wise strength
      if (
        this.dateWiseStrengthReportDomains.includes(this.reportDomain) &&
        this.myObj.type.value === "Students"
      ) {
        if (!this.formatOptions.includes("Date wise strength")) {
          this.formatOptions.push("Date wise strength");
        }
      } else if (this.myObj.format === "Date wise strength") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      if (
        this.isDriverReportDomain &&
        this.myObj.type.value === "Students"
      ) {
        if (!this.formatOptions.includes("Driver wise students")) {
          this.formatOptions.push("Driver wise students");
        }
      } else if (this.myObj.format === "Driver wise students") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      // Driver fees — Collection Report
      if (this.myObj.type.value === "dcr") {
        if (!this.formatOptions.includes("Driver fees")) {
          this.formatOptions.push("Driver fees");
        }
      } else if (this.myObj.format === "Driver fees") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      // Pending Fees — myskool St. Jacob only
      if (this.isMyskoolstjacobDomain && this.myObj.type.value === "Students") {
        if (!this.formatOptions.includes("Pending Fees")) {
          this.formatOptions.push("Pending Fees");
        }
      } else if (this.myObj.format === "Pending Fees") {
        this.myObj.format = this.formatOptions[0] || "";
      }

      if (this.myObj.format === "Student turnover") {
        if (!this.turnoverYear) {
          this.turnoverYear = new Date().getFullYear();
        }
        if (!this.turnoverMonthFrom) {
          this.turnoverMonthFrom = 1;
        }
        if (!this.turnoverMonthTo) {
          this.turnoverMonthTo = new Date().getMonth() + 1;
        }
      }

      this.setDateOption();

      // reset to present if not suspend visible
      if (!this.suspendVisible.includes(this.myObj.format)) {
        this.myObj.status = "present";
      }

      if (
        this.myObj.format !== "Class list" ||
        this.myObj.status !== "registered"
      ) {
        this.feePaymentStatus = "";
      }

      if (
        this.isMyskoolIussDomain() &&
        (this.myObj.format === "Fee status" ||
          this.myObj.format === "Average fees") &&
        this.isHeadOffice &&
        (!this.myObj.campusID || Number(this.myObj.campusID) === 0)
      ) {
        this.myObj.campusID = this.$store.state.userData.cId;
      }

      // reset campusid selection if head office and not in campus visible
      if (
        this.isHeadOffice &&
        !this.campusVisible.includes(this.myObj.type.value) &&
        this.myObj.format !== "Campus Transfer" &&
        this.myObj.format !== "Staff Campus Transfer"
      ) {
        if (
          this.myObj.format == "Planner Logs" ||
          this.myObj.format == "Timetable"
        ) {
          this.myObj.campusID = 0;
        } else {
          this.myObj.campusID = this.$store.state.userData.cId;
        }
      }

      if (this.myObj.format === "Student Email List") {
        this.myObj.classIDs = null;
        this.myObj.secIDs = null;
        this.classID = null;
        this.secID = null;
        this.admittedSections = [];
      }

      if (this.myObj.format === "Subject Wise Fees") {
        this.myObj.search = "";
        this.studentSearchQuery = "";
        this.filteredStudentOptions = [];
        this.selectedDep = 0;
        this.setClasses();
        this.$nextTick(() => {
          const firstClass = this.classesOptions.find((c) => c.id !== 0);
          if (firstClass) {
            this.classID = firstClass.id;
            this.FillSections();
            this.$nextTick(() => {
              const firstSec = this.admittedSections.find((s) => s.id !== 0);
              this.secID = firstSec ? firstSec.id : null;
            });
          } else {
            this.classID = null;
            this.secID = null;
            this.admittedSections = [];
          }
        });
      }

      if (
        this.myObj.format === "Campus Transfer" ||
        this.myObj.format === "Staff Campus Transfer"
      ) {
        this.myObj.classIDs = null;
        this.myObj.secIDs = null;
        this.classID = null;
        this.secID = null;
        this.admittedSections = [];
        this.campusTransferType = "";
        if (this.isHeadOffice) {
          this.myObj.campusID = 0;
        }
      }

      if (
        this.myObj.format === "Fee Reminder" ||
        this.myObj.format === "Fees Concession Report" ||
        this.myObj.format === "Class Wise Concession Report" ||
        this.myObj.format === "Sibling Concession Report" ||
        this.myObj.format === "Custom Fee Report" ||
        this.myObj.format === "Subject Wise Fees" ||
        this.myObj.format === "Pending Fees" ||
        this.myObj.format === "Terms acknowledge report"
      ) {
        this.selectedDep = 0;
        this.setClasses();
      }

      if (
        (this.myObj.format === "Fees Concession Report" ||
          this.myObj.format === "Class Wise Concession Report" ||
          this.myObj.format === "Sibling Concession Report") &&
        this.reportDomain === "myskoolaba" &&
        !this.disRefList.length
      ) {
        this.LoadDiscountReferences();
      }

      if (this.myObj.format === "Event Calendar Report") {
        this.eventCalendarEventFor = "Students";
        this.staffDepID = 0;
      }

      if (
        this.myObj.format === "Advance & Loan" &&
        this.reportDomain === "myskoolaba"
      ) {
        this.staffDepID = Array.isArray(this.staffDepID)
          ? this.staffDepID[0] || 0
          : this.staffDepID || 0;
        if (!this.loanReportType) {
          this.loanReportType = "loan";
        }
      }

      if (this.myObj.format === "App Stats") {
        this.syncAppStatsUserTypeFromReport();
        this.appStatsStatus = "active";
      }

      if (["Inquiry", "Visitors"].includes(this.myObj.format)) {
        this.loadSessions().then(() => {
          const currentSession = (this.sessions || []).find(
            (session) => session.isCurrentSession
          );
          if (currentSession) {
            this.myObj.sessionID = currentSession.id;
          }
        });
      }
    },
    setDateOption() {
      // console.log(this.myObj.format);
      if (
        (this.myObj.type.value == "dcr" ||
          this.dateVisible.includes(this.myObj.format)) &&
        ![
          "Slip range",
          "Fee Summary",
          "Remaining Leaves",
          "Leave Encashment",
          "Advance & Loan",
          "App Stats",
          "Fee Revenue",
          "NTN Certificate",
          "Driver fees",
        ].includes(this.myObj.format)
      ) {
        this.showDate = true;
      } else {
        this.showDate = false;
      }

      if (
        (this.myObj.format == "Attendance list" &&
          this.$store.state.currentBranch.organizationType == "coaching") ||
        (this.myObj.format == "Class list" &&
          this.$store.state.currentBranch.organizationType == "coaching")
      ) {
        this.myObj.sessionID = this.sessions.find(
          (el) => el.isCurrentSession
        ).id;
      }

      if (this.myObj.format == "Monthly summary") {
        this.myObj.feesTypeIDs = [];
      }

      if (
        this.myObj.type.value == "Advance Accounts" &&
        this.myObj.format == "Balance Sheet"
      ) {
        this.loadFiscalYears();
      }

      if (this.myObj.format === "Expense Report") {
        this.coa = 0;
      }

      if (
        this.myObj.format === "Ledger" ||
        this.myObj.format === "Ledger (reconciled)"
      ) {
        this.ledgerBelongsFilter = "all";
      }

      if (this.myObj.format === "Extended Trial Balance") {
        this.etbCategoryFilter = "all";
        if (this.usesEtbMonthWiseFilter) {
          const now = new Date();
          this.etbYear = now.getFullYear();
          this.etbMonthFrom = 1;
          this.etbMonthTo = now.getMonth() + 1;
        }
      }

      // on format change
      this.checkLock();

      if (["Subject List", "Timetable"].includes(this.myObj.format)) {
        if (
          this.usesSubjectListDomainReport &&
          this.myObj.format === "Subject List"
        ) {
          this.selectedDep = 0;
          this.setClasses();
          this.myObj.subjectID = 0;
          this.myObj.staffID = 0;
          this.LoadStaff();
        } else {
          this.initSubjectStaffFilters();
        }
      }

      this.initDriverWiseStudentsFilters();
      this.initDriverFeesFilters();
    },
    checkExam() {
      if (this.myObj.format == "Admit card") {
        var elem = this.$refs["exType"];
        if (this.eTypee == "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkSession() {
      if (
        this.myObj.format == "Admit card" ||
        this.myObj.format == "ID card" ||
        (this.myObj.format == "Attendance list" &&
          this.$store.state.currentBranch.organizationType == "coaching") ||
        (this.myObj.format == "Class list" &&
          this.$store.state.currentBranch.organizationType == "coaching")
      ) {
        var elem = this.$refs["session"];
        if (this.myObj.sessionID == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else if (
        this.myObj.format === "Inquiry" ||
        this.myObj.format === "Visitors"
      ) {
        // 0 = All Session is allowed
        var sessionRef = this.$refs["session"];
        if (
          this.myObj.sessionID === null ||
          this.myObj.sessionID === undefined ||
          this.myObj.sessionID === ""
        ) {
          return sessionRef ? (sessionRef.state = false) : false;
        }
        return sessionRef ? (sessionRef.state = true) : true;
      } else return true;
    },
    CheckCons() {
      if (this.myObj.format == "Consents") {
        var elem = this.$refs["cons"];
        if (this.myObj.consent == "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },

    CheckStatus() {
      if (this.myObj.status !== "registered") {
        this.feePaymentStatus = "";
      }

      if (
        this.statusVisible.includes(this.myObj.format) ||
        (this.myObj.type.value == "defaulters" &&
          !this.singleVisible.includes(this.myObj.format) &&
          this.myObj.format != "Summary")
      ) {
        var elem = this.$refs["status"];
        if (this.myObj.status == "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckFormat() {
      // console.log(this.myObj.format);
      var elem = this.$refs["format"];
      if (this.myObj.format == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckAccount() {
      if (
        this.myObj.type.value == "dcr" &&
        ![
          "Exemption",
          "Fee Summary",
          "Summary Details",
          "Fee Revenue",
          "Reconciliation fees",
          "Driver fees",
        ].includes(this.myObj.format)
      ) {
        // console.log(this.myObj.account);
        var elem = this.$refs["acc"];
        if (this.myObj.account == null) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkMultiAccounts() {
      if (this.myObj.type.value == "Accounts") {
        // console.log(this.myObj.account);
        var elem = this.$refs["accounts"];
        if (this.accList.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkAccountYear() {
      if (this.myObj.year[this.myObj.year.length - 1] == 0) {
        this.myObj.year = [0];
      } else {
        this.myObj.year = this.myObj.year.filter((el) => el != 0);
      }
    },
    CheckDate() {
      if (
        this.myObj.format === "Extended Trial Balance" &&
        this.usesEtbMonthWiseFilter
      ) {
        return this.checkEtbMonthFilter();
      }
      if (
        this.myObj.format === "Event Calendar Report" ||
        this.myObj.format === "Campus Transfer" ||
        this.myObj.format === "Staff Campus Transfer"
      ) {
        if (this.myObj.dtfrom && this.myObj.dtto) {
          return new Date(this.myObj.dtfrom) <= new Date(this.myObj.dtto);
        }
        return true;
      }
      if (
        (this.myObj.type.value == "dcr" ||
          this.dateVisible.includes(this.myObj.format)) &&
        ![
          "Slip range",
          "Fee Summary",
          "Planner Logs",
          "Left Category wise",
          "Campus Transfer",
          "Staff Campus Transfer",
          "Fee Revenue",
          "Inquiry",
          "Visitors",
          "Driver fees",
        ].includes(this.myObj.format)
      ) {
        if (
          ["Accounts", "Advance Accounts"].includes(this.myObj.type.value) ||
          this.myObj.format === "Event Calendar Report" ||
          this.myObj.format === "Campus Transfer" ||
          this.myObj.format === "Staff Campus Transfer"
        ) {
          var elem1 = this.$refs["dt_from"];
          if (!this.myObj.dtfrom) {
            elem1.state = false;
          } else {
            elem1.state = true;
          }
          var elem2 = this.$refs["dt_to"];
          if (!this.myObj.dtto) {
            elem2.state = false;
          } else {
            elem2.state = true;
          }
          if (this.myObj.dtfrom && this.myObj.dtto) {
            return new Date(this.myObj.dtfrom) <= new Date(this.myObj.dtto);
          }
          return elem1.state && elem2.state;
        } else {
          var elem = this.$refs["date"];
          if (!this.myObj.dtfrom || !this.myObj.dtto) {
            return (elem.state = false);
          } else {
            return (elem.state = true);
          }
        }
      } else return true;
    },
    CheckSingleDate() {
      if (this.singleDtVisible.includes(this.myObj.format)) {
        var elem = this.$refs["single_date"];
        if (!this.singleDate) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckClass() {
      if (this.myObj.format === "Subject Wise Fees") {
        const elem = this.$refs["class"];
        if (!elem) return true;
        const id = Array.isArray(this.classID) ? this.classID[0] : this.classID;
        if (!id || Number(id) === 0) {
          return (elem.state = false);
        }
        return (elem.state = true);
      }
      if (
        this.myObj.type.value != "Accounts" &&
        this.myObj.format !== "Monthly summary" &&
        this.myObj.type.value !== "challan-report" &&
        this.myObj.type.value !== "Advance Accounts" &&
        this.myObj.type.value != "Staff" &&
        this.myObj.format !== "Terms & Conditions report" &&
        this.myObj.format !== "Terms acknowledge report" &&
        this.myObj.format !== "Student turnover" &&
        this.myObj.format !== "Driver wise students" &&
        this.myObj.format !== "Driver fees" &&
        this.myObj.format !== "Campus Transfer" &&
        this.myObj.format !== "Fee Revenue"
      ) {
        var elem = this.$refs["class"];
        if (!elem) return true;
        if (this.classID.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckSec() {
      if (this.myObj.format === "Subject Wise Fees") {
        const elem = this.$refs["section"];
        if (!elem) return true;
        const id = Array.isArray(this.secID) ? this.secID[0] : this.secID;
        if (!id || Number(id) === 0) {
          return (elem.state = false);
        }
        return (elem.state = true);
      }
      if (
        this.myObj.type.value != "Accounts" &&
        this.myObj.format !== "Monthly summary" &&
        this.myObj.type.value !== "challan-report" &&
        this.myObj.type.value !== "Advance Accounts" &&
        this.myObj.type.value != "Staff" &&
        this.myObj.format !== "Terms & Conditions report" &&
        this.myObj.format !== "Terms acknowledge report" &&
        this.myObj.format !== "Student turnover" &&
        this.myObj.format !== "Driver wise students" &&
        this.myObj.format !== "Driver fees" &&
        this.myObj.format !== "Campus Transfer" &&
        this.myObj.format !== "Fee Revenue"
      ) {
        var elem = this.$refs["section"];
        if (!elem) return true;
        if (this.secID.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckIncrementYear() {
      if (this.myObj.format === "Increment list") {
        if (this.isAlhameedDomain) {
          var elem = this.$refs["incrementYear"];
          if (!elem) return true;
          if (this.incrementYear === null || this.incrementYear === undefined) {
            return (elem.state = false);
          } else {
            return (elem.state = true);
          }
        }

        // Normal domains: validate single date range
        const rangeRef = this.$refs["incrementRangeRef"];
        if (!this.incrementRange || this.incrementRange.length < 2) {
          if (rangeRef) rangeRef.state = false;
          return false;
        }
        if (rangeRef) rangeRef.state = true;
        return true;
      } else return true;
    },

    isTruthySetting(setting) {
      if (!setting) return false;
      if (setting.valueBool === true || setting.valueBool === 1) return true;
      if (typeof setting.valueBool === "string") {
        const t = setting.valueBool.toLowerCase().trim();
        return t === "true" || t === "1";
      }
      return false;
    },

    getAccountBelongsTo(account) {
      if (!account) return "";
      const raw = account.belongsTo != null ? account.belongsTo : account.belongs_to;
      return String(raw || "")
        .toLowerCase()
        .trim();
    },

    getLedgerBelongsApiType() {
      if (!this.showLedgerBelongsFilter) return "";
      if (this.ledgerBelongsFilter === "accounts_receivable") {
        return "receivable";
      }
      if (this.ledgerBelongsFilter === "accounts_payable") {
        return "payable";
      }
      return "";
    },

    onLedgerBelongsFilterChange() {
      if (
        this.coa &&
        !this.filteredCoaTypes.some((a) => a.id === this.coa)
      ) {
        this.coa = null;
      }
    },

    buildAdvanceLedgerPrintQuery() {
      const query = {
        db: this.myObj.db,
        cID: this.myObj.campusID,
        accountID: this.coa,
        dtFrom: this.myObj.dtfrom,
        dtTo: this.myObj.dtto,
      };
      const ledgerMode = this.getLedgerBelongsApiType();
      if (ledgerMode) {
        query.ledgerMode = ledgerMode;
      }
      return query;
    },

    async LoadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: [
          "student_list_with_dues",
          "head_office",
          "month_wise_challan",
          "new_ledger",
          "coa_receivable_payable",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.dueObj = res.find((el) => el.key == "student_list_with_dues");

      this.showBankReport = res.find((el) => el.key == "month_wise_challan");
      this.newLedgerSetting = res.find((el) => el.key == "new_ledger");
      this.coaReceivablePayableSetting = res.find(
        (el) => el.key == "coa_receivable_payable"
      );
      this.isHeadOffice = res.find(
        (el) =>
          el.key == "head_office" &&
          el.campusID == this.$store.state.userData.cId
      );

      if (this.showBankReport) {
        this.typeOptions.push({
          text: "Bank Report",
          value: "challan-report",
          format: ["Challan Issued", "Monthly Issued", "Annual Issued"],
        });
      }
      // if (this.showBankReport && this.isHeadOffice) {
      if (this.isHeadOffice) {
        this.LoadCampuses();
        if (this.reportDomain != "myskoolhpgs") this.LoadDistinctClasses();

        let ind = this.typeOptions.findIndex((el) => el.value == "Students");

        if (ind != -1) {
          let obj = this.typeOptions.find((el) => el.value == "Students");
          obj.format.splice(8, 0, "Campus Strength");
        }
      }
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },
    async LoadDiscountReferences() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "DiscountReference?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.disRefList = await this.get(obj2);
      this.disRefList.unshift({ id: 0, name: "All" });
    },
    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "FeeType?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.feeTypes = await this.get(obj);
      // console.log("fee", this.feeTypes);

      var obj2 = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj2);
      // console.log("class", this.classes);
      this.dataLoading = false;

      this.classesOptions = this.classes.map((el) => el.cls);
      this.classesOptions.unshift({ name: "All Classes", id: 0 });
    },
    async LoadDistinctClasses() {
      this.isDistinct = true;
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClassesAllDistinct?db=" +
          this.$store.state.userData.db +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.dClasses = await this.get(obj);

      this.dClassOptions = this.dClasses.map((el) => el.cls);
      this.dClassOptions.unshift({ name: "All Classes", id: 0 });

      this.classes = this.dClasses;
      this.classesOptions = this.dClassOptions;

      // console.log("cls opt", this.classesOptions);
    },

    async LoadCollectionLinks() {
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadLinkedAccounts?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.collectionLinks = await this.get(obj);
      // console.log("linked acc ", this.collectionLinks);
    },

    async loadAccounts() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "CollectionAccounts?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let result = await this.get(obj2);
      // console.log("acc", result);
      if (result !== "NotFound") {
        const linked = Array.isArray(result) ? result : [];
        this.accTypes = this.filterCollectionAccountsByRole(linked);
        this.accTypes.unshift({ account: "All", id: 0 });
      } else this.accTypes = [];

      var objHeads = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let resultHeads = await this.get(objHeads);
      // console.log("acc", result);
      if (resultHeads !== "NotFound") {
        const list = this.normalizeAccountsResponse(resultHeads);
        this.coaTypes = this.filterAccountsByRole(list);
        if (this.coa && !this.coaTypes.some((a) => a.id === this.coa)) {
          this.coa = null;
        }
      } else this.coaTypes = [];

      // this.accountType = this.$store.state.accountType;
    },

    async loadSessions() {
      let cID =
        this.appReportCampusID ||
        this.myObj.campusID ||
        this.$store.state.userData.cId;
      var obj = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          cID,
        token: this.$store.state.userData.token,
      };
      this.sessions = await this.get(obj);

      // console.log("Session", this.sessions);
    },
    async loadFiscalYears() {
      try {
        const cId = this.myObj.campusID || this.$store.state.userData.cId;
        const res = await this.get({
          url: `${this.$store.state.domain}FiscalYear/LoadFiscalYears?db=${this.$store.state.userData.db}&cID=${cId}`,
          token: this.$store.state.userData.token,
        });
        this.fiscalYears = Array.isArray(res)
          ? res
          : res?.data && Array.isArray(res.data)
          ? res.data
          : [];
        if (this.fiscalYears.length > 0 && !this.selectedFiscalYearID) {
          this.selectedFiscalYearID = this.fiscalYears[0].id;
        }
      } catch (e) {
        console.error("Failed to load fiscal years", e);
        this.fiscalYears = [];
      }
    },
    async loadExam() {
      var obj = {
        url:
          this.$store.state.domain +
          "ExamTypes?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.examType = await this.get(obj);
    },
    async loadConsent() {
      var obj = {
        url:
          this.$store.state.domain +
          "Consents/LoadConsent?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      this.consentList = res.result;
    },
    async LoadLeftCat() {
      var obj = {
        url:
          this.$store.state.domain +
          "DropDownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=leftCategories",
        token: this.$store.state.userData.token,
      };
      this.leftOptions = await this.get(obj);
    },
    async LoadSubjects() {
      var obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjectList = await this.get(obj);
      this.subjectList = Array.isArray(this.subjectList)
        ? this.subjectList
        : [];
    },
    async LoadProjects() {
      var obj = {
        url:
          this.$store.state.domain +
          "AccountsDepartment?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.projectList = await this.get(obj);
    },
    async LoadVendors() {
      var obj = {
        url:
          this.$store.state.domain +
          "Vendors?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.vendorList = await this.get(obj);
    },
    async LoadStaff() {
      const campusId = this.getReportCampusId();
      const status = this.myObj.staffStatus || "present";
      var obj = {
        url:
          this.$store.state.domain +
          "staff/filter?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          campusId +
          "&dptID=0&status=" +
          status,
        token: this.$store.state.userData.token,
      };
      const result = await this.get(obj);
      this.staffList = Array.isArray(result) ? result : [];
    },
    initSubjectStaffFilters() {
      if (!["Subject List", "Timetable"].includes(this.myObj.format)) {
        return;
      }
      this.myObj.subjectID = 0;
      this.myObj.staffID = 0;
      this.loadStaffForReport();
    },
    getReportCampusId() {
      const campusId = this.myObj.campusID || this.$store.state.userData.cId;
      return campusId > 0 ? campusId : this.$store.state.userData.cId;
    },
    onSubjectFilterChange() {
      if (
        this.usesSubjectListDomainReport &&
        this.myObj.format === "Subject List"
      ) {
        return;
      }
      if (!["Subject List", "Timetable"].includes(this.myObj.format)) {
        return;
      }
      this.myObj.staffID = 0;
      this.loadStaffForReport();
    },
    onTimetableCampusChange() {
      if (
        !["Subject List", "Timetable", "Planner Logs"].includes(
          this.myObj.format
        )
      ) {
        return;
      }
      this.myObj.staffID = 0;
      if (["Subject List", "Timetable"].includes(this.myObj.format)) {
        this.loadStaffForReport();
      } else {
        this.LoadStaff();
      }
    },
    onStaffStatusChange() {
      if (
        ["Subject List", "Timetable"].includes(this.myObj.format) &&
        !(Number(this.myObj.subjectID) > 0)
      ) {
        this.myObj.staffID = 0;
        this.loadStaffForReport();
        return;
      }
      if (
        !["Subject List", "Timetable"].includes(this.myObj.format) &&
        this.staffList.length
      ) {
        this.myObj.staffID = 0;
        this.LoadStaff();
      }
    },
    async loadStaffForReport() {
      if (!["Subject List", "Timetable"].includes(this.myObj.format)) {
        return;
      }
      if (
        this.usesSubjectListDomainReport &&
        this.myObj.format === "Subject List"
      ) {
        await this.LoadStaff();
        return;
      }

      const subjectID = Number(this.myObj.subjectID) || 0;

      if (subjectID > 0) {
        const campusId = this.getReportCampusId();
        const teachers = await this.get({
          url:
            this.$store.state.domain +
            (this.myObj.format === "Timetable"
              ? "Subjects/LoadTeachersBySubjectFromTimeTable?db=" +
                this.$store.state.userData.db +
                "&cID=" +
                campusId +
                "&subjectID=" +
                subjectID
              : "Subjects/LoadTeacherBySubjects?db=" +
                this.$store.state.userData.db +
                "&cId=" +
                campusId +
                "&subjectID=" +
                subjectID),
          token: this.$store.state.userData.token,
        });
        this.staffList = Array.isArray(teachers) ? teachers : [];
      } else {
        await this.LoadStaff();
      }
    },
    async loadDeparts() {
      var obj = {
        url:
          this.$store.state.domain +
          "departments?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.departments = await this.get(obj);

      var obj2 = {
        url:
          this.$store.state.domain +
          "StaffDepartments?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.staffDeparts = await this.get(obj2);
    },

    setDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.myObj.dtfrom = date[0];
            this.myObj.dtto = date[0];
          } else {
            this.myObj.dtfrom = date[0];
            this.myObj.dtto = date[1];
          }
        } else {
          this.myObj.dtfrom = dateStr;
          this.myObj.dtto = null;
        }
      } else {
        this.myObj.dtfrom = null;
        this.myObj.dtto = null;
      }
      // console.log(this.myObj.dtfrom, this.myObj.dtto);
      this.CheckDate();

      // on date change
      this.checkLock();
    },
    setAccounts() {
      if (this.accList[this.accList.length - 1] == 0) {
        this.accList = [0];
      } else {
        this.accList = this.accList.filter((el) => el != 0);
      }
    },
    setAccountsCOA() {
      if (this.coa[this.coa.length - 1] == 0) {
        this.coa = [0];
      } else {
        this.coa = this.coa.filter((el) => el != 0);
      }
    },
    variantFeetype(id) {
      return this.myObj.feesTypeIDs.includes(id);
    },
    selectFeetype(id) {
      if (this.myObj.format == "Monthly summary") {
        this.myObj.feesTypeIDs = [id];
      } else {
        if (this.myObj.feesTypeIDs.length == 0) {
          this.myObj.feesTypeIDs.push(id);
        } else {
          let data = this.myObj.feesTypeIDs.filter((el) => {
            return el !== id;
          });
          // console.log("data", data);
          if (data.length == this.myObj.feesTypeIDs.length) {
            this.myObj.feesTypeIDs.push(id);
          } else {
            this.myObj.feesTypeIDs = data;
          }
        }
        // console.log(this.myObj.feesTypeIDs);
        // console.log(this.variant(id));
      }
    },
    variantMonth(name) {
      return this.myObj.months.includes(name);
    },
    selectMonth(name) {
      if (this.myObj.months.length == 0) {
        this.myObj.months.push(name);
      } else {
        let data = this.myObj.months.filter((el) => {
          return el !== name;
        });
        // console.log("data", data);
        if (data.length == this.myObj.months.length) {
          this.myObj.months.push(name);
        } else {
          this.myObj.months = data;
        }
      }
      // console.log(this.myObj.months);
    },
    async getCmapusClasses() {
      // Clear current class/section selections
      this.classID = [0];
      this.secID = [0];

      let cID = this.myObj.campusID;

      if (cID === 0) {
        // Load all classes (distinct) if "All Campuses" is selected
        await this.LoadDistinctClasses();
      } else {
        // Load classes for specific campus
        this.isDistinct = false;
        var obj = {
          url:
            this.$store.state.domain +
            "myclasses/LoadClasses?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            cID +
            "&dID=0",
          token: this.$store.state.userData.token,
        };
        const res = await this.get(obj);
        if (res && res !== "NotFound") {
          this.classes = res;
          this.classesOptions = this.classes.map((el) => el.cls);
          this.classesOptions.unshift({ name: "All Classes", id: 0 });
        } else {
          this.classes = [];
          this.classesOptions = [{ name: "All Classes", id: 0 }];
        }
      }

      // Reset sections
      this.admittedSections = [{ section: "All Sections", id: 0 }];

      // Reload sessions for the selected campus
      this.loadSessions();
    },

    async getAppReportClasses() {
      // Clear current selection
      this.appReportClassID = null;
      this.appReportSectionID = null;

      let cID = this.appReportCampusID;

      if (!cID) return;

      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          cID +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      const res = await this.get(obj);
      if (res && res !== "NotFound") {
        this.classes = res;
        this.classesOptions = this.classes.map((el) => el.cls);
        this.classesOptions.unshift({ name: "All Classes", id: 0 });
      } else {
        this.classes = [];
        this.classesOptions = [{ name: "All Classes", id: 0 }];
      }

      // Also reload sessions for terms report
      this.loadSessions();
    },
    setClasses() {
      if (this.selectedDep == 0) {
        this.classesOptions = this.classes.map((el) => el.cls);
        this.classesOptions.unshift({ name: "All Classes", id: 0 });
        this.classID = [0];
        this.admittedSections = [{ section: "All Sections", id: 0 }];
        this.secID = [0];
      } else {
        this.classesOptions = this.classes.reduce((acc, el) => {
          if (el.cls.departmentID == this.selectedDep) {
            acc.push(el.cls);
          }
          return acc;
        }, []);
        this.classID = this.classesOptions.map((el) => el.id);
        this.admittedSections = [{ section: "All Sections", id: 0 }];
        this.secID = [0];
        if (this.classID.length == 1) {
          let secs = this.classes.find(
            (el) => el.cls.id == this.classID[0]
          ).sections;
          secs.forEach((el) => {
            this.admittedSections.push(el);
          });
        }
      }
    },
    async onStudentSearchChange(search) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      if (!search || search.trim().length < 2) {
        this.filteredStudentOptions = [];
        return;
      }
      this.searchTimeout = setTimeout(async () => {
        this.studentSearchLoading = true;

        try {
          const obj = {
            url: `${this.$store.state.domain}Students/Search?db=${
              this.$store.state.userData.db
            }&cID=${
              this.$store.state.userData.cId
            }&keyword=${encodeURIComponent(search)}&status=present`,
            token: this.$store.state.userData.token,
          };
          const response = await this.get(obj);
          let studentsData = [];
          if (response && response.data && Array.isArray(response.data)) {
            studentsData = response.data;
          } else if (Array.isArray(response)) {
            studentsData = response;
          }

          this.filteredStudentOptions = studentsData.map((student) => {
            let className = "No Class";
            let sectionName = "";
            if (student.meta_class) {
              const parts = student.meta_class.split(" - ");
              if (parts.length >= 2) {
                className = parts[0].trim();
                sectionName = parts[1].trim();
              } else if (parts.length === 1) {
                className = parts[0].trim();
              }
            }
            return {
              ...student,
              className: className,
              sectionName: sectionName,
            };
          });
        } catch (error) {
          console.error("Student search error:", error);
          this.filteredStudentOptions = [];
        } finally {
          this.studentSearchLoading = false;
        }
      }, 500);
    },
    selectStudent(student) {
      if (this.myObj.format === "Fee Reminder") {
        this.myObj.search = student.grNo || student.id;
      } else {
        this.myObj.search = student.id;
      }
      this.studentSearchQuery = student.name;
      this.filteredStudentOptions = [];
    },
    clearSelectedStudent() {
      this.myObj.search = "";
      this.studentSearchQuery = "";
      this.filteredStudentOptions = [];
    },
    FillSections() {
      // Handle single value from non-multiple v-select for Inquiry/Visitors
      let isArr = Array.isArray(this.classID);
      let workingClassID = isArr ? this.classID : [this.classID];

      if (workingClassID.at(-1) == 0) {
        if (this.myObj.format === "Subject Wise Fees") {
          this.admittedSections = [];
          this.secID = null;
        } else {
          this.classID = isArr ? [0] : 0;
          this.secID = isArr ? [0] : 0;
          this.admittedSections = [{ section: "All Sections", id: 0 }];
        }
      } else {
        if (isArr) {
          this.classID = this.classID.filter((e) => e !== 0);
        }
        this.secID = isArr ? [0] : 0;

        const selectedClassIds = (isArr ? this.classID : [this.classID]).filter(
          (id) => id !== 0 && id != null
        );

        if (selectedClassIds.length === 1) {
          let cls = this.classes.find((el) => el.cls.id == selectedClassIds[0]);
          if (cls && cls.sections && cls.sections.length > 0) {
            if (this.myObj.format === "Subject Wise Fees") {
              this.admittedSections = [...cls.sections];
              const secId = Array.isArray(this.secID)
                ? this.secID[0]
                : this.secID;
              if (
                !secId ||
                !this.admittedSections.some(
                  (s) => Number(s.id) === Number(secId)
                )
              ) {
                this.secID = this.admittedSections[0].id;
              }
            } else {
              this.admittedSections = [
                { section: "All Sections", id: 0 },
                ...cls.sections,
              ];
            }
          } else {
            this.admittedSections =
              this.myObj.format === "Subject Wise Fees"
                ? []
                : [{ section: "All Sections", id: 0 }];
          }
        } else {
          this.admittedSections =
            this.myObj.format === "Subject Wise Fees"
              ? []
              : [{ section: "All Sections", id: 0 }];
        }
      }
      this.CheckClass();

      // old code
      // if (this.classID[0] == 0 && this.classID.length !== 1) {
      //   this.classID = this.classID.filter((e) => e !== 0);
      //   // console.log(this.classID);
      //   this.classes.forEach((elem) => {
      //     if (this.classID.includes(elem.cls.id)) {
      //       if (elem.sections.length != 0) {
      //         elem.sections.forEach((el) => this.admittedSections.push(el));
      //       } else {
      //         // console.log("null");
      //         this.admittedSections = [{ section: "All Sections", id: 0 }];
      //       }
      //     }
      //   });
      // } else if (
      //   this.classID[this.classID.length - 1] !== 0 &&
      //   this.classID.length == 1
      // ) {
      //   this.classes.forEach((elem) => {
      //     if (this.classID.includes(elem.cls.id)) {
      //       if (elem.sections.length != 0) {
      //         elem.sections.forEach((el) => this.admittedSections.push(el));
      //       } else {
      //         // console.log("null");
      //         this.admittedSections = [{ section: "All Sections", id: 0 }];
      //       }
      //     }
      //   });
      // } else if (this.classID[this.classID.length - 1] == 0) {
      //   this.classID = [0];
      //   // console.log(this.classID);
      //   this.admittedSections = [{ section: "All Sections", id: 0 }];
      //   this.secID = [0];
      // } else {
      //   this.admittedSections = [{ section: "All Sections", id: 0 }];
      //   this.secID = [0];
      // }
    },
    setSections() {
      // console.log(this.secID);
      if (this.secID.at(-1) == 0) {
        this.secID = [0];
      } else {
        this.secID = this.secID.filter((e) => e !== 0);
      }
      this.CheckSec();
    },
    setDeps() {
      // For single-select options (Remaining Leaves and Leave Encashment)
      if (
        ["Remaining Leaves", "Leave Encashment", "Advance & Loan"].includes(
          this.myObj.format
        )
      ) {
        // Ensure it's a single value, not an array
        if (Array.isArray(this.staffDepID)) {
          this.staffDepID = this.staffDepID[0] || 0;
        }
      } else {
        // For multi-select options (existing behavior)
        if (this.staffDepID.at(-1) == 0) {
          this.staffDepID = [0];
        } else {
          this.staffDepID = this.staffDepID.filter((el) => el != 0);
        }
      }
    },
    checkStaffDep() {
      if (this.myObj.type.value == "Staff") {
        // Skip validation for Organization structure format
        if (
          this.myObj.format === "Organization structure" ||
          this.myObj.format === "Planner Logs" ||
          this.myObj.format === "App Stats" ||
          this.myObj.format === "Staff Campus Transfer"
        ) {
          return true;
        }
        var elem = this.$refs["staffDep"];

        // Handle single select for new report types
        if (
          [
            "Staff List Muster Roll",
            "Staff List With Salary",
            "New staff list",
            "New staff left list",
            "Increment list",
            "File cover",
            "Remaining Leaves",
            "Leave Encashment",
            "Advance & Loan",
          ].includes(this.myObj.format)
        ) {
          if (this.staffDepID === null || this.staffDepID === undefined) {
            return (elem.state = false);
          } else {
            return (elem.state = true);
          }
        }

        // Handle multi-select for other formats
        if (this.staffDepID.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },

    checkTurnoverMonths() {
      if (this.myObj.format !== "Student turnover") return true;

      const fromRef = this.$refs["turnoverMonthFrom"];
      const toRef = this.$refs["turnoverMonthTo"];
      const yearRef = this.$refs["turnoverYear"];

      if (!this.turnoverYear) {
        if (yearRef) yearRef.state = false;
        return false;
      }
      if (yearRef) yearRef.state = true;

      if (!this.turnoverMonthFrom || !this.turnoverMonthTo) {
        if (fromRef) fromRef.state = !!this.turnoverMonthFrom;
        if (toRef) toRef.state = !!this.turnoverMonthTo;
        return false;
      }

      if (this.turnoverMonthFrom > this.turnoverMonthTo) {
        this.$bvToast.toast("Month from cannot be after month to.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        if (fromRef) fromRef.state = false;
        if (toRef) toRef.state = false;
        return false;
      }

      if (fromRef) fromRef.state = true;
      if (toRef) toRef.state = true;
      return true;
    },

    checkNtnPeriod() {
      if (this.myObj.format !== "NTN Certificate") return true;

      const fromMonthRef = this.$refs["ntnFromMonth"];
      const fromYearRef = this.$refs["ntnFromYear"];
      const toMonthRef = this.$refs["ntnToMonth"];
      const toYearRef = this.$refs["ntnToYear"];

      if (
        !this.ntnFromMonth ||
        !this.ntnFromYear ||
        !this.ntnToMonth ||
        !this.ntnToYear
      ) {
        if (fromMonthRef) fromMonthRef.state = !!this.ntnFromMonth;
        if (fromYearRef) fromYearRef.state = !!this.ntnFromYear;
        if (toMonthRef) toMonthRef.state = !!this.ntnToMonth;
        if (toYearRef) toYearRef.state = !!this.ntnToYear;
        return false;
      }

      const fromKey = this.ntnFromYear * 12 + this.ntnFromMonth;
      const toKey = this.ntnToYear * 12 + this.ntnToMonth;
      if (fromKey > toKey) {
        this.$bvToast.toast("From period cannot be after to period.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        if (fromMonthRef) fromMonthRef.state = false;
        if (fromYearRef) fromYearRef.state = false;
        if (toMonthRef) toMonthRef.state = false;
        if (toYearRef) toYearRef.state = false;
        return false;
      }

      if (fromMonthRef) fromMonthRef.state = true;
      if (fromYearRef) fromYearRef.state = true;
      if (toMonthRef) toMonthRef.state = true;
      if (toYearRef) toYearRef.state = true;
      return true;
    },

    openNtnCertificateReport() {
      const routeData = this.$router.resolve({
        name: "ntn-certificate-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID || this.$store.state.userData.cId || 0,
          fromMonth: this.ntnFromMonth,
          fromYear: this.ntnFromYear,
          toMonth: this.ntnToMonth,
          toYear: this.ntnToYear,
        },
      });
      window.open(routeData.href, "_blank");
    },

    openOutstandingSummaryReport() {
      const routeData = this.$router.resolve({
        name: "outstanding-summary-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID || this.$store.state.userData.cId || 0,
          month: this.singleMonth,
          year: this.singleYear,
          depIDs: this.selectedDep,
          dtFrom: this.myObj.dtfrom,
          dtTo: this.myObj.dtto,
        },
      });
      window.open(routeData.href, "_blank");
    },

    resolveTurnoverCampusID() {
      const cID = Number(this.myObj.campusID);
      if (!cID || cID === 0) return 1;
      return cID;
    },

    resolveEventCalendarFilterId(val) {
      if (Array.isArray(val)) {
        const picked = val.find(
          (id) => id !== null && id !== undefined && Number(id) !== 0
        );
        return picked != null ? Number(picked) : 0;
      }
      return val !== null && val !== undefined && Number(val) !== 0
        ? Number(val)
        : 0;
    },

    normalizeFilterIds(val) {
      if (val === null || val === undefined) return [];
      return Array.isArray(val) ? val : [val];
    },

    hasSelectedFilterId(val) {
      return this.normalizeFilterIds(val).some(
        (id) => id !== null && id !== undefined && Number(id) !== 0
      );
    },

    openEventCalendarReport() {
      const isStudent = this.eventCalendarEventFor === "Students";
      const classID = isStudent
        ? this.resolveEventCalendarFilterId(this.classID)
        : 0;
      const sectionID = isStudent
        ? this.resolveEventCalendarFilterId(this.secID)
        : 0;
      const departmentID = !isStudent
        ? this.resolveEventCalendarFilterId(this.staffDepID)
        : 0;

      let classLabel = "All Classes";
      let sectionLabel = "All Sections";
      let departmentLabel = "All Departments";

      if (isStudent) {
        if (classID !== 0) {
          classLabel =
            this.classesOptions.find((c) => c.id === classID)?.name ||
            String(classID);
        }
        if (sectionID !== 0) {
          sectionLabel =
            this.admittedSections.find((s) => s.id === sectionID)?.section ||
            String(sectionID);
        }
      } else if (departmentID !== 0) {
        departmentLabel =
          this.staffDeparts.find((d) => d.id === departmentID)?.name ||
          String(departmentID);
      }

      const routeData = this.$router.resolve({
        name: "event-calendar-report-print",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID || this.$store.state.userData.cId,
          eventFor: this.eventCalendarEventFor,
          classID,
          sectionID,
          departmentID,
          dtFrom: this.myObj.dtfrom || "",
          dtTo: this.myObj.dtto || "",
          classLabel,
          sectionLabel,
          departmentLabel,
        },
      });
      window.open(routeData.href, "_blank");
    },

    openSubjectFeeReport() {
      const classID = this.resolveEventCalendarFilterId(this.classID);
      const sectionID = this.resolveEventCalendarFilterId(this.secID);

      if (!classID) {
        this.$bvToast.toast("Please select a class.", {
          title: "Required",
          variant: "warning",
          solid: true,
        });
        return;
      }
      if (!sectionID) {
        this.$bvToast.toast("Please select a section.", {
          title: "Required",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const classLabel =
        this.classesOptions.find((c) => c.id === classID)?.name ||
        String(classID);
      const sectionLabel =
        this.admittedSections.find((s) => s.id === sectionID)?.section ||
        String(sectionID);

      const routeData = this.$router.resolve({
        name: "subject-fee-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID || this.$store.state.userData.cId,
          classID,
          sectionID,
          classLabel,
          sectionLabel,
          sessionID: this.subjectFeeSessionID || 0,
        },
      });
      window.open(routeData.href, "_blank");
    },

    resolveMultiReportFilterIds(value) {
      if (value == null || value === "" || value === "all") return "0";
      if (Array.isArray(value)) {
        const ids = value
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id) && id > 0);
        return ids.length ? ids.join(",") : "0";
      }
      const raw = String(value).trim();
      if (!raw || raw === "0" || raw.toLowerCase() === "all") return "0";
      const ids = raw
        .split(",")
        .map((part) => Number(String(part).trim()))
        .filter((id) => Number.isFinite(id) && id > 0);
      return ids.length ? ids.join(",") : "0";
    },

    resolveSubjectListFilterLabels(classIDs, sectionIDs, subjectIDs) {
      const toIdList = (csv) =>
        String(csv || "")
          .split(",")
          .map((part) => Number(String(part).trim()))
          .filter((id) => id > 0);

      const classIds = toIdList(classIDs);
      const sectionIds = toIdList(sectionIDs);
      const subjectIds = toIdList(subjectIDs);

      let classLabel = "All Classes";
      if (classIds.length === 1) {
        const cls = (this.classesOptions || []).find(
          (c) => Number(c.id) === classIds[0]
        );
        classLabel = cls ? cls.name : `Class #${classIds[0]}`;
      } else if (classIds.length > 1) {
        classLabel = `${classIds.length} Classes`;
      }

      let sectionLabel = "All Sections";
      if (sectionIds.length === 1) {
        const sec = (this.admittedSections || []).find(
          (s) => Number(s.id) === sectionIds[0]
        );
        sectionLabel = sec
          ? sec.section || sec.name
          : `Section #${sectionIds[0]}`;
      } else if (sectionIds.length > 1) {
        sectionLabel = `${sectionIds.length} Sections`;
      }

      let subjectLabel = "All Subjects";
      if (subjectIds.length === 1) {
        const subject = (this.filteredSubjectList || this.subjectList || []).find(
          (s) => Number(s.id) === subjectIds[0]
        );
        subjectLabel = subject
          ? subject.subject || subject.name
          : `Subject #${subjectIds[0]}`;
      } else if (subjectIds.length > 1) {
        subjectLabel = `${subjectIds.length} Subjects`;
      }

      const statusRaw = String(this.myObj.status || "present");
      const statusLabel =
        statusRaw.toLowerCase() === "all"
          ? "All Status"
          : statusRaw.charAt(0).toUpperCase() + statusRaw.slice(1);

      return { classLabel, sectionLabel, subjectLabel, statusLabel };
    },

    buildSubjectListReportQuery() {
      const classIDs = this.resolveMultiReportFilterIds(
        this.myObj.classIDs != null &&
          !(Array.isArray(this.myObj.classIDs) && !this.myObj.classIDs.length)
          ? this.myObj.classIDs
          : this.classID
      );
      const sectionIDs = this.resolveMultiReportFilterIds(
        this.myObj.secIDs != null &&
          !(Array.isArray(this.myObj.secIDs) && !this.myObj.secIDs.length)
          ? this.myObj.secIDs
          : this.secID
      );
      const subjectIDs = this.resolveMultiReportFilterIds(
        this.myObj.subjectID
      );
      const labels = this.resolveSubjectListFilterLabels(
        classIDs,
        sectionIDs,
        subjectIDs
      );

      return {
        db: this.myObj.db,
        cID: this.myObj.campusID || this.$store.state.userData.cId || 0,
        status: this.myObj.status || "present",
        classIDs,
        sectionIDs,
        subjectIDs,
        departmentID: this.selectedDep || 0,
        ...labels,
      };
    },

    openSubjectListReport() {
      const query = this.buildSubjectListReportQuery();
      const routeData = this.$router.resolve({
        name: "subject-list-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    buildSubjectListDomainReportUrl(exportMode, clsName = "", secName = "") {
      const endpoint = exportMode ? "ShowExport" : "Show";
      const isCoaching =
        this.$store.state.currentBranch.organizationType == "coaching";
      const { cls, sec } = this.resolveLegacyListReportClsSec();
      let url =
        `https://${this.reportDomain}.myskool.app/List/${endpoint}?type=subjects` +
        "&dbb=" +
        this.myObj.db +
        "&cID=" +
        this.myObj.campusID +
        "&cls=" +
        cls +
        "&sec=" +
        sec +
        "&status=" +
        this.myObj.status +
        "&mob=false";

      if (!exportMode || isCoaching) {
        url += "&session=" + this.myObj.sessionID;
      }

      url +=
        "&subID=" +
        (this.myObj.subjectID != null ? this.myObj.subjectID : 0) +
        "&tID=" +
        (this.myObj.staffID != null ? this.myObj.staffID : 0) +
        "&clsName=" +
        clsName +
        "&secName=" +
        secName;

      return url;
    },

    /** Legacy List/Show subjects params (All Classes/Sections → empty string). */
    resolveLegacyListReportClsSec() {
      const classIds = this.normalizeFilterIds(this.classID).filter(
        (id) => Number(id) !== 0
      );
      const secIds = this.normalizeFilterIds(this.secID).filter(
        (id) => Number(id) !== 0
      );
      return {
        cls: classIds.length ? classIds.join(",") : "",
        sec: secIds.length ? secIds.join(",") : "",
      };
    },

    openSubjectListDomainReport(clsName = "", secName = "") {
      const url = this.buildSubjectListDomainReportUrl(false, clsName, secName);
      window.open(url, "_blank");
    },

    async exportSubjectListDomainReport(clsName = "", secName = "") {
      const url = this.buildSubjectListDomainReportUrl(true, clsName, secName);
      try {
        const response = await axios.get(url);
        window.open(response.data.data, "_blank");
      } catch (error) {
        console.error("Subject list domain export error:", error);
      }
    },

    async exportSubjectListExcel() {
      if (this.myObj.format !== "Subject List") return false;
      if (this.usesSubjectListDomainReport) return false;

      this.request = true;
      try {
        const query = this.buildSubjectListReportQuery();
        const params = {
          db: query.db,
          cID: query.cID,
          classIDs: query.classIDs || "0",
          sectionIDs: query.sectionIDs || "0",
          subjectIDs: query.subjectIDs || "0",
        };
        const status = String(query.status || "").toLowerCase();
        if (status && status !== "all") {
          params.status = query.status;
        }
        if (Number(query.departmentID) > 0) {
          params.departmentID = query.departmentID;
        }

        const response = await this.get({
          url:
            this.$store.state.domain +
            "Students/SubjectListReport?" +
            new URLSearchParams(params).toString(),
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        const payload =
          response && response.status === "success"
            ? response
            : response && response.data
            ? response
            : { data: [] };
        const groups = Array.isArray(payload.data)
          ? payload.data
          : Array.isArray(response)
          ? response
          : [];

        if (!groups.length) {
          this.$bvToast.toast("No subject list records found.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const excelRows = [];
        groups.forEach((group) => {
          (group.students || []).forEach((student, index) => {
            excelRows.push({
              Subject: group.subjectName || "",
              "S.No": student.sno || index + 1,
              "Gr.No": student.grNo || "",
              Student: student.name || "",
              "Father Name": student.fatherName || student.father_name || "",
              Class:
                student.class ||
                [student.className, student.sectionName]
                  .filter(Boolean)
                  .join(" - "),
            });
          });
        });

        if (!excelRows.length) {
          this.$bvToast.toast("No subject list records found.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const totalStudents =
          Number(payload.totalStudents) ||
          Number(payload.totalRows) ||
          excelRows.length;

        const metaRows = [
          ["Student-Subject Report"],
          [
            `Status: ${query.statusLabel || query.status || "present"}`,
            `Subject: ${query.subjectLabel || "All Subjects"}`,
            `Class: ${query.classLabel || "All Classes"}`,
            `Section: ${query.sectionLabel || "All Sections"}`,
          ],
          [`Total Students: ${totalStudents}`],
          [],
        ];
        const worksheet = XLSX.utils.aoa_to_sheet(metaRows);
        XLSX.utils.sheet_add_json(worksheet, excelRows, {
          origin: "A5",
          skipHeader: false,
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Subject List");
        XLSX.writeFile(
          workbook,
          `Student_Subject_Report_${Date.now()}.xlsx`
        );

        this.$bvToast.toast("Student-subject report exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Subject list export error:", error);
        this.$bvToast.toast("Failed to export student-subject report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    resolveAbaDiscountReportFilters() {
      const resolvedClassID =
        Array.isArray(this.classID) && this.classID.length > 0
          ? this.classID[0]
          : this.classID || 0;
      const resolvedSectionID =
        Array.isArray(this.secID) && this.secID.length > 0
          ? this.secID[0]
          : this.secID || 0;
      const departmentID = this.selectedDep || 0;
      const classOpt = this.classesOptions.find(
        (el) => el.id == resolvedClassID
      );
      const secOpt = this.admittedSections.find(
        (el) => el.id == resolvedSectionID
      );
      const depOpt = this.departments.find((el) => el.id == departmentID);
      return {
        classID: resolvedClassID,
        sectionID: resolvedSectionID,
        departmentID,
        className: classOpt?.name || "",
        sectionName: secOpt?.section || "",
        departmentName:
          departmentID && depOpt ? depOpt.name : departmentID ? "" : "All",
      };
    },

    openDepartmentWiseDiscountReport() {
      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        return;
      }
      const filters = this.resolveAbaDiscountReportFilters();
      const routeData = this.$router.resolve({
        name: "department-wise-discount-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID,
          ...filters,
        },
      });
      window.open(routeData.href, "_blank");
    },

    openDiscountSummaryReport() {
      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        return;
      }
      const filters = this.resolveAbaDiscountReportFilters();
      const routeData = this.$router.resolve({
        name: "discount-summary-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID,
          ...filters,
        },
      });
      window.open(routeData.href, "_blank");
    },

    async exportDepartmentWiseDiscountExcel() {
      if (this.myObj.format !== "Department-wise Discount Report") return false;
      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        this.request = false;
        return true;
      }

      const filters = this.resolveAbaDiscountReportFilters();
      let baseUrl = this.$store.state.domain;
      if (!baseUrl.endsWith("/")) baseUrl += "/";

      this.request = true;
      try {
        const apiResponse = await axios.get(
          `${baseUrl}Fees/DepartmentWiseDiscountReport`,
          {
            params: {
              db: this.myObj.db,
              cID: this.myObj.campusID,
              classID: filters.classID,
              sectionID: filters.sectionID,
              departmentID: filters.departmentID,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const body = apiResponse.data || {};
        if (body.status !== "success") {
          this.$bvToast.toast(body.message || "Failed to load report data.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
          return true;
        }

        const items = Array.isArray(body.data) ? body.data : [];
        const groups = new Map();

        items.forEach((item) => {
          const deptId = item.departmentID || 0;
          const deptName = (item.departmentName || "").trim() || "Unassigned";
          const key = `${deptId}-${deptName}`;
          if (!groups.has(key)) {
            groups.set(key, { departmentName: deptName, students: [] });
          }
          groups.get(key).students.push(item);
        });

        const exportData = [];
        let grandActual = 0;
        let grandDiscount = 0;
        let grandNet = 0;

        Array.from(groups.values())
          .sort((a, b) => a.departmentName.localeCompare(b.departmentName))
          .forEach((group) => {
            exportData.push({
              "S.No": "",
              Roll: "",
              "Student Name": group.departmentName,
              Class: "",
              Department: "",
              "Actual Fee": "",
              "Discount Amount": "",
              "Net Payable": "",
              "Discount %": "",
              Category: "",
            });

            let deptActual = 0;
            let deptDiscount = 0;
            let deptNet = 0;

            group.students.forEach((item, index) => {
              const actual = Number(item.actualFee ?? item.classFee) || 0;
              const discount =
                Number(item.discountAmount ?? item.discount) || 0;
              const net = Math.max(0, actual - discount);
              const discPct = actual > 0 ? (discount / actual) * 100 : 0;
              deptActual += actual;
              deptDiscount += discount;
              deptNet += net;

              exportData.push({
                "S.No": item.sno || index + 1,
                Roll: item.roll || "",
                "Student Name": (item.name || "").toUpperCase(),
                Class: item.className || "",
                Department: item.departmentName || "",
                "Actual Fee": actual,
                "Discount Amount": discount,
                "Net Payable": net,
                "Discount %": Math.round(discPct * 100) / 100,
                Category: item.category || "",
              });
            });

            exportData.push({
              "S.No": "",
              Roll: "",
              "Student Name": "",
              Class: "",
              Department: `${group.departmentName} Totals`,
              "Actual Fee": deptActual,
              "Discount Amount": deptDiscount,
              "Net Payable": deptNet,
              "Discount %":
                deptActual > 0
                  ? Math.round((deptDiscount / deptActual) * 10000) / 100
                  : 0,
              Category: "",
            });
            exportData.push({
              "S.No": "",
              Roll: "",
              "Student Name": "",
              Class: "",
              Department: "",
              "Actual Fee": "",
              "Discount Amount": "",
              "Net Payable": "",
              "Discount %": "",
              Category: "",
            });

            grandActual += deptActual;
            grandDiscount += deptDiscount;
            grandNet += deptNet;
          });

        if (exportData.length) {
          exportData.push({
            "S.No": "",
            Roll: "",
            "Student Name": "",
            Class: "",
            Department: "Grand Totals",
            "Actual Fee": grandActual,
            "Discount Amount": grandDiscount,
            "Net Payable": grandNet,
            "Discount %":
              grandActual > 0
                ? Math.round((grandDiscount / grandActual) * 10000) / 100
                : 0,
            Category: "",
          });
        }

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Dept Discount");
        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(workbook, `Department_Wise_Discount_${timestamp}.xlsx`);
        this.$bvToast.toast("Report exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error(error);
        this.$bvToast.toast("Failed to export report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    async exportDiscountSummaryExcel() {
      if (this.myObj.format !== "Discount Summary Report") return false;
      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        this.request = false;
        return true;
      }

      const filters = this.resolveAbaDiscountReportFilters();
      let baseUrl = this.$store.state.domain;
      if (!baseUrl.endsWith("/")) baseUrl += "/";

      this.request = true;
      try {
        const apiResponse = await axios.get(
          `${baseUrl}Fees/DiscountSummaryReport`,
          {
            params: {
              db: this.myObj.db,
              cID: this.myObj.campusID,
              classID: filters.classID,
              sectionID: filters.sectionID,
              departmentID: filters.departmentID,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const body = apiResponse.data || {};
        if (body.status !== "success") {
          this.$bvToast.toast(body.message || "Failed to load report data.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
          return true;
        }

        const summary = body.summary || {};
        const breakdown = body.departmentWiseBreakdown || [];
        const rows = [
          ["Discount Summary Report"],
          [],
          ["Total Students", summary.totalStudents || 0],
          ["Total Actual Fees", Number(summary.totalActualFees) || 0],
          ["Total Discount Amount", Number(summary.totalDiscountAmount) || 0],
          ["Net Payable Fees", Number(summary.netPayableFees) || 0],
          ["Discount Percentage", Number(summary.discountPercentage) || 0],
          [],
          [
            "Department",
            "Students",
            "Actual Fees",
            "Discount",
            "Net Payable",
            "Discount %",
          ],
        ];

        breakdown.forEach((row) => {
          rows.push([
            row.departmentName || "",
            row.studentCount || 0,
            Number(row.totalActualFees) || 0,
            Number(row.totalDiscountAmount) || 0,
            Number(row.netPayableFees) || 0,
            Number(row.discountPercentage) || 0,
          ]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Discount Summary");
        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(workbook, `Discount_Summary_${timestamp}.xlsx`);
        this.$bvToast.toast("Report exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error(error);
        this.$bvToast.toast("Failed to export report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    resolveFeeConcessionFilters() {
      const resolvedClassID =
        Array.isArray(this.classID) && this.classID.length > 0
          ? this.classID[0]
          : this.classID || 0;
      const resolvedSectionID =
        Array.isArray(this.secID) && this.secID.length > 0
          ? this.secID[0]
          : this.secID || 0;
      const discountRef = this.disRefList.find(
        (el) => el.id == (this.selectedDisRef || 0)
      );
      const classOpt = this.classesOptions.find(
        (el) => el.id == resolvedClassID
      );
      const secOpt = this.admittedSections.find(
        (el) => el.id == resolvedSectionID
      );
      return {
        classID: resolvedClassID,
        sectionID: resolvedSectionID,
        discountReferenceID: this.selectedDisRef || 0,
        discountRefName: discountRef?.name || "All",
        className: classOpt?.name || "",
        sectionName: secOpt?.section || "",
      };
    },

    openFeeConcessionReport(classWise = false) {
      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const filters = this.resolveFeeConcessionFilters();
      const query = {
        db: this.myObj.db,
        cID: this.myObj.campusID,
        classID: filters.classID,
        sectionID: filters.sectionID,
        discountReferenceID: filters.discountReferenceID,
        discountRefName: filters.discountRefName,
        className: filters.className,
        sectionName: filters.sectionName,
      };

      if (classWise) {
        query.classWise = 1;
      } else {
        query.orientation = this.feeConcessionOrientation || "landscape";
      }

      const routeData = this.$router.resolve({
        name: "fee-concession-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    openClassWiseConcessionReport() {
      this.openFeeConcessionReport(true);
    },

    openSiblingConcessionReport() {
      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const filters = this.resolveFeeConcessionFilters();
      const routeData = this.$router.resolve({
        name: "sibling-concession-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID,
          classID: filters.classID,
          sectionID: filters.sectionID,
          discountReferenceID: filters.discountReferenceID,
          discountRefName: filters.discountRefName,
          className: filters.className,
          sectionName: filters.sectionName,
        },
      });
      window.open(routeData.href, "_blank");
    },

    async exportFeeConcessionExcel() {
      if (this.myObj.format !== "Fees Concession Report") {
        return false;
      }

      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        this.request = false;
        return true;
      }

      const filters = this.resolveFeeConcessionFilters();
      let baseUrl = this.$store.state.domain;
      if (!baseUrl.endsWith("/")) {
        baseUrl += "/";
      }

      this.request = true;
      try {
        const apiResponse = await axios.get(
          `${baseUrl}Fees/FeeConcessionReport`,
          {
            params: {
              db: this.myObj.db,
              cID: this.myObj.campusID,
              classID: filters.classID,
              sectionID: filters.sectionID,
              discountReferenceID: filters.discountReferenceID,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const body = apiResponse.data || {};
        if (body.status !== "success") {
          this.$bvToast.toast(
            body.message || "Failed to load fees concession data.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const items = Array.isArray(body.data) ? body.data : [];
        const includeAmount = this.feeConcessionOrientation !== "portrait";
        const exportData = items.map((item, index) => {
          const row = {
            "S.No": item.sno || index + 1,
            Roll: item.roll || "",
            "Student Name": (item.name || "").toUpperCase(),
            Class: item.className || "",
            "Admission Date": item.admissionDate
              ? new Date(item.admissionDate).toLocaleDateString("en-GB")
              : "",
            Category: item.category || "",
            "Fee Status": item.feeStatus || "",
          };
          if (includeAmount) {
            row.Amount = Number(item.amount) || 0;
          }
          return row;
        });

        if (exportData.length && includeAmount) {
          const totalAmount = items.reduce(
            (sum, item) => sum + (Number(item.amount) || 0),
            0
          );
          exportData.push({
            "S.No": "",
            Roll: "",
            "Student Name": "",
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": "Totals",
            Amount: totalAmount,
          });
        }

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        worksheet["!cols"] = includeAmount
          ? [
              { wch: 6 },
              { wch: 12 },
              { wch: 28 },
              { wch: 14 },
              { wch: 14 },
              { wch: 16 },
              { wch: 16 },
              { wch: 12 },
            ]
          : [
              { wch: 6 },
              { wch: 12 },
              { wch: 28 },
              { wch: 14 },
              { wch: 14 },
              { wch: 16 },
              { wch: 16 },
            ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Fees Concession");

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(workbook, `Fees_Concession_${timestamp}.xlsx`);

        this.$bvToast.toast(
          "Fees concession report exported to Excel successfully.",
          {
            title: "Success",
            variant: "success",
            solid: true,
          }
        );
      } catch (error) {
        console.error("Fees concession export error:", error);
        this.$bvToast.toast("Failed to export fees concession report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    async exportClassWiseConcessionExcel() {
      if (this.myObj.format !== "Class Wise Concession Report") {
        return false;
      }

      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        this.request = false;
        return true;
      }

      const filters = this.resolveFeeConcessionFilters();
      let baseUrl = this.$store.state.domain;
      if (!baseUrl.endsWith("/")) {
        baseUrl += "/";
      }

      this.request = true;
      try {
        const apiResponse = await axios.get(
          `${baseUrl}Fees/FeeConcessionReport`,
          {
            params: {
              db: this.myObj.db,
              cID: this.myObj.campusID,
              classID: filters.classID,
              sectionID: filters.sectionID,
              discountReferenceID: filters.discountReferenceID,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const body = apiResponse.data || {};
        if (body.status !== "success") {
          this.$bvToast.toast(
            body.message || "Failed to load class wise concession data.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const items = Array.isArray(body.data) ? body.data : [];
        const grouped = new Map();

        items.forEach((item) => {
          const className =
            String(item.className || "Unassigned").trim() || "Unassigned";
          if (!grouped.has(className)) {
            grouped.set(className, []);
          }
          grouped.get(className).push(item);
        });

        const sortedClasses = Array.from(grouped.keys()).sort((a, b) =>
          a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" })
        );

        const exportData = [];
        let grandTotal = 0;

        sortedClasses.forEach((className) => {
          const classItems = grouped.get(className) || [];
          exportData.push({
            "S.No": "",
            Roll: "",
            "Student Name": `Class: ${className}`,
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": "",
            Amount: "",
          });

          classItems.forEach((item, index) => {
            exportData.push({
              "S.No": index + 1,
              Roll: item.roll || "",
              "Student Name": (item.name || "").toUpperCase(),
              Class: item.className || "",
              "Admission Date": item.admissionDate
                ? new Date(item.admissionDate).toLocaleDateString("en-GB")
                : "",
              Category: item.category || "",
              "Fee Status": item.feeStatus || "",
              Amount: Number(item.amount) || 0,
            });
          });

          const classTotal = classItems.reduce(
            (sum, item) => sum + (Number(item.amount) || 0),
            0
          );
          grandTotal += classTotal;

          exportData.push({
            "S.No": "",
            Roll: "",
            "Student Name": "",
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": `Class Total (${className})`,
            Amount: classTotal,
          });
          exportData.push({
            "S.No": "",
            Roll: "",
            "Student Name": "",
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": "",
            Amount: "",
          });
        });

        if (exportData.length) {
          exportData.push({
            "S.No": "",
            Roll: "",
            "Student Name": "",
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": "Grand Total",
            Amount: grandTotal,
          });
        }

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        worksheet["!cols"] = [
          { wch: 6 },
          { wch: 12 },
          { wch: 28 },
          { wch: 14 },
          { wch: 14 },
          { wch: 16 },
          { wch: 16 },
          { wch: 12 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Class Wise Concession"
        );

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(workbook, `Class_Wise_Concession_${timestamp}.xlsx`);

        this.$bvToast.toast(
          "Class wise concession report exported to Excel successfully.",
          {
            title: "Success",
            variant: "success",
            solid: true,
          }
        );
      } catch (error) {
        console.error("Class wise concession export error:", error);
        this.$bvToast.toast("Failed to export class wise concession report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    async exportSiblingConcessionExcel() {
      if (this.myObj.format !== "Sibling Concession Report") {
        return false;
      }

      if (this.reportDomain !== "myskoolaba") {
        this.$bvToast.toast("This report is only available for Myskool ABA.", {
          title: "Not Available",
          variant: "warning",
          solid: true,
        });
        this.request = false;
        return true;
      }

      const filters = this.resolveFeeConcessionFilters();
      let baseUrl = this.$store.state.domain;
      if (!baseUrl.endsWith("/")) {
        baseUrl += "/";
      }

      this.request = true;
      try {
        const apiResponse = await axios.get(
          `${baseUrl}Fees/SiblingsByFatherCnicReport`,
          {
            params: {
              db: this.myObj.db,
              cID: this.myObj.campusID,
              classID: filters.classID,
              sectionID: filters.sectionID,
              discountReferenceID: filters.discountReferenceID,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const body = apiResponse.data || {};
        if (body.status !== "success") {
          this.$bvToast.toast(
            body.message || "Failed to load sibling concession data.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const families = Array.isArray(body.data) ? body.data : [];
        const exportData = [];

        families.forEach((family) => {
          exportData.push({
            "Family #": family.sno || "",
            "Father CNIC": family.fatherCnic || "",
            "Father Name": family.fatherName || "",
            "Sibling Count": family.siblingCount || 0,
            Roll: "",
            "Student Name": "",
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": "",
            "Class Fee": "",
            Discount: "",
            Amount: "",
          });

          (family.students || []).forEach((student) => {
            exportData.push({
              "Family #": "",
              "Father CNIC": "",
              "Father Name": "",
              "Sibling Count": "",
              Roll: student.roll || "",
              "Student Name": (student.name || "").toUpperCase(),
              Class: student.className || "",
              "Admission Date": student.admissionDate
                ? new Date(student.admissionDate).toLocaleDateString("en-GB")
                : "",
              Category: student.category || "",
              "Fee Status": student.feeStatus || "",
              "Class Fee": Number(student.classFee) || 0,
              Discount: Number(student.discount) || 0,
              Amount: Number(student.amount) || 0,
            });
          });

          const familyTotal = (family.students || []).reduce(
            (sum, student) => sum + (Number(student.amount) || 0),
            0
          );
          exportData.push({
            "Family #": "",
            "Father CNIC": "",
            "Father Name": "Family Subtotal",
            "Sibling Count": "",
            Roll: "",
            "Student Name": "",
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": "",
            "Class Fee": "",
            Discount: "",
            Amount: familyTotal,
          });
        });

        const grandTotal = families.reduce((sum, family) => {
          return (
            sum +
            (family.students || []).reduce(
              (inner, student) => inner + (Number(student.amount) || 0),
              0
            )
          );
        }, 0);

        if (exportData.length) {
          exportData.push({
            "Family #": "",
            "Father CNIC": "",
            "Father Name": "Grand Total",
            "Sibling Count": "",
            Roll: "",
            "Student Name": "",
            Class: "",
            "Admission Date": "",
            Category: "",
            "Fee Status": "",
            "Class Fee": "",
            Discount: "",
            Amount: grandTotal,
          });
        }

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        worksheet["!cols"] = [
          { wch: 8 },
          { wch: 18 },
          { wch: 24 },
          { wch: 12 },
          { wch: 10 },
          { wch: 28 },
          { wch: 12 },
          { wch: 14 },
          { wch: 18 },
          { wch: 14 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sibling Concession");

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(workbook, `Sibling_Concession_${timestamp}.xlsx`);

        this.$bvToast.toast(
          "Sibling concession report exported to Excel successfully.",
          {
            title: "Success",
            variant: "success",
            solid: true,
          }
        );
      } catch (error) {
        console.error("Sibling concession export error:", error);
        this.$bvToast.toast("Failed to export sibling concession report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    openDateWiseStrengthReport() {
      if (!this.singleDate) {
        this.$bvToast.toast("Please select End Date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const resolveSingleFilterId = (value) => {
        if (Array.isArray(value)) {
          if (!value.length || value[0] === 0) return 0;
          if (value.length === 1) return Number(value[0]) || 0;
          return 0;
        }
        return Number(value) || 0;
      };

      const routeData = this.$router.resolve({
        name: "date-wise-strength-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID,
          endDate: this.singleDate,
          classID: resolveSingleFilterId(this.classID),
          sectionID: resolveSingleFilterId(this.secID),
          departmentID: this.selectedDep || 0,
        },
      });
      window.open(routeData.href, "_blank");
    },

    openBarcodeReport() {
      const start = Number(this.barcodeObj?.start);
      const end = Number(this.barcodeObj?.end);

      if (isNaN(start) || start <= 0 || isNaN(end) || end <= 0) {
        this.$bvToast.toast(this.$t("Start and End must be greater than 0."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
        return;
      }

      if (start >= end) {
        this.$bvToast.toast(this.$t("Start must be less than End."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
        return;
      }

      const db = this.myObj.db || this.$store.state.userData.db || "";
      const cID = this.myObj.campusID ?? this.$store.state.userData.cId ?? "";
      const prefix = this.barcodeObj?.prefix || "";

      const url = `https://${this.reportDomain}.myskool.app/Certificate/Barcode?dbb=${db}&cID=${cID}&prefix=${prefix}&start=${start}&end=${end}`;
      window.open(url, "_blank");
    },

    openCampusTransferReport() {
      const isStaff = this.myObj.format === "Staff Campus Transfer";
      const query = {
        db: this.myObj.db,
      };

      if (this.myObj.campusID && Number(this.myObj.campusID) > 0) {
        query.campusID = this.myObj.campusID;
      }
      if (this.myObj.dtfrom) {
        query.dtFrom = this.myObj.dtfrom;
      }
      if (this.myObj.dtto) {
        query.dtTo = this.myObj.dtto;
      }
      if (!isStaff && this.campusTransferType) {
        query.transferType = this.campusTransferType;
      }

      const routeData = this.$router.resolve({
        name: isStaff
          ? "staff-campus-transfer-report"
          : "campus-transfer-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    openFeeRevenueReport() {
      const routeData = this.$router.resolve({
        name: "fee-revenue-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID || this.$store.state.userData.cId,
          month: this.singleMonth,
          year: this.singleYear,
        },
      });
      window.open(routeData.href, "_blank");
    },

    async exportFeeRevenueExcel() {
      try {
        const res = await this.post({
          url:
            this.$store.state.domain +
            "Fees/LoadFeeRevenueCollection?db=" +
            this.myObj.db +
            "&cID=" +
            (this.myObj.campusID || this.$store.state.userData.cId),
          body: feeRevenueDateRange(this.singleMonth, this.singleYear),
          context: this,
          subjects: true,
          token: this.$store.state.userData.token,
        });

        const rows = Array.isArray(res) ? res : [];
        if (!rows.length) {
          this.$bvToast.toast("No fee revenue records found.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const excelRows = buildFeeRevenueExcelRows(rows);
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(excelRows);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Fee Revenue");
        XLSX.writeFile(workbook, "fee-revenue-report.xlsx");
        return true;
      } catch (e) {
        console.error(e);
        this.$bvToast.toast("Failed to export fee revenue report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return false;
      }
    },

    async exportCampusTransferExcel() {
      const isStaff = this.myObj.format === "Staff Campus Transfer";
      if (
        this.myObj.format !== "Campus Transfer" &&
        this.myObj.format !== "Staff Campus Transfer"
      ) {
        return false;
      }

      this.request = true;
      try {
        let url = isStaff
          ? buildStaffTransferReportUrl({
              domain: this.$store.state.domain,
              db: this.myObj.db,
              campusID: this.myObj.campusID,
              dtFrom: this.myObj.dtfrom,
              dtTo: this.myObj.dtto,
            })
          : this.$store.state.domain +
            "StudentStaffDataLog/CampusTransferReport?db=" +
            this.myObj.db +
            "&type=student";

        if (!isStaff) {
          if (this.myObj.campusID && Number(this.myObj.campusID) > 0) {
            url += "&campusID=" + this.myObj.campusID;
          }
          if (this.myObj.dtfrom) {
            url += "&dtFrom=" + this.myObj.dtfrom;
          }
          if (this.myObj.dtto) {
            url += "&dtTo=" + this.myObj.dtto;
          }
          if (this.campusTransferType) {
            url += "&transferType=" + this.campusTransferType;
          }
        }

        const response = await this.get({
          url,
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        const rows =
          response && response.status === "success"
            ? response.data || []
            : Array.isArray(response)
            ? response
            : response && Array.isArray(response.data)
            ? response.data
            : [];

        if (!rows.length) {
          this.$bvToast.toast(
            isStaff
              ? "No staff campus transfer records found."
              : "No campus transfer records found.",
            {
              title: "Warning",
              variant: "warning",
              solid: true,
            }
          );
          return true;
        }

        const excelRows = rows.map((item, index) =>
          isStaff
            ? buildStaffCampusTransferExcelRow(item, index)
            : buildCampusTransferExcelRow(item, index)
        );

        const worksheet = XLSX.utils.json_to_sheet(excelRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          isStaff ? "Staff Campus Transfer" : "Campus Transfer"
        );

        const from = this.myObj.dtfrom || "all";
        const to = this.myObj.dtto || "all";
        const filePrefix = isStaff
          ? "Staff_Campus_Transfer"
          : "Campus_Transfer";
        const typeSuffix =
          !isStaff && this.campusTransferType
            ? `_${this.campusTransferType}`
            : "";
        XLSX.writeFile(
          workbook,
          `${filePrefix}${typeSuffix}_${from}_to_${to}_${Date.now()}.xlsx`
        );

        this.$bvToast.toast(
          isStaff
            ? "Staff campus transfer report exported successfully."
            : "Campus transfer report exported successfully.",
          {
            title: "Success",
            variant: "success",
            solid: true,
          }
        );
      } catch (error) {
        console.error("Campus transfer export error:", error);
        this.$bvToast.toast(
          isStaff
            ? "Failed to export staff campus transfer report."
            : "Failed to export campus transfer report.",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.request = false;
      }
      return true;
    },

    async exportCustomFeeExcel() {
      if (this.myObj.format !== "Custom Fee Report") return false;

      this.request = true;
      try {
        const classID =
          Array.isArray(this.classID) && this.classID.length > 0
            ? this.classID[0]
            : this.classID || 0;
        const secID =
          Array.isArray(this.secID) && this.secID.length > 0
            ? this.secID[0]
            : this.secID || 0;

        const url =
          this.$store.state.domain +
          "StudentsCustomFee/GetCustomFeesReport?db=" +
          this.myObj.db +
          "&cID=" +
          (this.myObj.campusID || 0) +
          "&classID=" +
          (classID || 0) +
          "&secID=" +
          (secID || 0) +
          "&search=" +
          encodeURIComponent(this.myObj.search || "") +
          "&feeType=" +
          (this.customFeeTypeID || 0) +
          "&month=" +
          (this.customFeeMonth || 0);

        const response = await this.get({
          url,
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        const rows =
          response && response.status === "success"
            ? response.data || []
            : Array.isArray(response)
            ? response
            : response && Array.isArray(response.data)
            ? response.data
            : [];

        const reportTotalAmount =
          response && response.status === "success"
            ? response.totalAmount ?? response.total_amount
            : null;

        if (!rows.length) {
          this.$bvToast.toast("No custom fee records found.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const excelRows = rows.map((item, index) => {
          const joining = item.date_of_joining || item.dateOfJoining;
          const fatherName =
            item.father_name ??
            item.fatherName ??
            item.father ??
            item.FatherName ??
            "";
          const mobile =
            item.mobileNumber ??
            item.mobile ??
            item.contact_father ??
            item.contactFather ??
            item.contact ??
            item.phone ??
            "";
          const address =
            item.address ??
            item.address_current ??
            item.addressCurrent ??
            item.residentialArea ??
            item.studentAddress ??
            "";
          return {
            "#": index + 1,
            "GR No": item.grNo || "",
            "Student Name": item.studentName || item.name || "",
            "Father's Name": fatherName ? String(fatherName).trim() : "",
            "Mobile Number": mobile ? String(mobile).trim() : "",
            Address: address ? String(address).trim() : "",
            "Class / Sec":
              [item.className, item.sectionName].filter(Boolean).join(" - ") ||
              item.meta_class ||
              "",
            "Fee Type": item.feeType || "",
            Amount: Number(item.amount) || 0,
            "Date of Joining": joining
              ? new Date(joining).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              : "",
          };
        });

        if (
          reportTotalAmount !== undefined &&
          reportTotalAmount !== null &&
          reportTotalAmount !== ""
        ) {
          excelRows.push({
            "#": "",
            "GR No": "",
            "Student Name": "",
            "Father's Name": "",
            "Mobile Number": "",
            Address: "",
            "Class / Sec": "",
            "Fee Type": "TOTAL AMOUNT",
            Amount: Number(reportTotalAmount) || 0,
            "Date of Joining": "",
          });
        }

        const worksheet = XLSX.utils.json_to_sheet(excelRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Custom Fee");

        XLSX.writeFile(workbook, `Custom_Fee_Report_${Date.now()}.xlsx`);

        this.$bvToast.toast("Custom fee report exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Custom fee export error:", error);
        this.$bvToast.toast("Failed to export custom fee report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    async exportSubjectFeeExcel() {
      if (this.myObj.format !== "Subject Wise Fees") return false;

      const classID = this.resolveEventCalendarFilterId(this.classID);
      const sectionID = this.resolveEventCalendarFilterId(this.secID);

      if (!classID) {
        this.$bvToast.toast("Please select a class.", {
          title: "Required",
          variant: "warning",
          solid: true,
        });
        return true;
      }
      if (!sectionID) {
        this.$bvToast.toast("Please select a section.", {
          title: "Required",
          variant: "warning",
          solid: true,
        });
        return true;
      }

      const classLabel =
        this.classesOptions.find((c) => c.id === classID)?.name ||
        String(classID);
      const sectionLabel =
        this.admittedSections.find((s) => s.id === sectionID)?.section ||
        String(sectionID);

      this.request = true;
      try {
        const url =
          this.$store.state.domain +
          "StudentSubjectsEnrollnment/GetSubjectFeeReport?db=" +
          encodeURIComponent(this.myObj.db) +
          "&cID=" +
          (this.myObj.campusID || this.$store.state.userData.cId || 0) +
          "&classID=" +
          classID +
          "&sectionID=" +
          sectionID +
          "&sessionID=" +
          (this.subjectFeeSessionID || 0) +
          "&sID=0";

        const response = await this.get({
          url,
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        const students =
          response && response.status === "success"
            ? response.data || []
            : Array.isArray(response)
            ? response
            : response && Array.isArray(response.data)
            ? response.data
            : [];

        if (!students.length) {
          this.$bvToast.toast("No subject fee records found.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const subjectMap = new Map();
        students.forEach((student) => {
          (student.subjects || []).forEach((subject) => {
            const id = subject.subjectID;
            if (id != null && !subjectMap.has(id)) {
              subjectMap.set(id, subject.subjectName || `Subject ${id}`);
            }
          });
        });

        const subjectColumns = Array.from(subjectMap.entries())
          .map(([id, name]) => ({ id: Number(id), name }))
          .sort((a, b) => a.name.localeCompare(b.name));

        const getSubjectFee = (student, subjectID) => {
          const subject = (student.subjects || []).find(
            (s) => Number(s.subjectID) === Number(subjectID)
          );
          if (!subject) return "N/A";
          if (subject.isExcluded) return "Excl.";
          const fee = Number(subject.subjectFee);
          return !Number.isNaN(fee) ? fee : 0;
        };

        const excelRows = students.map((student, index) => {
          const row = {
            "#": index + 1,
            "GR No": student.grNo || "",
            "Student Name": student.studentName || "",
          };
          subjectColumns.forEach((subject) => {
            row[subject.name] = getSubjectFee(student, subject.id);
          });
          row.Total = Number(student.totalSubjectFee) || 0;
          return row;
        });

        const totalRow = {
          "#": "",
          "GR No": "",
          "Student Name": "Grand Total",
        };
        subjectColumns.forEach((subject) => {
          totalRow[subject.name] = students.reduce((sum, student) => {
            const fee = getSubjectFee(student, subject.id);
            return sum + (typeof fee === "number" ? fee : 0);
          }, 0);
        });
        totalRow.Total = students.reduce(
          (sum, student) => sum + (Number(student.totalSubjectFee) || 0),
          0
        );
        excelRows.push(totalRow);

        const sessionLabel = (() => {
          if (!this.subjectFeeSessionID) return "All Sessions";
          const sess = (this.sessions || []).find(
            (s) => s.id === this.subjectFeeSessionID
          );
          return sess ? sess.session : `Session ${this.subjectFeeSessionID}`;
        })();

        const metaRows = [
          ["Subject Wise Fees Report"],
          [
            `Class: ${classLabel}`,
            `Section: ${sectionLabel}`,
            `Session: ${sessionLabel}`,
          ],
          [],
        ];
        const worksheet = XLSX.utils.aoa_to_sheet(metaRows);
        XLSX.utils.sheet_add_json(worksheet, excelRows, {
          origin: "A4",
          skipHeader: false,
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Wise Fees");

        const safeClass = String(classLabel).replace(/[^\w\-]+/g, "_");
        const safeSection = String(sectionLabel).replace(/[^\w\-]+/g, "_");
        XLSX.writeFile(
          workbook,
          `Subject_Wise_Fees_${safeClass}_${safeSection}_${Date.now()}.xlsx`
        );

        this.$bvToast.toast("Subject wise fees exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Subject fee export error:", error);
        this.$bvToast.toast("Failed to export subject wise fees report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    dateWiseStrengthIsExMatricClass(className) {
      const cls = String(className || "")
        .trim()
        .toUpperCase()
        .replace(/-/g, " ");
      return cls.includes("EX MATRIC") || cls.includes("EXMATRIC");
    },

    dateWiseStrengthGetStudents(cls) {
      if (Array.isArray(cls.students) && cls.students.length) {
        return [...cls.students];
      }
      return [
        ...(cls.presentStudents || []),
        ...(cls.registeredStudents || []),
        ...(cls.leftStudents || []),
      ];
    },

    dateWiseStrengthClassSortOrder(className) {
      if (this.dateWiseStrengthIsExMatricClass(className)) return 900;

      const cls = String(className || "")
        .trim()
        .toUpperCase()
        .replace(/-/g, " ");

      if (cls.includes("PRE ADMISSION")) return 0;
      if (cls === "PG" || cls.startsWith("PG ")) return 1;
      if (cls.includes("PRE NURSERY")) return 2;
      if (cls.includes("NURSERY")) return 3;
      if (cls.includes("KINDER") || cls.includes("KG")) return 4;

      const tokens = cls.replace(/[^A-Z0-9]/g, " ").split(/\s+/);
      if (tokens.includes("XII") || tokens.includes("12")) return 16;
      if (tokens.includes("XI") || tokens.includes("11")) return 15;
      if (tokens.includes("X") || tokens.includes("10")) return 14;
      if (tokens.includes("IX") || tokens.includes("9")) return 13;
      if (tokens.includes("VIII") || tokens.includes("8")) return 12;
      if (tokens.includes("VII") || tokens.includes("7")) return 11;
      if (tokens.includes("VI") || tokens.includes("6")) return 10;
      if (tokens.includes("V") || tokens.includes("5")) return 9;
      if (tokens.includes("IV") || tokens.includes("4")) return 8;
      if (tokens.includes("III") || tokens.includes("3")) return 7;
      if (tokens.includes("II") || tokens.includes("2")) return 6;
      if (tokens.includes("I") || tokens.includes("1")) return 5;

      return 100;
    },

    dateWiseStrengthGetClassSequence(cls) {
      if (cls.classSequence != null && cls.classSequence !== "") {
        return Number(cls.classSequence);
      }
      const firstStudent = this.dateWiseStrengthGetStudents(cls)[0];
      if (firstStudent && firstStudent.classSequence != null) {
        return Number(firstStudent.classSequence);
      }
      return this.dateWiseStrengthClassSortOrder(cls.className);
    },

    dateWiseStrengthCompareClasses(a, b) {
      const exA = this.dateWiseStrengthIsExMatricClass(a.className) ? 1 : 0;
      const exB = this.dateWiseStrengthIsExMatricClass(b.className) ? 1 : 0;
      if (exA !== exB) return exA - exB;

      const seqA = this.dateWiseStrengthGetClassSequence(a);
      const seqB = this.dateWiseStrengthGetClassSequence(b);
      if (seqA !== seqB) return seqA - seqB;

      return String(a.className || "").localeCompare(
        String(b.className || ""),
        undefined,
        { numeric: true, sensitivity: "base" }
      );
    },

    normalizeDateWiseStrengthPayload(data, forHeadOffice) {
      if (!data) return null;
      if (Array.isArray(data)) {
        return { campuses: data };
      }
      if (typeof data !== "object") return data;

      const campuses = data.campuses || data.campusWiseData;
      if (Array.isArray(campuses) && campuses.length) {
        return data;
      }

      const classes = Array.isArray(data.classes) ? data.classes : [];
      if (!classes.length || forHeadOffice === false) return data;

      const campusMap = {};
      const campusOrder = [];
      const getStudents = (cls) => this.dateWiseStrengthGetStudents(cls);

      const campusKeyForClass = (cls) => {
        const students = getStudents(cls);
        const cid =
          cls.campusID ??
          cls.cID ??
          cls.campusId ??
          (students[0] &&
            (students[0].campusID ?? students[0].cID));
        const cname =
          cls.campusBranch ||
          cls.campusName ||
          cls.branch ||
          cls.branchName ||
          "";
        if (cid != null && cid !== "") return `id-${cid}`;
        if (cname) return `name-${cname}`;
        return null;
      };

      classes.forEach((cls) => {
        const key = campusKeyForClass(cls);
        if (!key) return;

        if (!campusMap[key]) {
          const cid =
            cls.campusID ?? cls.cID ?? cls.campusId ?? key.replace(/^id-/, "");
          const name =
            cls.campusName || cls.organizationName || cls.branch || "Campus";
          const branch = cls.campusBranch || cls.branch || cls.branchName || "";
          campusMap[key] = {
            campusID: cid,
            campusName: name,
            campusBranch: branch,
            classes: [],
          };
          campusOrder.push(key);
        }
        campusMap[key].classes.push(cls);
      });

      if (campusOrder.length > 1 && forHeadOffice !== false) {
        const { classes: _ignoredClasses, ...rest } = data;
        return {
          ...rest,
          campuses: campusOrder.map((key) => campusMap[key]),
        };
      }

      return data;
    },

    isDateWiseStrengthCampusWise(payload) {
      if (Number(this.myObj.campusID) !== 1) return false;
      if (!payload) return false;
      if (payload.campusWise === true || payload.isCampusWise === true) {
        return true;
      }
      const campuses = payload.campuses || payload.campusWiseData;
      return Array.isArray(campuses) && campuses.length > 0;
    },

    dateWiseStrengthCampusLabel(campus) {
      const name =
        campus.campusName ||
        campus.name ||
        campus.organizationName ||
        "Campus";
      const branch =
        campus.campusBranch || campus.branch || campus.branchName || "";
      return branch && branch !== name ? `${name} — ${branch}` : name;
    },

    dateWiseStrengthCampusStrength(campus, classes) {
      const summary = campus && campus.summary;
      if (summary) {
        const n = Number(summary.totalCount ?? summary.presentCount ?? 0);
        if (n) return n;
      }
      const list = classes || [];
      return list.reduce((sum, cls) => {
        const count = cls.presentCount ?? cls.totalCount;
        if (count != null && count !== "") return sum + (Number(count) || 0);
        return sum + this.dateWiseStrengthGetStudents(cls).length;
      }, 0);
    },

    buildDateWiseStrengthExportRows(payload) {
      const forHeadOffice = Number(this.myObj.campusID) === 1;
      const normalized =
        this.normalizeDateWiseStrengthPayload(payload, forHeadOffice) || {};
      const campusWise =
        forHeadOffice && this.isDateWiseStrengthCampusWise(normalized);
      const formatContact = (student) => {
        const direct = [
          student.contact_father,
          student.contact_mother,
          student.contact_student,
          student.contact_home,
        ].find((value) => value && String(value).trim());
        if (direct) return String(direct).trim();
        const details = String(student.contactDetails || "").trim();
        if (details) {
          return (
            details
              .split("\n")
              .map((line) => line.trim())
              .filter(Boolean)[0] || "-"
          );
        }
        return "-";
      };

      const appendClassesToRows = (classes, campusLabel) => {
        const sorted = [...(classes || [])].sort((a, b) =>
          this.dateWiseStrengthCompareClasses(a, b)
        );
        sorted.forEach((cls) => {
          const students = this.dateWiseStrengthGetStudents(cls).sort((a, b) =>
            String(a.grNo || "").localeCompare(String(b.grNo || ""), undefined, {
              numeric: true,
            })
          );
          students.forEach((student, index) => {
            const strength =
              cls.presentCount ?? cls.totalCount ?? students.length;
            if (campusWise) {
              rows.push({
                "#": index + 1,
                Campus: campusLabel || "",
                Class: cls.className || "",
                "GR No": student.grNo || "",
                "Student Name": student.name || "",
                "Father Name": student.fatherName || student.father_name || "",
                Section: student.sectionName || student.section || "",
                Gender: student.genderLabel || student.gender || "",
                Contact: formatContact(student),
                Strength: strength,
              });
            } else {
              rows.push({
                "#": index + 1,
                Class: cls.className || "",
                "GR No": student.grNo || "",
                "Student Name": student.name || "",
                "Father Name": student.fatherName || student.father_name || "",
                Section: student.sectionName || student.section || "",
                Gender: student.genderLabel || student.gender || "",
                Contact: formatContact(student),
                Strength: strength,
              });
            }
          });
        });
        return sorted;
      };

      const rows = [];
      let classCount = 0;
      const campusSummaryRows = [];

      if (campusWise) {
        const list = normalized.campuses || normalized.campusWiseData || [];
        list.forEach((campus) => {
          const label = this.dateWiseStrengthCampusLabel(campus);
          const classes =
            campus.classes || campus.Classes || campus.classList || [];
          const sorted = appendClassesToRows(classes, label);
          classCount += sorted.length;
          campusSummaryRows.push({
            Campus: label,
            Students: this.dateWiseStrengthCampusStrength(campus, classes),
            Classes: sorted.length,
          });
        });
      } else {
        let classes = Array.isArray(normalized.classes)
          ? normalized.classes
          : [];
        if (!classes.length) {
          const campuses = normalized.campuses || normalized.campusWiseData;
          if (Array.isArray(campuses) && campuses.length) {
            classes = campuses.flatMap(
              (c) => c.classes || c.Classes || c.classList || []
            );
          }
        }
        const sorted = appendClassesToRows(classes, "");
        classCount = sorted.length;
      }

      return {
        rows,
        campusWise,
        classCount,
        campusSummaryRows,
        normalized,
      };
    },

    async exportDateWiseStrengthExcel() {
      if (this.myObj.format !== "Date wise strength") return false;

      if (!this.singleDate) {
        this.$bvToast.toast("Please select End Date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return true;
      }

      const resolveSingleFilterId = (value) => {
        if (Array.isArray(value)) {
          if (!value.length || value[0] === 0) return 0;
          if (value.length === 1) return Number(value[0]) || 0;
          return 0;
        }
        return Number(value) || 0;
      };

      this.request = true;
      try {
        const classID = resolveSingleFilterId(this.classID);
        const sectionID = resolveSingleFilterId(this.secID);
        const departmentID = this.selectedDep || 0;

        const response = await this.get({
          url:
            this.$store.state.domain +
            "Students/ClassWiseStudentStatusReport?db=" +
            this.myObj.db +
            "&cID=" +
            this.myObj.campusID +
            "&endDate=" +
            this.singleDate +
            "&classID=" +
            classID +
            "&sectionID=" +
            sectionID +
            "&departmentID=" +
            departmentID,
          token: this.$store.state.userData.token,
          dashboard: true,
        });

        const payload =
          response && response.status === "success"
            ? response.data
            : response && response.data
            ? response.data
            : null;

        if (!payload) {
          this.$bvToast.toast("No date wise strength data found.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const {
          rows,
          campusWise,
          classCount,
          campusSummaryRows,
          normalized,
        } = this.buildDateWiseStrengthExportRows(payload);

        const summary = normalized.summary || payload.summary || {};
        const totalFromSummary = Number(
          summary.totalCount ?? summary.presentCount ?? 0
        );
        const summaryRows = [
          {
            Metric: "Total Strength",
            Value: totalFromSummary || rows.length,
          },
          { Metric: "Report Date", Value: this.singleDate },
          {
            Metric: campusWise ? "Total Classes" : "Classes",
            Value: classCount,
          },
        ];
        if (campusWise) {
          summaryRows.push({
            Metric: "Campuses",
            Value: campusSummaryRows.length,
          });
          campusSummaryRows.forEach((item) => {
            summaryRows.push({
              Metric: item.Campus,
              Value: `${item.Students} students / ${item.Classes} classes`,
            });
          });
        }

        const emptyStudentRow = campusWise
          ? {
              "#": "",
              Campus: "",
              Class: "",
              "GR No": "",
              "Student Name": "No records",
              "Father Name": "",
              Section: "",
              Gender: "",
              Contact: "",
              Strength: "",
            }
          : {
              "#": "",
              Class: "",
              "GR No": "",
              "Student Name": "No records",
              "Father Name": "",
              Section: "",
              Gender: "",
              Contact: "",
              Strength: "",
            };

        const workbook = XLSX.utils.book_new();
        const summarySheet = XLSX.utils.json_to_sheet(summaryRows);
        XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

        if (campusWise && campusSummaryRows.length) {
          const campusSheet = XLSX.utils.json_to_sheet(campusSummaryRows);
          XLSX.utils.book_append_sheet(
            workbook,
            campusSheet,
            "Campus Summary"
          );
        }

        const detailSheet = XLSX.utils.json_to_sheet(
          rows.length ? rows : [emptyStudentRow]
        );
        XLSX.utils.book_append_sheet(workbook, detailSheet, "Students");

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(
          workbook,
          `Date_Wise_Strength_${this.singleDate}_${timestamp}.xlsx`
        );

        this.$bvToast.toast(
          rows.length
            ? `Date wise strength exported (${rows.length} records).`
            : "Date wise strength exported (no records).",
          {
            title: "Success",
            variant: "success",
            solid: true,
          }
        );
      } catch (error) {
        console.error("Date wise strength export error:", error);
        this.$bvToast.toast("Failed to export date wise strength report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    normalizeInquiryReportDate(value) {
      if (value === null || value === undefined || value === "") return null;
      return value;
    },

    buildInquiryReportPayload(inquiryTypeOverride) {
      return {
        db: this.myObj.db,
        campusID:
          Number(this.myObj.campusID) ||
          Number(this.$store.state.userData.cId) ||
          0,
        inquiryType:
          inquiryTypeOverride ||
          (this.myObj.format === "Visitors" ? "visitor" : "inquiry"),
        classID: this.resolveEventCalendarFilterId(this.classID),
        sessionID:
          this.myObj.sessionID === null ||
          this.myObj.sessionID === undefined ||
          this.myObj.sessionID === ""
            ? 0
            : Number(this.myObj.sessionID),
        dateFrom: this.normalizeInquiryReportDate(this.myObj.dtfrom),
        dateTill: this.normalizeInquiryReportDate(this.myObj.dtto),
      };
    },

    openInquiryReport() {
      if (
        this.myObj.sessionID === null ||
        this.myObj.sessionID === undefined ||
        this.myObj.sessionID === ""
      ) {
        this.$bvToast.toast("Please select session.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return false;
      }

      const payload = this.buildInquiryReportPayload();
      const routeData = this.$router.resolve({
        name: "inquiry-report-print",
        query: {
          db: payload.db,
          cID: payload.campusID,
          classID: payload.classID,
          sessionID: payload.sessionID,
          inquiryType: payload.inquiryType,
          ...(payload.dateFrom ? { dateFrom: payload.dateFrom } : {}),
          ...(payload.dateTill ? { dateTill: payload.dateTill } : {}),
        },
      });
      window.open(routeData.href, "_blank");
      return true;
    },

    buildNewAdmissionListParams() {
      const classIds = this.normalizeFilterIds(this.classID)
        .map((id) => Number(id))
        .filter((id) => id > 0);
      const sectionIds = this.normalizeFilterIds(this.secID)
        .map((id) => Number(id))
        .filter((id) => id > 0);

      const classID =
        classIds.length === 1
          ? classIds[0]
          : this.resolveEventCalendarFilterId(this.classID);
      const sectionID =
        sectionIds.length === 1
          ? sectionIds[0]
          : this.resolveEventCalendarFilterId(this.secID);

      return {
        db: this.myObj.db,
        campusID:
          Number(this.myObj.campusID) ||
          Number(this.$store.state.userData.cId) ||
          0,
        dateFrom: this.normalizeInquiryReportDate(this.myObj.dtfrom),
        dateTill: this.normalizeInquiryReportDate(this.myObj.dtto),
        departmentID: Number(this.selectedDep) || 0,
        classID: Number(classID) || 0,
        sectionID: Number(sectionID) || 0,
        classIDs: classIds.length > 1 ? classIds.join(",") : "",
        sectionIDs: sectionIds.length > 1 ? sectionIds.join(",") : "",
      };
    },

    openNewAdmissionListReport() {
      if (!this.isMyskoolIussDomain()) {
        return false;
      }

      const params = this.buildNewAdmissionListParams();
      const routeData = this.$router.resolve({
        name: "new-admission-list-report",
        query: {
          db: params.db,
          cID: params.campusID,
          departmentID: params.departmentID,
          classID: params.classID,
          sectionID: params.sectionID,
          ...(params.classIDs ? { classIDs: params.classIDs } : {}),
          ...(params.sectionIDs ? { sectionIDs: params.sectionIDs } : {}),
          ...(params.dateFrom ? { dateFrom: params.dateFrom } : {}),
          ...(params.dateTill ? { dateTill: params.dateTill } : {}),
        },
      });
      window.open(routeData.href, "_blank");
      return true;
    },

    flattenNewAdmissionGroups(payload) {
      const formatDoa = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      };

      const pushStudentRows = (rows, campusName, deptName, students) => {
        (students || []).forEach((student, index) => {
          const doa =
            student.date_of_admission ||
            student.doa ||
            student.admissionDate ||
            student.dateOfAdmission ||
            null;
          rows.push({
            "#": index + 1,
            Campus: campusName || "",
            Department: deptName || "",
            "GR No": student.grNo || student.gr || student.GRNo || "",
            Name: student.name || student.studentName || "",
            "Father's Name":
              student.fatherName || student.father_name || student.father || "",
            "Date of Admission": formatDoa(doa),
            Class:
              student.className ||
              student.class ||
              student.clsName ||
              student.meta_class ||
              "",
            Address: student.address || student.residentialArea || "",
          });
        });
      };

      const looksLikeStudent = (item) => {
        if (!item || typeof item !== "object") return false;
        return (
          item.grNo != null ||
          item.GRNo != null ||
          item.date_of_admission != null ||
          item.doa != null ||
          ((item.name != null || item.studentName != null) &&
            item.departments == null &&
            item.Departments == null &&
            item.students == null &&
            item.Students == null)
        );
      };

      const rows = [];
      if (!payload) return rows;

      let source = payload;
      if (!Array.isArray(source) && typeof source === "object") {
        if (Array.isArray(source.campuses)) source = source.campuses;
        else if (Array.isArray(source.data)) source = source.data;
        else if (Array.isArray(source.departments)) {
          source = [
            {
              campusName: "Campus",
              campusBranch: "Campus",
              departments: source.departments,
            },
          ];
        } else if (Array.isArray(source.students)) {
          source = source.students;
        } else {
          source = [];
        }
      }

      if (!Array.isArray(source) || !source.length) return rows;

      // Flat student list
      if (looksLikeStudent(source[0])) {
        source.forEach((student, index) => {
          const doa =
            student.date_of_admission ||
            student.doa ||
            student.admissionDate ||
            null;
          rows.push({
            "#": index + 1,
            Campus:
              student.campusBranch ||
              student.campusName ||
              student.branch ||
              "",
            Department: student.departmentName || student.department || "",
            "GR No": student.grNo || student.gr || "",
            Name: student.name || student.studentName || "",
            "Father's Name":
              student.fatherName || student.father_name || student.father || "",
            "Date of Admission": formatDoa(doa),
            Class: student.className || student.class || "",
            Address: student.address || student.residentialArea || "",
          });
        });
        return rows;
      }

      // Campus → Department → students
      // or Department → students
      const isDepartmentFirst =
        source[0].students ||
        source[0].Students ||
        source[0].departmentName ||
        source[0].department;

      const campuses =
        isDepartmentFirst && !source[0].departments
          ? [
              {
                campusName: "Campus",
                campusBranch: "Campus",
                departments: source,
              },
            ]
          : source;

      campuses.forEach((campus) => {
        const campusName =
          campus.campusBranch ||
          campus.campusName ||
          campus.branch ||
          campus.branchName ||
          campus.name ||
          "";

        let departments =
          campus.departments ||
          campus.Departments ||
          campus.departmentList ||
          [];

        if (!Array.isArray(departments)) departments = [];

        if (!departments.length && Array.isArray(campus.students)) {
          departments = [
            {
              departmentName: "All Departments",
              students: campus.students,
            },
          ];
        }

        departments.forEach((dept) => {
          const deptName =
            dept.departmentName ||
            dept.name ||
            dept.department ||
            dept.title ||
            "";
          const students =
            dept.students || dept.Students || dept.items || dept.data || [];
          pushStudentRows(rows, campusName, deptName, students);
        });
      });

      return rows;
    },

    isMyskoolIussDomain() {
      const fromState = String(this.reportDomain || "")
        .replace(/_/g, "")
        .toLowerCase();
      const fromStore = String(this.$store.state.report || "")
        .replace(/_/g, "")
        .toLowerCase();
      return fromState === "myskooliuss" || fromStore === "myskooliuss";
    },

    async exportNewAdmissionListExcel() {
      if (this.myObj.format !== "New admission") {
        return false;
      }
      if (!this.isMyskoolIussDomain()) {
        return false;
      }

      if (!this.myObj.dtfrom || !this.myObj.dtto) {
        this.$bvToast.toast("Please select date range.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return true;
      }

      this.request = true;
      try {
        const params = this.buildNewAdmissionListParams();
        let baseUrl =
          this.$store.state.domain || "https://apiv26.myskool.app/api/";
        if (!baseUrl.endsWith("/")) baseUrl += "/";

        const query = {
          db: params.db,
          campusID: params.campusID,
          departmentID: params.departmentID,
          classID: params.classID,
          sectionID: params.sectionID,
          dateFrom: params.dateFrom,
          dateTill: params.dateTill,
        };
        if (params.classIDs) query.classIDs = params.classIDs;
        if (params.sectionIDs) query.sectionIDs = params.sectionIDs;

        const response = await axios.get(
          `${baseUrl}Students/NewAdmissionListReport`,
          {
            params: query,
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        let payload = [];
        if (response.data && response.data.status === "success") {
          payload = response.data.data;
        } else if (Array.isArray(response.data)) {
          payload = response.data;
        } else if (Array.isArray(response.data?.data)) {
          payload = response.data.data;
        } else if (response.data?.data) {
          payload = response.data.data;
        }

        const rows = this.flattenNewAdmissionGroups(payload);
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(
          rows.length
            ? rows
            : [
                {
                  "#": "",
                  Campus: "",
                  Department: "",
                  "GR No": "",
                  Name: "No records found",
                  "Father's Name": "",
                  "Date of Admission": "",
                  Class: "",
                  Address: "",
                },
              ]
        );
        XLSX.utils.book_append_sheet(workbook, sheet, "New Admission");

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        const dateSuffix =
          params.dateFrom && params.dateTill
            ? `${params.dateFrom}_to_${params.dateTill}_`
            : "all_dates_";
        XLSX.writeFile(
          workbook,
          `New_Admission_List_${dateSuffix}${timestamp}.xlsx`
        );

        this.$bvToast.toast(
          rows.length
            ? `New admission list exported (${rows.length} records).`
            : "New admission list exported (no records).",
          {
            title: "Success",
            variant: "success",
            solid: true,
          }
        );
      } catch (error) {
        console.error("New admission export error:", error);
        this.$bvToast.toast(
          error?.response?.data?.message ||
            "Failed to export New admission report.",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.request = false;
      }
      return true;
    },

    resolveReconciliationCampusId(campusID) {
      const id = Number(campusID) || 0;
      return id === 1 ? 0 : id;
    },

    buildReconciliationFeesParams() {
      const campusID =
        Number(this.myObj.campusID) ||
        Number(this.$store.state.userData.cId) ||
        0;
      const classID = this.resolveEventCalendarFilterId(this.classID) || 0;
      const sectionID = this.resolveEventCalendarFilterId(this.secID) || 0;

      return {
        db: this.myObj.db,
        cID: this.resolveReconciliationCampusId(campusID),
        selectedCampusID: campusID,
        classID: Number(classID) || 0,
        sectionID: Number(sectionID) || 0,
        departmentID: Number(this.selectedDep) || 0,
        reportStatus: this.reconciliationReportStatus || "all",
        dateFrom: this.normalizeInquiryReportDate(this.myObj.dtfrom),
        dateTill: this.normalizeInquiryReportDate(this.myObj.dtto),
      };
    },

    openReconciliationFeesReport() {
      if (!this.isMyskoolIussDomain()) {
        return false;
      }

      const params = this.buildReconciliationFeesParams();
      const routeData = this.$router.resolve({
        name: "reconciliation-fees-report",
        query: {
          db: params.db,
          cID: params.cID,
          selectedCampusID: params.selectedCampusID,
          departmentID: params.departmentID,
          classID: params.classID,
          sectionID: params.sectionID,
          reportStatus: params.reportStatus,
          ...(params.dateFrom ? { dateFrom: params.dateFrom } : {}),
          ...(params.dateTill ? { dateTill: params.dateTill } : {}),
        },
      });
      window.open(routeData.href, "_blank");
      return true;
    },

    flattenReconciliationFeesRows(payload, selectedCampusID, apiCampusId) {
      const formatDoa = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      };

      const formatFees = (value) => {
        if (value === null || value === undefined || value === "") return "";
        const num = Number(value);
        if (Number.isFinite(num)) return num;
        return String(value);
      };

      const formatFreeShip = (raw) => {
        const freeShip =
          raw.freeShipStudent ??
          raw.free_ship_student ??
          raw.isFreeShip ??
          raw.freeShip;
        if (freeShip === true || freeShip === 1 || freeShip === "1")
          return "YES";
        if (freeShip === false || freeShip === 0 || freeShip === "0")
          return "NO";
        if (freeShip != null && freeShip !== "") {
          return String(freeShip).toUpperCase();
        }
        return "";
      };

      const getCampusNameById = (id) => {
        if (id == null || id === "") return "";
        const match = (this.$store.state.branches || []).find(
          (b) => Number(b.id) === Number(id)
        );
        return match ? match.branch || match.name || "" : "";
      };

      const looksLikeRecord = (item) => {
        if (!item || typeof item !== "object") return false;
        return (
          item.grNo != null ||
          item.name != null ||
          item.sno != null ||
          item.reportStatus != null
        );
      };

      const normalizeRecord = (raw) => ({
        grNo: raw.grNo || raw.gr || raw.GRNo || "",
        name: raw.name || raw.studentName || "",
        fatherName: raw.fatherName || raw.father_name || raw.father || "",
        date_of_admission:
          raw.date_of_admission || raw.dateOfAdmission || raw.doa || null,
        fees: raw.fees ?? raw.monthly_fee ?? raw.monthlyFee ?? "",
        monthOfWithdrawal:
          raw.monthOfWithdrawal || raw.month_of_withdrawal || "",
        monthOfTransfer: raw.monthOfTransfer || raw.month_of_transfer || "",
        freeShipStudent: formatFreeShip(raw),
        reportStatus: raw.reportStatus || raw.status || raw.STATUS || "",
        campusID: raw.campusID,
        campusName:
          raw.campusBranch || raw.campusName || raw.branch || raw.campus || "",
      });

      const rows = [];
      if (!payload) return rows;

      let source = payload;
      if (!Array.isArray(source) && typeof source === "object") {
        if (Array.isArray(source.campuses)) source = source.campuses;
        else if (Array.isArray(source.data)) source = source.data;
        else if (Array.isArray(source.records)) source = source.records;
        else source = [];
      }

      if (!Array.isArray(source) || !source.length) return rows;

      const isAllCampuses =
        Number(selectedCampusID) === 1 || Number(apiCampusId) === 0;

      const pushRecord = (record, campusName, index) => {
        rows.push({
          "S.No": index + 1,
          Campus: campusName || "",
          "GR No": record.grNo,
          Name: record.name,
          "Father Name": record.fatherName,
          "Date of Admission": formatDoa(record.date_of_admission),
          Fees: formatFees(record.fees),
          "Month of Withdrawal": record.monthOfWithdrawal,
          "Month of Transfer": record.monthOfTransfer,
          "Free Ship Student": record.freeShipStudent,
          Status: record.reportStatus,
        });
      };

      if (looksLikeRecord(source[0])) {
        const campusMap = {};
        const campusOrder = [];

        source.forEach((raw) => {
          const record = normalizeRecord(raw);
          const campusID =
            raw.campusID != null ? raw.campusID : record.campusID;
          const campusName =
            record.campusName ||
            getCampusNameById(campusID) ||
            "Unknown Campus";
          const campusKey =
            campusID != null && campusID !== ""
              ? `id-${campusID}`
              : `name-${campusName}`;

          if (!campusMap[campusKey]) {
            campusMap[campusKey] = { name: campusName, records: [] };
            campusOrder.push(campusKey);
          }
          campusMap[campusKey].records.push(record);
        });

        if (campusOrder.length <= 1 && !isAllCampuses) {
          const campusName =
            campusOrder.length === 1
              ? campusMap[campusOrder[0]].name
              : getCampusNameById(selectedCampusID);
          source.forEach((raw, index) => {
            pushRecord(normalizeRecord(raw), campusName, index);
          });
          return rows;
        }

        campusOrder
          .sort((a, b) =>
            String(campusMap[a].name).localeCompare(String(campusMap[b].name))
          )
          .forEach((key) => {
            campusMap[key].records.forEach((record, index) => {
              pushRecord(record, campusMap[key].name, index);
            });
          });
        return rows;
      }

      source.forEach((campus) => {
        const campusName =
          campus.campusBranch ||
          campus.campusName ||
          campus.branch ||
          campus.name ||
          getCampusNameById(campus.campusID) ||
          "Unknown Campus";
        const rawRecords =
          campus.records ||
          campus.items ||
          campus.students ||
          campus.data ||
          [];
        (Array.isArray(rawRecords) ? rawRecords : []).forEach((raw, index) => {
          pushRecord(normalizeRecord(raw), campusName, index);
        });
      });

      return rows;
    },

    async exportReconciliationFeesExcel() {
      if (this.myObj.format !== "Reconciliation fees") {
        return false;
      }
      if (!this.isMyskoolIussDomain()) {
        return false;
      }

      this.request = true;
      try {
        const params = this.buildReconciliationFeesParams();
        let baseUrl =
          this.$store.state.domain || "https://apiv26.myskool.app/api/";
        if (!baseUrl.endsWith("/")) baseUrl += "/";

        const query = {
          db: params.db,
          cID: params.cID,
          classID: params.classID,
          sectionID: params.sectionID,
          departmentID: params.departmentID,
          reportStatus: params.reportStatus,
        };
        if (params.dateFrom) query.dateFrom = params.dateFrom;
        if (params.dateTill) query.dateTill = params.dateTill;

        const response = await axios.get(
          `${baseUrl}Students/ReconciliationRequirementReport`,
          {
            params: query,
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        let payload = [];
        if (response.data && response.data.status === "success") {
          payload = response.data.data;
        } else if (Array.isArray(response.data)) {
          payload = response.data;
        } else if (Array.isArray(response.data?.data)) {
          payload = response.data.data;
        } else if (response.data?.data) {
          payload = response.data.data;
        }

        const rows = this.flattenReconciliationFeesRows(
          payload,
          params.selectedCampusID,
          params.cID
        );
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(
          rows.length
            ? rows
            : [
                {
                  "S.No": "",
                  Campus: "",
                  "GR No": "",
                  Name: "No records found",
                  "Father Name": "",
                  "Date of Admission": "",
                  Fees: "",
                  "Month of Withdrawal": "",
                  "Month of Transfer": "",
                  "Free Ship Student": "",
                  Status: "",
                },
              ]
        );
        XLSX.utils.book_append_sheet(workbook, sheet, "Reconciliation Fees");

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        const dateSuffix =
          params.dateFrom && params.dateTill
            ? `${params.dateFrom}_to_${params.dateTill}_`
            : "all_dates_";
        XLSX.writeFile(
          workbook,
          `Reconciliation_Fees_${dateSuffix}${timestamp}.xlsx`
        );

        this.$bvToast.toast(
          rows.length
            ? `Reconciliation fees exported (${rows.length} records).`
            : "Reconciliation fees exported (no records).",
          {
            title: "Success",
            variant: "success",
            solid: true,
          }
        );
      } catch (error) {
        console.error("Reconciliation fees export error:", error);
        this.$bvToast.toast(
          error?.response?.data?.message ||
            "Failed to export Reconciliation fees report.",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.request = false;
      }
      return true;
    },

    async exportInquiryVisitorsExcel() {
      if (!["Inquiry", "Visitors"].includes(this.myObj.format)) return false;

      if (
        this.myObj.sessionID === null ||
        this.myObj.sessionID === undefined ||
        this.myObj.sessionID === ""
      ) {
        this.$bvToast.toast("Please select session.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return true;
      }

      this.request = true;
      try {
        const payload = this.buildInquiryReportPayload();

        const response = await axios.post(
          (this.$store.state.domain || "https://apiv26.myskool.app/api/") +
            "StudentInquiries/GetInquiryReport",
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const items =
          response.data && response.data.status === "success"
            ? response.data.data || []
            : Array.isArray(response.data)
            ? response.data
            : Array.isArray(response.data && response.data.data)
            ? response.data.data
            : [];

        const formatDate = (dateStr) => {
          if (!dateStr) return "";
          const date = new Date(dateStr);
          if (Number.isNaN(date.getTime())) return String(dateStr).slice(0, 10);
          return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        };

        const isAllCampuses = Number(payload.campusID) === 1;
        const resolveCampusName = (item) => {
          const inquiry = (item && item.inquiry) || item || {};
          return (
            (item && item.campusBranch) ||
            inquiry.campusBranch ||
            (item && item.campusName) ||
            inquiry.campusName ||
            (item && item.branch) ||
            inquiry.branch ||
            ""
          );
        };

        const sortedItems = isAllCampuses
          ? [...(items || [])].sort((a, b) =>
              String(resolveCampusName(a)).localeCompare(
                String(resolveCampusName(b)),
                undefined,
                { sensitivity: "base" }
              )
            )
          : items || [];

        const rows = sortedItems.map((item, index) => {
          const inquiry = (item && item.inquiry) || item || {};
          const row = {
            "#": index + 1,
          };
          if (isAllCampuses) {
            row.Campus = resolveCampusName(item);
          }
          row.Date = formatDate(inquiry.date);
          row.Name = inquiry.name || "";
          row["Father's Name"] = inquiry.father_name || "";
          row.Contact = inquiry.contact || "";
          row.Age = inquiry.age || "";
          row.Class = (item && item.className) || inquiry.className || "";
          row["Last School"] = inquiry.lastSchool || "";
          row.Purpose = inquiry.purpose || "";
          row.Address = inquiry.address || inquiry.residentialArea || "";
          row["Next Follow-up"] = formatDate(inquiry.nextFollowup);
          return row;
        });

        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(
          rows.length
            ? rows
            : [
                isAllCampuses
                  ? {
                      "#": "",
                      Campus: "",
                      Date: "",
                      Name: "No records found",
                      "Father's Name": "",
                      Contact: "",
                      Age: "",
                      Class: "",
                      "Last School": "",
                      Purpose: "",
                      Address: "",
                      "Next Follow-up": "",
                    }
                  : {
                      "#": "",
                      Date: "",
                      Name: "No records found",
                      "Father's Name": "",
                      Contact: "",
                      Age: "",
                      Class: "",
                      "Last School": "",
                      Purpose: "",
                      Address: "",
                      "Next Follow-up": "",
                    },
              ]
        );
        const sheetName =
          this.myObj.format === "Visitors" ? "Visitors" : "Inquiry";
        XLSX.utils.book_append_sheet(workbook, sheet, sheetName);

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        const fileLabel =
          this.myObj.format === "Visitors" ? "Visitors" : "Student_Inquiry";
        const dateSuffix =
          payload.dateFrom && payload.dateTill
            ? `${payload.dateFrom}_to_${payload.dateTill}_`
            : "all_dates_";
        XLSX.writeFile(workbook, `${fileLabel}_${dateSuffix}${timestamp}.xlsx`);

        this.$bvToast.toast(`${this.myObj.format} exported successfully.`, {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Inquiry/Visitors export error:", error);
        this.$bvToast.toast(`Failed to export ${this.myObj.format} report.`, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    openStudentTurnoverReport(asExport = false) {
      const query = {
        db: this.myObj.db,
        cID: this.resolveTurnoverCampusID(),
        year: this.turnoverYear,
        monthFrom: this.turnoverMonthFrom,
        monthTo: this.turnoverMonthTo,
        categoryType: "leavingCategory",
      };
      if (asExport) {
        query.export = "1";
      }
      const routeData = this.$router.resolve({
        name: "student-turnover-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    resolveSingleReportFilterId(value) {
      if (Array.isArray(value)) {
        if (!value.length || Number(value[0]) === 0) return 0;
        if (value.length === 1) return Number(value[0]) || 0;
        return 0;
      }
      return Number(value) || 0;
    },

    resolveDriverReportFilterLabels(classID, sectionID) {
      const clsId = this.resolveSingleReportFilterId(classID);
      const secId = this.resolveSingleReportFilterId(sectionID);
      let classLabel = "All classes";
      let sectionLabel = "All sections";
      if (clsId > 0) {
        const cls = (this.classesOptions || []).find((c) => c.id === clsId);
        classLabel = cls ? cls.name : `Class #${clsId}`;
      }
      if (secId > 0) {
        const sec = (this.admittedSections || []).find((s) => s.id === secId);
        sectionLabel = sec ? sec.section || sec.name : `Section #${secId}`;
      }
      return { classLabel, sectionLabel };
    },

    mapDriverReportOptions(list) {
      return (list || [])
        .filter((row) => row && (row.driver || row.id))
        .map((row) => ({
          id: row.driver?.id ?? row.id,
          name: row.driver?.name ?? row.name ?? "Driver",
          contact: row.driver?.contact ?? row.contact,
          details: row.details || [],
        }));
    },

    async loadDriverReportOptions() {
      this.driverReportOptionsLoading = true;
      try {
        const db = this.myObj.db || this.$store.state.userData.db;
        const cID = this.myObj.campusID || this.$store.state.userData.cId;
        const url =
          this.$store.state.domain +
          "Driver/loadData?db=" +
          encodeURIComponent(db) +
          "&cID=" +
          cID;

        const response = await this.get({
          url,
          token: this.$store.state.userData.token,
          returnData: true,
        });

        let list = [];
        if (response && Array.isArray(response)) {
          list = response;
        } else if (response && Array.isArray(response.data)) {
          list = response.data;
        } else if (
          response &&
          String(response.status || "").toLowerCase() === "success" &&
          Array.isArray(response.data)
        ) {
          list = response.data;
        } else {
          const unwrapped = await this.get({
            url,
            token: this.$store.state.userData.token,
          });
          if (Array.isArray(unwrapped)) {
            list = unwrapped;
          }
        }

        this.driverReportOptions = this.mapDriverReportOptions(list);
      } catch (e) {
        console.error("loadDriverReportOptions", e);
        this.driverReportOptions = [];
      } finally {
        this.driverReportOptionsLoading = false;
      }
    },

    initDriverWiseStudentsFilters() {
      if (this.myObj.format !== "Driver wise students") return;
      if (!this.isDriverReportDomain) return;
      this.driverReportDriverID = "all";
      this.classID = 0;
      this.secID = 0;
      this.loadDriverReportOptions();
      this.FillSections();
    },

    openDriverWiseStudentsReport() {
      const classID = this.resolveSingleReportFilterId(this.classID);
      const sectionID = this.resolveSingleReportFilterId(this.secID);
      const driverID = Number(this.driverReportDriverID) || 0;
      const { classLabel, sectionLabel } = this.resolveDriverReportFilterLabels(
        classID,
        sectionID
      );
      const driverOpt = this.driverReportOptions.find((d) => d.id === driverID);
      const query = {
        db: this.myObj.db,
        cID: this.myObj.campusID,
        driverID,
        classID,
        sectionID,
        driverLabel: driverOpt?.name || (driverID ? "" : "All drivers"),
        classLabel,
        sectionLabel,
      };
      const routeData = this.$router.resolve({
        name: "driver-wise-students-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    initDriverFeesFilters() {
      if (this.myObj.format !== "Driver fees") return;
      this.driverReportDriverID = "all";
      this.classID = 0;
      this.secID = 0;
      this.driverFeeMonth = 0;
      this.driverFeeYear = 0;
      this.driverFeeStatus = "all";
      this.driverFeeFeeTypeID = 0;
      this.driverFeeRange = null;
      this.driverFeeFrom = "";
      this.driverFeeTo = "";
      this.loadDriverReportOptions();
      this.FillSections();
    },

    getDefaultDriverFeeTypeID() {
      const list = Array.isArray(this.feeTypes) ? this.feeTypes : [];
      const patterns = [
        /transportation/i,
        /transport/i,
        /conveyance/i,
        /pickup/i,
        /\bbus\b/i,
        /\bvan\b/i,
      ];
      for (const pattern of patterns) {
        const match = list.find(
          (fee) => fee && pattern.test(String(fee.feeType || "").trim())
        );
        if (match && Number(match.id) > 0) return match.id;
      }
      return 0;
    },

    setDriverFeeDate(selectedDates, dateStr) {
      if (!dateStr) {
        this.driverFeeFrom = "";
        this.driverFeeTo = "";
        return;
      }
      const parts = String(dateStr).split(" to ");
      this.driverFeeFrom = parts[0] || "";
      this.driverFeeTo = parts[1] || parts[0] || "";
    },

    openDriverFeesReport() {
      const classID = this.resolveSingleReportFilterId(this.classID);
      const sectionID = this.resolveSingleReportFilterId(this.secID);
      const driverID = Number(this.driverReportDriverID) || 0;
      const feeTypeID = Number(this.driverFeeFeeTypeValue) || 0;
      const month = Number(this.driverFeeMonth) || 0;
      const year = Number(this.driverFeeYear) || 0;
      const status = this.driverFeeStatus || "all";

      const { classLabel, sectionLabel } = this.resolveDriverReportFilterLabels(
        classID,
        sectionID
      );
      const driverOpt = this.driverReportOptions.find((d) => d.id === driverID);
      const feeTypeOpt = (this.feeTypes || []).find((f) => f.id === feeTypeID);
      const monthOpt = this.monthsSOptions.find((m) => m.id === month);

      const monthLabel = month
        ? monthOpt?.name || `Month #${month}`
        : "All months";
      const yearLabel = year ? String(year) : "All years";
      const statusLabel =
        status === "paid"
          ? "Paid only"
          : status === "unpaid"
          ? "Unpaid only"
          : "All statuses";
      const feeTypeLabel = feeTypeID
        ? feeTypeOpt?.feeType || `Fee Type #${feeTypeID}`
        : "Transport fee type";
      const receiptLabel =
        this.driverFeeFrom || this.driverFeeTo
          ? `${this.driverFeeFrom || "Start"} to ${this.driverFeeTo || "Today"}`
          : "All receipt dates";

      const query = {
        db: this.myObj.db,
        cID: this.myObj.campusID || this.$store.state.userData.cId || 0,
        driverID,
        classID,
        sectionID,
        feeTypeID,
        month,
        year,
        status,
        dtFrom: this.driverFeeFrom || "",
        dtTo: this.driverFeeTo || "",
        driverLabel: driverOpt?.name || (driverID ? "" : "All drivers"),
        classLabel,
        sectionLabel,
        feeTypeLabel,
        monthLabel,
        yearLabel,
        statusLabel,
        receiptLabel,
      };
      const routeData = this.$router.resolve({
        name: "driver-fees-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    driverWiseStudentGr(stu) {
      const gr = stu?.grNo ?? stu?.gr ?? stu?.GR;
      return gr !== null && gr !== undefined && String(gr).trim() !== ""
        ? gr
        : "";
    },
    driverWiseStudentFather(stu) {
      const name = stu?.father_name ?? stu?.fatherName ?? stu?.father;
      return name && String(name).trim() ? name : "";
    },
    driverWiseStudentContact(stu) {
      const contact =
        stu?.contact_father ??
        stu?.contactNo ??
        stu?.contact_no ??
        stu?.contact;
      return contact && String(contact).trim() ? contact : "";
    },
    driverWiseStudentClassSection(stu) {
      const cls = stu?.className;
      const sec = stu?.sectionName;
      const clsStr =
        cls !== null && cls !== undefined && String(cls).trim()
          ? String(cls).trim()
          : "";
      const secStr =
        sec !== null && sec !== undefined && String(sec).trim()
          ? String(sec).trim()
          : "";
      if (clsStr && secStr) return `${clsStr} / ${secStr}`;
      return clsStr || secStr || "";
    },
    driverWiseBlockTotalAmount(block) {
      if (
        block?.totalAmount !== undefined &&
        block?.totalAmount !== null &&
        block?.totalAmount !== ""
      ) {
        return block.totalAmount;
      }
      return (block?.students || []).reduce((sum, stu) => {
        const n = Number(stu?.amount);
        return sum + (Number.isNaN(n) ? 0 : n);
      }, 0);
    },

    async exportDriverWiseStudentsExcel() {
      if (
        this.myObj.format !== "Driver wise students" ||
        !this.isDriverReportDomain
      ) {
        return false;
      }

      this.request = true;
      try {
        const classID = this.resolveSingleReportFilterId(this.classID);
        const sectionID = this.resolveSingleReportFilterId(this.secID);
        const driverID = Number(this.driverReportDriverID) || 0;
        const cID =
          this.myObj.campusID || this.$store.state.userData.cId || 0;
        const url = `${this.$store.state.domain}Driver/LoadDriverWiseReport`;

        const response = await axios.get(url, {
          params: {
            db: this.myObj.db,
            cID,
            driverID,
            classID,
            sectionID,
          },
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
            accept: "application/json",
          },
        });

        const payload = response?.data;
        if (!payload || String(payload.status || "").toLowerCase() !== "success") {
          this.$bvToast.toast(
            payload?.message || "Failed to load driver wise student report.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const blocks = Array.isArray(payload.data) ? payload.data : [];
        const excelRows = [];
        blocks.forEach((block) => {
          const driverName = block?.name || "";
          const students = block?.students || [];
          students.forEach((stu) => {
            excelRows.push({
              driverName,
              grNo: this.driverWiseStudentGr(stu),
              name: stu?.name || "",
              father_name: this.driverWiseStudentFather(stu),
              classSection: this.driverWiseStudentClassSection(stu),
              contactNo: this.driverWiseStudentContact(stu),
              vehicleNo: stu?.vehicleNo ?? "",
              amount: stu?.amount ?? "",
            });
          });
          if (students.length) {
            excelRows.push({
              driverName: "",
              grNo: "",
              name: "",
              father_name: "",
              classSection: "Driver total",
              contactNo: "",
              vehicleNo: "",
              amount: this.driverWiseBlockTotalAmount(block),
            });
          }
        });

        const studentRowCount = blocks.reduce(
          (n, b) => n + (b?.students || []).length,
          0
        );
        if (!studentRowCount) {
          this.$bvToast.toast("No driver wise student records found.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        if (
          payload.totalAmount !== undefined &&
          payload.totalAmount !== null &&
          payload.totalAmount !== ""
        ) {
          excelRows.push({
            driverName: "",
            grNo: "",
            name: "",
            father_name: "",
            classSection: "Grand total",
            contactNo: "",
            vehicleNo: "",
            amount: payload.totalAmount,
          });
        }

        const stamp = new Date().toISOString().slice(0, 10);
        await exportObjectsToExcel(
          excelRows,
          `Driver_Wise_Students_${stamp}.xlsx`,
          {
            sheetName: "Driver Wise Students",
            columns: [
              { key: "driverName", label: "Driver" },
              { key: "grNo", label: "GR" },
              { key: "name", label: "Name" },
              { key: "father_name", label: "Father Name" },
              { key: "classSection", label: "Class / Sec" },
              { key: "contactNo", label: "Contact No" },
              { key: "vehicleNo", label: "Vehicle" },
              { key: "amount", label: "Amount" },
            ],
            title: "Driver Wise Students",
          }
        );

        this.$bvToast.toast("Driver wise students exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        return true;
      } catch (error) {
        console.error("Driver wise students export error:", error);
        this.$bvToast.toast("Failed to export driver wise students.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return false;
      } finally {
        this.request = false;
      }
    },

    async exportDriverFeesExcel() {
      if (this.myObj.format !== "Driver fees") return false;

      this.request = true;
      try {
        const classID = this.resolveSingleReportFilterId(this.classID);
        const sectionID = this.resolveSingleReportFilterId(this.secID);
        const driverID = Number(this.driverReportDriverID) || 0;
        const feeTypeID = Number(this.driverFeeFeeTypeValue) || 0;
        const month = Number(this.driverFeeMonth) || 0;
        const year = Number(this.driverFeeYear) || 0;
        const status = this.driverFeeStatus || "all";
        const cID =
          this.myObj.campusID || this.$store.state.userData.cId || 0;
        const url = `${this.$store.state.domain}Driver/LoadDriverFeesReport`;

        const response = await axios.get(url, {
          params: {
            db: this.myObj.db,
            cID,
            driverID,
            classID,
            sectionID,
            feeTypeID,
            year,
            month,
            status,
            dtFrom: this.driverFeeFrom || null,
            dtTo: this.driverFeeTo || null,
          },
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
            accept: "application/json",
          },
        });

        const payload = response?.data;
        if (!payload || String(payload.status || "").toLowerCase() !== "success") {
          this.$bvToast.toast(
            payload?.message || "Failed to load the driver fees report.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const blocks = Array.isArray(payload.data) ? payload.data : [];
        const excelRows = buildDriverFeesExportRows(blocks, payload);

        if (!excelRows.length) {
          this.$bvToast.toast("No driver fee records found to export.", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const monthOpt = this.monthsSOptions.find((m) => m.id === month);
        const feeTypeOpt = (this.feeTypes || []).find(
          (fee) => Number(fee.id) === feeTypeID
        );
        const subtitleParts = [
          driverID ? "" : "All drivers",
          classID ? "" : "All classes",
          sectionID ? "" : "All sections",
          month || year
            ? `${monthOpt ? monthOpt.name : ""} ${year || ""}`.trim()
            : "All periods",
          feeTypeID
            ? feeTypeOpt?.feeType || `Fee Type #${feeTypeID}`
            : "Transport fee type",
          status === "paid"
            ? "Paid only"
            : status === "unpaid"
            ? "Unpaid only"
            : "All statuses",
        ].filter(Boolean);
        const stamp = new Date().toISOString().slice(0, 10);

        await exportObjectsToExcel(
          excelRows,
          `Driver_Fees_${stamp}.xlsx`,
          {
            sheetName: "Driver Fees",
            title: "Driver Fees Report",
            subtitle: subtitleParts.join(" | "),
            columns: DRIVER_FEES_EXPORT_COLUMNS,
          }
        );

        this.$bvToast.toast("Driver fees report exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        return true;
      } catch (error) {
        console.error("Driver fees export error:", error);
        this.$bvToast.toast("Failed to export the driver fees report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return false;
      } finally {
        this.request = false;
      }
    },

    resolveClassListIUSSFilters() {
      const resolveSingleId = (value) => {
        if (!value || (Array.isArray(value) && value.length === 0)) return 0;
        if (Array.isArray(value)) {
          if (value.length === 1 && Number(value[0]) !== 0) {
            return Number(value[0]);
          }
          return 0;
        }
        const id = Number(value);
        return id > 0 ? id : 0;
      };

      return {
        classID: resolveSingleId(this.classID),
        sectionID: resolveSingleId(this.secID),
      };
    },

    resolveStaffTimetableFilters() {
      const resolveSingleId = (value) => {
        if (!value || (Array.isArray(value) && value.length === 0)) return 0;
        if (Array.isArray(value)) return Number(value[0]) || 0;
        const id = Number(value);
        return id > 0 ? id : 0;
      };

      return {
        cID: this.myObj.campusID || this.$store.state.userData.cId,
        clsID: resolveSingleId(this.classID),
        section: resolveSingleId(this.secID),
        tID: this.myObj.staffID || 0,
        subID: this.myObj.subjectID || 0,
      };
    },

    openStaffTimetableReport() {
      const filters = this.resolveStaffTimetableFilters();
      const routeData = this.$router.resolve({
        name: "staff-timetable-print",
        query: {
          db: this.$store.state.userData.db,
          cID: filters.cID,
          clsID: filters.clsID,
          section: filters.section,
          tID: filters.tID,
          subID: filters.subID,
        },
      });
      window.open(routeData.href, "_blank");
    },

    buildPlannerLogsQuery() {
      const userFrom = this.myObj.dtfrom;
      const userTo = this.myObj.dtto;
      const showDateRange = !!(userFrom && userTo);

      let dtFrom = userFrom;
      let dtTo = userTo;

      if (!dtFrom) {
        dtFrom = "1990-01-01";
      }
      if (!dtTo) {
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        dtTo = `${yyyy}-${mm}-${dd}`;
      }

      let cName = "All";
      if (this.myObj.campusID > 0) {
        const campus = (this.campuses || []).find(
          (c) => c.id == this.myObj.campusID
        );
        if (campus) {
          cName = campus.branch;
        }
      }

      let staffName = "All Teachers";
      const staffId = this.myObj.staffID || 0;
      if (staffId > 0) {
        const staff = (this.filteredStaffList || this.staffList || []).find(
          (s) => s.id == staffId
        );
        if (staff) {
          staffName = staff.name;
        }
      }

      return {
        db: this.myObj.db || this.$store.state.userData.db,
        campusID: this.myObj.campusID,
        campusName: cName,
        tID: staffId,
        staffName,
        dtFrom,
        dtTo,
        showDateRange: showDateRange ? "1" : "0",
      };
    },

    openPlannerLogsReport() {
      const q = this.buildPlannerLogsQuery();
      const routeData = this.$router.resolve({
        name: "planner-logs-print",
        query: q,
      });
      window.open(routeData.href, "_blank");
    },

    async exportPlannerLogsExcel() {
      if (this.myObj.format !== "Planner Logs") return false;

      this.CheckDate();
      if (this.CheckDate() === false) {
        this.$bvToast.toast("Please select a valid date range.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return true;
      }

      const q = this.buildPlannerLogsQuery();
      this.request = true;

      try {
        const parsed = await fetchPlannerLogs({
          domain: this.$store.state.domain,
          token: this.$store.state.userData.token,
          db: q.db,
          campusID: q.campusID,
          tID: q.tID,
          dtFrom: q.dtFrom,
          dtTo: q.dtTo,
        });

        if (!parsed.ok) {
          this.$bvToast.toast(
            parsed.message || "Failed to load planner logs for export.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const includeTeacher = !q.tID || q.tID === 0;
        const sections = buildCampusSections(parsed);
        const totalRows = sections.reduce(
          (n, s) => n + (s.logs ? s.logs.length : 0),
          0
        );

        if (!totalRows) {
          this.$bvToast.toast("No planner logs found for export.", {
            title: "Info",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        const exported = await exportPlannerLogsWorkbookFile(
          parsed,
          `Planner_Logs_${timestamp}.xlsx`,
          { includeTeacher }
        );
        if (!exported) {
          this.$bvToast.toast("No planner logs found for export.", {
            title: "Info",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        this.$bvToast.toast("Planner logs exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Planner logs export error:", error);
        this.$bvToast.toast(describePlannerLogsRequestError(error), {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }

      return true;
    },

    formatTimetableTime(time) {
      if (!time) return "";
      let t = String(time).trim();
      if (t.toLowerCase().includes("am") || t.toLowerCase().includes("pm")) {
        return t;
      }
      const parts = t.split(":");
      if (parts.length >= 1) {
        const hour = parseInt(parts[0], 10);
        if ((hour >= 1 && hour < 7) || hour === 12) {
          return `${t} PM`;
        }
        if (hour >= 7 && hour < 12) {
          return `${t} AM`;
        }
      }
      return t;
    },

    capitalizeTimetableDay(day) {
      if (!day || typeof day !== "string") return "Unknown";
      return day.charAt(0).toUpperCase() + day.slice(1);
    },

    buildStaffTimetableExportRows(timetableItems) {
      const orderedDays = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ];
      const rows = [];
      const now = new Date().toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });

      rows.push(["Staff TimeTable Report"]);
      rows.push([`Generated on ${now}`]);
      rows.push([]);

      const uniqueStaff = [...new Set(timetableItems.map((item) => item.tID))];
      const uniqueSubjects = [
        ...new Set(timetableItems.map((item) => item.subID)),
      ];
      rows.push([
        "Total Staff",
        uniqueStaff.length,
        "Total Subjects",
        uniqueSubjects.length,
        "Total Sessions",
        timetableItems.length,
      ]);
      rows.push([]);

      if (!timetableItems.length) {
        rows.push(["No timetable data available for the selected filters."]);
        return rows;
      }

      const grouped = {};
      timetableItems.forEach((item) => {
        const key = `${item.clsID}-${item.section}`;
        if (!grouped[key]) {
          grouped[key] = {
            classID: item.clsID,
            sectionID: item.section,
            className: item.meta_className,
            sectionName: item.meta_sectionName,
          };
        }
      });

      Object.values(grouped).forEach((classGroup) => {
        rows.push([`${classGroup.className} - ${classGroup.sectionName}`]);
        rows.push(["Day", "Time", "Subject", "Staff Name"]);

        orderedDays.forEach((day) => {
          const dayItems = timetableItems
            .filter(
              (item) =>
                item.clsID === classGroup.classID &&
                item.section === classGroup.sectionID &&
                item.day &&
                item.day.toLowerCase() === day.toLowerCase()
            )
            .sort((a, b) => {
              const timeA = this.formatTimetableTime(a.startTime);
              const timeB = this.formatTimetableTime(b.startTime);
              return (
                new Date(`2000-01-01 ${timeA}`) -
                new Date(`2000-01-01 ${timeB}`)
              );
            });

          dayItems.forEach((item) => {
            rows.push([
              this.capitalizeTimetableDay(day),
              `${this.formatTimetableTime(
                item.startTime
              )} - ${this.formatTimetableTime(item.endTime)}`,
              item.meta_subjectName || "-",
              item.meta_teacherName || "-",
            ]);
          });
        });

        rows.push([]);
      });

      return rows;
    },

    async exportStaffTimetableExcel() {
      if (this.myObj.format !== "Timetable") return false;

      const filters = this.resolveStaffTimetableFilters();
      let baseUrl = this.$store.state.domain;
      if (!baseUrl.endsWith("/")) {
        baseUrl += "/";
      }

      this.request = true;
      try {
        const response = await axios.get(`${baseUrl}TimeTable/StaffTimeTable`, {
          params: {
            db: this.myObj.db || this.$store.state.userData.db,
            cID: filters.cID,
            clsID: filters.clsID,
            section: filters.section,
            tID: filters.tID,
            subID: filters.subID,
          },
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
            accept: "application/json",
          },
        });

        if (response.data && response.data.status !== "success") {
          this.$bvToast.toast(
            response.data.message || "Failed to load timetable data.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const timetableItems =
          response.data && response.data.status === "success"
            ? response.data.data || []
            : [];

        const rows = this.buildStaffTimetableExportRows(timetableItems);
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        worksheet["!cols"] = [
          { wch: 14 },
          { wch: 18 },
          { wch: 28 },
          { wch: 28 },
        ];
        XLSX.utils.book_append_sheet(workbook, worksheet, "Staff Timetable");

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(workbook, `Staff_Timetable_${timestamp}.xlsx`);

        this.$bvToast.toast("Staff timetable exported successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Staff timetable export error:", error);
        this.$bvToast.toast("Failed to export staff timetable report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    openClassListIUSSReport(asExport = false) {
      const filters = this.resolveClassListIUSSFilters();
      const query = {
        db: this.myObj.db,
        cID: this.myObj.campusID,
        classID: filters.classID,
        sectionID: filters.sectionID,
        status: this.myObj.status || "present",
      };

      if (
        String(this.myObj.status).toLowerCase() === "registered" &&
        this.feePaymentStatus
      ) {
        query.feePaymentStatus = this.feePaymentStatus;
      }

      if (asExport) {
        query.export = "1";
      }

      const routeData = this.$router.resolve({
        name: "class-list-iuss-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    /** Standard fee status — List/Show on report domain (all schools incl. IUSS). */
    openListFeeStatusReport(clsName = "", secName = "") {
      const cls = Array.isArray(this.myObj.classIDs)
        ? this.myObj.classIDs.join(",")
        : this.myObj.classIDs ?? "";
      const sec = Array.isArray(this.myObj.secIDs)
        ? this.myObj.secIDs.join(",")
        : this.myObj.secIDs ?? "";
      const session = this.myObj.sessionID ?? 0;
      const disRef = this.selectedDisRef ?? "";

      const url =
        `https://${this.reportDomain}.myskool.app/List/Show?type=feeStatus&dbb=` +
        this.myObj.db +
        "&cID=" +
        this.myObj.campusID +
        "&cls=" +
        cls +
        "&sec=" +
        sec +
        "&status=&mob=false&session=" +
        session +
        "&clsName=" +
        clsName +
        "&secName=" +
        secName +
        "&disRefID=" +
        disRef;

      window.open(url, "_blank");
    },

    /** IUSS only — Average fees print (fee-status-report?section=average). */
    openFeeStatusIUSSReport(asExport = false, section) {
      if (!this.isMyskoolIussDomain()) return;

      const campusID =
        Number(this.myObj.campusID) || Number(this.$store.state.userData.cId);

      if (!campusID) {
        this.$bvToast.toast("Please select a campus.", {
          title: "Campus required",
          variant: "warning",
          solid: true,
        });
        return;
      }

      let reportSection = section;
      if (!reportSection) {
        reportSection = "average";
      }

      if (reportSection === "both") {
        reportSection = "average";
      }

      const query = {
        db: this.myObj.db,
        campusID,
        section: reportSection,
      };

      const routeData = this.$router.resolve({
        name: "fee-status-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    async exportFeeStatusIUSSExcel(section) {
      if (!this.isMyskoolIussDomain()) {
        return false;
      }

      const campusID =
        Number(this.myObj.campusID) || Number(this.$store.state.userData.cId);

      if (!campusID) {
        this.$bvToast.toast("Please select a campus.", {
          title: "Campus required",
          variant: "warning",
          solid: true,
        });
        return true;
      }

      let reportSection = section;
      if (!reportSection) {
        if (this.myObj.format === "Average fees") {
          reportSection = "average";
        } else {
          return false;
        }
      }

      if (reportSection === "both") {
        reportSection = "average";
      }

      this.request = true;
      try {
        const response = await axios.get(
          "https://apiv26.myskool.app/api/Students/FeeStatusReport",
          {
            params: {
              db: this.myObj.db,
              campusID,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const parsed = normalizeFeeStatusResponse(response.data);
        if (!parsed.campuses.length) {
          this.$bvToast.toast(
            parsed.message || "No fee status records found.",
            {
              title: "Warning",
              variant: "warning",
              solid: true,
            }
          );
          return true;
        }

        const { feeStatusRows, averageRows } = buildFeeStatusExcelRows(
          parsed.campuses
        );
        const workbook = XLSX.utils.book_new();
        const showStatus =
          reportSection === "both" || reportSection === "status";
        const showAverage =
          reportSection === "both" || reportSection === "average";

        if (showStatus && feeStatusRows.length) {
          XLSX.utils.book_append_sheet(
            workbook,
            XLSX.utils.json_to_sheet(feeStatusRows),
            "Fee Status"
          );
        }
        if (showAverage && averageRows.length) {
          XLSX.utils.book_append_sheet(
            workbook,
            XLSX.utils.json_to_sheet(averageRows),
            "Average Fees"
          );
        }

        const stamp = new Date().toISOString().slice(0, 10);
        let fileName = "Fee_Status_Report";
        if (reportSection === "average") {
          fileName = "Average_Fees";
        } else if (reportSection === "status") {
          fileName = "Fee_Status";
        }
        XLSX.writeFile(workbook, `${fileName}_${stamp}.xlsx`);

        this.$bvToast.toast("Report exported to Excel successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
        return true;
      } catch (error) {
        console.error("Fee status export error:", error);
        this.$bvToast.toast("Failed to export report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return true;
      } finally {
        this.request = false;
      }
    },

    resolvePendingFeesFilters() {
      const classID =
        Array.isArray(this.classID) && this.classID.length > 0
          ? this.classID[0]
          : this.classID || 0;
      const sectionID =
        Array.isArray(this.secID) && this.secID.length > 0
          ? this.secID[0]
          : this.secID || 0;
      const classOpt = this.classesOptions.find((c) => c.id == classID);
      const secOpt = this.admittedSections.find((s) => s.id == sectionID);
      return {
        classID,
        sectionID,
        className: classID && classOpt ? classOpt.name : "All Classes",
        sectionName: sectionID && secOpt ? secOpt.section : "All Sections",
      };
    },

    isPendingFeeExempted(fee) {
      const status = String(fee?.status || "")
        .toLowerCase()
        .trim();
      return (
        status === "exempted" || status === "exempt" || status === "exemption"
      );
    },

    openPendingFeesReport() {
      if (this.myObj.format !== "Pending Fees") {
        return false;
      }

      if (!this.isMyskoolstjacobDomain) {
        this.$bvToast.toast(
          "This report is only available for Myskool St. Jacob.",
          {
            title: "Not Available",
            variant: "warning",
            solid: true,
          }
        );
        return true;
      }

      const filters = this.resolvePendingFeesFilters();
      const routeData = this.$router.resolve({
        name: "pending-fees-after-admission-report",
        query: {
          db: this.myObj.db,
          cID: this.myObj.campusID,
          classID: filters.classID,
          sectionID: filters.sectionID,
          className: filters.className,
          sectionName: filters.sectionName,
        },
      });
      window.open(routeData.href, "_blank");
      return true;
    },

    async exportPendingFeesExcel() {
      if (this.myObj.format !== "Pending Fees") {
        return false;
      }

      if (!this.isMyskoolstjacobDomain) {
        this.$bvToast.toast(
          "This report is only available for Myskool St. Jacob.",
          {
            title: "Not Available",
            variant: "warning",
            solid: true,
          }
        );
        this.request = false;
        return true;
      }

      const filters = this.resolvePendingFeesFilters();
      let baseUrl = this.$store.state.domain;
      if (!baseUrl.endsWith("/")) {
        baseUrl += "/";
      }

      this.request = true;
      try {
        const apiResponse = await axios.get(
          `${baseUrl}Fees/NoFeeSubmittedAfterAdmissionReport`,
          {
            params: {
              db: this.myObj.db,
              cID: this.myObj.campusID,
              classID: filters.classID,
              sectionID: filters.sectionID,
            },
            headers: {
              Authorization: `Bearer ${this.$store.state.userData.token}`,
              accept: "application/json",
            },
          }
        );

        const body = apiResponse.data || {};
        if (body.status !== "success") {
          this.$bvToast.toast(
            body.message || "Failed to load pending fees data.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return true;
        }

        const groups = Array.isArray(body.data) ? body.data : [];
        const exportData = [];
        let sno = 0;
        let studentCount = 0;

        groups.forEach((group) => {
          let groupUnpaid = 0;
          let groupStudents = 0;

          (group.students || []).forEach((student) => {
            const feeMonths = (student.feeMonths || []).filter(
              (fee) => !this.isPendingFeeExempted(fee)
            );
            if (!feeMonths.length) return;

            groupStudents += 1;
            studentCount += 1;

            const studentTotal = feeMonths.reduce(
              (sum, fee) => sum + (Number(fee.netFee) || 0),
              0
            );
            groupUnpaid += studentTotal;

            feeMonths.forEach((fee, feeIndex) => {
              sno += 1;
              const month =
                fee.monthYear ||
                (fee.monthVal && fee.year ? `${fee.monthVal}-${fee.year}` : "");

              exportData.push({
                "S.No": sno,
                Class: group.className || "",
                Section: group.sectionName || "",
                "GR No": student.grNo || "",
                "Student Name": student.name || "",
                "Father Name": student.father_name || "",
                "Admission Date": student.date_of_admission
                  ? new Date(student.date_of_admission).toLocaleDateString(
                      "en-GB"
                    )
                  : "",
                Month: month,
                "Fee Type": fee.feeType || "",
                "Net Fee": Number(fee.netFee) || 0,
                "Student Total": feeIndex === 0 ? studentTotal : "",
              });
            });
          });

          if (groupStudents > 0) {
            exportData.push({
              "S.No": "",
              Class: group.className || "",
              Section: group.sectionName || "",
              "GR No": "",
              "Student Name": `Section Total (${groupStudents} student${
                groupStudents === 1 ? "" : "s"
              })`,
              "Father Name": "",
              "Admission Date": "",
              Month: "",
              "Fee Type": "",
              "Net Fee": groupUnpaid,
              "Student Total": "",
            });
          }
        });

        if (exportData.length === 0) {
          this.$bvToast.toast("No pending fee records found to export.", {
            title: "No Data",
            variant: "warning",
            solid: true,
          });
          return true;
        }

        const totalUnpaid =
          Number(body.totalUnpaidAmount) ||
          exportData
            .filter((row) =>
              String(row["Student Name"] || "").includes("Section Total")
            )
            .reduce((sum, row) => sum + (Number(row["Net Fee"]) || 0), 0);

        const summaryRow = {
          "S.No": "",
          Class: "SUMMARY",
          Section: "",
          "GR No": "",
          "Student Name": `Total Students: ${
            body.totalStudents || studentCount
          }`,
          "Father Name": "",
          "Admission Date": "",
          Month: "",
          "Fee Type": "",
          "Net Fee": totalUnpaid,
          "Student Total": "",
        };

        const worksheet = XLSX.utils.json_to_sheet([summaryRow, ...exportData]);
        worksheet["!cols"] = [
          { wch: 6 },
          { wch: 14 },
          { wch: 10 },
          { wch: 10 },
          { wch: 22 },
          { wch: 22 },
          { wch: 14 },
          { wch: 14 },
          { wch: 16 },
          { wch: 12 },
          { wch: 14 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Fees");

        const timestamp = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
        XLSX.writeFile(workbook, `Pending_Fees_${timestamp}.xlsx`);

        this.$bvToast.toast("Pending fees exported to Excel successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Pending fees export error:", error);
        this.$bvToast.toast("Failed to export pending fees report.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
      return true;
    },

    checkRangeMonth() {
      if (
        this.myObj.type.value == "defaulters" &&
        !this.singleVisible.includes(this.myObj.format)
      ) {
        this.generateDateRange();
        return true;
        // if (this.dateRange.length == 0) {
        //   this.$bvToast.toast("Please select the month range correctly!", {
        //     title: this.$t("Error!"),
        //     variant: "danger",
        //     toaster: "b-toaster-top-center",
        //   });
        //   return false;
        // } else return true;
      }
      return true;
    },
    CheckSlipFrom() {
      if (this.myObj.format == "Slip range") {
        var elem = this.$refs["spFrom"];
        let x = parseInt(this.slipFrom);
        if (isNaN(x) || x <= 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else true;
    },
    CheckSlipTo() {
      if (this.myObj.format == "Slip range") {
        var elem = this.$refs["spTo"];
        let x = parseInt(this.slipTo);
        if (isNaN(x) || x <= 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else true;
    },
    checkSlipRange() {
      if (this.myObj.format == "Slip range") {
        if (this.CheckSlipFrom() == false || this.CheckSlipTo() == false)
          return false;
        else {
          return parseInt(this.slipFrom) <= parseInt(this.slipTo);
        }
      } else true;
    },
    async loadStatement() {
      this.CheckSec();
      this.CheckClass();

      if (this.CheckSec() == false || this.CheckClass() == false) {
        this.request = false;
        this.stLoading = false;
        return this.$bvToast.toast("Please provide the required details.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        let cls = [];
        if (this.classID[0] !== 0) {
          cls = this.classID;
        }
        let sec = [];
        if (this.secID[0] !== 0) {
          sec = this.secID;
        }

        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/GetChallanStatement?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.myObj.campusID,
          context: this,
          body: {
            clsIDs: cls,
            secIDs: sec,
          },
          token: this.$store.state.userData.token,
          subjects: true,
        });

        // console.log(status);

        if (Array.isArray(status)) {
          const worksheet = XLSX.utils.json_to_sheet(status);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
          XLSX.writeFile(workbook, "Statement.xlsx");
        }
        this.request = false;
        this.stLoading = false;
      }
    },
    async LoadFeeSummary() {
      if (this.CheckDate() == true) {
        this.stLoading = true;
        var obj = {
          url:
            this.$store.state.domain +
            "feesummarydetails/loaddata?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.myObj.campusID +
            "&dtFrom=" +
            this.myObj.dtfrom +
            "&dtTo=" +
            this.myObj.dtto,
          token: this.$store.state.userData.token,
        };
        let res = await this.get(obj);
        let url =
          `https://${this.reportDomain}.myskool.app/Fee/Show?type=summaryDetails&dbb=` +
          this.myObj.db +
          "&cID=" +
          this.myObj.campusID;
        window.open(url, "_blank");
        this.stLoading = false;
      } else {
        this.$bvToast.toast("Please provide the required details.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    async LoadDues(val) {
      this.CheckSec();
      this.CheckClass();
      this.CheckDate();
      if (
        this.CheckSec() == false ||
        this.CheckClass() == false ||
        this.CheckDate() == false
      ) {
        return this.$bvToast.toast("Please provide the required details.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (val == "export") this.request = true;
        else this.stLoading = true;

        let cls = [];
        if (this.classID[0] !== 0) {
          cls = this.classID;
        }
        let sec = [];
        if (this.secID[0] !== 0) {
          sec = this.secID;
        }

        var status = await this.post({
          url:
            this.$store.state.domain +
            "Students/CalculateDues?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.myObj.campusID,
          context: this,
          body: {
            clsIDs: cls,
            secIDs: sec,
            status: "left",
          },
          token: this.$store.state.userData.token,
          subjects: true,
        });

        let contr = val == "export" ? "ShowExport" : "Show";
        let url =
          `https://${this.reportDomain}.myskool.app/List/${contr}?type=left&dbb=` +
          this.myObj.db +
          "&cID=" +
          this.myObj.campusID +
          "&cls=" +
          cls +
          "&sec=" +
          sec +
          "&status=&mob=false&dtFrom=" +
          this.myObj.dtfrom +
          "&dtTo=" +
          this.myObj.dtto;

        if (this.$store.state.currentBranch.organizationType == "coaching") {
          url = url + "&session=" + this.myObj.sessionID;
        }
        if (val == "export") {
          axios
            .get(url)
            .then((response) => {
              // console.log(response.data.data);
              window.open(response.data.data, "_blank");
            })
            .catch((error) => {
              console.error("There was an error!", error);
            });
        } else {
          window.open(url, "_blank");
        }
        this.request = false;
        this.stLoading = false;
      }
    },
    async checkLock() {
      this.isLocked = false;
      if (
        ["Staff Share", "Staff Share Summary"].includes(this.myObj.format) &&
        this.CheckDate() == true
      ) {
        this.lockChecking = true;
        let res = await this.get({
          url:
            this.$store.state.domain +
            "dcrStaffShare/CheckLocked?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.myObj.campusID +
            "&dtFrom=" +
            this.myObj.dtfrom +
            "&dtTo=" +
            this.myObj.dtto,
          token: this.$store.state.userData.token,
          context: this,
        });
        this.lockChecking = false;
        this.isLocked = res == "locked";
      }
    },
    async syncShare(lock, val) {
      if (this.CheckDate() == true) {
        // do not sync if locked
        if (this.isLocked) this.openShareReport(val);
        else {
          if (lock) this.lockLoading = true;
          else if (val == "export") this.request = true;
          else this.stLoading = true;

          let res = await this.get({
            url:
              this.$store.state.domain +
              "dcrStaffShare/CreateStaffShareBulk?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.myObj.campusID +
              "&dtFrom=" +
              this.myObj.dtfrom +
              "&dtTo=" +
              this.myObj.dtto +
              "&locked=" +
              lock,
            token: this.$store.state.userData.token,
            context: this,
            returnData: true,
          });
          if (lock) {
            if (!res) {
              // for request timeout to sync records completely
              setTimeout(() => {
                this.lockLoading = false;
                this.checkLock();
                this.$bvToast.toast("Staff share is locked now.", {
                  title: "Success!",
                  variant: "success",
                  toaster: "b-toaster-top-center",
                });
              }, 120000);
            } else {
              if (res.status == "success") {
                this.$bvToast.toast("Staff share is locked now.", {
                  title: "Success!",
                  variant: "success",
                  toaster: "b-toaster-top-center",
                });
                this.checkLock();
              } else {
                this.$bvToast.toast("Something went wrong.", {
                  title: this.$t("Error!"),
                  variant: "danger",
                  toaster: "b-toaster-top-center",
                });
              }
              this.lockLoading = false;
            }
          } else {
            if (!res) {
              // for request timeout to sync records completely
              setTimeout(() => {
                this.openShareReport(val);
              }, 120000);
            } else {
              this.openShareReport(val);
            }
          }
        }
      }
    },
    openShareReport(val) {
      let contr = val == "export" ? "ShowExport" : "Show";

      let url =
        `https://${this.reportDomain}.myskool.app/Fee/${contr}?type=` +
        this.myObj.type.value +
        "&dtFrom=" +
        this.myObj.dtfrom +
        "&dtTo=" +
        this.myObj.dtto +
        "&dbb=" +
        this.myObj.db +
        "&cID=" +
        this.myObj.campusID +
        "&month=" +
        this.myObj.months +
        "&feeType=" +
        this.myObj.feesTypeIDs +
        "&format=" +
        this.myObj.format +
        "&cls=" +
        this.myObj.classIDs +
        "&sec=" +
        this.myObj.secIDs +
        "&accId=" +
        this.myObj.account +
        "&tID=" +
        this.myObj.staffID;

      if (val == "export") {
        axios
          .get(url)
          .then((response) => {
            // console.log(response.data.data);
            window.open(response.data.data, "_blank");
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
      } else {
        window.open(url, "_blank");
      }
      this.request = false;
      this.stLoading = false;
      this.lockLoading = false;
    },
    async showReport() {
      if (
        this.myObj.format === "Campus Transfer" ||
        this.myObj.format === "Staff Campus Transfer"
      ) {
        this.openCampusTransferReport();
        return;
      }
      if (this.myObj.format === "App Stats") {
        this.showAppStatsReport();
        return;
      }
      if (this.myObj.format == "Barcode") {
        this.openBarcodeReport();
        return;
      }
      if (this.myObj.format === "Driver fees") {
        this.openDriverFeesReport();
        return;
      }
      if (this.openPendingFeesReport()) {
        return;
      }
      if (["Inquiry", "Visitors"].includes(this.myObj.format)) {
        this.openInquiryReport();
        return;
      }
      if (this.myObj.format === "New admission" && this.isMyskoolIussDomain()) {
        this.openNewAdmissionListReport();
        return;
      }
      if (
        this.myObj.format === "Reconciliation fees" &&
        this.isMyskoolIussDomain()
      ) {
        this.openReconciliationFeesReport();
        return;
      }
      if (this.myObj.format == "Timetable") {
        this.openStaffTimetableReport();
        return;
      }
      if (this.myObj.format === "Planner Logs") {
        if (this.CheckDate() === false) {
          return this.$bvToast.toast("Please provide the required details.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
        this.openPlannerLogsReport();
        return;
      }
      if (this.myObj.format == "Challan Statement") {
        this.stLoading = true;
        this.loadStatement();
      } else if (this.myObj.format == "Summary Details") {
        this.LoadFeeSummary();
      } else if (
        this.myObj.format == "Left students" &&
        this.dueObj &&
        this.dueObj.valueBool
      ) {
        this.LoadDues();
      } else if (
        ["Staff Share", "Staff Share Summary"].includes(this.myObj.format)
      ) {
        this.syncShare(false, "");
      } else {
        // console.log("ClsID", this.classID);
        let clsName = "";
        let secName = "";
        const selectedClassIds = this.normalizeFilterIds(this.classID);
        const selectedSecIds = this.normalizeFilterIds(this.secID);

        if (this.hasSelectedFilterId(this.classID)) {
          if (this.isDistinct) {
            let ids = this.classes
              .filter((e) => selectedClassIds.includes(e.cls.id))
              .map((e) => e.cls.status)
              .join()
              .split(",");
            // console.log("cls",ids);
            this.myObj.classIDs = ids;
          } else this.myObj.classIDs = selectedClassIds;

          clsName = this.classesOptions
            .filter((e) => selectedClassIds.includes(e.id))
            .map((e) => e.name)
            .join();
        } else {
          this.myObj.classIDs = [];
        }

        if (this.hasSelectedFilterId(this.secID)) {
          //console.log(this.secID);
          if (this.isDistinct) {
            let ids = this.admittedSections
              .filter((e) => selectedSecIds.includes(e.id))
              .map((e) => e.metaVal)
              .join()
              .split(",");
            // console.log("sec",ids);
            this.myObj.secIDs = ids;
          } else this.myObj.secIDs = selectedSecIds;

          secName = this.admittedSections
            .filter((e) => selectedSecIds.includes(e.id))
            .map((e) => e.section)
            .join();
        } else {
          this.myObj.secIDs = [];
        }
        // console.log(this.myObj);
        this.CheckStatus();
        this.CheckFormat();
        this.CheckAccount();
        this.CheckDate();
        this.CheckSingleDate();
        this.checkExam();
        this.checkSession();
        // this.checkMultiAccounts();
        this.CheckType();
        this.CheckSec();
        this.CheckClass();
        this.checkSingleMonth();
        this.checkSingleYear();
        this.checkTurnoverMonths();
        this.checkNtnPeriod();
        this.CheckDepartment();
        this.checkBalance();
        this.checkPerc();
        this.checkStaffDep();
        this.CheckIncrementYear();
        this.CheckCons();
        this.CheckSlipFrom();
        this.CheckSlipTo();
        if (
          this.CheckType() == false ||
          this.CheckSec() == false ||
          this.CheckClass() == false ||
          this.CheckFormat() == false ||
          this.CheckAccount() == false ||
          this.CheckDate() == false ||
          this.CheckSingleDate() == false ||
          this.checkExam() == false ||
          this.checkSession() == false ||
          this.CheckStatus() == false ||
          // this.checkMultiAccounts() == false ||
          this.checkYear() == false ||
          this.checkSingleMonth() == false ||
          this.checkSingleYear() == false ||
          this.checkTurnoverMonths() == false ||
          this.checkNtnPeriod() == false ||
          this.CheckDepartment() == false ||
          this.CheckFee() == false ||
          this.checkBalance() == false ||
          this.checkPerc() == false ||
          this.checkStaffDep() == false ||
          this.CheckIncrementYear() == false ||
          this.checkRangeMonth() == false ||
          this.CheckCons() == false ||
          this.CheckSlipFrom() == false ||
          this.CheckSlipTo() == false ||
          this.checkSlipRange() == false
        ) {
          return this.$bvToast.toast("Please provide the required details.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          if (this.myObj.format == "Fee Revenue") {
            this.openFeeRevenueReport();
            return;
          }
          if (
            this.myObj.format === "Reconciliation fees" &&
            this.isMyskoolIussDomain()
          ) {
            this.openReconciliationFeesReport();
            return;
          }
          if (this.myObj.format == "NTN Certificate") {
            this.openNtnCertificateReport();
            return;
          }
          if (this.reportDomain == "myskoolhhpublic" && this.myObj.format == "Outstanding summary") {
            this.openOutstandingSummaryReport();
            return;
          }

          if (this.myObj.type.value == "dcr") {
            if (this.myObj.format == "Fee Summary") {
              var url =
                `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
                this.myObj.type.value +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&month=" +
                this.singleMonth +
                "&feeType=" +
                this.myObj.feesTypeIDs +
                "&format=" +
                this.myObj.format +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&accId=" +
                this.myObj.account +
                "&slipFrom=" +
                this.slipFrom +
                "&slipTo=" +
                this.slipTo +
                "&year=" +
                this.singleYear;
              window.open(url, "_blank");
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
                this.myObj.type.value +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&month=" +
                this.myObj.months +
                "&feeType=" +
                this.myObj.feesTypeIDs +
                "&format=" +
                this.myObj.format +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&accId=" +
                this.myObj.account +
                "&slipFrom=" +
                this.slipFrom +
                "&slipTo=" +
                this.slipTo;
              window.open(url, "_blank");
            }
          } else if (this.myObj.type.value == "Students") {
            if (this.myObj.format == "Event Calendar Report") {
              this.openEventCalendarReport();
              return;
            }

            // Handle Fees Concession Report
            if (this.myObj.format == "Fees Concession Report") {
              this.openFeeConcessionReport();
              return;
            }

            if (this.myObj.format == "Class Wise Concession Report") {
              this.openClassWiseConcessionReport();
              return;
            }

            if (this.myObj.format == "Sibling Concession Report") {
              this.openSiblingConcessionReport();
              return;
            }

            if (this.myObj.format == "Department-wise Discount Report") {
              this.openDepartmentWiseDiscountReport();
              return;
            }

            if (this.myObj.format == "Discount Summary Report") {
              this.openDiscountSummaryReport();
              return;
            }

            // Handle Fee Reminder report
            if (this.myObj.format == "Fee Reminder") {
              const routeData = this.$router.resolve({
                name: "fee-reminder-print",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  classID:
                    Array.isArray(this.classID) && this.classID.length > 0
                      ? this.classID[0]
                      : this.classID || 0,
                  secID:
                    Array.isArray(this.secID) && this.secID.length > 0
                      ? this.secID[0]
                      : this.secID || 0,
                  search: this.myObj.search || "",
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            // Handle Date wise strength (myskool / myskoolsmartdha / myskooliuss / myskoolprofectus)
            if (this.myObj.format == "Date wise strength") {
              this.openDateWiseStrengthReport();
              return;
            }

            if (
              this.myObj.format == "Driver wise students" &&
              this.isDriverReportDomain
            ) {
              this.openDriverWiseStudentsReport();
              return;
            }

            // Handle Campus Transfer / Staff Campus Transfer report
            if (
              this.myObj.format == "Campus Transfer" ||
              this.myObj.format == "Staff Campus Transfer"
            ) {
              this.openCampusTransferReport();
              return;
            }

            // Handle Custom Fee Report
            if (this.myObj.format == "Custom Fee Report") {
              const routeData = this.$router.resolve({
                name: "custom-fee-report-print",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  classID:
                    Array.isArray(this.classID) && this.classID.length > 0
                      ? this.classID[0]
                      : this.classID || 0,
                  secID:
                    Array.isArray(this.secID) && this.secID.length > 0
                      ? this.secID[0]
                      : this.secID || 0,
                  search: this.myObj.search || "",
                  feeType: this.customFeeTypeID || 0,
                  month: this.customFeeMonth || 0,
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            // Handle Terms & Conditions report (Terms History) for myskooliuss domain
            if (
              this.myObj.format == "Terms & Conditions report" &&
              this.reportDomain.toLowerCase() === "myskooliuss"
            ) {
              const routeData = this.$router.resolve({
                name: "terms-history-print",
                query: {
                  db: this.myObj.db,
                  cID: this.appReportCampusID || this.myObj.campusID,
                  classID: this.appReportClassID || 0,
                  fromDate: this.appReportFromDate || "",
                  toDate: this.appReportToDate || "",
                  status: this.appReportStatus || "",
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            // Handle Terms acknowledge report for myskooliuss domain
            if (
              this.myObj.format == "Terms acknowledge report" &&
              this.reportDomain.toLowerCase() === "myskooliuss"
            ) {
              const routeData = this.$router.resolve({
                name: "terms-acknowledge-print",
                query: {
                  db: this.myObj.db,
                  cID: this.appReportCampusID || this.myObj.campusID,
                  classID: this.appReportClassID || 0,
                  sectionID: this.appReportSectionID || 0,
                  sID: this.myObj.search || "",
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            // Handle Student turnover (myskooliuss)
            if (
              this.myObj.format == "Student turnover" &&
              this.supportsStudentTurnoverReport
            ) {
              this.openStudentTurnoverReport();
              return;
            }

            // Handle Subject Wise Fees report
            if (this.myObj.format == "Subject Wise Fees") {
              this.openSubjectFeeReport();
              return;
            }

            // Student Subject List — Vue print (non-SKH) or report domain URL (myskoolskh)
            if (this.myObj.format == "Subject List") {
              if (this.usesSubjectListDomainReport) {
                this.openSubjectListDomainReport(clsName, secName);
                return;
              }
              this.openSubjectListReport();
              return;
            }

            // Handle Student Email List report
            if (this.myObj.format == "Student Email List") {
              const routeData = this.$router.resolve({
                name: "student-email-report",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  cls: Array.isArray(this.myObj.classIDs)
                    ? this.myObj.classIDs.join(",")
                    : this.myObj.classIDs || "",
                  sec: Array.isArray(this.myObj.secIDs)
                    ? this.myObj.secIDs.join(",")
                    : this.myObj.secIDs || "",
                  status: this.myObj.status,
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            // Handle Class list (myskooliuss)
            if (
              this.myObj.format == "Class list" &&
              this.reportDomain.toLowerCase() === "myskooliuss"
            ) {
              this.openClassListIUSSReport();
              return;
            }

            if (this.myObj.format === "Fee status") {
              this.openListFeeStatusReport(clsName, secName);
              return;
            }

            if (
              this.myObj.format === "Average fees" &&
              this.isMyskoolIussDomain()
            ) {
              this.openFeeStatusIUSSReport(false, "average");
              return;
            }

            // Handle New admission (myskooliuss)
            if (
              this.myObj.format == "New admission" &&
              this.isMyskoolIussDomain()
            ) {
              this.openNewAdmissionListReport();
              return;
            }

            // Handle Class list verification
            if (this.myObj.format == "Class list verification") {
              const routeData = this.$router.resolve({
                name: "class-verification-report",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  cls: Array.isArray(this.myObj.classIDs)
                    ? this.myObj.classIDs.join(",")
                    : this.myObj.classIDs || "",
                  sec: Array.isArray(this.myObj.secIDs)
                    ? this.myObj.secIDs.join(",")
                    : this.myObj.secIDs || "",
                  status: this.myObj.status,
                  cols: this.selectedCols.join(","),
                  signs: this.selectedSigns.join(","),
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            let ty = "list";
            if (this.myObj.format == "Strength report") ty = "strength";
            else if (this.myObj.format == "Student Details")
              ty = "student-details";
            else if (this.myObj.format == "Campus Strength")
              ty = "campus-strength";
            else if (this.myObj.format == "Fee status") ty = "feeStatus";
            else if (this.myObj.format == "Fee projection")
              ty = "feeProjection";
            else if (this.myObj.format == "Free ship") ty = "freeship";
            else if (this.myObj.format == "Discount Percentage")
              ty = "discount-perc";
            else if (this.myObj.format == "GR Registered") ty = "gr";
            else if (this.myObj.format == "New admission") ty = "admission";
            else if (this.myObj.format == "Registration List")
              ty = "registration";
            else if (this.myObj.format == "Admission List - Unpaid")
              ty = "admission-unpaid";
            else if (this.myObj.format == "Admission List - Paid")
              ty = "admission-paid";
            else if (this.myObj.format == "Left students") ty = "left";
            else if (this.myObj.format == "Left Category wise")
              ty = "leftcategory";
            else if (this.myObj.format == "Attendance list") ty = "attendance";
            else if (this.myObj.format == "Housewise List") ty = "house";
            else if (this.myObj.format == "Family List") ty = "family";
            else if (this.myObj.format == "Discount list") ty = "discount";
            else if (this.myObj.format == "Missing contacts")
              ty = "missingcontacts";
            else if (this.myObj.format == "Family wise fees status")
              ty = "familywisefee";
            else if (this.myObj.format == "Consents") ty = "consents";
            else if (this.myObj.format == "Transport List") ty = "transport";
            else if (this.myObj.format == "Subject List") ty = "subjects";
            else if (this.myObj.format == "Class list 2") ty = "list2";

            if (
              this.$store.state.currentBranch.organizationType == "coaching"
            ) {
              if (ty == "list" || ty == "student-details") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=" +
                  this.myObj.status +
                  "&session=" +
                  this.myObj.sessionID +
                  "&mob=false&dtFrom=" +
                  this.myObj.dtfrom +
                  "&dtTo=" +
                  this.myObj.dtto +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName +
                  "&gender=" +
                  this.selectedGender;
                window.open(url, "_blank");
              } else if (ty == "attendance") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&session=" +
                  this.myObj.sessionID +
                  "&status=&mob=false" +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;
                window.open(url, "_blank");
              } else if (
                ty == "list" ||
                ty == "admission" ||
                ty == "registration" ||
                ty == "admission-unpaid" ||
                ty == "admission-paid" ||
                ty == "left" ||
                ty == "house" ||
                ty == "family" ||
                ty == "transport"
              ) {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=" +
                  this.myObj.status +
                  "&mob=false&dtFrom=" +
                  this.myObj.dtfrom +
                  "&dtTo=" +
                  this.myObj.dtto +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName +
                  "&gender=" +
                  this.selectedGender;
                window.open(url, "_blank");
              } else if (ty == "discount-perc") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=&mob=false&perc=" +
                  this.disPerc +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;
                window.open(url, "_blank");
              } else if (ty == "consents") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&consent=" +
                  this.myObj.consent +
                  "&status=&mob=false" +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;
                window.open(url, "_blank");
              } else if (ty == "leftcategory") {
                let catName =
                  this.myObj.leftCategory == "All"
                    ? ""
                    : this.myObj.leftCategory;
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&category=" +
                  catName +
                  "&status=&mob=false&dtFrom=" +
                  this.myObj.dtfrom +
                  "&dtTo=" +
                  this.myObj.dtto +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;
                window.open(url, "_blank");
              } else if (ty == "subjects") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=" +
                  this.myObj.status +
                  "&mob=false" +
                  "&session=" +
                  this.myObj.sessionID +
                  "&subID=" +
                  this.myObj.subjectID +
                  "&tID=" +
                  this.myObj.staffID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;
                window.open(url, "_blank");
              } else {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=&mob=false" +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;
                window.open(url, "_blank");
              }
            } else if (
              ty == "list" ||
              ty == "student-details" ||
              ty == "admission" ||
              ty == "registration" ||
              ty == "admission-unpaid" ||
              ty == "admission-paid" ||
              ty == "left" ||
              ty == "house" ||
              ty == "family" ||
              ty == "list2" ||
              ty == "transport"
            ) {
              var url =
                `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=" +
                this.myObj.status +
                "&mob=false&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName +
                "&gender=" +
                this.selectedGender;

              window.open(url, "_blank");
            } else if (ty == "discount-perc") {
              var url =
                `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=&mob=false&perc=" +
                this.disPerc +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;

              window.open(url, "_blank");
            } else if (ty == "consents") {
              var url =
                `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&consent=" +
                this.myObj.consent +
                "&status=&mob=false" +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;

              window.open(url, "_blank");
            } else if (ty == "leftcategory") {
              let catName =
                this.myObj.leftCategory == "All" ? "" : this.myObj.leftCategory;
              var url =
                `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&category=" +
                catName +
                "&status=&mob=false&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;

              window.open(url, "_blank");
            } else if (ty == "subjects") {
              var url =
                `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=" +
                this.myObj.status +
                "&mob=false" +
                "&session=" +
                this.myObj.sessionID +
                "&subID=" +
                this.myObj.subjectID +
                "&tID=" +
                this.myObj.staffID +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;

              window.open(url, "_blank");
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=&mob=false" +
                "&session=" +
                this.myObj.sessionID +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName +
                "&disRefID=" +
                (this.selectedDisRef || "");
              // console.log(url);
              window.open(url, "_blank");
            }
          } else if (this.myObj.type.value == "Staff") {
            if (
              this.myObj.format == "Remaining Leaves" ||
              this.myObj.format == "Leave Encashment" ||
              this.myObj.format == "Advance & Loan"
            ) {
              // Handle remaining leaves, leave encashment, and advance & loan reports
              const routeData = this.$router.resolve({
                name: "remaining-leaves-print",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  depID: Array.isArray(this.staffDepID)
                    ? this.staffDepID[0]
                    : this.staffDepID || 0,
                  title: this.myObj.format,
                },
              });
              window.open(routeData.href, "_blank");
            } else if (this.myObj.format == "Organization structure") {
              // Handle hierarchy report - open directly in new tab
              this.openHierarchyInNewTab();
            } else if (this.myObj.format == "Jubilee Insurance") {
              // Handle Jubilee Insurance report for myskooliuss domain
              this.showJubileeInsuranceReport();
            } else if (this.myObj.format == "Staff Allocation") {
              // Custom frontend report backed by Staff/StaffAllocation
              this.openStaffAllocationReport();
            } else if (this.myObj.format == "File cover") {
              // Same file cover route as the staff grid (new tab)
              const fileCoverDepIDs = Array.isArray(this.staffDepID)
                ? this.staffDepID.join(",")
                : this.staffDepID || 0;
              const routeData = this.$router.resolve({
                name: "file-cover",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  depID: fileCoverDepIDs,
                  status: this.myObj.staffStatus || "present",
                },
              });
              window.open(routeData.href, "_blank");
            } else if (
              [
                "Staff List Muster Roll",
                "Staff List With Salary",
                "New staff list",
                "New staff left list",
              ].includes(this.myObj.format)
            ) {
              // Handle new staff report types with API call
              this.showNewStaffReport();
            } else if (this.myObj.format === "Increment list") {
              const classLabel = Array.isArray(this.incrementRange)
                ? this.incrementRange
                : (this.incrementRange || "").split(" to ");
              const dtFrom = this.formatYMD(classLabel[0]);
              const dtTo = classLabel[1] ? this.formatYMD(classLabel[1]) : "";

              if (
                this.isAlhameedDomain &&
                (this.incrementYear === null ||
                  this.incrementYear === undefined)
              ) {
                this.$bvToast.toast("Please select a year.", {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                return;
              }
              if (
                !this.isAlhameedDomain &&
                (!this.incrementRange || this.incrementRange.length < 2)
              ) {
                this.$bvToast.toast("Please select a valid date range.", {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                return;
              }

              const routeData = this.$router.resolve({
                name: "staff-increment-report",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  depID: this.staffDepID || 0,
                  year: this.incrementYear || "",
                  dtFrom: dtFrom,
                  dtTo: dtTo,
                  domain: this.isAlhameedDomain ? "alhameed" : "normal",
                },
              });
              window.open(routeData.href, "_blank");
            } else {
              // Handle existing staff report formats
              let ty = "staff";
              if (this.myObj.format == "Deposit List") ty = "deposit";
              else if (this.myObj.format == "Staff List Date wise")
                ty = "staffdatewise";

              var url =
                `https://${this.reportDomain}.myskool.app/List/Show?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=" +
                this.myObj.staffStatus +
                "&mob=false&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&depID=" +
                this.staffDepID;
              // console.log(url);
              window.open(url, "_blank");
            }
          } else if (this.myObj.type.value == "Accounts") {
            if (this.accList[0] !== 0) {
              this.myObj.accIDs = this.accList;
            } else {
              this.myObj.accIDs = "";
            }

            let ty = "expense";
            if (this.myObj.format == "Income report") ty = "income";
            else if (this.myObj.format == "Closing report") ty = "closing";
            else if (this.myObj.format == "Cashbook") ty = "cashbookNew";
            else if (this.myObj.format == "Monthly Fee") ty = "Receivables";
            else if (this.myObj.format == "Estimation") ty = "estimation";

            if (
              this.myObj.format == "Closing report" ||
              this.myObj.format == "Cashbook"
            ) {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/Show?type=` +
                ty +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&accID=0";

              window.open(url, "_blank");
            } else if (
              this.myObj.format == "Monthly Fee" ||
              this.myObj.format == "Estimation"
            ) {
              let m = 0;
              if (this.singleMonth < 10) m = `0${this.singleMonth}`;
              else m = this.singleMonth;
              let dt = `${this.singleYear}-${m}-01`;

              var url =
                `https://${this.reportDomain}.myskool.app/Account/Show?type=` +
                ty +
                "&dtFrom=" +
                dt +
                "&dtTo=" +
                dt +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&accID=0";

              window.open(url, "_blank");
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/Show?type=` +
                ty +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&accID=" +
                this.coa;

              window.open(url, "_blank");
            }
          } else if (this.myObj.type.value == "Advance Accounts") {
            // Handle Balance Sheet - route to internal page
            if (this.myObj.format == "Balance Sheet") {
              if (!this.selectedFiscalYearID) {
                this.$bvToast.toast("Please select a fiscal year", {
                  title: "Validation",
                  variant: "warning",
                  solid: true,
                });
                return;
              }
              this.$router.push({
                path: "/balance-sheet-print",
                query: {
                  db: this.myObj.db || this.$store.state.userData.db,
                  campusID:
                    this.myObj.campusID || this.$store.state.userData.cId,
                  fiscalYearID: this.selectedFiscalYearID,
                },
              });
              return;
            }
            // Handle Expense Report (Al Hameed / Beprince)
            if (this.myObj.format == "Expense Report") {
              const selectedAccount = this.filteredCoaTypes.find(
                (acc) => acc.id === (this.coa || 0)
              );
              const isBeprince =
                this.reportDomain === "myskoolbeprince" ||
                String(this.reportDomain || "")
                  .replace(/_/g, "")
                  .toLowerCase() === "myskoolbeprince";
              const routeData = this.$router.resolve({
                name: isBeprince
                  ? "expense-report-beprince-print"
                  : "expense-report-print",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  accountID: this.coa || 0,
                  accountTitle: selectedAccount?.title || "All Accounts",
                  dtFrom: this.myObj.dtfrom,
                  dtTo: this.myObj.dtto,
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            // Handle Ledger (reconciled) format
            if (this.myObj.format == "Ledger (reconciled)") {
              await this.showLedgerReconciled();
              return;
            }

            // Handle New Ledger Print
            if (this.myObj.format == "Ledger" && this.newLedgerSetting) {
              this.stLoading = true;
              try {
                const routeData = this.$router.resolve({
                  name: "advance-ledger-print",
                  query: this.buildAdvanceLedgerPrintQuery(),
                });
                window.open(routeData.href, "_blank");
              } finally {
                this.stLoading = false;
              }
              return;
            }

            // Cash Flow Statement
            if (this.myObj.format == "Cash Flow Statement") {
              await this.showCashFlowReport();
              return;
            }
            if (this.myObj.format == "Cash Flow Expenses") {
              await this.showCashFlowExpenses();
              return;
            }

            // Accounts Summary
            if (this.myObj.format == "Accounts Summary") {
              await this.showAccountsSummary();
              return;
            }

            // Cheque Summary
            if (
              this.myObj.format == "Cheque Summary" &&
              this.newLedgerSetting
            ) {
              const routeData = this.$router.resolve({
                name: "cheque-summary-print",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  dtFrom: this.myObj.dtfrom,
                  dtTo: this.myObj.dtto,
                },
              });
              window.open(routeData.href, "_blank");
              return;
            }

            let ty = "journal";
            if (this.myObj.format == "Ledger") ty = "ledger";
            else if (this.myObj.format == "Trial Balance") ty = "trialBalance";
            else if (this.myObj.format == "Extended Trial Balance")
              ty = "extendedTrialBalance";
            else if (this.myObj.format == "Income Statement")
              ty = "incomeStatement";
            else if (this.myObj.format == "Cash Flow") ty = "cashFlow";
            else if (this.myObj.format == "Cheque Summary")
              ty = "chequeSummary";
            else if (this.myObj.format == "Daily Summary") ty = "dailySummary";
            else if (this.myObj.format == "Monthly Summary")
              ty = "monthlySummary";
            else if (this.myObj.format == "Party Ledger") ty = "partyLedger";
            else if (this.myObj.format == "SBU Ledger") ty = "sbuLedger";

            if (
              this.myObj.format == "Extended Trial Balance" &&
              this.newLedgerSetting
            ) {
              this.stLoading = true;
              try {
                await this.prefetchExtendedTrialBalanceGenerateApi();
                const etbRouteName =
                  this.reportDomain === "myskoolaba"
                    ? "aba-extended-trial-balance-print"
                    : "extended-trial-balance-print";
                const routeData = this.$router.resolve({
                  name: etbRouteName,
                  query: this.buildEtbRouteQuery(),
                });
                window.open(routeData.href, "_blank");
              } finally {
                this.stLoading = false;
              }
              return;
            }
            if (this.myObj.format == "Extended Trial Balance") {
              // Special handling for Extended Trial Balance with new API
              this.stLoading = true;

              let dtFrom = this.myObj.dtfrom;
              let dtTo = this.myObj.dtto;

              try {
                await this.prefetchExtendedTrialBalanceGenerateApi();

                // Step 2: Immediately open the report URL
                var url = `https://${this.reportDomain}.myskool.app/Account/Show?type=extendedTrialBalance&dtFrom=${dtFrom}&dtTo=${dtTo}&dbb=${this.myObj.db}&cID=${this.myObj.campusID}&dptID=1&accID=${this.coa}`;
                // console.log("Opening report URL:", url);
                window.open(url, "_blank");
              } catch (error) {
                console.error(
                  "Error generating Extended Trial Balance:",
                  error
                );
                this.$bvToast.toast(
                  "Failed to generate Extended Trial Balance report.",
                  {
                    title: this.$t("Error"),
                    variant: "danger",
                  }
                );
              } finally {
                this.stLoading = false;
              }
            } else if (
              ["Ledger", "Daily Summary", "Monthly Summary"].includes(
                this.myObj.format
              )
            ) {
              let dtFrom = this.myObj.dtfrom;
              let dtTo = this.myObj.dtto;
              if (this.myObj.format == "Daily Summary") {
                dtFrom = this.singleDate;
                dtTo = this.singleDate;
              }

              let linkedAcc = this.collectionLinks.find(
                (el) => el.id == this.coa
              );
              const toSync =
                (this.myObj.format == "Ledger" && linkedAcc) ||
                ["Daily Summary", "Monthly Summary"].includes(
                  this.myObj.format
                );

              if (toSync) {
                this.stLoading = true;

                var status = await this.get({
                  url:
                    this.$store.state.domain +
                    "JournalEntry/SyncLedger?db=" +
                    this.$store.state.userData.db +
                    "&cID=" +
                    this.myObj.campusID +
                    "&dtFrom=" +
                    dtFrom +
                    "&dtTo=" +
                    dtTo,
                  context: this,
                  token: this.$store.state.userData.token,
                });
                this.stLoading = false;
              }

              var url =
                `https://${this.reportDomain}.myskool.app/Account/Show?type=` +
                ty +
                "&dtFrom=" +
                dtFrom +
                "&dtTo=" +
                dtTo +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&dptID=1&accID=" +
                this.coa;

              window.open(url, "_blank");
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/Show?type=` +
                ty +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&dptID=1&accID=0";

              window.open(url, "_blank");
            }
          } else if (this.myObj.type.value == "Attendance") {
            if (this.myObj.format == "Student") {
              var url =
                `https://${this.reportDomain}.myskool.app/Attendance/Show?type=student&dtFrom=` +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=";

              window.open(url, "_blank");
            } else {
              // var status = await this.get({
              //   url:
              //     this.$store.state.domain +
              //     "StaffAttendance/UpdateLateComing?db=" +
              //     this.$store.state.userData.db +
              //     "&cID=" +
              //     this.myObj.campusID +
              //     "&dtFrom=" +
              //     this.myObj.dtfrom +
              //     "&dtTo=" +
              //     this.myObj.dtto,
              //   context: this,
              //   token: this.$store.state.userData.token,
              // });
              var url =
                `https://${this.reportDomain}.myskool.app/Attendance/ShowStaff?dtFrom=` +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&depID=0";
              //  +
              // "&status=";

              window.open(url, "_blank");
            }
          } else if (this.myObj.type.value == "Certificates") {
            if (this.myObj.format == "Admit card") {
              //Admit card
              // console.log(this.eTypee);
              // const currentDate = new Date();
              // const day = ("0" + currentDate.getDate()).slice(-2);
              // const month = currentDate.toLocaleString("default", {
              //   month: "short",
              // });
              // const year = currentDate.getFullYear();
              // const formattedDate = `${day}-${month}-${year}`;

              var url =
                `https://${this.reportDomain}.myskool.app/Certificate/Show?type=` +
                "admit-card" +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&exam=" +
                this.eTypee +
                "&session=" +
                this.myObj.sessionID +
                "&date=" +
                this.formattedDate;
              // console.log(url);
              window.open(url, "_blank");
            } else if (this.myObj.format == "ID card") {
              let sess = this.sessions.find(
                (el) => el.id == this.myObj.sessionID
              ).session;
              if (this.reportDomain === "myskoolfarabicoa") {
                const routeData = this.$router.resolve({
                  name: "farabi-coa-id-card",
                  query: {
                    db: this.myObj.db,
                    cID: this.myObj.campusID,
                    cls: Array.isArray(this.myObj.classIDs)
                      ? this.myObj.classIDs.join(",")
                      : this.myObj.classIDs || "",
                    sec: Array.isArray(this.myObj.secIDs)
                      ? this.myObj.secIDs.join(",")
                      : this.myObj.secIDs || "",
                    status: this.myObj.status,
                    sess: sess,
                    sessionID: this.myObj.sessionID,
                  },
                });
                window.open(routeData.href, "_blank");
                return;
              } else if (this.reportDomain === "myskoolhappinessfoundation") {
                const routeData = this.$router.resolve({
                  name: "happiness-foundation-id-card",
                  query: {
                    db: this.myObj.db,
                    cID: this.myObj.campusID,
                    cls: Array.isArray(this.myObj.classIDs)
                      ? this.myObj.classIDs.join(",")
                      : this.myObj.classIDs || "",
                    sec: Array.isArray(this.myObj.secIDs)
                      ? this.myObj.secIDs.join(",")
                      : this.myObj.secIDs || "",
                    status: this.myObj.status,
                    sess: sess,
                    sessionID: this.myObj.sessionID,
                  },
                });
                window.open(routeData.href, "_blank");
                return;
              } else if (this.reportDomain === "myskoolkentschool") {
                const routeData = this.$router.resolve({
                  name: "kent-id-card",
                  query: {
                    db: this.myObj.db,
                    cID: this.myObj.campusID,
                    cls: Array.isArray(this.myObj.classIDs)
                      ? this.myObj.classIDs.join(",")
                      : this.myObj.classIDs || "",
                    sec: Array.isArray(this.myObj.secIDs)
                      ? this.myObj.secIDs.join(",")
                      : this.myObj.secIDs || "",
                    status: this.myObj.status,
                    sess: sess,
                    sessionID: this.myObj.sessionID,
                  },
                });
                window.open(routeData.href, "_blank");
                return;
              } else if (
                this.reportDomain === "myskoolsmarthf" &&
                this.myObj.campusID == 2
              ) {
                const routeData = this.$router.resolve({
                  name: "smart-hassan-id-card",
                  query: {
                    db: this.myObj.db,
                    cID: this.myObj.campusID,
                    cls: Array.isArray(this.myObj.classIDs)
                      ? this.myObj.classIDs.join(",")
                      : this.myObj.classIDs || "",
                    sec: Array.isArray(this.myObj.secIDs)
                      ? this.myObj.secIDs.join(",")
                      : this.myObj.secIDs || "",
                    status: this.myObj.status,
                    sess: sess,
                    sessionID: this.myObj.sessionID,
                  },
                });
                window.open(routeData.href, "_blank");
                return;
              } else if (this.reportDomain === "myskoolbeprince") {
                const routeData = this.$router.resolve({
                  name: "beprince-id-card",
                  query: {
                    db: this.myObj.db,
                    cID: this.myObj.campusID,
                    cls: Array.isArray(this.myObj.classIDs)
                      ? this.myObj.classIDs.join(",")
                      : this.myObj.classIDs || "",
                    sec: Array.isArray(this.myObj.secIDs)
                      ? this.myObj.secIDs.join(",")
                      : this.myObj.secIDs || "",
                    status: this.myObj.status,
                    sess: sess,
                    sessionID: this.myObj.sessionID,
                  },
                });
                window.open(routeData.href, "_blank");
                return;
              } else if (this.reportDomain === "myskoolhpgs") {
                const routename = this.myObj.campusID == 57 ? "hpgs-id-card-alevel": "hpgs-id-card";
                const routeData = this.$router.resolve({
                  name: routename,
                  query: {
                    db: this.myObj.db,
                    cID: this.myObj.campusID,
                    cls: Array.isArray(this.myObj.classIDs)
                      ? this.myObj.classIDs.join(",")
                      : this.myObj.classIDs || "",
                    sec: Array.isArray(this.myObj.secIDs)
                      ? this.myObj.secIDs.join(",")
                      : this.myObj.secIDs || "",
                    status: this.myObj.status,
                    sess: sess,
                    sessionID: this.myObj.sessionID,
                  },
                });
                window.open(routeData.href, "_blank");
                return;
              }

              var url =
                `https://${this.reportDomain}.myskool.app/Certificate/Show?type=id-card&dbb=` +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&session=" +
                sess;
              window.open(url, "_blank");
            } else {
              let ty = "transfer";
              if (this.myObj.format == "Character") ty = "character";
              else if (this.myObj.format == "Leaving") ty = "leaving";
              else if (this.myObj.format == "Provisional") ty = "provisional";
              else if (this.myObj.format == "Gate Pass") ty = "gatepass";
              else if (this.myObj.format == "Pickup card (Parent)")
                ty = "pcparent";
              else if (this.myObj.format == "Pickup card (Driver)")
                ty = "pcdriver";
              else if (this.myObj.format == "Fee Card") ty = "fee-card";
              else if (this.myObj.format == "Acknowledgement Form")
                ty = "acknowledgement-form";

              var url =
                `https://${this.reportDomain}.myskool.app/Certificate/Show?type=${ty}&dbb=` +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&sID=0&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs;
              window.open(url, "_blank");
            }
          } else if (this.myObj.format == "Outstanding summary") {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              this.myObj.dtfrom +
              "&dtTo=" +
              this.myObj.dtto +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              this.singleMonth +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.singleYear +
              "&depID=" +
              this.selectedDep;
            window.open(url, "_blank");
          } else if (this.myObj.format == "Monthly summary") {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              this.myObj.dtfrom +
              "&dtTo=" +
              this.myObj.dtto +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              this.singleMonth +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.singleYear +
              "&depID=" +
              this.myObj.depID;
            window.open(url, "_blank");
          } else if (
            this.reportDomain == "myskoolstjacob" &&
            this.myObj.type.value == "defaulters" &&
            (this.myObj.format == "Class wise" ||
              this.myObj.format == "Family wise")
          ) {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              (this.jDate || "") +
              "&dtTo=" +
              (this.jDate || "") +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              // this.myObj.months +
              this.dateRange +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.myObj.year +
              "&status=" +
              this.myObj.status +
              "&balance=" +
              this.myObj.balance;
            window.open(url, "_blank");
          } else if (this.myObj.type.value == "defaulters") {
            // console.log(this.dateRange);
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              "&dtTo=" +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              // this.myObj.months +
              this.dateRange +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.myObj.year +
              "&status=" +
              this.myObj.status +
              "&balance=" +
              this.myObj.balance;
            window.open(url, "_blank");
          } else if (this.myObj.type.value == "challan-report") {
            let format = "challan-issued";
            if (this.myObj.format == "Monthly Issued")
              format = "monthly-issued";
            else if (this.myObj.format == "Annual Issued")
              format = "annual-issued";

            const monthVal = this.monthsSOptions
              .find((el) => el.id == this.singleMonth)
              .name.substring(0, 3);

            var url =
              `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
              this.myObj.type.value +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              monthVal +
              "&format=" +
              format +
              "&year=" +
              this.singleYear;
            window.open(url, "_blank");
          } else {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/Show?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              this.myObj.dtfrom +
              "&dtTo=" +
              this.myObj.dtto +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              // this.myObj.months +
              this.dateRange +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.myObj.year +
              "&status=" +
              this.myObj.status +
              "&balance=" +
              this.myObj.balance;
            window.open(url, "_blank");
          }
        }
      }
    },

    async exportReport() {
      if (
        this.myObj.format === "Campus Transfer" ||
        this.myObj.format === "Staff Campus Transfer"
      ) {
        await this.exportCampusTransferExcel();
        return;
      }
      if (this.myObj.format === "App Stats") {
        await this.exportAppStatsReport();
        return;
      }
      if (this.myObj.format == "Barcode") {
        this.openBarcodeReport();
        return;
      }
      if (this.myObj.format === "Driver fees") {
        await this.exportDriverFeesExcel();
        return;
      }
      if (await this.exportPendingFeesExcel()) {
        return;
      }
      if (await this.exportFeeConcessionExcel()) {
        return;
      }
      if (await this.exportClassWiseConcessionExcel()) {
        return;
      }
      if (await this.exportSiblingConcessionExcel()) {
        return;
      }
      if (await this.exportDepartmentWiseDiscountExcel()) {
        return;
      }
      if (await this.exportDiscountSummaryExcel()) {
        return;
      }
      if (await this.exportDateWiseStrengthExcel()) {
        return;
      }
      if (
        this.myObj.format === "Driver wise students" &&
        this.isDriverReportDomain
      ) {
        await this.exportDriverWiseStudentsExcel();
        return;
      }
      if (await this.exportInquiryVisitorsExcel()) {
        return;
      }
      if (this.myObj.format === "New admission" && this.isMyskoolIussDomain()) {
        await this.exportNewAdmissionListExcel();
        return;
      }
      if (
        this.myObj.format === "Reconciliation fees" &&
        this.isMyskoolIussDomain()
      ) {
        await this.exportReconciliationFeesExcel();
        return;
      }
      if (await this.exportStaffTimetableExcel()) {
        return;
      }
      if (await this.exportPlannerLogsExcel()) {
        return;
      }
      if (await this.exportCustomFeeExcel()) {
        return;
      }
      if (await this.exportSubjectFeeExcel()) {
        return;
      }
      if (await this.exportSubjectListExcel()) {
        return;
      }
      if (
        this.myObj.format === "Student turnover" &&
        this.supportsStudentTurnoverReport
      ) {
        this.checkTurnoverMonths();
        if (this.checkTurnoverMonths() === false) {
          return this.$bvToast.toast("Please provide the required details.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
        this.openStudentTurnoverReport(true);
        return;
      }
      if (
        this.myObj.format === "Class list" &&
        this.reportDomain.toLowerCase() === "myskooliuss"
      ) {
        this.openClassListIUSSReport(true);
        this.request = false;
        return;
      }
      if (
        this.myObj.format === "Average fees" &&
        this.isMyskoolIussDomain()
      ) {
        this.request = false;
        await this.exportFeeStatusIUSSExcel("average");
        return;
      }
      if (this.myObj.format == "Challan Statement") {
        this.request = true;
        this.loadStatement();
      } else if (
        this.myObj.format == "Left students" &&
        this.dueObj &&
        this.dueObj.valueBool
      ) {
        this.LoadDues("export");
      } else if (
        ["Staff Share", "Staff Share Summary"].includes(this.myObj.format)
      ) {
        this.syncShare(false, "export");
      } else if (
        ["New staff list", "New staff left list", "Increment list"].includes(
          this.myObj.format
        )
      ) {
        // Handle new staff reports with proper Excel export
        this.exportNewStaffReport();
      } else {
        // console.log("ClsID", this.classID);
        let clsName = "";
        let secName = "";
        const selectedClassIds = this.normalizeFilterIds(this.classID);
        const selectedSecIds = this.normalizeFilterIds(this.secID);

        if (this.hasSelectedFilterId(this.classID)) {
          if (this.isDistinct) {
            let ids = this.classes
              .filter((e) => selectedClassIds.includes(e.cls.id))
              .map((e) => e.cls.status)
              .join()
              .split(",");
            // console.log("cls",ids);
            this.myObj.classIDs = ids;
          } else this.myObj.classIDs = selectedClassIds;

          clsName = this.classesOptions
            .filter((e) => selectedClassIds.includes(e.id))
            .map((e) => e.name)
            .join();
        } else {
          this.myObj.classIDs = [];
        }

        if (this.hasSelectedFilterId(this.secID)) {
          //console.log(this.secID);
          if (this.isDistinct) {
            let ids = this.admittedSections
              .filter((e) => selectedSecIds.includes(e.id))
              .map((e) => e.metaVal)
              .join()
              .split(",");
            // console.log("sec",ids);
            this.myObj.secIDs = ids;
          } else this.myObj.secIDs = selectedSecIds;

          secName = this.admittedSections
            .filter((e) => selectedSecIds.includes(e.id))
            .map((e) => e.section)
            .join();
        } else {
          this.myObj.secIDs = [];
        }

        // console.log(this.myObj);
        this.CheckStatus();
        this.CheckFormat();
        this.CheckAccount();
        this.CheckDate();
        this.checkExam();
        this.checkSession();
        // this.checkMultiAccounts();
        this.CheckType();
        this.CheckSec();
        this.CheckClass();
        this.checkSingleMonth();
        this.checkSingleYear();
        this.checkTurnoverMonths();
        this.CheckDepartment();
        this.checkBalance();
        this.checkPerc();
        this.checkStaffDep();
        this.CheckIncrementYear();
        this.CheckSlipFrom();
        this.CheckSlipTo();
        if (
          this.CheckType() == false ||
          this.CheckSec() == false ||
          this.CheckClass() == false ||
          this.CheckFormat() == false ||
          this.CheckAccount() == false ||
          this.CheckDate() == false ||
          this.CheckSingleDate() == false ||
          this.checkExam() == false ||
          this.checkSession() == false ||
          this.CheckStatus() == false ||
          // this.checkMultiAccounts() == false ||
          this.checkYear() == false ||
          this.checkSingleMonth() == false ||
          this.checkSingleYear() == false ||
          this.checkTurnoverMonths() == false ||
          this.CheckDepartment() == false ||
          this.CheckFee() == false ||
          this.checkBalance() == false ||
          this.checkPerc() == false ||
          this.checkStaffDep() == false ||
          this.CheckIncrementYear() == false ||
          this.checkRangeMonth() == false ||
          this.CheckSlipFrom() == false ||
          this.CheckSlipTo() == false ||
          this.checkSlipRange() == false
        ) {
          return this.$bvToast.toast("Please provide the required details.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          this.request = true;
          if (this.myObj.format == "Fee Revenue") {
            await this.exportFeeRevenueExcel();
            this.request = false;
            return;
          }
          if (
            this.myObj.format === "Reconciliation fees" &&
            this.isMyskoolIussDomain()
          ) {
            await this.exportReconciliationFeesExcel();
            return;
          }
          if (this.myObj.type.value == "dcr") {
            if (this.myObj.format == "Fee Summary") {
              var url =
                `https://${this.reportDomain}.myskool.app/Fee/ShowExport?type=` +
                this.myObj.type.value +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&month=" +
                this.singleMonth +
                "&feeType=" +
                this.myObj.feesTypeIDs +
                "&format=" +
                this.myObj.format +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&accId=" +
                this.myObj.account +
                "&slipFrom=" +
                this.slipFrom +
                "&slipTo=" +
                this.slipTo +
                "&year=" +
                this.singleYear;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/Fee/ShowExport?type=` +
                this.myObj.type.value +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&month=" +
                this.myObj.months +
                "&feeType=" +
                this.myObj.feesTypeIDs +
                "&format=" +
                this.myObj.format +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&accId=" +
                this.myObj.account +
                "&slipFrom=" +
                this.slipFrom +
                "&slipTo=" +
                this.slipTo;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            }
          } else if (this.myObj.type.value == "Students") {
            if (this.myObj.format == "Event Calendar Report") {
              this.openEventCalendarReport();
              this.request = false;
              return;
            }

            // Handle Student Email List export redirect to same print page for now
            if (this.myObj.format == "Student Email List") {
              const routeData = this.$router.resolve({
                name: "student-email-report",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  cls: Array.isArray(this.myObj.classIDs)
                    ? this.myObj.classIDs.join(",")
                    : this.myObj.classIDs || "",
                  sec: Array.isArray(this.myObj.secIDs)
                    ? this.myObj.secIDs.join(",")
                    : this.myObj.secIDs || "",
                  status: this.myObj.status,
                },
              });
              window.open(routeData.href, "_blank");
              this.request = false;
              return;
            }

            if (this.myObj.format == "Date wise strength") {
              await this.exportDateWiseStrengthExcel();
              this.request = false;
              return;
            }

            if (
              this.myObj.format == "Driver wise students" &&
              this.isDriverReportDomain
            ) {
              await this.exportDriverWiseStudentsExcel();
              this.request = false;
              return;
            }

            if (
              this.myObj.format == "Campus Transfer" ||
              this.myObj.format == "Staff Campus Transfer"
            ) {
              await this.exportCampusTransferExcel();
              this.request = false;
              return;
            }

            if (this.myObj.format == "Custom Fee Report") {
              await this.exportCustomFeeExcel();
              this.request = false;
              return;
            }

            if (this.myObj.format == "Subject List") {
              if (this.usesSubjectListDomainReport) {
                await this.exportSubjectListDomainReport(clsName, secName);
                this.request = false;
                return;
              }
              await this.exportSubjectListExcel();
              this.request = false;
              return;
            }

            // Handle New admission (myskooliuss) export
            if (
              this.myObj.format == "New admission" &&
              this.isMyskoolIussDomain()
            ) {
              this.request = false;
              await this.exportNewAdmissionListExcel();
              return;
            }

            let ty = "list";
            if (this.myObj.format == "Strength report") ty = "strength";
            else if (this.myObj.format == "Student Details")
              ty = "student-details";
            else if (this.myObj.format == "Campus Strength")
              ty = "campus-strength";
            else if (this.myObj.format == "Fee status") ty = "feeStatus";
            else if (this.myObj.format == "Fee projection")
              ty = "feeProjection";
            else if (this.myObj.format == "Free ship") ty = "freeship";
            else if (this.myObj.format == "Discount Percentage")
              ty = "discount-perc";
            else if (this.myObj.format == "GR Registered") ty = "gr";
            else if (this.myObj.format == "New admission") ty = "admission";
            else if (this.myObj.format == "Registration List")
              ty = "registration";
            else if (this.myObj.format == "Admission List - Unpaid")
              ty = "admission-unpaid";
            else if (this.myObj.format == "Admission List - Paid")
              ty = "admission-paid";
            else if (this.myObj.format == "Left students") ty = "left";
            else if (this.myObj.format == "Left Category wise")
              ty = "leftcategory";
            else if (this.myObj.format == "Attendance list") ty = "attendance";
            else if (this.myObj.format == "Housewise List") ty = "house";
            else if (this.myObj.format == "Family List") ty = "family";
            else if (this.myObj.format == "Discount list") ty = "discount";
            else if (this.myObj.format == "Missing contacts")
              ty = "missingcontacts";
            else if (this.myObj.format == "Family wise fees status")
              ty = "familywisefee";
            else if (this.myObj.format == "Consents") ty = "consents";
            else if (this.myObj.format == "Transport List") ty = "transport";
            else if (this.myObj.format == "Subject List") ty = "subjects";
            else if (this.myObj.format == "Class list 2") ty = "list2";

            if (
              this.$store.state.currentBranch.organizationType == "coaching"
            ) {
              if (ty == "list" || ty == "student-details") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=" +
                  this.myObj.status +
                  "&session=" +
                  this.myObj.sessionID +
                  "&mob=false&dtFrom=" +
                  this.myObj.dtfrom +
                  "&dtTo=" +
                  this.myObj.dtto +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName +
                  "&gender=" +
                  this.selectedGender;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              } else if (ty == "attendance") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&session=" +
                  this.myObj.sessionID +
                  "&status=&mob=false" +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              } else if (
                ty == "list" ||
                ty == "admission" ||
                ty == "registration" ||
                ty == "admission-unpaid" ||
                ty == "admission-paid" ||
                ty == "left" ||
                ty == "house" ||
                ty == "family" ||
                ty == "transport"
              ) {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=" +
                  this.myObj.status +
                  "&mob=false&dtFrom=" +
                  this.myObj.dtfrom +
                  "&dtTo=" +
                  this.myObj.dtto +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName +
                  "&gender=" +
                  this.selectedGender;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              } else if (ty == "discount-perc") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=&mob=false&perc=" +
                  this.disPerc +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              } else if (ty == "consents") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&consent=" +
                  this.myObj.consent +
                  "&status=&mob=false" +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              } else if (ty == "leftcategory") {
                let catName =
                  this.myObj.leftCategory == "All"
                    ? ""
                    : this.myObj.leftCategory;
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&category=" +
                  catName +
                  "&status=&mob=false&dtFrom=" +
                  this.myObj.dtfrom +
                  "&dtTo=" +
                  this.myObj.dtto +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              } else if (ty == "subjects") {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=" +
                  this.myObj.status +
                  "&mob=false" +
                  "&session=" +
                  this.myObj.sessionID +
                  "&subID=" +
                  this.myObj.subjectID +
                  "&tID=" +
                  this.myObj.staffID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              } else {
                var url =
                  `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                  ty +
                  "&dbb=" +
                  this.myObj.db +
                  "&cID=" +
                  this.myObj.campusID +
                  "&cls=" +
                  this.myObj.classIDs +
                  "&sec=" +
                  this.myObj.secIDs +
                  "&status=&mob=false" +
                  "&session=" +
                  this.myObj.sessionID +
                  "&clsName=" +
                  clsName +
                  "&secName=" +
                  secName;

                axios
                  .get(url)
                  .then((response) => {
                    // console.log(response.data.data);
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    // Handle errors here
                    console.error("There was an error!", error);
                  });
              }
            } else if (
              ty == "list" ||
              ty == "student-details" ||
              ty == "admission" ||
              ty == "registration" ||
              ty == "admission-unpaid" ||
              ty == "admission-paid" ||
              ty == "left" ||
              ty == "house" ||
              ty == "family" ||
              ty == "list2" ||
              ty == "transport"
            ) {
              var url =
                `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=" +
                this.myObj.status +
                "&mob=false&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName +
                "&gender=" +
                this.selectedGender;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else if (ty == "discount-perc") {
              var url =
                `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=&mob=false&perc=" +
                this.disPerc +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else if (ty == "consents") {
              var url =
                `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&consent=" +
                this.myObj.consent +
                "&status=&mob=false" +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;
              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else if (ty == "leftcategory") {
              let catName =
                this.myObj.leftCategory == "All" ? "" : this.myObj.leftCategory;
              var url =
                `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&category=" +
                catName +
                "&status=&mob=false&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else if (ty == "subjects") {
              var url =
                `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=" +
                this.myObj.status +
                "&mob=false" +
                "&subID=" +
                this.myObj.subjectID +
                "&tID=" +
                this.myObj.staffID +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=&mob=false" +
                "&clsName=" +
                clsName +
                "&secName=" +
                secName +
                "&disRefID=" +
                (this.selectedDisRef || "");

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            }
          } else if (this.myObj.type.value == "Staff") {
            if (
              this.myObj.format == "Remaining Leaves" ||
              this.myObj.format == "Leave Encashment" ||
              this.myObj.format == "Advance & Loan"
            ) {
              // Handle remaining leaves, leave encashment, and advance & loan reports
              const routeData = this.$router.resolve({
                name: "remaining-leaves-print",
                query: {
                  db: this.myObj.db,
                  cID: this.myObj.campusID,
                  depID: Array.isArray(this.staffDepID)
                    ? this.staffDepID[0]
                    : this.staffDepID || 0,
                  title: this.myObj.format,
                },
              });
              window.open(routeData.href, "_blank");
            } else if (this.myObj.format == "Organization structure") {
              // Handle hierarchy report - open directly in new tab
              this.openHierarchyInNewTab();
            } else if (this.myObj.format == "Jubilee Insurance") {
              // Handle Jubilee Insurance report export for myskooliuss domain
              this.exportJubileeInsuranceReport();
            } else if (this.myObj.format == "Staff Allocation") {
              // Direct Excel export for the custom backend report
              this.exportStaffAllocationReport();
            } else if (
              [
                "Staff List Muster Roll",
                "Staff List With Salary",
                "New staff list",
                "New staff left list",
                "Increment list",
                "File cover",
              ].includes(this.myObj.format)
            ) {
              // Handle new staff report types with API call
              this.showNewStaffReport();
            } else {
              // Handle existing staff report formats
              let ty = "staff";
              if (this.myObj.format == "Deposit List") ty = "deposit";
              else if (this.myObj.format == "Staff List Date wise")
                ty = "staffdatewise";

              var url =
                `https://${this.reportDomain}.myskool.app/List/ShowExport?type=` +
                ty +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=" +
                this.myObj.staffStatus +
                "&mob=false&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&depID=" +
                this.staffDepID;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            }
          } else if (this.myObj.type.value == "Accounts") {
            if (this.accList[0] !== 0) {
              this.myObj.accIDs = this.accList;
            } else {
              this.myObj.accIDs = "";
            }

            let ty = "expense";
            if (this.myObj.format == "Income report") ty = "income";
            else if (this.myObj.format == "Closing report") ty = "closing";
            else if (this.myObj.format == "Cashbook") ty = "cashbookNew";
            else if (this.myObj.format == "Monthly Fee") ty = "Receivables";
            else if (this.myObj.format == "Estimation") ty = "estimation";

            if (
              this.myObj.format == "Closing report" ||
              this.myObj.format == "Cashbook"
            ) {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/ShowExport?type=` +
                ty +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&accID=0";

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else if (
              this.myObj.format == "Monthly Fee" ||
              this.myObj.format == "Estimation"
            ) {
              let m = 0;
              if (this.singleMonth < 10) m = `0${this.singleMonth}`;
              else m = this.singleMonth;
              let dt = `${this.singleYear}-${m}-01`;

              var url =
                `https://${this.reportDomain}.myskool.app/Account/ShowExport?type=` +
                ty +
                "&dtFrom=" +
                dt +
                "&dtTo=" +
                dt +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&accID=0";

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/ShowExport?type=` +
                ty +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&accID=" +
                this.coa;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            }
          } else if (this.myObj.type.value == "Advance Accounts") {
            // Balance Sheet - same as Show, route to print page
            if (this.myObj.format == "Balance Sheet") {
              if (!this.selectedFiscalYearID) {
                this.$bvToast.toast("Please select a fiscal year", {
                  title: "Validation",
                  variant: "warning",
                  solid: true,
                });
                return;
              }
              this.$router.push({
                path: "/balance-sheet-print",
                query: {
                  db: this.myObj.db || this.$store.state.userData.db,
                  campusID:
                    this.myObj.campusID || this.$store.state.userData.cId,
                  fiscalYearID: this.selectedFiscalYearID,
                },
              });
              return;
            }

            // Expense Report Excel Export
            if (this.myObj.format == "Expense Report") {
              this.stLoading = true;
              try {
                let baseUrl = this.$store.state.domain;
                if (!baseUrl.endsWith("/")) {
                  baseUrl += "/";
                }

                const isBeprince =
                  this.reportDomain === "myskoolbeprince" ||
                  String(this.reportDomain || "")
                    .replace(/_/g, "")
                    .toLowerCase() === "myskoolbeprince";

                if (isBeprince) {
                  const apiUrl = `${baseUrl}Expenses/GetExpenseReport?db=${
                    this.myObj.db
                  }&cID=${this.myObj.campusID}&dtFrom=${
                    this.myObj.dtfrom
                  }&dtTo=${this.myObj.dtto}&accountID=${this.coa || 0}`;

                  const response = await this.get({
                    url: apiUrl,
                    token: this.$store.state.userData.token,
                    returnData: true,
                  });

                  const reportData =
                    response && response.status === "success"
                      ? response.data
                      : response && response.data
                      ? response.data
                      : response;
                  const groups =
                    reportData && Array.isArray(reportData.groups)
                      ? reportData.groups
                      : [];

                  const exportData = [];
                  groups.forEach((master) => {
                    (master.accounts || []).forEach((account) => {
                      (account.entries || []).forEach((entry) => {
                        exportData.push({
                          "MASTER HEAD": master.masterHeadTitle || "",
                          ACCOUNT: account.accountTitle || "",
                          DATE: this.formatDate(entry.date),
                          "VOUCHER #":
                            entry.voucherNumStr ||
                            entry.voucherNum ||
                            entry.voucherID ||
                            entry.expenseID ||
                            "-",
                          DESCRIPTION: entry.description || "-",
                          AMOUNT: entry.amount || 0,
                        });
                      });
                      exportData.push({
                        "MASTER HEAD": master.masterHeadTitle || "",
                        ACCOUNT: account.accountTitle || "",
                        DATE: "",
                        "VOUCHER #": "",
                        DESCRIPTION: `TOTAL EXPENSES OF: ${
                          account.accountTitle || ""
                        }`,
                        AMOUNT: account.accountTotal || 0,
                      });
                    });
                    exportData.push({
                      "MASTER HEAD": master.masterHeadTitle || "",
                      ACCOUNT: "",
                      DATE: "",
                      "VOUCHER #": "",
                      DESCRIPTION: `TOTAL EXPENSES OF: ${
                        master.masterHeadTitle || ""
                      }`,
                      AMOUNT: master.masterTotal || 0,
                    });
                  });

                  if (exportData.length === 0) {
                    this.$bvToast.toast("No records found to export.", {
                      title: "No Data",
                      variant: "warning",
                    });
                    this.stLoading = false;
                    this.request = false;
                    return;
                  }

                  exportData.push({
                    "MASTER HEAD": "",
                    ACCOUNT: "",
                    DATE: "",
                    "VOUCHER #": "",
                    DESCRIPTION: "GRAND TOTAL",
                    AMOUNT: (reportData && reportData.grandTotal) || 0,
                  });

                  const XLSX = await import("xlsx");
                  const worksheet = XLSX.utils.json_to_sheet(exportData);
                  worksheet["!cols"] = [
                    { wch: 24 },
                    { wch: 24 },
                    { wch: 14 },
                    { wch: 12 },
                    { wch: 40 },
                    { wch: 14 },
                  ];
                  const workbook = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    "Expense Report"
                  );
                  XLSX.writeFile(
                    workbook,
                    `Expense_Report_${this.myObj.dtfrom}_to_${this.myObj.dtto}.xlsx`
                  );

                  this.$bvToast.toast("Exported successfully!", {
                    title: "Success",
                    variant: "success",
                  });
                  this.stLoading = false;
                  this.request = false;
                  return;
                }

                const apiUrl = `${baseUrl}JournalEntry/GetExpenseReport?db=${
                  this.myObj.db
                }&cID=${this.myObj.campusID}&dtFrom=${this.myObj.dtfrom}&dtTo=${
                  this.myObj.dtto
                }&accountID=${this.coa || 0}`;

                const response = await this.get({
                  url: apiUrl,
                  token: this.$store.state.userData.token,
                  returnData: true,
                });

                let items = [];
                let reportMeta = {
                  count: 0,
                  totalExpense: 0,
                };

                if (Array.isArray(response)) {
                  items = response;
                  reportMeta.count = response.length;
                  reportMeta.totalExpense = response.reduce(
                    (sum, item) => sum + (parseFloat(item.amount) || 0),
                    0
                  );
                } else if (response && Array.isArray(response.data)) {
                  items = response.data;
                  reportMeta = {
                    count: response.count || items.length,
                    totalExpense: response.totalExpense || 0,
                  };
                } else if (
                  response &&
                  response.data &&
                  Array.isArray(response.data.data)
                ) {
                  items = response.data.data;
                  reportMeta = {
                    count: response.data.count || items.length,
                    totalExpense: response.data.totalExpense || 0,
                  };
                }

                if (items.length === 0) {
                  this.$bvToast.toast("No records found to export.", {
                    title: "No Data",
                    variant: "warning",
                  });
                  this.stLoading = false;
                  this.request = false;
                  return;
                }

                const selectedAccount = this.filteredCoaTypes.find(
                  (acc) => acc.id === (this.coa || 0)
                );

                const exportData = [
                  {
                    "V.NO": "SUMMARY",
                    DATE: "",
                    TYPE: "",
                    ACCOUNT: selectedAccount?.title || "All Accounts",
                    DESCRIPTION: `Total Records: ${
                      reportMeta.count || items.length
                    }`,
                    "CHEQUE NO": "",
                    DEBIT: "",
                    CREDIT: "",
                    AMOUNT: reportMeta.totalExpense || 0,
                  },
                  ...items.map((item) => ({
                    "V.NO": item.voucherNum || "-",
                    DATE: this.formatDate(item.date),
                    TYPE: item.voucherType || "-",
                    ACCOUNT: item.accountTitle || "-",
                    DESCRIPTION:
                      item.description || item.detailDescription || "-",
                    "CHEQUE NO": item.chequeNo || "-",
                    DEBIT: item.debit || 0,
                    CREDIT: item.credit || 0,
                    AMOUNT: item.amount || 0,
                  })),
                ];

                const XLSX = await import("xlsx");
                const worksheet = XLSX.utils.json_to_sheet(exportData);

                worksheet["!cols"] = [
                  { wch: 10 },
                  { wch: 14 },
                  { wch: 10 },
                  { wch: 24 },
                  { wch: 40 },
                  { wch: 14 },
                  { wch: 14 },
                  { wch: 14 },
                  { wch: 14 },
                ];

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  workbook,
                  worksheet,
                  "Expense Report"
                );
                XLSX.writeFile(
                  workbook,
                  `Expense_Report_${this.myObj.dtfrom}_to_${this.myObj.dtto}.xlsx`
                );

                this.$bvToast.toast("Exported successfully!", {
                  title: "Success",
                  variant: "success",
                });
                this.stLoading = false;
                this.request = false;
              } catch (error) {
                console.error("Export error:", error);
                this.$bvToast.toast("Failed to export expense report.", {
                  title: "Error",
                  variant: "danger",
                });
                this.stLoading = false;
                this.request = false;
              }
              return;
            }

            // Cheque Summary Excel Export
            if (
              this.myObj.format == "Cheque Summary" &&
              this.newLedgerSetting
            ) {
              this.stLoading = true;
              try {
                let baseUrl = this.$store.state.domain;
                let apiUrl = "";
                if (baseUrl.endsWith("/api/")) {
                  apiUrl = `${baseUrl}JournalEntry/GetChequeSummaryReport`;
                } else {
                  if (!baseUrl.endsWith("/")) {
                    baseUrl += "/";
                  }
                  apiUrl = `${baseUrl}api/JournalEntry/GetChequeSummaryReport`;
                }

                apiUrl = `${apiUrl}?db=${this.myObj.db}&cID=${this.myObj.campusID}&dtFrom=${this.myObj.dtfrom}&dtTo=${this.myObj.dtto}`;

                const response = await this.get({
                  url: apiUrl,
                  token: this.$store.state.userData.token,
                });

                let rawData = [];
                if (Array.isArray(response)) {
                  rawData = response;
                } else if (response && Array.isArray(response.data)) {
                  rawData = response.data;
                } else if (
                  response &&
                  response.data &&
                  Array.isArray(response.data.data)
                ) {
                  rawData = response.data.data;
                }

                // Filter records with '-' cheque title
                const items = rawData.filter(
                  (item) =>
                    item.entry &&
                    item.entry.chequeTitle &&
                    item.entry.chequeTitle !== "-"
                );

                if (items.length === 0) {
                  this.$bvToast.toast("No records found to export.", {
                    title: "No Data",
                    variant: "warning",
                  });
                  this.stLoading = false;
                  this.request = false;
                  return;
                }

                const exportData = items.map((item, index) => ({
                  "S.NO": index + 1,
                  "V.NO": `${item.entry.voucherType}-${item.entry.voucherNum}`,
                  DATE: this.formatDate(item.entry.date),
                  "CHEQUE TITLE": item.entry.chequeTitle || "-",
                  DESCRIPTION: item.entry.description || "-",
                  PAYEE: item.entry.payee || "-",
                  AMOUNT: item.entry.amount || 0,
                }));

                const XLSX = await import("xlsx");
                const worksheet = XLSX.utils.json_to_sheet(exportData);

                // Styling column widths
                worksheet["!cols"] = [
                  { wch: 8 }, // S.No
                  { wch: 15 }, // Voucher No
                  { wch: 15 }, // Date
                  { wch: 20 }, // Cheque Title
                  { wch: 50 }, // Description
                  { wch: 25 }, // Payee
                  { wch: 15 }, // Amount
                ];

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  workbook,
                  worksheet,
                  "Cheque Summary"
                );
                XLSX.writeFile(
                  workbook,
                  `Cheque_Summary_${this.myObj.dtfrom}_to_${this.myObj.dtto}.xlsx`
                );

                this.$bvToast.toast("Exported successfully!", {
                  title: "Success",
                  variant: "success",
                });
                this.stLoading = false;
                this.request = false;
              } catch (error) {
                console.error("Export error:", error);
                this.$bvToast.toast("Failed to export report.", {
                  title: "Error",
                  variant: "danger",
                });
                this.stLoading = false;
                this.request = false;
              }
              return;
            }

            // Account Ledger Excel Export
            if (this.myObj.format == "Ledger" && this.newLedgerSetting) {
              this.stLoading = true;
              try {
                await this.syncLedgerIfNeeded(
                  this.myObj.dtfrom,
                  this.myObj.dtto
                );

                let baseUrl = this.$store.state.domain;
                if (!baseUrl.endsWith("/")) {
                  baseUrl += "/";
                }
                const apiUrl = `${baseUrl}Accounts/AdvanceAccountsLedger?db=${this.myObj.db}&cID=${this.myObj.campusID}&accountID=${this.coa}&dtFrom=${this.myObj.dtfrom}&dtTo=${this.myObj.dtto}`;

                const response = await this.get({
                  url: apiUrl,
                  token: this.$store.state.userData.token,
                  returnData: true,
                });

                const ledgerData = this.parseAdvanceLedgerResponse(response);
                const items = ledgerData.data || [];

                if (items.length === 0 && !ledgerData.openingBalance) {
                  this.$bvToast.toast("No records found to export.", {
                    title: "No Data",
                    variant: "warning",
                  });
                  this.stLoading = false;
                  this.request = false;
                  return;
                }

                const openingDate =
                  items.length > 0 && items[0].date
                    ? items[0].date
                    : this.myObj.dtfrom;

                const totalDebit = items.reduce(
                  (sum, item) => sum + (parseFloat(item.debit) || 0),
                  0
                );
                const totalCredit = items.reduce(
                  (sum, item) => sum + (parseFloat(item.credit) || 0),
                  0
                );

                const isAba =
                  String(this.reportDomain || "")
                    .replace(/_/g, "")
                    .toLowerCase() === "myskoolaba";

                const formatAbaBalance = (value, withTag = true) => {
                  const num = Number(value) || 0;
                  if (!isAba || !withTag) return num;
                  const abs = Math.abs(num);
                  if (num > 0) return `${abs} DR`;
                  if (num < 0) return `${abs} CR`;
                  return abs;
                };

                const exportData = [
                  {
                    "V.NO": "-",
                    DATE: this.formatLedgerExportDate(openingDate),
                    "CHEQUE TITLE": "-",
                    DESCRIPTION: "Opening Balance B/F",
                    DEBIT: "",
                    CREDIT: "",
                    BALANCE: formatAbaBalance(
                      ledgerData.openingBalance || 0,
                      false
                    ),
                  },
                  ...items.map((item) => {
                    const debit = parseFloat(item.debit) || 0;
                    const credit = parseFloat(item.credit) || 0;
                    return {
                      "V.NO": item.vNo || "-",
                      DATE: this.formatLedgerExportDate(item.date),
                      "CHEQUE TITLE": (item && item.chequeTitle) || "-",
                      DESCRIPTION: item.description || "-",
                      DEBIT: debit > 0 ? debit : "",
                      CREDIT: credit > 0 ? credit : "",
                      BALANCE: formatAbaBalance(
                        parseFloat(item.balance) || 0,
                        true
                      ),
                    };
                  }),
                  {
                    "V.NO": "",
                    DATE: "",
                    "CHEQUE TITLE": "",
                    DESCRIPTION: "TOTALS",
                    DEBIT: totalDebit,
                    CREDIT: totalCredit,
                    BALANCE: formatAbaBalance(
                      ledgerData.closingBalance || 0,
                      false
                    ),
                  },
                ];

                const XLSX = await import("xlsx");
                const worksheet = XLSX.utils.json_to_sheet(exportData);

                // Styling column widths
                worksheet["!cols"] = [
                  { wch: 12 }, // V.NO
                  { wch: 15 }, // DATE
                  { wch: 20 }, // CHEQUE TITLE
                  { wch: 50 }, // DESCRIPTION
                  { wch: 15 }, // DEBIT
                  { wch: 15 }, // CREDIT
                  { wch: 15 }, // BALANCE
                ];

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger");
                XLSX.writeFile(
                  workbook,
                  `Ledger_${ledgerData.accountTitle || "Report"}_${
                    this.myObj.dtfrom
                  }_to_${this.myObj.dtto}.xlsx`
                );

                this.$bvToast.toast("Exported successfully!", {
                  title: "Success",
                  variant: "success",
                });
                this.stLoading = false;
                this.request = false;
              } catch (error) {
                console.error("Export error:", error);
                this.$bvToast.toast("Failed to export ledger.", {
                  title: "Error",
                  variant: "danger",
                });
                this.stLoading = false;
                this.request = false;
              }
              return;
            }
            let ty = "journal";
            if (this.myObj.format == "Ledger") ty = "ledger";
            else if (this.myObj.format == "Trial Balance") ty = "trialBalance";
            else if (this.myObj.format == "Extended Trial Balance")
              ty = "extendedTrialBalance";
            else if (this.myObj.format == "Income Statement")
              ty = "incomeStatement";
            else if (this.myObj.format == "Cash Flow") ty = "cashFlow";
            else if (this.myObj.format == "Cheque Summary")
              ty = "chequeSummary";
            else if (this.myObj.format == "Daily Summary") ty = "dailySummary";
            else if (this.myObj.format == "Monthly Summary")
              ty = "monthlySummary";
            else if (this.myObj.format == "Party Ledger") ty = "partyLedger";
            else if (this.myObj.format == "SBU Ledger") ty = "sbuLedger";

            if (
              this.myObj.format == "Extended Trial Balance" &&
              this.newLedgerSetting
            ) {
              this.stLoading = true;
              try {
                await this.exportExtendedTrialBalanceExcel();
              } finally {
                this.stLoading = false;
                this.request = false;
              }
              return;
            }
            if (this.myObj.format == "Extended Trial Balance") {
              // Special handling for Extended Trial Balance with new API
              this.stLoading = true;

              let dtFrom = this.myObj.dtfrom;
              let dtTo = this.myObj.dtto;

              try {
                await this.prefetchExtendedTrialBalanceGenerateApi();

                // Step 2: Immediately open the export URL
                var url = `https://${this.reportDomain}.myskool.app/Account/ShowExport?type=extendedTrialBalance&dtFrom=${dtFrom}&dtTo=${dtTo}&dbb=${this.myObj.db}&cID=${this.myObj.campusID}&dptID=1&accID=${this.coa}`;
                // console.log("Opening export URL:", url);

                axios
                  .get(url)
                  .then((response) => {
                    window.open(response.data.data, "_blank");
                  })
                  .catch((error) => {
                    console.error("There was an error!", error);
                  });
              } catch (error) {
                console.error(
                  "Error generating Extended Trial Balance:",
                  error
                );
                this.$bvToast.toast(
                  "Failed to generate Extended Trial Balance report.",
                  {
                    title: this.$t("Error"),
                    variant: "danger",
                  }
                );
              } finally {
                this.stLoading = false;
              }
            } else if (
              ["Ledger", "Daily Summary", "Monthly Summary"].includes(
                this.myObj.format
              )
            ) {
              let dtFrom = this.myObj.dtfrom;
              let dtTo = this.myObj.dtto;
              if (this.myObj.format == "Daily Summary") {
                dtFrom = this.singleDate;
                dtTo = this.singleDate;
              }

              let linkedAcc = this.collectionLinks.find(
                (el) => el.id == this.coa
              );
              const toSync =
                (this.myObj.format == "Ledger" && linkedAcc) ||
                ["Daily Summary", "Monthly Summary"].includes(
                  this.myObj.format
                );

              if (toSync) {
                var status = await this.get({
                  url:
                    this.$store.state.domain +
                    "JournalEntry/SyncLedger?db=" +
                    this.$store.state.userData.db +
                    "&cID=" +
                    this.myObj.campusID +
                    "&dtFrom=" +
                    dtFrom +
                    "&dtTo=" +
                    dtTo,
                  context: this,
                  token: this.$store.state.userData.token,
                });
              }

              var url =
                `https://${this.reportDomain}.myskool.app/Account/ShowExport?type=` +
                ty +
                "&dtFrom=" +
                dtFrom +
                "&dtTo=" +
                dtTo +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&dptID=1&accID=" +
                this.coa;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/ShowExport?type=` +
                ty +
                "&dtFrom=" +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&dptID=1&accID=0";

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            }
          } else if (this.myObj.type.value == "Attendance") {
            if (this.myObj.format == "Student") {
              var url =
                `https://${this.reportDomain}.myskool.app/Attendance/ShowExport?type=student&dtFrom=` +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&status=";

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else {
              // var status = await this.get({
              //   url:
              //     this.$store.state.domain +
              //     "StaffAttendance/UpdateLateComing?db=" +
              //     this.$store.state.userData.db +
              //     "&cID=" +
              //     this.myObj.campusID +
              //     "&dtFrom=" +
              //     this.myObj.dtfrom +
              //     "&dtTo=" +
              //     this.myObj.dtto,
              //   context: this,
              //   token: this.$store.state.userData.token,
              // });

              var url =
                `https://${this.reportDomain}.myskool.app/Attendance/ShowStaffExport?dtFrom=` +
                this.myObj.dtfrom +
                "&dtTo=" +
                this.myObj.dtto +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&depID=0";

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            }
          } else if (this.myObj.type.value == "Certificates") {
            if (this.myObj.format == "Admit card") {
              //Admit card
              // console.log(this.eTypee);
              // const currentDate = new Date();
              // const day = ("0" + currentDate.getDate()).slice(-2);
              // const month = currentDate.toLocaleString("default", {
              //   month: "short",
              // });
              // const year = currentDate.getFullYear();
              // const formattedDate = `${day}-${month}-${year}`;

              var url =
                `https://${this.reportDomain}.myskool.app/Certificate/ShowExport?type=` +
                "admit-card" +
                "&dbb=" +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&exam=" +
                this.eTypee +
                "&session=" +
                this.myObj.sessionID +
                "&date=" +
                this.formattedDate;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else if (this.myObj.format == "ID card") {
              let sess = this.sessions.find(
                (el) => el.id == this.myObj.sessionID
              ).session;
              var url =
                `https://${this.reportDomain}.myskool.app/Certificate/ShowExport?type=id-card&dbb=` +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs +
                "&session=" +
                sess;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            } else {
              let ty = "transfer";
              if (this.myObj.format == "Character") ty = "character";
              else if (this.myObj.format == "Leaving") ty = "leaving";
              else if (this.myObj.format == "Provisional") ty = "provisional";
              else if (this.myObj.format == "Gate Pass") ty = "gatepass";
              else if (this.myObj.format == "Pickup card (Parent)")
                ty = "pcparent";
              else if (this.myObj.format == "Pickup card (Driver)")
                ty = "pcdriver";
              else if (this.myObj.format == "Fee Card") ty = "fee-card";
              else if (this.myObj.format == "Acknowledgement Form")
                ty = "acknowledgement-form";

              var url =
                `https://${this.reportDomain}.myskool.app/Certificate/ShowExport?type=${ty}&dbb=` +
                this.myObj.db +
                "&cID=" +
                this.myObj.campusID +
                "&sID=0&cls=" +
                this.myObj.classIDs +
                "&sec=" +
                this.myObj.secIDs;

              axios
                .get(url)
                .then((response) => {
                  // console.log(response.data.data);
                  window.open(response.data.data, "_blank");
                })
                .catch((error) => {
                  // Handle errors here
                  console.error("There was an error!", error);
                });
            }
          } else if (this.myObj.format == "Outstanding summary") {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/ShowExport?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              this.myObj.dtfrom +
              "&dtTo=" +
              this.myObj.dtto +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              this.singleMonth +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.singleYear +
              "&depID=" +
              this.selectedDep;

            axios
              .get(url)
              .then((response) => {
                // console.log(response.data.data);
                window.open(response.data.data, "_blank");
              })
              .catch((error) => {
                // Handle errors here
                console.error("There was an error!", error);
              });
          } else if (this.myObj.format == "Monthly summary") {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/ShowExport?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              this.myObj.dtfrom +
              "&dtTo=" +
              this.myObj.dtto +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              this.singleMonth +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.singleYear +
              "&depID=" +
              this.myObj.depID;

            axios
              .get(url)
              .then((response) => {
                // console.log(response.data.data);
                window.open(response.data.data, "_blank");
              })
              .catch((error) => {
                // Handle errors here
                console.error("There was an error!", error);
              });
          } else if (
            this.reportDomain == "myskoolstjacob" &&
            this.myObj.type.value == "defaulters" &&
            (this.myObj.format == "Class wise" ||
              this.myObj.format == "Family wise")
          ) {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/ShowExport?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              (this.jDate || "") +
              "&dtTo=" +
              (this.jDate || "") +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              // this.myObj.months +
              this.dateRange +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.myObj.year +
              "&status=" +
              this.myObj.status +
              "&balance=" +
              this.myObj.balance;

            axios
              .get(url)
              .then((response) => {
                // console.log(response.data.data);
                window.open(response.data.data, "_blank");
              })
              .catch((error) => {
                // Handle errors here
                console.error("There was an error!", error);
              });
          } else if (this.myObj.type.value == "challan-report") {
            let format = "challan-issued";
            if (this.myObj.format == "Monthly Issued")
              format = "monthly-issued";
            else if (this.myObj.format == "Annual Issued")
              format = "annual-issued";

            const monthVal = this.monthsSOptions
              .find((el) => el.id == this.singleMonth)
              .name.substring(0, 3);

            var url =
              `https://${this.reportDomain}.myskool.app/Fee/ShowExport?type=` +
              this.myObj.type.value +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              monthVal +
              "&format=" +
              format +
              "&year=" +
              this.singleYear;

            axios
              .get(url)
              .then((response) => {
                window.open(response.data.data, "_blank");
              })
              .catch((error) => {
                // Handle errors here
                console.error("There was an error!", error);
              });
          } else {
            var url =
              `https://${this.reportDomain}.myskool.app/Fee/ShowExport?type=` +
              this.myObj.type.value +
              "&dtFrom=" +
              this.myObj.dtfrom +
              "&dtTo=" +
              this.myObj.dtto +
              "&dbb=" +
              this.myObj.db +
              "&cID=" +
              this.myObj.campusID +
              "&month=" +
              // this.myObj.months +
              this.dateRange +
              "&feeType=" +
              this.myObj.feesTypeIDs +
              "&format=" +
              this.myObj.format +
              "&cls=" +
              this.myObj.classIDs +
              "&sec=" +
              this.myObj.secIDs +
              "&year=" +
              this.myObj.year +
              "&status=" +
              this.myObj.status +
              "&balance=" +
              this.myObj.balance;

            axios
              .get(url)
              .then((response) => {
                // console.log(response.data.data);
                window.open(response.data.data, "_blank");
              })
              .catch((error) => {
                // Handle errors here
                console.error("There was an error!", error);
              });
          }
          this.request = false;
        }
      }
    },

    async exportNewStaffReport() {
      try {
        this.request = true;

        // Get the data first
        let data = [];

        if (
          this.myObj.format === "New staff list" ||
          this.myObj.format === "New staff left list"
        ) {
          // Call the showNewStaffReport method to get data
          data = await this.getNewStaffData();
        } else if (this.myObj.format === "Increment list") {
          // Call the showNewStaffReport method to get increment data
          data = await this.getNewStaffData();
        }

        if (!data || data.length === 0) {
          this.$bvToast.toast("No data available for export.", {
            title: this.$t("Error"),
            variant: "danger",
          });
          return;
        }

        // Import XLSX library
        const XLSX = require("xlsx");

        // Prepare export data based on format
        let expData = [];

        if (this.myObj.format === "New staff list") {
          expData = data.map((item, index) => ({
            "S.NO": index + 1,
            "Staff Name": item.name || "",
            "Father Name": item.father_name || "",
            Department:
              item.department && item.department.name
                ? item.department.name
                : "",
            Designation: item.designation || "",
            "Date of Appointment": item.appointedOn
              ? new Date(item.appointedOn).toLocaleDateString("en-UK")
              : "",
            Salary: item.basicSalary || 0,
            "Current Deposit": 0,
            "Deposit Upto": 0,
            Status: item.status || "",
          }));
        } else if (this.myObj.format === "New staff left list") {
          expData = data.map((item, index) => ({
            "S.NO": index + 1,
            "Staff Name": item.name || "",
            "Father Name": item.father_name || "",
            Department:
              item.department && item.department.name
                ? item.department.name
                : "",
            Designation: item.designation || "",
            "Date of Appointment": item.appointedOn
              ? new Date(item.appointedOn).toLocaleDateString("en-UK")
              : "",
            "Left Date": item.leaving_date
              ? new Date(item.leaving_date).toLocaleDateString("en-UK")
              : "",
            Salary: item.basicSalary || 0,
            "Deposit Upto": 0,
            "Return Deposit": 0,
            Status: item.status || "",
          }));
        } else if (this.myObj.format === "Increment list") {
          const isAlhameedDomain = this.isAlhameedDomain;
          const isAllDepartments = this.staffDepID === 0;

          if (isAlhameedDomain) {
            // Al Hameed format with different columns
            expData = data.map((item, index) => {
              const previousSalary =
                item.basicSalary - (item.totalIncrementAmount || 0);
              const nextSalary = item.basicSalary;
              const totalIncrement = item.totalIncrementAmount || 0;
              const lastIncrementDate =
                item.incrementDetails && item.incrementDetails.length > 0
                  ? new Date(
                      item.incrementDetails[
                        item.incrementDetails.length - 1
                      ].incrementDate
                    ).toLocaleDateString("en-UK")
                  : "N/A";

              let row = {
                "S.NO": index + 1,
                "Staff Code": item.staffID || "N/A",
                "Staff Name": item.name || "",
                Designation: item.designation || "",
              };

              if (isAllDepartments) {
                row["Department"] =
                  item.department && item.department.name
                    ? item.department.name
                    : "N/A";
              }

              row["Previous Salary"] = previousSalary;
              row["Next Salary"] = nextSalary;
              row["Total Increment"] = totalIncrement;
              row["Last Increment Date"] = lastIncrementDate;

              return row;
            });
          } else {
            // Normal format (matching PDF view)
            expData = data.map((item, index) => {
              let row = {
                "S.NO": index + 1,
                "Staff Name": item.name || "",
                Designation: item.designation || "",
              };

              if (isAllDepartments) {
                row["Department"] =
                  item.department && item.department.name
                    ? item.department.name
                    : "N/A";
              }

              row["Year"] = item.year || this.incrementYear;
              row["Salary"] = item.basicSalary || 0;
              row["Total Increment"] = item.totalIncrementAmount || 0;
              row["Increment Count"] = item.incrementCount || 0;

              return row;
            });
          }
        }

        // Create workbook and worksheet
        const ws = XLSX.utils.json_to_sheet(expData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");

        // Generate filename
        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/:/g, "-");
        const filename = `${this.myObj.format}_${timestamp}.xlsx`;

        // Save file
        XLSX.writeFile(wb, filename);

        this.$bvToast.toast("Report exported successfully!", {
          title: this.$t("Success"),
          variant: "success",
        });
      } catch (error) {
        console.error("Export error:", error);
        this.$bvToast.toast("Error exporting report: " + error.message, {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.request = false;
      }
    },

    async getNewStaffData() {
      try {
        // Use the existing showNewStaffReport method to get data
        // We'll call the same API and data processing logic
        let data = [];

        if (
          this.myObj.format === "New staff list" ||
          this.myObj.format === "New staff left list"
        ) {
          // Use the correct API endpoint
          const status =
            this.myObj.format === "New staff left list" ? "left" : "present";
          const apiUrl = `https://apiv26.myskool.app/api/staff/LoadDataPagination?db=${encodeURIComponent(
            this.$store.state.userData.db
          )}&cId=${this.myObj.campusID}&dptID=${
            this.staffDepID
          }&status=${status}&depname=&page=1&pageSize=1000`;

          const response = await this.get({
            url: apiUrl,
            token: this.$store.state.userData.token,
          });

          if (Array.isArray(response)) {
            data = response;
          } else if (
            response &&
            response.data &&
            Array.isArray(response.data)
          ) {
            data = response.data;
          }

          // Process the data the same way as showNewStaffReport
          if (data && data.length > 0) {
            data = data.map((item, index) => ({
              sno: index + 1,
              rfID: item.rfID || "N/A",
              staffName: item.name || "N/A",
              fatherName: item.father_name || "N/A",
              designation: item.designation || "N/A",
              department: item.department || {
                name: item.departmentName || "N/A",
              },
              salary: item.totalSalary || item.basicSalary || 0,
              basicSalary: item.basicSalary || 0,
              appointedOn: item.appointedOn || "N/A",
              currentDeposit: item.currentDeposit || 0,
              depositUpto: item.depositUpto || 0,
              year: item.appointedOn
                ? new Date(item.appointedOn).getFullYear()
                : "N/A",
              leftDate: item.leaving_date || "N/A",
              returnDeposit: item.returnDeposit || 0,
              status: item.status || "N/A",
              name: item.name || "N/A",
              father_name: item.father_name || "N/A",
              leaving_date: item.leaving_date || "N/A",
            }));
          }
        } else if (this.myObj.format === "Increment list") {
          // Call the same API as showNewStaffReport for increment list
          let apiUrl;
          const depID = this.staffDepID || 0;

          if (this.isAlhameedDomain) {
            apiUrl = `https://apiv26.myskool.app/api/Staff/IncrementReport?db=${this.$store.state.userData.db}&cID=${this.myObj.campusID}&year=${this.incrementYear}&depID=${depID}`;
          } else {
            apiUrl = `https://apiv26.myskool.app/api/Staff/IncrementReport?db=${encodeURIComponent(
              this.$store.state.userData.db
            )}&cID=${
              this.myObj.campusID
            }&depID=${depID}&dtFrom=${encodeURIComponent(
              this.incrementFrom
            )}&dtTo=${encodeURIComponent(this.incrementTo)}`;
          }

          const response = await this.get({
            url: apiUrl,
            token: this.$store.state.userData.token,
          });

          if (Array.isArray(response)) {
            data = response;
          } else if (
            response &&
            response.data &&
            Array.isArray(response.data)
          ) {
            data = response.data;
          }

          // Process the data the same way as showNewStaffReport
          if (data && data.length > 0) {
            data = data.map((item, index) => {
              // For normal domains, calculate year-wise increment amounts
              let yearWiseIncrements = "";
              if (
                !this.isAlhameedDomain &&
                item.incrementDetails &&
                item.incrementDetails.length > 0
              ) {
                const yearGroups = {};
                item.incrementDetails.forEach((detail) => {
                  const year = new Date(detail.incrementDate).getFullYear();
                  if (!yearGroups[year]) yearGroups[year] = 0;
                  yearGroups[year] += detail.incrementAmount || 0;
                });

                // Format as "3000, 2000" for different years
                yearWiseIncrements = Object.keys(yearGroups)
                  .sort()
                  .map((year) => yearGroups[year])
                  .join(", ");
              }

              return {
                sno: index + 1,
                staffID: item.staffID || "N/A",
                rfID: item.rfID || "N/A",
                staffName: item.staffName || item.name || "N/A",
                fatherName: item.fatherName || "N/A",
                designation: item.designation || "N/A",
                department: item.department || {
                  name: item.departmentName || "N/A",
                },
                salary: item.totalSalary || item.basicSalary || 0,
                basicSalary: item.basicSalary || 0,
                appointedOn: "N/A",
                currentDeposit: 0,
                depositUpto: 0,
                year: this.isAlhameedDomain
                  ? this.incrementYear
                  : this.getYearRange(),
                leftDate: "N/A",
                returnDeposit: 0,
                totalIncrementAmount: this.isAlhameedDomain
                  ? item.totalIncrementAmount || 0
                  : yearWiseIncrements,
                incrementCount: item.incrementCount || 0,
                incrementDetails: item.incrementDetails || [],
                name: item.staffName || item.name || "N/A",
              };
            });
          }
        }

        return data;
      } catch (error) {
        console.error("Error fetching data for export:", error);
        return [];
      }
    },

    async showLeavesModal() {
      this.leavesDataLoading = true;
      this.leavesData = []; // Clear previous data
      this.modalTitle = this.myObj.format;

      try {
        const params = {
          db: this.myObj.db,
          cID: this.myObj.campusID,
        };

        // Add department ID if selected (single select for these options)
        if (
          ["Remaining Leaves", "Leave Encashment", "Advance & Loan"].includes(
            this.myObj.format
          )
        ) {
          // For single-select, staffDepID is a single value
          if (this.staffDepID && this.staffDepID !== 0) {
            params.depID = this.staffDepID;
          }
        } else {
          // For multi-select (existing behavior)
          if (
            this.staffDepID &&
            this.staffDepID.length > 0 &&
            this.staffDepID[0] !== 0
          ) {
            params.depID = this.staffDepID[0];
          }
        }

        // Determine API endpoint based on report type
        let apiEndpoint = "";
        if (this.myObj.format === "Advance & Loan") {
          apiEndpoint = "Staff/StaffLoansAndAdvanceReport";
          params.status = "present";
        } else {
          apiEndpoint = "Staff/StaffRemainingLeavesReport";
        }

        let apiUrl = `${this.$store.state.domain}${apiEndpoint}?`;
        const queryParams = new URLSearchParams(params);
        apiUrl += queryParams.toString();

        const response = await this.get({
          url: apiUrl,
          token: this.$store.state.userData.token, // Added authentication token
        });

        if (response && response.data) {
          this.leavesData = this.filterLeavesData(response.data);
        } else if (response) {
          // If response doesn't have .data property, use response directly
          this.leavesData = Array.isArray(response)
            ? this.filterLeavesData(response)
            : [];
        } else {
          this.leavesData = [];
        }

        this.$bvModal.show("staff-leaves-modal");
      } catch (error) {
        console.error("Error fetching staff data:", error);
        this.$bvToast.toast("Error fetching data. Please try again.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.leavesData = [];
      } finally {
        this.leavesDataLoading = false;
      }
    },

    // Jubilee Insurance Report for myskooliuss domain
    async showJubileeInsuranceReport() {
      this.stLoading = true;
      this.leavesDataLoading = true;
      this.leavesData = [];
      this.modalTitle = "Jubilee Insurance Report";

      try {
        // Use the same API as staffGrid.vue
        const apiUrl = `${this.$store.state.domain}staff/LoadDataPagination?db=${this.$store.state.userData.db}&cId=${this.$store.state.userData.cId}&dptID=0&status=present&page=1&appointedFrom=&appointedTo=&leavingFrom=&leavingTo=&designation=&sortBy=name&sortOrder=asc`;

        const response = await this.get({
          url: apiUrl,
          token: this.$store.state.userData.token,
        });

        let staffData = [];
        if (response && response.data && Array.isArray(response.data)) {
          staffData = response.data;
        } else if (Array.isArray(response)) {
          staffData = response;
        }

        // Filter for permanent staff only
        staffData = staffData.filter(
          (item) =>
            item.availibility && item.availibility.toLowerCase() === "permanent"
        );

        // Calculate age from date of birth
        const calculateAge = (dob) => {
          if (!dob) return "";
          const birthDate = new Date(dob);
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birthDate.getDate())
          ) {
            age--;
          }
          return age;
        };

        // Format date
        const formatDate = (dateStr) => {
          if (!dateStr) return "";
          const date = new Date(dateStr);
          return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        };

        // Map to required format for Jubilee Insurance
        this.leavesData = staffData.map((item, index) => ({
          sno: index + 1,
          insuredName: item.name || "",
          today: formatDate(new Date()),
          dateOfBirth: formatDate(item.date_of_birth),
          age: calculateAge(item.date_of_birth),
          cnicNo: item.cnic || "",
          designationRelation: item.designation || "",
          dateOfJoining: formatDate(item.appointedOn),
          maternity: item.gender === "Female" ? "Yes" : "No",
          campus: item.school?.branch || item.metaCampusName || "",
          status: item.status || "",
          // Keep original data for reference
          gender: item.gender || "",
          fatherName: item.father_name || "",
        }));

        this.$bvModal.show("staff-leaves-modal");
      } catch (error) {
        console.error("Error fetching Jubilee Insurance data:", error);
        this.$bvToast.toast("Error fetching data. Please try again.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.leavesData = [];
      } finally {
        this.stLoading = false;
        this.leavesDataLoading = false;
      }
    },

    async exportJubileeInsuranceReport() {
      this.request = true;
      this.stLoading = true;

      try {
        // Use Staff/Filter API to get all staff in single call (no pagination)
        const apiUrl = `${this.$store.state.domain}staff/filter?db=${this.$store.state.userData.db}&cId=${this.$store.state.userData.cId}&dptID=0&status=present`;

        const response = await this.get({
          url: apiUrl,
          token: this.$store.state.userData.token,
        });

        let allStaffData = [];
        if (response && response.data && Array.isArray(response.data)) {
          allStaffData = response.data;
        } else if (Array.isArray(response)) {
          allStaffData = response;
        }

        // Filter for permanent staff only (case-insensitive)
        let staffData = allStaffData.filter(
          (item) =>
            item.availibility && item.availibility.toLowerCase() === "permanent"
        );

        if (staffData.length === 0) {
          this.$bvToast.toast("No permanent staff found to export.", {
            title: "Info",
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
          return;
        }

        // Calculate age from date of birth
        const calculateAge = (dob) => {
          if (!dob) return "";
          const birthDate = new Date(dob);
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birthDate.getDate())
          ) {
            age--;
          }
          return age;
        };

        // Format date as DD/MM/YYYY for Today and Date of Birth
        const formatDateDMY = (dateStr) => {
          if (!dateStr) return "";
          const date = new Date(dateStr);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        };

        // Format date as DD-MMM-YY for Date of Joining
        const formatDateJoining = (dateStr) => {
          if (!dateStr) return "";
          const date = new Date(dateStr);
          const day = String(date.getDate()).padStart(2, "0");
          const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const month = months[date.getMonth()];
          const year = String(date.getFullYear()).slice(-2);
          return `${day}-${month}-${year}`;
        };

        // Get today's date
        const today = formatDateDMY(new Date());

        // Map to required format for Excel export
        const exportData = staffData.map((item, index) => ({
          "S. No": index + 1,
          "Insured's Name": item.name || "",
          Today: today,
          "Date Of Birth": formatDateDMY(item.date_of_birth),
          Age: calculateAge(item.date_of_birth),
          "CNIC No": item.cnic || "",
          "Designation/Relation": item.designation || "",
          "Date of Joining": formatDateJoining(item.appointedOn),
          Maternity: item.gender === "Female" ? "Yes" : "No",
          Campus: item.school?.branch || item.metaCampusName || "",
          Status: item.availibility || "",
        }));

        // Export to Excel
        const XLSX = await import("xlsx");
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Set column widths for better readability
        worksheet["!cols"] = [
          { wch: 8 }, // S. No
          { wch: 25 }, // Insured's Name
          { wch: 15 }, // Today
          { wch: 15 }, // Date Of Birth
          { wch: 6 }, // Age
          { wch: 18 }, // CNIC No
          { wch: 25 }, // Designation/Relation
          { wch: 15 }, // Date of Joining
          { wch: 10 }, // Maternity
          { wch: 20 }, // Campus
          { wch: 12 }, // Status
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Jubilee Insurance");
        XLSX.writeFile(workbook, "Jubilee_Insurance_Report.xlsx");

        this.$bvToast.toast(
          `Report exported successfully! (${staffData.length} records)`,
          {
            title: this.$t("Success"),
            variant: "success",
            toaster: "b-toaster-top-center",
          }
        );
      } catch (error) {
        console.error("Error exporting Jubilee Insurance report:", error);
        this.$bvToast.toast("Error exporting report. Please try again.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.request = false;
        this.stLoading = false;
      }
    },

    // Computed properties for modal statistics
    totalRemainingLeaves() {
      return this.leavesData.reduce(
        (total, staff) => total + (staff.remaining_leaves || 0),
        0
      );
    },

    totalSickLeaves() {
      return this.leavesData.reduce(
        (total, staff) => total + (staff.remaining_sickLeaves || 0),
        0
      );
    },

    totalEncashment() {
      return this.leavesData.reduce(
        (total, staff) => total + (staff.encashmentAmount || 0),
        0
      );
    },

    // New simplified table fields for remaining leaves
    remainingLeavesTableFields() {
      // Debug log

      // For Remaining Leaves, show S.NO, Employee Code, Staff Name, Father Name, Designation, and Casual Leave columns
      if (this.modalTitle === "Remaining Leaves") {
        const fields = [
          {
            key: "sno",
            label: "S.NO",
            sortable: false,
            class: "text-center",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "employeeCode",
            label: "Employee Code",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "staffName",
            label: "Staff Name",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "fatherName",
            label: "Father Name",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "designation",
            label: "Designation",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "clAllowed",
            label: "CL Allowed",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "cl",
            label: "CL",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "balanceCl",
            label: "Balance CL",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center",
          },
        ];
        return fields;
      }

      // For other reports, use the full structure
      const baseFields = [
        { key: "sno", label: "S.No", sortable: false, class: "text-center" },
        { key: "staffInfo", label: "Staff Information", sortable: true },
        { key: "department", label: "Department", sortable: true },
      ];

      // Add specific columns based on report type
      if (this.modalTitle === "Leave Encashment") {
        baseFields.push(
          {
            key: "remaining_leaves",
            label: "Remaining Leaves",
            sortable: true,
            class: "text-center",
          },
          {
            key: "remaining_sickLeaves",
            label: "Sick Leaves",
            sortable: true,
            class: "text-center",
          },
          {
            key: "encashmentAmount",
            label: "Encashment Amount",
            sortable: true,
            class: "text-right",
          }
        );
      } else if (this.modalTitle === "Advance & Loan") {
        baseFields.push(
          {
            key: "advanceAmount",
            label: "Advance Amount",
            sortable: true,
            class: "text-right",
          },
          {
            key: "loanAmount",
            label: "Loan Amount",
            sortable: true,
            class: "text-right",
          }
        );
      }

      return baseFields;
    },

    // Filter data based on report type
    filterLeavesData(data) {
      if (
        this.modalTitle === "Remaining Leaves" ||
        this.modalTitle === "Leave Encashment"
      ) {
        // For remaining leaves and leave encashment, return all required data
        return data.map((item) => {
          const clAllowed = item.totalLeaves || 0;
          const usedCL = item.utilized_leaves || 0;
          const clBalance = item.remaining_leaves || 0;

          const slAllowed = item.sickLeaves || 0;
          const usedSL = item.utilized_sickLeaves || 0;
          const slBalance = item.remaining_sickLeaves || 0;

          return {
            sno: item.sno || data.indexOf(item) + 1,
            employeeCode:
              item.employeeCode || item.id || item.employee_id || "N/A",
            staffName: item.name,
            fatherName: item.fatherName || item.father_name || "N/A",
            designation: item.designation || "N/A",
            // CL fields
            clAllowed,
            totalLeaves: usedCL,
            clBalance,
            remaining_leaves: clBalance,
            // SL fields
            slAllowed,
            sickLeaves: usedSL,
            slBalance,
            remaining_sickLeaves: slBalance,
            encashmentAmount: item.encashmentAmount || 0,
          };
        });
      } else if (this.modalTitle === "Advance & Loan") {
        // For advance & loan, return all required data
        return data.map((item) => ({
          sno: item.sno || data.indexOf(item) + 1,
          employeeCode:
            item.employeeCode || item.id || item.employee_id || "N/A",
          staffName: item.name,
          fatherName: item.fatherName || item.father_name || "N/A",
          designation: item.designation || "N/A",
          totalAdvance: item.totalAdvance || item.advanceAmount || 0,
          advanceReturned: item.advanceReturned || 0,
          remainingAdvance: item.remainingAdvance || 0,
          totalLoan: item.totalLoan || item.loanAmount || 0,
          loanReturned: item.loanReturned || 0,
          remainingLoan: item.remainingLoan || 0,
        }));
      }
      return data;
    },

    // Methods for modal functionality
    formatCurrency(amount) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PKR",
        minimumFractionDigits: 2,
      })
        .format(amount || 0)
        .replace("PKR", "Rs. ");
    },

    formatDate(dateString) {
      if (!dateString || dateString === "N/A") {
        return "N/A";
      }

      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          return "N/A";
        }

        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      } catch (error) {
        console.error("Error formatting date:", error);
        return "N/A";
      }
    },

    formatLedgerExportDate(dateString) {
      if (!dateString) return "-";
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      } catch (error) {
        return dateString;
      }
    },

    parseAdvanceLedgerResponse(response) {
      const empty = {
        accountTitle: "",
        openingBalance: 0,
        closingBalance: 0,
        data: [],
      };

      if (!response) return empty;

      if (Array.isArray(response)) {
        return { ...empty, data: response };
      }

      if (Array.isArray(response.data)) {
        return {
          accountTitle: response.accountTitle || "",
          openingBalance: parseFloat(response.openingBalance) || 0,
          closingBalance: parseFloat(response.closingBalance) || 0,
          data: response.data,
        };
      }

      if (
        response.data &&
        typeof response.data === "object" &&
        Array.isArray(response.data.data)
      ) {
        return {
          accountTitle:
            response.data.accountTitle || response.accountTitle || "",
          openingBalance:
            parseFloat(
              response.data.openingBalance ?? response.openingBalance
            ) || 0,
          closingBalance:
            parseFloat(
              response.data.closingBalance ?? response.closingBalance
            ) || 0,
          data: response.data.data,
        };
      }

      return empty;
    },

    formatDateDDMMYYYY(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },

    async showAccountsSummary() {
      // Validate inputs
      if (!this.myObj.dtfrom || !this.myObj.dtto) {
        this.$bvToast.toast("Please select a date range.", {
          title: "Validation Error",
          variant: "warning",
        });
        return;
      }

      this.stLoading = true;

      try {
        // Get summary
        const initializeObj = {
          url:
            this.$store.state.domain +
            "Accounts/SummaryEverest?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dtFrom=" +
            this.myObj.dtfrom +
            "&dtTo=" +
            this.myObj.dtto,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(initializeObj);

        // console.log("API Response:", response);

        // Handle the API response
        let data = response;

        if (!data) {
          throw new Error("No data received");
        }

        // Generate HTML report
        const reportHTML = this.generateAccountsSummaryHTML(
          data,
          this.myObj.dtfrom,
          this.myObj.dtto
        );

        // Open in new tab
        try {
          const reportWindow = window.open("", "_blank");
          const reportTitle = "Accounts Summary";

          if (reportWindow) {
            reportWindow.document.open("text/html", "replace");
            reportWindow.document.write(reportHTML);
            reportWindow.document.close();
            reportWindow.document.title = reportTitle;
            setTimeout(() => {
              reportWindow.focus();
            }, 100);
          } else {
            this.$bvToast.toast(
              "Pop-up blocked! Please allow pop-ups for this site.",
              {
                title: this.$t("Error"),
                variant: "warning",
              }
            );
          }
        } catch (error) {
          console.error("Error opening report window:", error);
          this.$bvToast.toast(
            "Failed to open report window: " + error.message,
            {
              title: this.$t("Error"),
              variant: "danger",
            }
          );
        }
      } catch (error) {
        console.error("Error loading Accounts Summary:", error);
        this.$bvToast.toast("Failed to load Accounts Summary.", {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.stLoading = false;
      }
    },

    async showCashFlowReport() {
      // Validate inputs
      if (!this.myObj.dtfrom || !this.myObj.dtto) {
        this.$bvToast.toast("Please select a date range.", {
          title: "Validation Error",
          variant: "warning",
        });
        return;
      }

      this.stLoading = true;

      try {
        // Get summary
        const initializeObj = {
          url:
            this.$store.state.domain +
            "Accounts/SummaryCPLC?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dtFrom=" +
            this.myObj.dtfrom +
            "&dtTo=" +
            this.myObj.dtto,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(initializeObj);

        // console.log("API Response:", response);

        // Handle the API response
        let data = null;
        if (response && response.data) {
          data = response.data;
        } else {
          data = response;
        }

        if (!data) {
          throw new Error("No data received");
        }

        // Generate HTML report
        const reportHTML = this.generateCashFlowHTML(
          data,
          this.myObj.dtfrom,
          this.myObj.dtto
        );

        // Open in new tab
        try {
          const reportWindow = window.open("", "_blank");
          const reportTitle = "Cash Flow Statement";

          if (reportWindow) {
            reportWindow.document.open("text/html", "replace");
            reportWindow.document.write(reportHTML);
            reportWindow.document.close();
            reportWindow.document.title = reportTitle;
            setTimeout(() => {
              reportWindow.focus();
            }, 100);
          } else {
            this.$bvToast.toast(
              "Pop-up blocked! Please allow pop-ups for this site.",
              {
                title: this.$t("Error"),
                variant: "warning",
              }
            );
          }
        } catch (error) {
          console.error("Error opening report window:", error);
          this.$bvToast.toast(
            "Failed to open report window: " + error.message,
            {
              title: this.$t("Error"),
              variant: "danger",
            }
          );
        }
      } catch (error) {
        console.error("Error loading cashflow statement:", error);
        this.$bvToast.toast("Failed to load Cash Flow Statement.", {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.stLoading = false;
      }
    },

    async showCashFlowExpenses() {
      // Validate inputs
      if (!this.myObj.dtfrom || !this.myObj.dtto) {
        this.$bvToast.toast("Please select a date range.", {
          title: "Validation Error",
          variant: "warning",
        });
        return;
      }

      this.stLoading = true;

      try {
        // Get summary
        const initializeObj = {
          url:
            this.$store.state.domain +
            "Accounts/ExpenseDetailsCPLC?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dtFrom=" +
            this.myObj.dtfrom +
            "&dtTo=" +
            this.myObj.dtto,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(initializeObj);

        // console.log("API Response:", response);

        // Handle the API response
        let data = null;
        if (response && response.data) {
          data = response.data;
        } else {
          data = response;
        }

        if (!data) {
          throw new Error("No data received");
        }

        // Generate HTML report
        const reportHTML = this.generateCashFlowExpensesHTML(
          data,
          this.myObj.dtfrom,
          this.myObj.dtto
        );

        // Open in new tab
        try {
          const reportWindow = window.open("", "_blank");
          const reportTitle = "Cash Flow Statement";

          if (reportWindow) {
            reportWindow.document.open("text/html", "replace");
            reportWindow.document.write(reportHTML);
            reportWindow.document.close();
            reportWindow.document.title = reportTitle;
            setTimeout(() => {
              reportWindow.focus();
            }, 100);
          } else {
            this.$bvToast.toast(
              "Pop-up blocked! Please allow pop-ups for this site.",
              {
                title: this.$t("Error"),
                variant: "warning",
              }
            );
          }
        } catch (error) {
          console.error("Error opening report window:", error);
          this.$bvToast.toast(
            "Failed to open report window: " + error.message,
            {
              title: this.$t("Error"),
              variant: "danger",
            }
          );
        }
      } catch (error) {
        console.error("Error loading cashflow statement:", error);
        this.$bvToast.toast("Failed to load Cash Flow Statement.", {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.stLoading = false;
      }
    },

    /**
     * Legacy ledger / daily / monthly reports call JournalEntry/SyncLedger before Show.
     * Advance ledger print route runs SyncLedger in AdvanceLedgerPrint.vue after the first load.
     */
    async syncLedgerIfNeeded(dtFrom, dtTo) {
      const from = dtFrom || this.myObj?.dtfrom;
      const to = dtTo || this.myObj?.dtto;
      if (!from || !to) return;

      const linkedAcc = (this.collectionLinks || []).find(
        (el) => el.id == this.coa
      );
      const needsSync =
        (this.myObj?.format === "Ledger" &&
          (linkedAcc || this.newLedgerSetting)) ||
        ["Daily Summary", "Monthly Summary"].includes(this.myObj?.format);

      if (!needsSync) return;

      await this.get({
        url:
          this.$store.state.domain +
          "JournalEntry/SyncLedger?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.myObj.campusID +
          "&dtFrom=" +
          from +
          "&dtTo=" +
          to,
        token: this.$store.state.userData.token,
      }).catch((error) => {});
    },

    /**
     * Extended trial balance (legacy Show/ShowExport URL and new ledger print route):
     * backend expects TrialBalanceData/GenerateTrialBalance before the report runs.
     */
    isEtbMonthFilterActive() {
      return (
        this.usesEtbMonthWiseFilter &&
        this.myObj.format === "Extended Trial Balance" &&
        this.etbMonthFrom > 0 &&
        this.etbMonthTo > 0
      );
    },
    checkEtbMonthFilter() {
      const yearRef = this.$refs["etbYear"];
      const fromRef = this.$refs["etbMonthFrom"];
      const toRef = this.$refs["etbMonthTo"];
      if (yearRef) yearRef.state = !!this.etbYear;
      if (fromRef) fromRef.state = !!this.etbMonthFrom;
      if (toRef) toRef.state = !!this.etbMonthTo;
      if (!this.etbYear || !this.etbMonthFrom || !this.etbMonthTo) {
        return false;
      }
      if (this.etbMonthFrom > this.etbMonthTo) {
        if (fromRef) fromRef.state = false;
        if (toRef) toRef.state = false;
        return false;
      }
      return true;
    },
    async prefetchExtendedTrialBalanceGenerateApi() {
      if (this.isEtbMonthFilterActive()) {
        return;
      }
      const dtFrom = this.myObj.dtfrom;
      const dtTo = this.myObj.dtto;
      const apiUrl = `https://apiv26.myskool.app/api/TrialBalanceData/GenerateTrialBalance?_db=${this.$store.state.userData.db}&campusID=${this.myObj.campusID}&fromDate=${dtFrom}&toDate=${dtTo}`;
      await this.get({
        url: apiUrl,
        context: this,
        token: this.$store.state.userData.token,
      }).catch((error) => {});
    },

    normalizeEtbNature(nature) {
      let n = String(nature || "OTHER").toUpperCase();
      if (n === "EXPENSES") n = "EXPENSE";
      if (n === "REVENUES") n = "REVENUE";
      if (n === "EQUITIES") n = "EQUITY";
      return n;
    },

    getEtbCategoryQueryValue() {
      if (!this.usesEtbBankCashCategory || this.etbCategoryFilter === "all") {
        return "";
      }
      return this.etbCategoryFilter;
    },

    buildEtbRouteQuery() {
      if (this.isEtbMonthFilterActive()) {
        const monthQuery = {
          db: this.myObj.db,
          cID: this.myObj.campusID,
          monthFrom: this.etbMonthFrom,
          monthTo: this.etbMonthTo,
          year: this.etbYear || new Date().getFullYear(),
          monthWise: "1",
        };
        const monthCategory = this.getEtbCategoryQueryValue();
        if (monthCategory) monthQuery.cashFlowCategory = monthCategory;
        return monthQuery;
      }
      const query = {
        db: this.myObj.db,
        cID: this.myObj.campusID,
        dtFrom: this.myObj.dtfrom,
        dtTo: this.myObj.dtto,
      };
      const category = this.getEtbCategoryQueryValue();
      if (category) query.cashFlowCategory = category;
      return query;
    },

    buildExtendedTrialBalanceApiParams() {
      const params = {
        _db: this.myObj.db,
        campusID: this.myObj.campusID,
      };
      if (this.isEtbMonthFilterActive()) {
        params.monthFrom = this.etbMonthFrom;
        params.monthTo = this.etbMonthTo;
        params.year = this.etbYear || new Date().getFullYear();
      }
      const category = this.getEtbCategoryQueryValue();
      if (category) params.cashFlowCategory = category;
      return params;
    },

    etbMonthSheetName(month, year, index) {
      const names = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const m = Number(month);
      const label =
        m >= 1 && m <= 12 ? names[m - 1] : `M${month || index + 1}`;
      const raw = `${label}_${year || ""}`.replace(/[^\w-]+/g, "_");
      return raw.substring(0, 31);
    },
    filterEtbItemsByCategory(items) {
      const list = Array.isArray(items) ? items : [];
      const category = this.getEtbCategoryQueryValue();
      if (!category) return list;
      return list.filter((item) => {
        const raw = String(item?.cashFlowCategory ?? "")
          .trim()
          .toLowerCase();
        if (category === "bank_account") {
          return (
            raw === "1" ||
            raw === "bank" ||
            raw === "bank_account" ||
            raw === "bank account"
          );
        }
        if (category === "cash_account") {
          return (
            raw === "0" ||
            raw === "cash" ||
            raw === "cash_account" ||
            raw === "cash account"
          );
        }
        return true;
      });
    },
    parseExtendedTrialBalanceApiPayload(responseData) {
      const root = responseData || {};
      const payload =
        root.status === "success" && root.data != null ? root : root;
      const data = payload.data;
      const list = Array.isArray(data)
        ? data
        : Array.isArray(payload.items)
        ? payload.items
        : Array.isArray(payload)
        ? payload
        : null;
      const sample = list && list[0];
      // New FGS pivot: Op.Bal | months[net] | Cl.Bal
      const isPivot =
        sample &&
        sample.months &&
        typeof sample.months === "object" &&
        !Array.isArray(sample.months) &&
        sample.month == null;
      if (isPivot || (payload.monthWise && Array.isArray(payload.monthColumns))) {
        const rows = Array.isArray(list) ? list : [];
        return {
          monthWise: true,
          pivot: true,
          // FGS: keep API order (sno); already filtered for bank/cash
          items: rows,
          totals: payload.totals || root.totals || null,
          sections: payload.sections || root.sections || [],
          grandTotal: payload.grandTotal || root.grandTotal || null,
          imbalances: payload.imbalances || root.imbalances || [],
          isBalanced:
            payload.isBalanced != null
              ? payload.isBalanced
              : root.isBalanced != null
              ? root.isBalanced
              : payload.grandTotal && payload.grandTotal.isBalanced != null
              ? payload.grandTotal.isBalanced
              : null,
          monthKeys:
            payload.monthColumns ||
            root.monthColumns ||
            payload.monthKeys ||
            root.monthKeys ||
            null,
          blocks: [],
        };
      }
      const monthWise =
        payload.monthWise === true ||
        (Array.isArray(data) &&
          data.length > 0 &&
          data[0] &&
          data[0].month != null &&
          Array.isArray(data[0].data));
      if (monthWise && Array.isArray(data)) {
        return {
          monthWise: true,
          pivot: false,
          blocks: data.map((block) => ({
            month: block.month,
            year: block.year,
            fromDate: block.fromDate,
            toDate: block.toDate,
            items: this.filterEtbItemsByCategory(
              Array.isArray(block.data) ? block.data : []
            ),
          })),
        };
      }
      let items = [];
      if (Array.isArray(payload)) items = payload;
      else if (Array.isArray(payload.data)) items = payload.data;
      items = this.filterEtbItemsByCategory(items);
      return { monthWise: false, pivot: false, blocks: [{ items }] };
    },

    getEtbClosingSignedNet(item) {
      const debit = Number(item?.closingDebit);
      const credit = Number(item?.closingCredit);
      const debitVal = Number.isFinite(debit) ? debit : 0;
      const creditVal = Number.isFinite(credit) ? credit : 0;

      if (debitVal !== 0 || creditVal !== 0) {
        if (debitVal !== 0 && creditVal === 0) return debitVal;
        if (creditVal !== 0 && debitVal === 0) return -creditVal;
        return debitVal - creditVal;
      }

      if (
        item &&
        item.closingNet !== undefined &&
        item.closingNet !== null &&
        item.closingNet !== ""
      ) {
        return Number(item.closingNet) || 0;
      }

      return 0;
    },

    async exportExtendedTrialBalanceExcel() {
      try {
        await this.prefetchExtendedTrialBalanceGenerateApi();

        let baseUrl =
          this.$store.state.domain || "https://apiv26.myskool.app/api/";
        if (!baseUrl.endsWith("/")) baseUrl += "/";

        const apiUrl = `${baseUrl}TrialBalanceData/ExtendedTrialBalance`;
        const response = await axios.get(apiUrl, {
          params: this.buildExtendedTrialBalanceApiParams(),
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
            accept: "application/json",
          },
        });

        const parsed = this.parseExtendedTrialBalanceApiPayload(response.data);
        const isFgsPivot =
          parsed.pivot === true &&
          String(this.reportDomain || "")
            .replace(/_/g, "")
            .toLowerCase() === "myskoolfgs";

        const flatBlocks = (parsed.blocks || []).filter(
          (b) => b.items && b.items.length
        );
        if (!isFgsPivot && !flatBlocks.length) {
          this.$bvToast.toast("No records found to export.", {
            title: "No Data",
            variant: "warning",
            solid: true,
          });
          return;
        }
        if (isFgsPivot && !(parsed.items || []).length) {
          this.$bvToast.toast("No records found to export.", {
            title: "No Data",
            variant: "warning",
            solid: true,
          });
          return;
        }

        const isAba =
          String(this.reportDomain || "")
            .replace(/_/g, "")
            .toLowerCase() === "myskoolaba";

        const natureOrder = [
          "ASSET",
          "ASSETS",
          "EXPENSE",
          "LIABILITY",
          "LIABILITIES",
          "EQUITY",
          "REVENUE",
        ];

        const mapEtbExportRows = (items) => {
          const sorted = [...items].sort((a, b) => {
            const na = this.normalizeEtbNature(a.nature);
            const nb = this.normalizeEtbNature(b.nature);
            const ia = natureOrder.indexOf(na);
            const ib = natureOrder.indexOf(nb);
            if (ia !== ib) {
              return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
            }
            return String(a.accountCode || "").localeCompare(
              String(b.accountCode || ""),
              undefined,
              { numeric: true, sensitivity: "base" }
            );
          });
          if (isAba) {
            return sorted.map((item) => {
              const net = this.getEtbClosingSignedNet(item);
              return {
                Nature: this.normalizeEtbNature(item.nature),
                Code: item.accountCode || "",
                Account: item.accountTitle || "",
                DR: net > 0 ? net : "",
                CR: net < 0 ? Math.abs(net) : "",
              };
            });
          }
          return sorted.map((item) => ({
            Nature: this.normalizeEtbNature(item.nature),
            Code: item.accountCode || "",
            Account: item.accountTitle || "",
            "Opening DR": Number(item.openingDebit) || "",
            "Opening CR": Number(item.openingCredit) || "",
            "Activity DR": Number(item.activityDebit) || "",
            "Activity CR": Number(item.activityCredit) || "",
            "Closing DR": Number(item.closingDebit) || "",
            "Closing CR": Number(item.closingCredit) || "",
          }));
        };

        const mapFgsPivotExportRows = (
          items,
          monthKeys,
          sections,
          grandTotal,
          totals
        ) => {
          const keys =
            Array.isArray(monthKeys) && monthKeys.length
              ? monthKeys
              : items[0] && items[0].months
              ? Object.keys(items[0].months)
              : [];
          const toRow = (item, titleOverride) => {
            const row = {
              "Account title":
                titleOverride ||
                item.accountTitle ||
                item.title ||
                item.label ||
                "",
              "Account number":
                item.accountNumber || item.accountCode || "",
              "Op. Bal Dr.": Number(item.openingDebit) || 0,
              "Op. Bal Cr.": Number(item.openingCredit) || 0,
            };
            keys.forEach((k) => {
              const n = Number(item.months && item.months[k]);
              row[k] = Number.isFinite(n) ? n : 0;
            });
            row["Cl. Bal Dr."] = Number(item.closingDebit) || 0;
            row["Cl. Bal Cr."] = Number(item.closingCredit) || 0;
            return row;
          };
          // Keep API order (sno) — do not resort
          const rows = (items || []).map((item) => toRow(item));
          (sections || []).forEach((sec) => {
            rows.push(
              toRow(
                sec,
                sec.title ||
                  sec.label ||
                  sec.name ||
                  sec.section ||
                  "TOTAL"
              )
            );
          });
          const footer = grandTotal || totals;
          if (footer) {
            rows.push(
              toRow(footer, footer.label || footer.title || "GRAND TOTAL")
            );
          }
          return rows;
        };

        const workbook = XLSX.utils.book_new();
        let exportCount = 0;

        if (isFgsPivot) {
          const exportData = mapFgsPivotExportRows(
            parsed.items,
            parsed.monthKeys,
            parsed.sections,
            parsed.grandTotal,
            parsed.totals
          );
          exportCount = exportData.length;
          const sheet = XLSX.utils.json_to_sheet(exportData);
          XLSX.utils.book_append_sheet(workbook, sheet, "Trial Balance");
        } else {
          flatBlocks.forEach((block, idx) => {
            const exportData = mapEtbExportRows(block.items);
            exportCount += exportData.length;
            const sheetName = parsed.monthWise
              ? this.etbMonthSheetName(block.month, block.year, idx)
              : "Extended TB";
            const sheet = XLSX.utils.json_to_sheet(exportData);
            XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
          });
        }

        const stamp = new Date().toISOString().slice(0, 10);
        const fileSuffix = this.isEtbMonthFilterActive()
          ? `Y${this.etbYear}_M${this.etbMonthFrom}-${this.etbMonthTo}`
          : `${this.myObj.dtfrom || "from"}_to_${this.myObj.dtto || "to"}`;
        XLSX.writeFile(
          workbook,
          `Extended_Trial_Balance_${fileSuffix}_${stamp}.xlsx`
        );

        this.$bvToast.toast(`Exported ${exportCount} account row(s).`, {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Extended Trial Balance export error:", error);
        this.$bvToast.toast("Failed to export Extended Trial Balance.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    async showLedgerReconciled() {
      // Validate inputs
      if (!this.coa || this.coa === 0) {
        this.$bvToast.toast("Please select a chart of account.", {
          title: "Validation Error",
          variant: "warning",
        });
        return;
      }

      if (!this.myObj.dtfrom || !this.myObj.dtto) {
        this.$bvToast.toast("Please select a date range.", {
          title: "Validation Error",
          variant: "warning",
        });
        return;
      }

      this.stLoading = true;

      try {
        // Get account title
        const selectedAccount = this.coaTypes.find(
          (acc) => acc.id === this.coa
        );
        const accountTitle = selectedAccount ? selectedAccount.title : "";

        // Call BankReconciliation/Initialize API
        const initializeObj = {
          url:
            this.$store.state.domain +
            "BankReconciliation/Initialize?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&dateFrom=" +
            this.myObj.dtfrom +
            "&dateTo=" +
            this.myObj.dtto +
            "&accountID=" +
            this.coa,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(initializeObj);

        // Handle the API response
        let data = null;

        if (response && response.status === "success" && response.data) {
          data = response.data;
        } else if (response && response.closingBalance !== undefined) {
          data = response;
        } else if (
          response &&
          response.data &&
          response.data.closingBalance !== undefined
        ) {
          data = response.data;
        } else if (response && Array.isArray(response)) {
          // If response is directly an array, wrap it
          data = {
            closingBalance: 0,
            allDetails: response,
            details: response,
          };
        } else if (response) {
          // Try to use response directly
          data = response;
        }

        const closingBalance = data ? parseFloat(data.closingBalance) || 0 : 0;
        const detailsArray = data ? data.allDetails || data.details || [] : [];

        // Generate HTML report even if no data (to show structure)
        const reportHTML = this.generateLedgerReconciledHTML(
          accountTitle,
          this.myObj.dtfrom,
          this.myObj.dtto,
          closingBalance,
          detailsArray
        );

        // Open in new tab
        try {
          const reportWindow = window.open("", "_blank");
          const reportTitle = `Ledger Report - ${accountTitle || "Account"}`;

          if (reportWindow) {
            // Clear any existing content
            reportWindow.document.open("text/html", "replace");
            reportWindow.document.write(reportHTML);
            reportWindow.document.close();
            reportWindow.document.title = reportTitle;
            // Focus the new window
            setTimeout(() => {
              reportWindow.focus();
            }, 100);
          } else {
            this.$bvToast.toast(
              "Pop-up blocked! Please allow pop-ups for this site.",
              {
                title: this.$t("Error"),
                variant: "warning",
              }
            );
          }
        } catch (error) {
          console.error("Error opening report window:", error);
          this.$bvToast.toast(
            "Failed to open report window: " + error.message,
            {
              title: this.$t("Error"),
              variant: "danger",
            }
          );
        }

        if (detailsArray.length === 0) {
          this.$bvToast.toast(
            "No transactions found for the selected criteria.",
            {
              title: "Info",
              variant: "info",
            }
          );
        }
      } catch (error) {
        console.error("Error loading ledger reconciled:", error);
        this.$bvToast.toast("Failed to load ledger reconciled data.", {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.stLoading = false;
      }
    },

    generateLedgerReconciledHTML(
      accountTitle,
      dateFrom,
      dateTo,
      closingBalance,
      detailsArray
    ) {
      // Get campus name
      const campusName =
        this.$store.state.currentBranch?.branch ||
        this.$store.state.currentBranch?.name ||
        "";
      const formattedDateFrom = dateFrom
        ? new Date(dateFrom).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })
        : "";

      const formattedDateTo = dateTo
        ? new Date(dateTo).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })
        : "";

      // Process transactions in Journal Report format
      // Group by voucher if available, otherwise show individual entries
      const transactions = [];
      let lastVNo = "";
      let lastDate = "";

      if (!detailsArray || detailsArray.length === 0) {
      }

      detailsArray.forEach((item, index) => {
        // Try multiple field names for amounts
        const amountAdd =
          parseFloat(
            item.amountAdd || item.AmountAdd || item.debit || item.Debit || 0
          ) || 0;
        const amountSubtract =
          parseFloat(
            item.amountSubtract ||
              item.AmountSubtract ||
              item.credit ||
              item.Credit ||
              0
          ) || 0;

        // Skip if both amounts are 0
        if (amountAdd === 0 && amountSubtract === 0) {
          return;
        }

        // Get voucher info if available - try multiple field names
        const voucherNo =
          item.voucherNum ||
          item.voucherNumber ||
          item.meta_voucherNum ||
          item.journalEntryVoucherNum ||
          item.VoucherNum ||
          item.VoucherNumber ||
          item.voucherNo ||
          "";
        const voucherType =
          item.voucherType ||
          item.meta_voucherType ||
          item.journalEntryVoucherType ||
          item.VoucherType ||
          item.vType ||
          "";
        const vNo =
          voucherNo && voucherType
            ? `${voucherType}-${voucherNo}`
            : voucherNo || voucherType || "";

        // Get date - try multiple field names
        const entryDate =
          item.date ||
          item.entryDate ||
          item.meta_date ||
          item.journalEntryDate ||
          item.Date ||
          item.EntryDate ||
          item.transactionDate ||
          dateFrom;
        const formattedDate = entryDate
          ? new Date(entryDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })
          : "";

        // Get account name - try multiple field names
        const accountName =
          item.meta_accountTitle ||
          item.title ||
          item.accountTitle ||
          item.Title ||
          item.AccountTitle ||
          item.accountName ||
          item.account ||
          "-";

        // Get description - try multiple field names
        const description =
          item.description ||
          item.meta_description ||
          item.Description ||
          item.narration ||
          item.note ||
          "";

        // Check if this is a new voucher group
        const isNewVoucher = vNo && vNo !== lastVNo;
        const isNewDate = formattedDate && formattedDate !== lastDate;

        // Track if we've added the first row for this voucher
        let isFirstRowForVoucher = false;

        // Add debit entry if amountAdd > 0
        if (amountAdd > 0) {
          isFirstRowForVoucher = isNewVoucher;
          transactions.push({
            vNo: isFirstRowForVoucher ? vNo : "",
            date: isFirstRowForVoucher || isNewDate ? formattedDate : "",
            account: accountName,
            debit: amountAdd,
            credit: 0,
            description: description,
            isPresented: item.isPresented || false,
          });
          if (isNewVoucher) {
            lastVNo = vNo;
            lastDate = formattedDate;
          }
        }

        // Add credit entry if amountSubtract > 0
        if (amountSubtract > 0) {
          // If we already added a debit row, this is the second row (don't show vNo/date again)
          // If no debit row was added, this is the first row (show vNo/date)
          const showVNoDate = amountAdd === 0 && isNewVoucher;
          transactions.push({
            vNo: showVNoDate ? vNo : "",
            date:
              showVNoDate || (amountAdd === 0 && isNewDate)
                ? formattedDate
                : "",
            account: accountName,
            debit: 0,
            credit: amountSubtract,
            description: description,
            isPresented: item.isPresented || false,
          });
          if (amountAdd === 0 && isNewVoucher) {
            lastVNo = vNo;
            lastDate = formattedDate;
          }
        }
      });

      const totalDebit = transactions.reduce(
        (sum, t) => sum + (t.debit || 0),
        0
      );
      const totalCredit = transactions.reduce(
        (sum, t) => sum + (t.credit || 0),
        0
      );
      const closingBal = (closingBalance || 0) + totalDebit - totalCredit;
      const reportTitle = `Ledger Report - ${accountTitle || "Account"}`;

      return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${reportTitle}</title>
<link rel="icon" href="data:,">
<style>
*{margin:0;padding:0;box-sizing:border-box}
html,body{font-family:Arial,sans-serif;font-size:13px;color:#000;background:#fff;margin:0;padding:0;min-height:100vh;visibility:visible}
body{padding:10px 12px;line-height:1.4;display:block}
.header{text-align:left;margin-bottom:8px;padding-bottom:5px;border-bottom:1px solid #000}
.header h1{font-size:20px;font-weight:700;margin:0 0 3px 0}
.header .campus{font-size:13px;margin:2px 0}
.header .account{font-size:13px;margin:2px 0;font-weight:600}
.header .date{font-size:12px;margin:2px 0}
.opening-balance{display:flex;justify-content:space-between;padding:6px 10px;margin-bottom:6px;border:1px solid #000;font-weight:700;font-size:13px}
.table-wrapper{width:100%;overflow:visible}
table{width:100%;border-collapse:collapse;font-size:12px}
th{background:#e5e7eb;border:1px solid #000;padding:8px 10px;text-align:left;font-weight:700;font-size:12px}
th:nth-child(4),th:nth-child(5){text-align:right}
td{border:1px solid #ccc;padding:6px 10px;font-size:12px;word-wrap:break-word}
td:nth-child(4),td:nth-child(5){text-align:right}
.total-row{font-weight:700;background:#e5e7eb}
.closing-balance{display:flex;justify-content:space-between;padding:6px 10px;margin-top:6px;border:1px solid #000;font-weight:700;font-size:13px}
@media print{
@page{margin:5mm;size:A4 portrait;marks:none}
html,body{margin:0;padding:0}
body{padding:8px 10px;font-size:12px;line-height:1.4}
.header{margin:0 0 6px 0;padding:0 0 4px 0;page-break-after:avoid}
.header h1{font-size:18px;margin:0 0 3px 0}
.header .campus{font-size:12px;margin:2px 0}
.header .account{font-size:12px;margin:2px 0}
.header .date{font-size:11px;margin:2px 0}
.opening-balance,.closing-balance{padding:5px 8px;margin:4px 0;font-size:12px}
th{background:#e5e7eb;border:1px solid #000;padding:7px 8px;font-size:12px;font-weight:700}
td{border:1px solid #ccc;padding:6px 8px;font-size:12px}
.print-btn{display:none}
table{page-break-inside:auto;margin:0;width:100%;border-collapse:collapse}
tr{page-break-inside:avoid;page-break-after:auto}
thead{display:table-header-group}
tfoot{display:table-footer-group}
body>*:first-child{margin-top:0}
body>*:last-child{margin-bottom:0}
}
.print-btn{position:fixed;top:10px;right:10px;background:#7c5dfa;color:#fff;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;font-size:12px;z-index:1000}
</style>
</head>
<body>
<button class="print-btn" onclick="window.print()">Print</button>
<div class="header">
<h1>Ledger Report</h1>
${campusName ? `<div class="campus">${campusName}</div>` : ""}
<div class="account">${accountTitle || "N/A"}</div>
<div class="date">${formattedDateFrom || ""} to ${formattedDateTo || ""}</div>
</div>
<div class="opening-balance">
<span>OPENING BALANCE:</span>
<span>${this.formatCurrency(closingBalance || 0)}</span>
</div>
<table>
<thead>
<tr>
<th>V. No.</th>
<th>Date</th>
<th>Account</th>
<th>Debit</th>
<th>Credit</th>
<th>Description</th>
</tr>
</thead>
<tbody>
${
  transactions.length > 0
    ? transactions
        .map(
          (row) => `
<tr>
<td>${row.vNo || ""}</td>
<td>${row.date || ""}</td>
<td>${row.account || "-"}</td>
<td>${row.debit > 0 ? this.formatCurrency(row.debit) : ""}</td>
<td>${row.credit > 0 ? this.formatCurrency(row.credit) : ""}</td>
<td>${row.description || ""}</td>
</tr>
`
        )
        .join("")
    : `
<tr>
<td colspan="6" style="text-align:center;padding:20px">No transactions found</td>
</tr>
`
}
${
  transactions.length > 0
    ? `
<tr class="total-row">
<td colspan="3" style="text-align:right">Total:</td>
<td>${this.formatCurrency(totalDebit)}</td>
<td>${this.formatCurrency(totalCredit)}</td>
<td></td>
</tr>
`
    : ""
}
</tbody>
</table>
<div class="closing-balance">
<span>CLOSING BALANCE:</span>
<span>${this.formatCurrency(closingBal)}</span>
</div>
</body>
</html>`;
    },

    generateCashFlowHTML(data, dateFrom, dateTo) {
      const campusName = this.$store.state.currentBranch?.name;

      const formatCurrency = (amount) =>
        new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(amount || 0);

      const startDate = new Date(dateFrom);
      const startMonth = startDate.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      const endDate = new Date(dateTo);
      const endMonth = endDate.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      // Calculations
      const openingBalance = data.openingBalance || 0;
      const zrcTotal = data.zrcTotal || 0;
      const collectionTotal = data.collectionTotal || 0;
      const incomeTotal = data.incomeTotal || 0;

      const bankDeposited = data.bankDeposited || 0;
      const disbursements = data.disbursements || 0;
      const expenseTotal = data.expenseTotal || 0;

      // Closing balance
      const closingBalance = data.closingBalance || 0;

      // Breakup
      const collectionBalance = data.collectionBalance || 0;
      const pettyCashBalance = data.pettyCashBalance || 0;

      // Canteen Row
      const canteenTotal = data.canteenTotal || 0;
      // Donations Row
      const donationTotal = data.donationTotal || 0;
      // Others
      const tcFeeTotal = data.tcFeeTotal || 0;
      const wasteMaterialTotal = data.wasteMaterialTotal || 0;

      // Collections rows
      const rows = data.collections || [];
      const collectionRows = rows
        .map((row) => {
          const dateObj = new Date(row.date);
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = dateObj.toLocaleDateString("en-US", { month: "short" });
          const year = dateObj.getFullYear();
          const formattedDate = `${day} ${month}, ${year}`;

          const receiptRange =
            row.minBillID && row.maxBillID
              ? `${row.minBillID} to ${row.maxBillID}`
              : row.minBillID || row.maxBillID || "";

          return `
            <tr>
              <td style="white-space: nowrap;">${formattedDate}</td>
              <td style="text-align: center;">${receiptRange}</td>
              <td style="text-align: right;">${
                row.amountRcvd ? formatCurrency(row.amountRcvd) : ""
              }</td>
              <td style="text-align: right;">${
                row.zrcRcvd ? formatCurrency(row.zrcRcvd) : ""
              }</td>
            </tr>
          `;
        })
        .join("");

      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Cash Flow Statement</title>
    <style>
        body { font-family: 'Times New Roman', serif; padding: 20px; max-width: 900px; margin: 0 auto; color: #000; font-size: 14px; }
        .header { text-align: center; margin-bottom: 25px; }
        .header h2 { margin: 0 0 5px 0; font-size: 18px; font-weight: bold; }
        .header h3 { margin: 0; font-size: 16px; font-weight: bold; text-decoration: underline; text-transform: uppercase; }
        
        .main-container { display: flex; flex-direction: column; gap: 20px; }
        
        .summary-grid { display: grid; grid-template-columns: 1.2fr 0.8fr; gap: 30px; }
        
        .section-title { font-weight: bold; text-decoration: underline; margin-bottom: 10px; font-size: 16px; }
        .section-title.large { font-size: 18px; margin-bottom: 15px; text-transform: uppercase; }
        
        .row { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 4px; font-size: 14px; }
        .row.bold { font-weight: bold; margin-bottom: 8px; }
        
        .label { flex: 1; }
        .amount-col { width: 100px; text-align: right; }
        
        .amount-box { border: 1px solid #000; padding: 2px 4px; display: inline-block; min-width: 80px; }
        .amount-underline { border-bottom: 1px solid #000; min-width: 80px; display: inline-block; text-align: right; }
        .amount-plain { min-width: 80px; display: inline-block; text-align: right; }
        
        .indent { padding-left: 30px; }
        
        .signatures { display: flex; flex-direction: column; gap: 40px; margin-top: 55px; }
        .sig-row { display: flex; align-items: flex-end;}
        .sig-label { font-size:16px; font-weight: bold; margin-right: 10px; white-space: nowrap; }
        .sig-line { border-bottom: 1px solid #000; flex: 1; min-width: 150px; }
        .sig-name { font-weight: bold; text-decoration: underline; }
        
        /* Table Styles */
        table { width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 5px; }
        th, td { border: 1px solid #000; padding: 3px 4px; }
        th { text-align: center; font-weight: bold; background-color: #f8f9fa; }
        
        .daily-receipts-container { display: flex; gap: 40px; margin-top: 10px; }
        .table-section { flex: 6; }
        .breakup-section { flex: 4; padding-top: 50px; }
        
        .breakup-box { }
        .breakup-row { display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 15px; }
        .breakup-line { border-bottom: 1px solid #000; flex: 1; margin: 0 10px; position: relative; top: -5px; }
        .breakup-amount { font-weight: bold; }
        
        .total-row { border-top: 1px solid #000; padding-top: 5px; font-weight: bold; margin-top: 10px; }
        
        @media print {
            @page { size: A4; margin: 10mm; }
            body { 
                padding: 0; 
                margin: 0; 
                width: 100%; 
                max-width: none;
                zoom: 1;
                font-size: 16px;
                -webkit-print-color-adjust: exact;
            }
            table { font-size: 14px; }
            .no-print { display: none; }
            .header { margin-top: 0; margin-bottom: 20px; }
            /* Ensure grid fits */
            .summary-grid { gap: 20px; }
            .daily-receipts-container { gap: 20px; }
        }
    </style>
</head>
<body>
    <div class="header">
        <h2>${campusName}</h2>
        <h2>CASH FLOW STATEMENT</h2>
    </div>

    <div class="summary-grid">
        <!-- Left Side: Summary -->
        <div class="summary-left">
            <div class="section-title large">SUMMARY:</div>
            
            <div class="row bold">
                <span class="label" style="font-size: 16px">CASH AVAILABLE AT ${startMonth} Rs.</span>
                <div class="amount-col">
                    <span class="amount-underline">${formatCurrency(
                      openingBalance
                    )}</span>
                </div>
            </div>
            
            <div style="margin-top: 15px;">
                <div class="row">
                    <span class="label">Add: Received from ZRC</span>
                    <div class="amount-col">
                        <span class="amount-box">${formatCurrency(
                          zrcTotal
                        )}</span>
                    </div>
                </div>
                <div class="row">
                    <span class="label indent">Collection Total Receipts</span>
                    <div class="amount-col">
                        <span class="amount-box">${formatCurrency(
                          collectionTotal
                        )}</span>
                    </div>
                </div>
            </div>

            <div style="margin-top: 10px;">
               <div class="row">
                    <span class="label">Available for Use</span>
                    <div class="amount-col">
                        <span class="amount-plain" style="border-top: 1px solid #000; padding-top: 2px;">${formatCurrency(
                          incomeTotal
                        )}</span>
                    </div>
                </div>
            </div>

            <div style="margin-top: 15px;">
                <div class="row">
                    <span class="label">Less: Deposited into: Bank</span>
                    <div class="amount-col">
                        <span class="amount-box">${formatCurrency(
                          bankDeposited
                        )}</span>
                    </div>
                </div>
                <div class="row">
                    <span class="label indent">Cash sent to ZRC</span>
                    <div class="amount-col">
                        <span class="amount-box">-</span>
                    </div>
                </div>
                <div class="row">
                    <span class="label indent">Disbursements</span>
                    <div class="amount-col">
                        <span class="amount-box">${formatCurrency(
                          disbursements
                        )}</span>
                    </div>
                </div>
                <div class="row">
                    <span class="label">Total Fund Outflow</span>
                    <div class="amount-col">
                        <span class="amount-plain" style="border-top: 1px solid #000; padding-top: 2px;">${formatCurrency(
                          expenseTotal
                        )}</span>
                    </div>
                </div>
            </div>

            <div style="margin-top: 20px;">
              <div class="row bold" style="margin-bottom: 4px;">
                  <span class="label">CASH AVAILABLE AT ${endMonth} Rs.</span>
                  <div class="amount-col">
                      <span class="amount-underline" style="border-bottom: 1px solid #000;">${formatCurrency(
                        closingBalance
                      )}</span>
                  </div>
              </div>
              <div class="row bold">
                  <span class="label"> </span>
                  <div class="amount-col">
                      <span class="amount-plain">${formatCurrency(
                        closingBalance
                      )}</span>
                  </div>
              </div>
            </div>
        </div>

        <!-- Right Side: Signatures -->
        <div class="summary-right">
            <div class="signatures">
                <div class="sig-row">
                    <span class="sig-label">Approved By:</span>
                    <span class="sig-line"></span>
                </div>
                <div class="sig-row">
                    <span class="sig-label">Checked By:</span>
                    <span class="sig-line"></span>
                </div>
                <div class="sig-row">
                    <span class="sig-label">Prepared By:</span>
                    <span class="sig-line"></span>
                </div>
            </div>
        </div>
    </div>

    <div class="daily-receipts-container">
        <!-- Table Section -->
        <div class="table-section">
            <div class="section-title">DAILY RECEIPTS:</div>
            <table>
                <thead>
                    <tr>
                        <th rowspan="2" style="width: 15%">Date</th>
                        <th rowspan="2" style="width: 35%">Receipts No.</th>
                        <th colspan="2">Amounts</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th style="width: 25%">ZRC</th>
                    </tr>
                </thead>
                <tbody>
                    ${collectionRows}
                    ${`
                    <tr>
                         <td style="text-align: center;">-</td>
                         <td style="text-align: center;">Canteen contribution</td>
                         <td style="text-align: right; font-weight: bold;">${formatCurrency(
                           canteenTotal
                         )}</td>
                         <td></td>
                    </tr>
                    <tr>
                         <td style="text-align: center;">-</td>
                         <td style="text-align: center;">Donations</td>
                         <td style="text-align: right; font-weight: bold;">${formatCurrency(
                           donationTotal
                         )}</td>
                         <td></td>
                    </tr>
                    <tr>
                         <td style="text-align: center;">-</td>
                         <td style="text-align: center;">TC Fee</td>
                         <td style="text-align: right; font-weight: bold;">${formatCurrency(
                           tcFeeTotal
                         )}</td>
                         <td></td>
                    </tr>
                    <tr>
                         <td style="text-align: center;">-</td>
                         <td style="text-align: center;">Waste Material</td>
                         <td style="text-align: right; font-weight: bold;">${formatCurrency(
                           wasteMaterialTotal
                         )}</td>
                         <td></td>
                    </tr>
                    `}
                    <tr style="font-weight: bold;">
                        <td colspan="2" style="text-align: center; border: 2px solid #000;">Total for the Month</td>
                        <td style="text-align: right; border: 2px solid #000;">${formatCurrency(
                          collectionTotal
                        )}</td>
                        <td style="text-align: right; border: 2px solid #000;">${formatCurrency(
                          zrcTotal
                        )}</td>
                     </tr>
                </tbody>
            </table>
        </div>

        <!-- Breakup Section -->
        <div class="breakup-section">
            <h3 style="margin: 0 0 20px 0; font-size: 24px; font-weight: bold;">Break Up:</h3>
            
            <div class="breakup-row" style="font-size: 18px;">
                <span style="font-weight: bold;">Collection:</span>
                <span style="flex: 1; margin: 0 15px;"></span>
                <span class="breakup-amount" style="border-bottom: 1px solid #000; min-width: 120px; text-align: right; display: inline-block;">${formatCurrency(
                  collectionBalance
                )}</span>
            </div>
            
            <div class="breakup-row" style="margin-top: 15px; font-size: 18px;">
                <span style="font-weight: bold;">Petty Cash:</span>
                <span style="flex: 1; margin: 0 15px;"></span>
                <span class="breakup-amount" style="border-bottom: 1px solid #000; min-width: 120px; text-align: right; display: inline-block;">${formatCurrency(
                  pettyCashBalance
                )}</span>
            </div>
            
            <div class="breakup-row" style="margin-top: 30px; font-size: 22px;">
                <span style="font-weight: bold;">Total</span>
                <span style="flex: 1; margin: 0 15px;"></span>
                <span class="breakup-amount" style="border-bottom: 1px solid #000; min-width: 120px; text-align: right; display: inline-block;">${formatCurrency(
                  closingBalance
                )}</span>
            </div>
        </div>
    </div>

    <button onclick="window.print()" class="no-print" style="position: fixed; top: 10px; right: 10px; padding: 10px 20px; background: #007bff; color: white; border: none; cursor: pointer;">Print Report</button>

</body>
</html>`;
    },

    generateCashFlowExpensesHTML(data, dateFrom, dateTo) {
      const campusName =
        this.$store.state.currentBranch?.name ||
        this.$store.state.currentBranch?.branch ||
        this.$store.state.userData?.campusName ||
        "";

      const getOrdinal = (n) => {
        const s = ["th", "st", "nd", "rd"];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
      };

      const formatDateWithOrdinal = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const dayOrdinal = getOrdinal(d.getDate());
        const month = d.toLocaleDateString("en-US", { month: "long" });
        const year = d.getFullYear();
        return `${dayOrdinal} ${month}, ${year}`;
      };

      const formattedDateFrom = formatDateWithOrdinal(dateFrom);
      const formattedDateTo = formatDateWithOrdinal(dateTo);
      const dateRangeStr =
        formattedDateFrom && formattedDateTo
          ? `From: ${formattedDateFrom} to ${formattedDateTo}`
          : formattedDateFrom || formattedDateTo || "";

      const formatAmount = (amount) => {
        if (amount == null || amount === "" || isNaN(amount)) return "0";
        const num = Number(amount);
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(num);
      };

      const formatRowAmount = (amount) => {
        if (amount == null || amount === "" || isNaN(amount)) return "";
        const num = Number(amount);
        if (num === 0) return "";
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(num);
      };

      const escapeHtml = (text) => {
        if (text == null) return "";
        return String(text)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      };

      const defaultHeads = [
        "Salary",
        "Conveyance",
        "Events",
        "Photocopy",
        "Cleaning Material",
        "Electric Bill",
        "Communication Expenses",
        "Equipment",
        "Rep & Maint",
        "Sundry",
      ];

      const headTotals = data?.totals?.headTotals || {};
      const headKeysFromTotals = Object.keys(headTotals);
      const headKeysFromRows = data?.rows?.[0]?.headAmounts
        ? Object.keys(data.rows[0].headAmounts)
        : [];

      const headColumns =
        headKeysFromTotals.length > 0
          ? headKeysFromTotals
          : headKeysFromRows.length > 0
          ? headKeysFromRows
          : defaultHeads;

      const rows = Array.isArray(data?.rows)
        ? data.rows
        : Array.isArray(data)
        ? data
        : [];

      const tableRows = rows
        .map((row, idx) => {
          const rowDate = row.dateFormatted || row.date || "";
          const voucherNo = row.index != null ? row.index : idx + 1;
          const particulars =
            row.particulars || row.accountTitle || row.description || "";
          const amountVal =
            row.amount != null && row.amount !== ""
              ? formatAmount(row.amount)
              : "";

          const headCells = headColumns
            .map((head) => {
              const val = row.headAmounts ? row.headAmounts[head] : null;
              return `<td style="text-align: right;">${formatRowAmount(
                val
              )}</td>`;
            })
            .join("");

          return `<tr>
            <td style="text-align: center; white-space: nowrap;">${escapeHtml(
              rowDate
            )}</td>
            <td style="text-align: center;">${escapeHtml(voucherNo)}</td>
            <td style="text-align: left;">${escapeHtml(particulars)}</td>
            <td style="text-align: right;">${amountVal}</td>
            ${headCells}
          </tr>`;
        })
        .join("");

      const totalAmount =
        data?.totals?.totalAmount != null
          ? data.totals.totalAmount
          : rows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);

      const totalHeadCells = headColumns
        .map((head) => {
          const headTotal =
            headTotals[head] != null
              ? headTotals[head]
              : rows.reduce(
                  (sum, r) => sum + (Number(r.headAmounts?.[head]) || 0),
                  0
                );
          return `<td style="text-align: right; font-weight: bold;">${formatAmount(
            headTotal
          )}</td>`;
        })
        .join("");

      const totalRow = `<tr style="font-weight: bold;">
        <td></td>
        <td></td>
        <td style="text-align: center;">Total</td>
        <td style="text-align: right;">${formatAmount(totalAmount)}</td>
        ${totalHeadCells}
      </tr>`;

      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Cash Flow Statement</title>
    <style>
        @page { size: A4 landscape; margin: 10mm; }
        body { 
            font-family: 'Times New Roman', Times, serif; 
            padding: 10px; 
            margin: 0 auto; 
            color: #000; 
            font-size: 12px; 
        }
        .header { text-align: center; margin-bottom: 20px; }
        .header h2 { margin: 0 0 4px 0; font-size: 20px; font-weight: bold; }
        .header h3 { margin: 0 0 4px 0; font-size: 18px; font-weight: bold; }
        .header p { margin: 0; font-size: 15px; font-weight: normal; }
        
        table { width: 100%; border-collapse: collapse; font-size: 11px; margin-top: 10px; }
        th, td { border: 1px solid #000; padding: 3px 4px; box-sizing: border-box; }
        th { text-align: center; font-weight: bold; background-color: #fff; vertical-align: middle; }
        th.head-col {
            height: 40px;
            max-width: 65px;
            min-width: 48px;
            white-space: normal;
            word-break: normal;
            overflow-wrap: break-word;
            line-height: 1.15;
            font-size: 10.5px;
            padding: 2px 2px;
            vertical-align: middle;
        }
        
        .signatures { 
            display: flex; 
            justify-content: space-around; 
            margin-top: 50px; 
            font-size: 14px; 
        }
        .sig-col { display: flex; align-items: flex-end; gap: 15px; }
        .sig-label { font-weight: bold; white-space: nowrap; }
        .sig-line { border-bottom: 1px solid #000; width: 200px; display: inline-block; height: 1px; }
        
        @media print {
            @page { size: A4 landscape; margin: 10mm; }
            body { 
                padding: 0; 
                margin: 0; 
                width: 100%; 
                font-size: 12px;
                -webkit-print-color-adjust: exact;
            }
            .no-print { display: none; }
            .header { margin-top: 0; margin-bottom: 15px; }
        }
    </style>
</head>
<body>
    <div class="header">
        <h2>${escapeHtml(campusName)}</h2>
        <h3>CASH FLOW STATEMENT</h3>
        <p>${escapeHtml(dateRangeStr)}</p>
    </div>

    <table>
        <thead>
            <tr>
                <th rowspan="2" style="width: 60px;">Date</th>
                <th rowspan="2" style="width: 50px;">Voucher<br>No.</th>
                <th rowspan="2" style="min-width: 150px;">PARTICULARS</th>
                <th rowspan="2" style="width: 75px;">AMOUNT</th>
                <th colspan="${headColumns.length}">HEAD OF ACCOUNTS</th>
            </tr>
            <tr>
                ${headColumns.map((head) => `<th class="head-col">${escapeHtml(head)}</th>`).join("")}
            </tr>
        </thead>
        <tbody>
            ${
              tableRows ||
              `<tr><td colspan="${
                headColumns.length + 4
              }" style="text-align: center;">No records found</td></tr>`
            }
            ${totalRow}
        </tbody>
    </table>

    <div class="signatures">
        <div class="sig-col">
            <span class="sig-label">Prepared by:</span>
            <span class="sig-line"></span>
        </div>
        <div class="sig-col">
            <span class="sig-label">Verified:</span>
            <span class="sig-line"></span>
        </div>
    </div>

    <button onclick="window.print()" class="no-print" style="position: fixed; top: 10px; right: 10px; padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px; font-family: sans-serif;">Print Report</button>
</body>
</html>`;
    },

    generateAccountsSummaryHTML(data, dateFrom, dateTo) {
      const formatCurrency = (amount) => {
        if (amount === null || amount === undefined || amount === "") return "";
        if (amount === "-") return "-";
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(amount);
      };

      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        const day = String(d.getDate()).padStart(2, "0");
        const month = d.toLocaleDateString("en-US", { month: "short" });
        const year = d.getFullYear();
        return `${day} ${month}, ${year}`;
      };

      const formatHeaderDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        const day = String(d.getDate()).padStart(2, "0");
        const month = d.toLocaleDateString("en-US", { month: "short" });
        const year = d.getFullYear();
        return `${day} ${month}, ${year}`;
      };
      let monthYear = `${formatHeaderDate(dateFrom)} to ${formatHeaderDate(
        dateTo
      )}`;

      const records = data && data.records ? data.records : [];

      const rowsHTML = records
        .map(
          (row, index) => `
        <tr>
          <td class="text-center">${index + 1}</td>
          <td class="text-center" style="white-space: nowrap;">${formatDate(
            row.date
          )}</td>
          <td>${formatCurrency(row.cashRcvd)}</td>
          <td>${formatCurrency(row.bankRcvd)}</td>
          <td></td>
          <td>${formatCurrency(row.expenses)}</td>
          <td>${formatCurrency(row.jjExpenses)}</td>
          <td>${formatCurrency(row.withdrawlExpenses)}</td>
          <td>${formatCurrency(row.cashInHand)}</td>
          <td>${formatCurrency(row.bankBalance)}</td>
          <td>${formatCurrency(row.totalBalance)}</td>
        </tr>
      `
        )
        .join("");

      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Income and Expenses Summary</title>
    <style>
        body { font-family: 'Arial', sans-serif; padding: 10px 20px; margin: 0; font-size: 13px; color: #000; }
        table { width: 100%; border-collapse: collapse; margin-top: 5px; }
        th, td { border: 1px solid #000; padding: 4px 6px; text-align: right; }
        th { font-weight: bold; text-align: center; background-color: #fff; }
        .text-center { text-align: center; }
        .font-bold { font-weight: bold; }
        .table-title-row td { border: none; font-weight: bold; text-align: center; font-size: 15px; padding: 2px; }
        .table-subtitle-row td { border: none; font-weight: bold; text-align: center; font-size: 14px; padding: 2px; }
        .table-date-row td { border: none; font-weight: bold; text-align: center; font-size: 14px; padding: 2px; border-bottom: 1px solid #000; }
        
        @media print {
            @page { size: A4 landscape; margin: 10mm; }
            body { padding: 0; margin: 0; zoom: 1; -webkit-print-color-adjust: exact; }
            .no-print { display: none; }
        }
    </style>
</head>
<body>
    <button onclick="window.print()" class="no-print" style="position: fixed; top: 10px; right: 10px; padding: 10px 20px; background: #007bff; color: white; border: none; cursor: pointer;">Print Report</button>
    
    <table>
        <thead>
            <tr class="table-title-row">
                <td colspan="11">INCOME AND EXPENSES</td>
            </tr>
            <tr class="table-subtitle-row">
                <td colspan="11">SUMMARY</td>
            </tr>
            <tr class="table-date-row">
                <td colspan="11">${monthYear}</td>
            </tr>
            <tr>
                <th style="width: 4%">S.NO</th>
                <th style="width: 8%">DATE</th>
                <th>REC</th>
                <th>Online</th>
                <th>Deposit</th>
                <th>EXP</th>
                <th>JJ</th>
                <th>W.DRAWL</th>
                <th>IN HAND</th>
                <th>BANK</th>
                <th>TOTAL</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="text-center"></td>
                <td class="text-center">B/F</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>${formatCurrency(data.openingJJExpense)}</td>
                <td></td>
                <td>${formatCurrency(data.openingCashBalance)}</td>
                <td>${formatCurrency(data.openingBankBalance)}</td>
                <td>${formatCurrency(data.openingTotalBalance)}</td>
            </tr>
            ${rowsHTML}
            <tr class="font-bold">
                <td colspan="2" class="text-center">Total</td>
                <td>${formatCurrency(data.totalCashRcvd)}</td>
                <td>${formatCurrency(data.totalBankRcvd)}</td>
                <td class="text-center">-</td>
                <td>${formatCurrency(data.totalExpenses)}</td>
                <td>${formatCurrency(data.totalJJExpenses)}</td>
                <td>${formatCurrency(data.totalWithdrawlExpenses)}</td>
                <td>${formatCurrency(data.closingCashBalance)}</td>
                <td>${formatCurrency(data.closingBankBalance)}</td>
                <td>${formatCurrency(data.closingTotalBalance)}</td>
            </tr>
            <tr class="font-bold">
                <td colspan="6" class="text-center" style="padding-top: 5px; padding-bottom: 5px; font-size: 16px;">Over All JJ Total</td>
                <td style="font-size: 16px; padding-top: 5px; padding-bottom: 5px">
                  ${formatCurrency(data.overallJJExpenses)}
                </td>
                <td colspan="4" style="border: none;"></td>
            </tr>
        </tbody>
    </table>
</body>
</html>`;
    },

    avatarText(name) {
      if (!name) return "NA";
      const names = name.split(" ");
      if (names.length >= 2) {
        return names[0].charAt(0) + names[1].charAt(0);
      }
      return names[0].charAt(0) + names[0].charAt(1);
    },

    printLeavesReport() {
      // Hide modal temporarily
      this.$bvModal.hide("staff-leaves-modal");

      // Determine which columns to show based on report type
      const showEncashment = this.modalTitle === "Leave Encashment";

      // Create print styles - more compact and professional
      const printStyles = `
        <style>
          @media print {
            * {
              box-sizing: border-box !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            @page {
              margin: 0.5in !important;
            }
            /* Force print styles to override browser defaults */
            * {
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            /* Additional border forcing */
            table, table *, .table, .table * {
              border-color: #000000 !important;
              border-style: solid !important;
            }
            body {
              font-family: 'Arial', sans-serif;
              font-size: 12px;
              line-height: 1.4;
              margin: 0;
              padding: 15px;
              color: #000;
              background: white;
            }
            .print-area {
              width: 100%;
              max-width: none;
            }
            .print-header {
              text-align: center;
              margin-bottom: 20px;
              padding: 15px;
              background: #7367f0;
              color: white;
              border-radius: 8px;
            }
            .print-header h1 {
              font-size: 20px;
              margin: 0 0 5px 0;
              font-weight: bold;
            }
            .print-header p {
              margin: 2px 0;
              font-size: 11px;
              opacity: 0.9;
            }
            table, .table {
              width: 100% !important;
              border-collapse: collapse !important;
              margin-top: 15px;
              font-size: 10px;
              border: 4px solid #000000 !important;
              border-spacing: 0 !important;
              border-style: solid !important;
            }
            table th, .table th {
              background-color: #f8f9fa !important;
              font-weight: bold !important;
              padding: 8px 6px !important;
              text-align: left !important;
              border: 2px solid #000000 !important;
              border-style: solid !important;
              font-size: 9px !important;
              text-transform: uppercase !important;
              letter-spacing: 0.5px !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            table td, .table td {
              padding: 6px !important;
              border: 2px solid #000000 !important;
              border-style: solid !important;
              vertical-align: top !important;
              font-size: 10px !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            /* Force all table elements to have black borders */
            table *, .table * {
              border-color: #000000 !important;
            }
            table thead tr:first-child th, .table thead tr:first-child th {
              border-top: 4px solid #000000 !important;
              border-style: solid !important;
            }
            table thead tr:last-child th, .table thead tr:last-child th {
              border-bottom: 4px solid #000000 !important;
              border-style: solid !important;
            }
            table tbody tr:last-child td, .table tbody tr:last-child td {
              border-bottom: 4px solid #000000 !important;
              border-style: solid !important;
            }
            table th:first-child, table td:first-child,
            .table th:first-child, .table td:first-child {
              border-left: 4px solid #000000 !important;
              border-style: solid !important;
            }
            table th:last-child, table td:last-child,
            .table th:last-child, .table td:last-child {
              border-right: 4px solid #000000 !important;
              border-style: solid !important;
            }
            table tbody tr td, .table tbody tr td {
              border-top: 2px solid #000000 !important;
              border-bottom: 2px solid #000000 !important;
              border-style: solid !important;
            }
            .table tbody tr:nth-child(even) {
              background-color: #f8f9fa;
            }
            table th.bg-primary, .table th.bg-primary {
              background-color: #007bff !important;
              color: white !important;
              border: 3px solid #000000 !important;
              border-style: solid !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            table th.bg-warning, .table th.bg-warning {
              background-color: #ffc107 !important;
              color: #000 !important;
              border: 3px solid #000000 !important;
              border-style: solid !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            table th.bg-success, .table th.bg-success {
              background-color: #28a745 !important;
              color: white !important;
              border: 3px solid #000000 !important;
              border-style: solid !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            .staff-name { font-weight: 600; font-size: 11px; }
            .staff-details { font-size: 9px; color: #6c757d; line-height: 1.2; }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .dept-badge {
              background: #e9ecef;
              padding: 2px 6px;
              border-radius: 3px;
              font-size: 9px;
              font-weight: 500;
            }
            .avatar {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              background: #7367f0;
              color: white;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 10px;
              margin-right: 8px;
              vertical-align: middle;
            }
            .col-sno { width: ${showEncashment ? "8%" : "10%"}; }
            .col-staff { width: ${showEncashment ? "27%" : "30%"}; }
            .col-dept { width: ${showEncashment ? "20%" : "25%"}; }
            .col-leaves { width: ${showEncashment ? "15%" : "17.5%"}; }
            .col-sick { width: ${showEncashment ? "15%" : "17.5%"}; }
            .col-amount { width: 15%; }
          }
        </style>
      `;

      // Create table headers based on report type
      const tableHeaders = `
        <tr>
          <th class="col-sno text-center">S.No</th>
          <th class="col-staff">Staff Information</th>
          <th class="col-dept">Department</th>
          <th class="col-leaves text-center">Remaining Leaves</th>
          <th class="col-sick text-center">Sick Leaves</th>
          ${
            showEncashment
              ? '<th class="col-amount text-right">Encashment Amount</th>'
              : ""
          }
        </tr>
      `;

      // Create table rows
      const tableRows = this.leavesData
        .map(
          (item, index) => `
        <tr>
          <td class="col-sno text-center">
            <strong>${index + 1}</strong>
          </td>
          <td class="col-staff">
            <div style="display: flex; align-items: center;">
              <span class="avatar">${this.avatarText(item.name)}</span>
              <div>
                <div class="staff-name">${item.name}</div>
                <div class="staff-details">${item.designation}</div>
              </div>
            </div>
          </td>
          <td class="col-dept">
            <span class="dept-badge">${item.department.name}</span>
          </td>
          <td class="col-leaves text-center">
            <strong>${item.remaining_leaves}</strong>
          </td>
          <td class="col-sick text-center">
            <strong>${item.remaining_sickLeaves}</strong>
          </td>
          ${
            showEncashment
              ? `<td class="col-amount text-right"><strong>${this.formatCurrency(
                  item.encashmentAmount
                )}</strong></td>`
              : ""
          }
        </tr>
      `
        )
        .join("");

      // Create printable content
      const printContent = `
        <div class="print-area">
          <div class="print-header">
            <h1>${this.modalTitle} Report</h1>
            <p>Generated on ${new Date().toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}</p>
            <p>Total Staff: ${this.leavesData.length}${
        showEncashment
          ? ` | Total Encashment: ${this.formatCurrency(this.totalEncashment)}`
          : ""
      }</p>
          </div>
          <table class="table" style="border: 4px solid #000000 !important; border-collapse: collapse !important; border-spacing: 0 !important;">
            <thead>
              ${tableHeaders}
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
          <div style="text-align: center; margin-top: 20px; font-size: 9px; color: #6c757d; border-top: 1px solid #dee2e6; padding-top: 10px;">
            <p>MySkool Management System - Staff Leaves Report</p>
          </div>
        </div>
      `;

      // Add styles to head
      const styleElement = document.createElement("style");
      styleElement.innerHTML = printStyles;
      document.head.appendChild(styleElement);

      // Add content to body
      const printDiv = document.createElement("div");
      printDiv.innerHTML = printContent;
      document.body.appendChild(printDiv);

      // Print
      window.print();

      // Clean up
      document.head.removeChild(styleElement);
      document.body.removeChild(printDiv);

      // Show modal again
      setTimeout(() => {
        this.$bvModal.show("staff-leaves-modal");
      }, 100);
    },
    viewStaffReport() {
      if (
        this.myObj.format === "Advance & Loan" &&
        this.reportDomain === "myskoolaba"
      ) {
        const depID = Array.isArray(this.staffDepID)
          ? this.staffDepID[0]
          : this.staffDepID || 0;
        const depName =
          depID === 0
            ? "All Departments"
            : this.staffDeparts.find((d) => d.id === depID || d.id == depID)
                ?.name || `Department #${depID}`;

        const routeData = this.$router.resolve({
          name: "staff-loan-advance-report",
          query: {
            db: this.myObj.db,
            cID: this.myObj.campusID,
            depID: depID || 0,
            depName,
            loanType: this.loanReportType || "loan",
          },
        });
        window.open(routeData.href, "_blank");
        return;
      }

      if (
        ["Remaining Leaves", "Leave Encashment", "Advance & Loan"].includes(
          this.myObj.format
        )
      ) {
        const routeData = this.$router.resolve({
          name: "remaining-leaves-print",
          query: {
            db: this.myObj.db,
            cID: this.myObj.campusID,
            depID: Array.isArray(this.staffDepID)
              ? this.staffDepID[0]
              : this.staffDepID || 0,
            title: this.myObj.format,
            ...(this.myObj.format === "Advance & Loan"
              ? { status: "present" }
              : {}),
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.showLeavesModal();
      }
    },

    async showLeavesTab() {
      try {
        this.leavesDataLoading = true;
        const params = { db: this.myObj.db, cID: this.myObj.campusID };
        if (this.staffDepID && this.staffDepID !== 0)
          params.depID = this.staffDepID;

        let showEncashment = this.myObj.format === "Leave Encashment";
        const apiUrl = `${
          this.$store.state.domain
        }Staff/StaffRemainingLeavesReport?${new URLSearchParams({
          ...params,
          sortBy: "doa",
          sortOrder: "asc",
        }).toString()}`;
        const response = await this.get({
          url: apiUrl,
          token: this.$store.state.userData.token,
        });
        const data = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
          ? response
          : [];

        const totalEncashment = data.reduce(
          (s, r) => s + (r.encashmentAmount || 0),
          0
        );

        const rows = data
          .map((item, idx) => {
            const usedCL = item.totalLeaves || 0;
            const remainingCL = item.remaining_leaves || 0;
            const clAllowed = usedCL + remainingCL;
            const clBalance = clAllowed - usedCL;
            const usedSL = item.sickLeaves || 0;
            const remainingSL = item.remaining_sickLeaves || 0;
            const slAllowed = usedSL + remainingSL;
            const slBalance = slAllowed - usedSL;

            return `
          <tr ${idx % 2 === 1 ? 'class="even-row"' : ""}>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${
              idx + 1
            }</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${
              item.employeeCode || item.id || item.employee_id || "N/A"
            }</td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\">${
              item.name || ""
            }</td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\">${
              item.fatherName || item.father_name || "N/A"
            }</td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\">${
              item.designation || "N/A"
            }</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${clAllowed}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${usedCL}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${clBalance}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${slAllowed}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${usedSL}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${slBalance}</td>
            ${
              showEncashment
                ? `<td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
                    item.encashmentAmount || 0
                  )}</td>`
                : ""
            }
          </tr>
        `;
          })
          .join("");

        const html = `
          <!DOCTYPE html>
          <html lang=\"en\">
          <head>
            <meta charset=\"UTF-8\" />
            <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\" />
            <title>${this.myObj.format} Report</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 0; padding: 20px; color: #333; }
              .print-header { text-align: center; margin-bottom: 20px; padding: 16px; border-radius: 12px; color: #212529; background: #f8f9fa; }
              .print-header h1 { margin: 0 0 6px 0; color: #212529; }
              .summary { display:flex; justify-content:center; gap:24px; margin-top: 10px; }
              .summary .item { text-align:center; }
              .summary .item small { display:block; opacity: .85; }
              .summary .item h3 { margin: 6px 0 0; }
              table { width: 100%; border-collapse: collapse; background: #fff; box-shadow: 0 2px 10px rgba(0,0,0,.1); }
              thead th { background: #e9ecef; color: #212529; padding: 10px; font-size: 12px; text-transform: uppercase; letter-spacing:.5px; }
              td { padding: 10px; border-bottom: 1px solid #eee; font-size: 12px; }
              tr.even-row { background: #fafbfc; }
              .text-center { text-align: center; }
              .text-right { text-align: right; }
              .text-left { text-align: left; }
              .avatar { width: 24px; height: 24px; background:#7367f0; color:#fff; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; margin-right:8px; }
              .dept-badge { background: #ebedf0; border-radius: 10rem; padding: 2px 8px; font-size: 11px; color: #6c757d; }
              .staff-name { font-weight: 700; }
              .staff-details { font-size: 11px; color: #6c757d; }
              .print-controls { position: fixed; top: 16px; right: 16px; }
              .print-btn { background: linear-gradient(135deg, #28a745 0%, #20c997 100%); color: #fff; border: 0; padding: 8px 12px; border-radius: 8px; cursor: pointer; }
              @media print { .print-controls { display:none } }
            </style>
          </head>
          <body>
            <div class=\"print-controls\"><button class=\"print-btn\" onclick=\"window.print()\">🖨️ Print Report</button></div>
            <div class=\"print-header\">
              <h1>${this.myObj.format} Report</h1>
              <div class=\"summary\">
                <div class=\"item\"><small>Total Records</small><h3>${
                  data.length
                }</h3></div>
                <div class=\"item\"><small>Department</small><h3>${
                  (Array.isArray(this.staffDepID) &&
                    this.staffDepID[0] === 0) ||
                  (!Array.isArray(this.staffDepID) && this.staffDepID === 0) ||
                  !this.staffDepID
                    ? "All Departments"
                    : data.length > 0 &&
                      data[0].department &&
                      data[0].department.name
                    ? data[0].department.name
                    : "All Departments"
                }</h3></div>
                ${
                  showEncashment
                    ? `<div class=\"item\"><small>Total Encashment</small><h3>${this.formatCurrency(
                        totalEncashment
                      )}</h3></div>`
                    : ""
                }
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th class=\"text-center\" style=\"width:5%; border: 2px solid #000000 !important;\">S.NO</th>
                  <th class=\"text-center\" style=\"width:8%; border: 2px solid #000000 !important;\">Employee Code</th>
                  <th style=\"width:14%; border: 2px solid #000000 !important;\">Staff Name</th>
                  <th style=\"width:12%; border: 2px solid #000000 !important;\">Father Name</th>
                  <th style=\"width:10%; border: 2px solid #000000 !important;\">Designation</th>
                  <th colspan=\"3\" class=\"text-center\" style=\"width:18%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">Casual Leave</th>
                  <th colspan=\"3\" class=\"text-center\" style=\"width:18%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">Sick Leave</th>
                  ${
                    showEncashment
                      ? '<th class="text-center" style="width:15%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Leave Encashment</th>'
                      : ""
                  }
                </tr>
                <tr>
                  <th style=\"border: 2px solid #000000 !important;\"></th>
                  <th style=\"border: 2px solid #000000 !important;\"></th>
                  <th style=\"border: 2px solid #000000 !important;\"></th>
                  <th style=\"border: 2px solid #000000 !important;\"></th>
                  <th style=\"border: 2px solid #000000 !important;\"></th>
                  <th class=\"text-center\" style=\"width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">CL Allowed</th>
                  <th class=\"text-center\" style=\"width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">CL</th>
                  <th class=\"text-center\" style=\"width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">Balance CL</th>
                  <th class=\"text-center\" style=\"width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">SL Allowed</th>
                  <th class=\"text-center\" style=\"width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">SL</th>
                  <th class=\"text-center\" style=\"width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;\">Balance SL</th>
                  ${
                    showEncashment
                      ? '<th class="text-center" style="width:15%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Amount</th>'
                      : ""
                  }
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
          </body>
          </html>
        `;

        const w = window.open(
          "",
          "_blank",
          "width=1200,height=800,scrollbars=yes,resizable=yes"
        );
        if (w) {
          w.document.write(html);
          w.document.close();
        } else {
          this.$bvToast.toast(
            "Pop-up blocked! Please allow pop-ups for this site to view the report.",
            { title: "Notice", variant: "warning" }
          );
        }
      } catch (err) {
        console.error("Leaves report tab error", err);
        this.$bvToast.toast("Failed to load report.", {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.leavesDataLoading = false;
      }
    },

    async showAdvanceLoanReport() {
      try {
        this.leavesDataLoading = true;
        const params = { db: this.myObj.db, cID: this.myObj.campusID };
        if (this.staffDepID && this.staffDepID !== 0)
          params.depID = this.staffDepID;

        const apiUrl = `${
          this.$store.state.domain
        }Staff/StaffLoansAndAdvanceReport?${new URLSearchParams({
          ...params,
          status: "present",
          sortBy: "doa",
          sortOrder: "asc",
        }).toString()}`;
        const response = await this.get({
          url: apiUrl,
          token: this.$store.state.userData.token,
        });
        const data = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
          ? response
          : [];

        const totalAdvance = data.reduce(
          (s, r) => s + (r.totalAdvance || r.advanceAmount || 0),
          0
        );
        const totalLoan = data.reduce(
          (s, r) => s + (r.totalLoan || r.loanAmount || 0),
          0
        );
        const totalAdvanceReturned = data.reduce(
          (s, r) => s + (r.advanceReturned || 0),
          0
        );
        const totalLoanReturned = data.reduce(
          (s, r) => s + (r.loanReturned || 0),
          0
        );
        const totalAdvanceRemaining = data.reduce(
          (s, r) => s + (r.remainingAdvance || 0),
          0
        );
        const totalLoanRemaining = data.reduce(
          (s, r) => s + (r.remainingLoan || 0),
          0
        );

        // Build printable HTML like reconcilation.vue
        const rows = data
          .map(
            (item, idx) => `
          <tr ${idx % 2 === 1 ? 'class="even-row"' : ""}>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${
              idx + 1
            }</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${
              item.employeeCode || item.id || item.employee_id || "N/A"
            }</td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\">${
              item.name || ""
            }</td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\">${
              item.fatherName || item.father_name || "N/A"
            }</td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\">${
              item.designation || "N/A"
            }</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              item.totalAdvance || item.advanceAmount || 0
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              item.advanceReturned || 0
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              item.remainingAdvance || 0
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              item.totalLoan || item.loanAmount || 0
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              item.loanReturned || 0
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              item.remainingLoan || 0
            )}</td>
          </tr>
        `
          )
          .join("");

        // Add totals row
        const totalsRow = `
          <tr style="background-color: #f8f9fa; font-weight: bold;">
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">TOTAL</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\"></td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\"></td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\"></td>
            <td class=\"text-left\" style=\"border: 2px solid #000000 !important;\"></td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              totalAdvance
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              totalAdvanceReturned
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              totalAdvanceRemaining
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              totalLoan
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              totalLoanReturned
            )}</td>
            <td class=\"text-center\" style=\"border: 2px solid #000000 !important;\">${this.formatCurrency(
              totalLoanRemaining
            )}</td>
          </tr>
        `;

        const html = `
          <!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>Advance & Loan Report</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 0; padding: 20px; color: #333; }
              .print-header { text-align: center; margin-bottom: 20px; padding: 16px; border-radius: 12px; color: #212529; background: #f8f9fa; }
              .print-header h1 { margin: 0 0 6px 0; color: #212529; }
              .summary { display:flex; justify-content:center; gap:24px; margin-top: 10px; flex-wrap: wrap; }
              .summary .item { text-align:center; min-width: 130px; }
              .summary .item small { display:block; opacity: .85; }
              .summary .item h3 { margin: 6px 0 0; }
              table { width: 100%; border-collapse: collapse; background: #fff; box-shadow: 0 2px 10px rgba(0,0,0,.1); }
              thead th { background: #e9ecef; color: #212529; padding: 10px; font-size: 12px; text-transform: uppercase; letter-spacing:.5px; }
              td { padding: 10px; border-bottom: 1px solid #eee; font-size: 12px; }
              tr.even-row { background: #fafbfc; }
              .text-center { text-align: center; }
              .text-right { text-align: right; }
              .text-left { text-align: left; }
              .avatar { width: 24px; height: 24px; background:#7367f0; color:#fff; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; margin-right:8px; }
              .dept-badge { background: #ebedf0; border-radius: 10rem; padding: 2px 8px; font-size: 11px; color: #6c757d; }
              .staff-name { font-weight: 700; }
              .staff-details { font-size: 11px; color: #6c757d; }
              .print-controls { position: fixed; top: 16px; right: 16px; }
              .print-btn { background: linear-gradient(135deg, #28a745 0%, #20c997 100%); color: #fff; border: 0; padding: 8px 12px; border-radius: 8px; cursor: pointer; }
              @media print { .print-controls { display:none } }
            </style>
          </head>
          <body>
            <div class="print-controls"><button class="print-btn" onclick="window.print()">🖨️ Print Report</button></div>
            <div class="print-header">
              <h1>Advance & Loan Report</h1>
              <div class="summary">
                <div class="item"><small>Total Records</small><h3>${
                  data.length
                }</h3></div>
                <div class="item"><small>Department</small><h3>${
                  (Array.isArray(this.staffDepID) &&
                    this.staffDepID[0] === 0) ||
                  (!Array.isArray(this.staffDepID) && this.staffDepID === 0) ||
                  !this.staffDepID
                    ? "All Departments"
                    : data.length > 0 &&
                      data[0].department &&
                      data[0].department.name
                    ? data[0].department.name
                    : "All Departments"
                }</h3></div>
                </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th class="text-center" style="width:5%; border: 2px solid #000000 !important;">S.NO</th>
                  <th class="text-center" style="width:8%; border: 2px solid #000000 !important;">Employee Code</th>
                  <th style="width:14%; border: 2px solid #000000 !important;">Staff Name</th>
                  <th style="width:12%; border: 2px solid #000000 !important;">Father Name</th>
                  <th style="width:10%; border: 2px solid #000000 !important;">Designation</th>
                  <th colspan="3" class="text-center" style="width:18%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Advance</th>
                  <th colspan="3" class="text-center" style="width:18%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Loan</th>
                </tr>
                <tr>
                  <th style="border: 2px solid #000000 !important;"></th>
                  <th style="border: 2px solid #000000 !important;"></th>
                  <th style="border: 2px solid #000000 !important;"></th>
                  <th style="border: 2px solid #000000 !important;"></th>
                  <th style="border: 2px solid #000000 !important;"></th>
                  <th class="text-center" style="width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Total</th>
                  <th class="text-center" style="width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Returned</th>
                  <th class="text-center" style="width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Remaining</th>
                  <th class="text-center" style="width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Total</th>
                  <th class="text-center" style="width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Returned</th>
                  <th class="text-center" style="width:6%; border: 2px solid #000000 !important; background-color: #e9ecef !important; color: #212529 !important;">Remaining</th>
                </tr>
              </thead>
              <tbody>${rows}${totalsRow}</tbody>
            </table>
          </body>
          </html>
        `;

        const w = window.open(
          "",
          "_blank",
          "width=1200,height=800,scrollbars=yes,resizable=yes"
        );
        if (w) {
          w.document.write(html);
          w.document.close();
        } else {
          this.$bvToast.toast(
            "Pop-up blocked! Please allow pop-ups for this site to view the report.",
            { title: "Notice", variant: "warning" }
          );
        }
      } catch (err) {
        console.error("Advance & Loan report error", err);
        this.$bvToast.toast("Failed to load Advance & Loan report.", {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.leavesDataLoading = false;
      }
    },

    // Hierarchy method
    async viewHierarchy() {
      this.hierarchyLoading = true;
      this.hierarchyData = []; // Clear previous data

      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Staff/GetHierarchy?db=" +
            this.myObj.db +
            "&cID=" +
            this.myObj.campusID,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(obj);

        // Handle different response formats
        let hierarchyData = null;

        if (response && response.status === "success" && response.data) {
          hierarchyData = response.data;
        } else if (response && Array.isArray(response)) {
          // Handle case where response is directly an array
          hierarchyData = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          // Handle case where data is directly an array without status
          hierarchyData = response.data;
        }

        if (hierarchyData && hierarchyData.length > 0) {
          this.hierarchyData = hierarchyData;
          this.$bvModal.show("hierarchy-modal");
          this.$bvToast.toast("Hierarchy data loaded successfully", {
            title: this.$t("Success"),
            variant: "success",
            toaster: "b-toaster-top-center",
          });
        } else if (hierarchyData && hierarchyData.length === 0) {
          this.$bvToast.toast("No hierarchy data found for this campus", {
            title: "Info",
            variant: "info",
            toaster: "b-toaster-top-center",
          });
        } else {
          this.$bvToast.toast("Invalid response format from hierarchy API", {
            title: this.$t("Error"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error loading hierarchy:", error);
        this.$bvToast.toast("Failed to load hierarchy data", {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.hierarchyLoading = false;
      }
    },

    // Helper methods for hierarchy
    getInitials(name) {
      if (!name) return "?";
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();
    },

    handleImageError(event) {
      event.target.style.display = "none";
      event.target.nextElementSibling.style.display = "flex";
    },

    async openHierarchyInNewTab() {
      this.hierarchyLoading = true;

      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Staff/GetHierarchy?db=" +
            this.myObj.db +
            "&cID=" +
            this.myObj.campusID,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(obj);

        // Handle different response formats
        let hierarchyData = null;

        if (response && response.status === "success" && response.data) {
          hierarchyData = response.data;
        } else if (response && Array.isArray(response)) {
          hierarchyData = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          hierarchyData = response.data;
        }

        if (hierarchyData && hierarchyData.length > 0) {
          this.hierarchyData = hierarchyData;
          this.createHierarchyWindow();
        } else {
          this.$bvToast.toast("No hierarchy data found for this campus", {
            title: "Info",
            variant: "info",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error loading hierarchy:", error);
        this.$bvToast.toast("Failed to load hierarchy data", {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.hierarchyLoading = false;
      }
    },

    createHierarchyWindow() {
      // Create a new window with hierarchy data
      const hierarchyWindow = window.open(
        "",
        "_blank",
        "width=1400,height=900"
      );

      if (hierarchyWindow) {
        const hierarchyHTML = this.generateHierarchyHTML();
        hierarchyWindow.document.write(hierarchyHTML);
        hierarchyWindow.document.close();
      }
    },

    generateHierarchyHTML() {
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Organization Hierarchy</title>
          <style>
            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              margin: 0;
              padding: 15px;
              background: #f5f5f5;
              min-height: 100vh;
            }
            .hierarchy-container {
              max-width: 1200px;
              margin: 0 auto;
              background: white;
              border-radius: 8px;
              box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              overflow: hidden;
            }
            .hierarchy-header {
              background: #f8f9fa;
              color: #000;
              padding: 15px;
              text-align: center;
              border-bottom: 2px solid #dee2e6;
            }
            .hierarchy-title {
              font-size: 20px;
              font-weight: bold;
              margin: 0;
              color: #000;
            }
            .hierarchy-subtitle {
              font-size: 12px;
              margin-top: 3px;
              color: #666;
            }
            .hierarchy-content {
              padding: 20px;
              background: #f8f9fa;
            }
            .hierarchy-chart {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              gap: 40px;
              position: relative;
              width: 100%;
              margin-top: 30px;
              padding: 20px;
            }
            .hierarchy-level-0 {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              position: relative;
            }
            .subordinates-level {
              margin-top: 25px;
              width: 100%;
              position: relative;
            }
            .subordinates-container {
              display: flex;
              justify-content: center;
              align-items: flex-start;
              gap: 15px;
              flex-wrap: nowrap;
              width: 100%;
              overflow-x: auto;
            }
            .subordinate-card {
              background: white;
              border-radius: 8px;
              padding: 10px;
              margin: 0;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              text-align: center;
              width: 150px;
              border: 1px solid #e9ecef;
              position: relative;
              flex-shrink: 0;
            }
            .manager-level {
              position: relative;
              margin-bottom: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
            }
            .person-card {
              background: white;
              border-radius: 8px;
              padding: 12px;
              margin: 0 auto;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              text-align: center;
              width: 180px;
              border: 2px solid #007bff;
              position: relative;
              transition: transform 0.2s ease, box-shadow 0.2s ease;
            }
            .person-card:hover {
              transform: translateY(-1px);
              box-shadow: 0 2px 6px rgba(0,0,0,0.15);
            }
            .manager-card {
              border-color: #007bff;
              background: #f8f9ff;
              border-width: 2px;
            }
            .subordinate-card {
              border-color: #6c757d;
              background: #f8f9fa;
            }
            .person-avatar {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              margin: 0 auto 10px;
              overflow: hidden;
              background: #007bff;
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
              font-weight: bold;
              font-size: 18px;
              border: 3px solid #fff;
              box-shadow: 0 3px 8px rgba(0,0,0,0.2);
              flex-shrink: 0;
              position: relative;
              min-width: 60px;
              min-height: 60px;
            }
            .manager-avatar {
              width: 60px;
              height: 60px;
              font-size: 18px;
              background: #007bff;
            }
            .subordinate-avatar {
              width: 50px;
              height: 50px;
              font-size: 14px;
              background: #6c757d;
              min-width: 50px;
              min-height: 50px;
              border-radius: 50%;
              overflow: hidden;
            }
            .avatar-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
              position: absolute;
              top: 0;
              left: 0;
            }
            /* Connection lines */
            .hierarchy-level-0::before {
              content: '';
              position: absolute;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);
              width: 3px;
              height: 20px;
              background: #333;
              z-index: 1;
            }
            .subordinates-level::before {
              content: '';
              position: absolute;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);
              width: 3px;
              height: 20px;
              background: #333;
              z-index: 1;
            }
            .subordinates-container::before {
              content: '';
              position: absolute;
              top: -20px;
              left: 20%;
              right: 20%;
              height: 3px;
              background: #333;
              z-index: 1;
            }
            .subordinate-card::before {
              content: '';
              position: absolute;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);
              width: 3px;
              height: 20px;
              background: #333;
              z-index: 1;
            }
            .avatar-img { width: 100%; height: 100%; object-fit: cover; }
            .avatar-placeholder {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: white;
              color: black;
              font-weight: bold;
              border: 2px solid #dee2e6;
            }
            .person-name { margin: 0 0 2px; font-size: 11px; font-weight: bold; color: #333; }
            .manager-name { font-size: 13px; }
            .subordinate-name { font-size: 10px; }
            .person-designation { margin: 0 0 2px; color: #666; font-size: 9px; font-weight: 500; }
            .manager-designation { font-size: 11px; }
            .subordinate-designation { font-size: 8px; }
            .person-department {
              margin: 0;
              color: #888;
              font-size: 8px;
              background: #e9ecef;
              padding: 1px 4px;
              border-radius: 4px;
              display: inline-block;
            }
            .connection-lines {
              position: relative;
              width: 100%;
              height: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 10;
            }
            .vertical-line {
              width: 3px;
              height: 25px;
              background: #000;
              border-radius: 2px;
              box-shadow: 0 0 2px rgba(0,0,0,0.3);
            }
            .horizontal-line {
              position: absolute;
              top: 12px;
              left: 50%;
              transform: translateX(-50%);
              width: 80%;
              height: 3px;
              background: #000;
              border-radius: 2px;
              box-shadow: 0 0 2px rgba(0,0,0,0.3);
            }
            .subordinates-level {
              position: relative;
              width: 100%;
            }
            .subordinates-container {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              gap: 8px;
              margin-top: 8px;
              position: relative;
            }
            .person-card-wrapper {
              position: relative;
            }
            .level-0 {
              margin-bottom: 12px;
            }
            .level-1 {
              margin-bottom: 8px;
            }
            .level-2 {
              margin-bottom: 6px;
            }
            .connecting-line {
              position: absolute;
              top: -18px;
              left: 50%;
              transform: translateX(-50%);
              width: 3px;
              height: 18px;
              background: #000;
              border-radius: 2px;
              box-shadow: 0 0 2px rgba(0,0,0,0.3);
              z-index: 5;
            }
            .print-button {
              position: fixed;
              top: 20px;
              right: 20px;
              background: #007bff;
              color: white;
              border: none;
              padding: 12px 24px;
              border-radius: 25px;
              cursor: pointer;
              font-weight: bold;
              box-shadow: 0 4px 15px rgba(0,123,255,0.3);
              transition: all 0.3s ease;
            }
            .print-button:hover {
              background: #0056b3;
              transform: translateY(-2px);
              box-shadow: 0 6px 20px rgba(0,123,255,0.4);
            }
            @media print {
              * {
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
              body {
                background: white !important;
                margin: 0 !important;
                padding: 10px !important;
              }
              .hierarchy-container {
                box-shadow: none !important;
                border: 1px solid #ddd !important;
                max-width: 100% !important;
              }
              .hierarchy-content {
                padding: 10px !important;
              }
              .hierarchy-header {
                padding: 10px !important;
                background: #f8f9fa !important;
                color: #000 !important;
              }
              .hierarchy-title {
                font-size: 18px !important;
              }
              .hierarchy-subtitle {
                font-size: 10px !important;
              }
              .person-card {
                break-inside: avoid;
                page-break-inside: avoid;
                margin: 2px !important;
                padding: 6px !important;
                min-width: 100px !important;
                max-width: 130px !important;
              }
                .person-avatar {
                  width: 60px !important;
                  height: 60px !important;
                  font-size: 18px !important;
                  border-radius: 50% !important;
                  overflow: hidden !important;
                  flex-shrink: 0 !important;
                  margin: 0 auto 15px !important;
                  display: flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  background: #007bff !important;
                  color: white !important;
                  font-weight: bold !important;
                  border: 3px solid #fff !important;
                  box-shadow: 0 3px 8px rgba(0,0,0,0.2) !important;
                  position: relative !important;
                  min-width: 60px !important;
                  min-height: 60px !important;
                }
                .manager-avatar {
                  width: 60px !important;
                  height: 60px !important;
                  font-size: 18px !important;
                  background: #007bff !important;
                }
                .subordinate-avatar {
                  width: 50px !important;
                  height: 50px !important;
                  font-size: 14px !important;
                  background: #6c757d !important;
                  min-width: 50px !important;
                  min-height: 50px !important;
                  border-radius: 50% !important;
                  overflow: hidden !important;
                }
                .avatar-img {
                  width: 100% !important;
                  height: 100% !important;
                  object-fit: cover !important;
                  border-radius: 50% !important;
                  position: absolute !important;
                  top: 0 !important;
                  left: 0 !important;
                }
              .person-name {
                font-size: 10px !important;
                margin: 0 0 1px !important;
              }
              .manager-name {
                font-size: 12px !important;
              }
              .subordinate-name {
                font-size: 9px !important;
              }
              .person-designation {
                font-size: 8px !important;
                margin: 0 0 1px !important;
              }
              .manager-designation {
                font-size: 10px !important;
              }
              .subordinate-designation {
                font-size: 7px !important;
              }
              .person-department {
                font-size: 7px !important;
                padding: 1px 3px !important;
              }
              .connection-lines {
                height: 25px !important;
                display: flex !important;
                justify-content: center !important;
                align-items: center !important;
                position: relative !important;
                z-index: 10 !important;
              }
              .vertical-line {
                height: 20px !important;
                width: 4px !important;
                background: #000 !important;
                border: 1px solid #000 !important;
                border-radius: 2px !important;
                display: block !important;
              }
              .horizontal-line {
                top: 10px !important;
                width: 70% !important;
                height: 4px !important;
                background: #000 !important;
                border: 1px solid #000 !important;
                border-radius: 2px !important;
                position: absolute !important;
                left: 50% !important;
                transform: translateX(-50%) !important;
                display: block !important;
              }
              .subordinates-container {
                gap: 8px !important;
                margin-top: 8px !important;
              }
              .level-0 {
                margin-bottom: 12px !important;
              }
              .level-1 {
                margin-bottom: 10px !important;
              }
              .level-2 {
                margin-bottom: 8px !important;
              }
              .connecting-line {
                top: -15px !important;
                height: 15px !important;
                width: 4px !important;
                background: #000 !important;
                border: 1px solid #000 !important;
                border-radius: 2px !important;
                position: absolute !important;
                left: 50% !important;
                transform: translateX(-50%) !important;
                display: block !important;
                z-index: 5 !important;
              }
              .manager-level {
                display: flex !important;
                justify-content: center !important;
                align-items: center !important;
                width: 100% !important;
                margin-bottom: 20px !important;
              }
              .hierarchy-chart {
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                justify-content: flex-start !important;
                width: 100% !important;
                margin-top: 30px !important;
                gap: 40px !important;
                padding: 20px !important;
              }
              .hierarchy-level-0 {
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                width: 100% !important;
                position: relative !important;
              }
              .person-card {
                background: white !important;
                border-radius: 8px !important;
                padding: 12px !important;
                margin: 0 auto !important;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
                text-align: center !important;
                width: 180px !important;
                border: 2px solid #007bff !important;
                position: relative !important;
              }
              .subordinates-level {
                margin-top: 25px !important;
                width: 100% !important;
                position: relative !important;
              }
              .subordinates-container {
                display: flex !important;
                justify-content: center !important;
                align-items: flex-start !important;
                gap: 15px !important;
                flex-wrap: nowrap !important;
                width: 100% !important;
                overflow-x: auto !important;
              }
              .subordinate-card {
                background: white !important;
                border-radius: 8px !important;
                padding: 10px !important;
                margin: 0 !important;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
                text-align: center !important;
                width: 150px !important;
                border: 1px solid #e9ecef !important;
                position: relative !important;
                flex-shrink: 0 !important;
              }
              .avatar-placeholder {
                width: 100% !important;
                height: 100% !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                background: white !important;
                color: black !important;
                font-weight: bold !important;
                border: 2px solid #dee2e6 !important;
              }
              .hierarchy-level-0::before {
                content: '' !important;
                position: absolute !important;
                top: -20px !important;
                left: 50% !important;
                transform: translateX(-50%) !important;
                width: 3px !important;
                height: 20px !important;
                background: #333 !important;
                z-index: 1 !important;
              }
              .subordinates-level::before {
                content: '' !important;
                position: absolute !important;
                top: -20px !important;
                left: 50% !important;
                transform: translateX(-50%) !important;
                width: 3px !important;
                height: 20px !important;
                background: #333 !important;
                z-index: 1 !important;
              }
              .subordinates-container::before {
                content: '' !important;
                position: absolute !important;
                top: -20px !important;
                left: 20% !important;
                right: 20% !important;
                height: 3px !important;
                background: #333 !important;
                z-index: 1 !important;
              }
              .subordinate-card::before {
                content: '' !important;
                position: absolute !important;
                top: -20px !important;
                left: 50% !important;
                transform: translateX(-50%) !important;
                width: 3px !important;
                height: 20px !important;
                background: #333 !important;
                z-index: 1 !important;
              }
              .print-button { display: none !important; }
            }
          </style>
        </head>
        <body>
          <button class="print-button" onclick="window.print()">🖨️ Print Report</button>
          <div class="hierarchy-container">
            <div class="hierarchy-header">
              <h1 class="hierarchy-title">ORGANIZATION HIERARCHY</h1>
              <p class="hierarchy-subtitle">Staff Reporting Structure</p>
            </div>
            <div class="hierarchy-content">
              <div class="hierarchy-chart">
                ${this.generateHierarchyCards()}
              </div>
            </div>
          </div>
        </body>
        </html>
      `;
    },

    generateHierarchyCards() {
      if (!this.hierarchyData || this.hierarchyData.length === 0) {
        return '<div style="text-align: center; padding: 50px; color: #666;">No hierarchy data available</div>';
      }

      return this.hierarchyData
        .map((person) => {
          return this.generatePersonCard(person, 0);
        })
        .join("");
    },

    generatePersonCard(person, level) {
      const avatarHTML = person.picture
        ? `<img src="${person.picture}" alt="${
            person.name
          }" class="avatar-img" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
           <div class="avatar-placeholder" style="display: none;">${this.getInitials(
             person.name
           )}</div>`
        : `<div class="avatar-placeholder">${this.getInitials(
            person.name
          )}</div>`;

      const subordinatesHTML =
        person.subordinates && person.subordinates.length > 0
          ? `
          <div class="connection-lines">
            <div class="vertical-line"></div>
            <div class="horizontal-line"></div>
          </div>
          <div class="subordinates-level">
            <div class="subordinates-container">
              ${person.subordinates
                .map((sub) => this.generatePersonCard(sub, level + 1))
                .join("")}
            </div>
          </div>`
          : "";

      const cardClass =
        level === 0
          ? "person-card manager-card"
          : "person-card subordinate-card";
      const avatarClass =
        level === 0
          ? "person-avatar manager-avatar"
          : "person-avatar subordinate-avatar";
      const nameClass =
        level === 0
          ? "person-name manager-name"
          : "person-name subordinate-name";
      const designationClass =
        level === 0
          ? "person-designation manager-designation"
          : "person-designation subordinate-designation";

      return `
        <div class="person-card-wrapper level-${level}">
          <div class="${cardClass}">
            <div class="connecting-line"></div>
            <div class="${avatarClass}">${avatarHTML}</div>
            <div class="person-info">
              <h6 class="${nameClass}">${person.name}</h6>
              <p class="${designationClass}">${person.designation || "N/A"}</p>
              <p class="person-department">${person.departmentName}</p>
            </div>
          </div>
          ${subordinatesHTML}
        </div>
      `;
    },

    async fetchAppDownloadStatsData() {
      const campusID =
        this.myObj.campusID > 0
          ? this.myObj.campusID
          : this.$store.state.userData.cId;

      const url =
        this.$store.state.domain +
        "Users/GetAppDownloadStatistics?db=" +
        encodeURIComponent(this.$store.state.userData.db) +
        "&campusID=" +
        campusID;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${this.$store.state.userData.token}`,
          accept: "application/json",
        },
      });

      return response.data?.data || response.data || {};
    },

    getAppStatsItemsFromRes(res) {
      const isStaff = this.resolvedAppStatsUserType === "staff";
      const isActive = this.appStatsStatus === "active";

      if (isStaff) {
        return isActive
          ? res.activeStaffList || []
          : res.inactiveStaffList || [];
      }

      return isActive
        ? res.activeStudentsList || []
        : res.inactiveStudentsList || [];
    },

    async loadAppDownloadStats() {
      this.appStatsLoading = true;

      try {
        const res = await this.fetchAppDownloadStatsData();

        this.downloadStats = {
          totalDownloads: res.totalDownloads || 0,
          activeStudents: res.activeStudents || 0,
          activeStaff: res.activeStaff || 0,
          totalActiveUsers: res.totalActiveUsers || 0,
          studentStrength: res.studentStrength || 0,
          staffStrength: res.staffStrength || 0,
          activeStudentsList: res.activeStudentsList || [],
          inactiveStudentsList: res.inactiveStudentsList || [],
          activeStaffList: res.activeStaffList || [],
          inactiveStaffList: res.inactiveStaffList || [],
        };
      } catch (error) {
        console.error("Error loading app download statistics:", error);
        this.downloadStats = null;
        this.$bvToast.toast("Failed to load app stats.", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.appStatsLoading = false;
      }
    },

    showAppStatsReport() {
      this.syncAppStatsUserTypeFromReport();
      const routeData = this.$router.resolve({
        name: "app-stats-report",
        query: {
          db: this.myObj.db || this.$store.state.userData.db,
          cID: this.myObj.campusID || this.$store.state.userData.cId,
          userType: this.resolvedAppStatsUserType,
          status: this.appStatsStatus,
        },
      });
      window.open(routeData.href, "_blank");
    },

    getAppStatsExportRows(items) {
      const statusLabel =
        this.appStatsStatus === "active" ? "INSTALLED" : "PENDING";
      const list = items || this.appStatsListItems;

      const hasContact = (value) => {
        const text = value == null ? "" : String(value).trim();
        return text !== "" && text !== "-" && text.toLowerCase() !== "null";
      };

      const resolveStudentPhone = (item) => {
        if (hasContact(item?.phoneNumber)) {
          return {
            number: String(item.phoneNumber).trim(),
            label: "",
          };
        }
        if (hasContact(item?.contact_father)) {
          return {
            number: String(item.contact_father).trim(),
            label: "Father",
          };
        }
        if (hasContact(item?.contact_mother)) {
          return {
            number: String(item.contact_mother).trim(),
            label: "Mother",
          };
        }
        if (hasContact(item?.contact_student)) {
          return {
            number: String(item.contact_student).trim(),
            label: "Student",
          };
        }
        return { number: "", label: "" };
      };

      if (this.resolvedAppStatsUserType === "staff") {
        return list.map((item, index) => ({
          "S.No": index + 1,
          "Staff Name": item.name || "",
          Designation: item.designation || "",
          Phone: hasContact(item?.phoneNumber)
            ? String(item.phoneNumber).trim()
            : hasContact(item?.contact_number)
            ? String(item.contact_number).trim()
            : "",
          Status: statusLabel,
        }));
      }

      return list.map((item, index) => {
        const classLabel = [item.className, item.sectionName]
          .filter(Boolean)
          .join(" - ");
        const phone = resolveStudentPhone(item);

        return {
          "S.No": index + 1,
          "GR No": item.grNo != null ? String(item.grNo) : "",
          "Student Name": item.name || "",
          "Father Name": item.father_name || "",
          Class: classLabel,
          Phone: phone.number,
          "Phone Of": phone.label,
          Status: statusLabel,
        };
      });
    },

    async exportAppStatsReport() {
      this.request = true;
      this.syncAppStatsUserTypeFromReport();

      try {
        const res = await this.fetchAppDownloadStatsData();
        const items = this.getAppStatsItemsFromRes(res);
        const expData = this.getAppStatsExportRows(items);

        if (!expData.length) {
          this.$bvToast.toast("No data available for export.", {
            title: this.$t("Error"),
            variant: "danger",
            solid: true,
          });
          return;
        }

        const stamp = new Date().toISOString().slice(0, 10);
        const slug = `${this.resolvedAppStatsUserType}-${this.appStatsStatus}`;
        const filename = `App-Stats-${slug}-${stamp}.xlsx`;
        const sheetName =
          `${this.appStatsUserTypeLabel}-${this.appStatsStatusLabel}`
            .replace(/\s+/g, " ")
            .slice(0, 31);

        const worksheet = XLSX.utils.json_to_sheet(expData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        XLSX.writeFile(workbook, filename);

        this.$bvToast.toast(`Exported ${expData.length} record(s).`, {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Error exporting app stats:", error);
        this.$bvToast.toast("Failed to export app stats.", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.request = false;
      }
    },

    setStaffAllocClasses(selected) {
      let ids = Array.isArray(selected) ? [...selected] : [selected];
      if (ids.length === 0) ids = [0];
      // "All Classes" (0) is exclusive: choosing it clears the rest, and picking
      // a real class while it is still selected drops the "All" entry.
      if (ids[ids.length - 1] == 0) {
        this.staffAllocClassIDs = [0];
        this.staffAllocSectionIDs = [0];
        return;
      }
      ids = ids.filter((id) => id != 0);
      this.staffAllocClassIDs = ids;

      const allowedSections = new Set(
        this.staffAllocSectionOptions.map((section) => Number(section.id))
      );
      const keptSections = (this.staffAllocSectionIDs || []).filter((id) =>
        allowedSections.has(Number(id))
      );
      this.staffAllocSectionIDs = keptSections.length ? keptSections : [0];
    },
    setStaffAllocSections(selected) {
      let ids = Array.isArray(selected) ? [...selected] : [selected];
      if (ids.length === 0) ids = [0];
      this.staffAllocSectionIDs =
        ids[ids.length - 1] == 0 ? [0] : ids.filter((id) => id != 0);
    },
    setStaffAllocSubjects(selected) {
      let ids = Array.isArray(selected) ? [...selected] : [selected];
      if (ids.length === 0) ids = [0];
      this.staffAllocSubjectIDs =
        ids[ids.length - 1] == 0 ? [0] : ids.filter((id) => id != 0);
    },

    openStaffAllocationReport() {
      const filters = this.getStaffAllocationFilters();
      const query = {
        db: this.myObj.db,
        cID: this.myObj.campusID,
        status: this.getStaffAllocationStatus(),
      };
      if (filters.departmentNames.length)
        query.depNames = filters.departmentNames.join("|");
      if (filters.classNames.length)
        query.classNames = filters.classNames.join("|");
      if (filters.sectionNames.length)
        query.sectionNames = filters.sectionNames.join("|");
      if (filters.subjectNames.length)
        query.subjectNames = filters.subjectNames.join("|");

      const routeData = this.$router.resolve({
        name: "staff-allocation-report",
        query,
      });
      window.open(routeData.href, "_blank");
    },

    getStaffAllocationFilters() {
      const departmentNames = (
        Array.isArray(this.staffDepID) ? this.staffDepID : [this.staffDepID]
      )
        .filter((id) => id && id != 0)
        .map((id) => {
          const dep = (this.staffDeparts || []).find((d) => d.id == id);
          return dep ? dep.name : "";
        })
        .filter(Boolean);

      const classNames = (this.staffAllocClassIDs || [])
        .filter((id) => id && id != 0)
        .map((id) => {
          const cls = (this.classesOptions || []).find((c) => c.id == id);
          return cls ? cls.name : "";
        })
        .filter(Boolean);

      const sectionNames = (this.staffAllocSectionIDs || [])
        .filter((id) => id && id != 0)
        .map((id) => {
          const section = this.staffAllocSectionOptions.find(
            (sec) => sec.id == id
          );
          return section ? section.section : "";
        })
        .filter(Boolean);

      const subjectNames = (this.staffAllocSubjectIDs || [])
        .filter((id) => id && id != 0)
        .map((id) => {
          const subject = this.filteredSubjectList.find((s) => s.id == id);
          return subject ? subject.subject || subject.name : "";
        })
        .filter(Boolean);

      return { departmentNames, classNames, sectionNames, subjectNames };
    },

    getStaffAllocationStatus() {
      const rawStatus = this.myObj.staffStatus;
      return (rawStatus && rawStatus.value) || rawStatus || "present";
    },

    async fetchStaffAllocationRows() {
      const response = await axios.get(
        `${this.$store.state.domain}Staff/StaffAllocation`,
        {
          params: {
            db: this.myObj.db,
            cID: this.myObj.campusID,
            status: this.getStaffAllocationStatus(),
          },
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
            accept: "application/json",
          },
        }
      );

      const payload = response.data;
      if (!payload || payload.status !== "success") {
        throw new Error(
          (payload && payload.message) ||
            "Failed to load staff allocation data."
        );
      }
      return Array.isArray(payload.data) ? payload.data : [];
    },

    async exportStaffAllocationReport() {
      this.staffAllocationExporting = true;
      try {
        const filters = this.getStaffAllocationFilters();
        const rows = flattenStaffAllocationRows(
          buildStaffAllocationGroups(
            await this.fetchStaffAllocationRows(),
            filters
          )
        );

        if (rows.length === 0) {
          this.$bvToast.toast(
            "No staff allocation records found for the selected filters.",
            {
              title: "Warning",
              variant: "warning",
              solid: true,
            }
          );
          return;
        }

        const filterLabel = [
          filters.departmentNames.length &&
            `Department: ${filters.departmentNames.join(", ")}`,
          filters.classNames.length &&
            `Class: ${filters.classNames.join(", ")}`,
          filters.sectionNames.length &&
            `Section: ${filters.sectionNames.join(", ")}`,
          filters.subjectNames.length &&
            `Subject: ${filters.subjectNames.join(", ")}`,
        ]
          .filter(Boolean)
          .join(" | ");
        const stamp = new Date().toISOString().slice(0, 10);

        await exportObjectsToExcel(
          rows,
          `Staff_Allocation_${stamp}.xlsx`,
          {
            sheetName: "Staff Allocation",
            title: "Staff Allocation",
            subtitle: [
              filterLabel,
              `Generated on ${new Date().toLocaleString("en-GB")}`,
            ]
              .filter(Boolean)
              .join(" | "),
            columns: STAFF_ALLOCATION_EXPORT_COLUMNS,
          }
        );
      } catch (error) {
        console.error("Staff allocation export failed:", error);
        this.$bvToast.toast(
          error.message || "Failed to export staff allocation report.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.staffAllocationExporting = false;
      }
    },

    async showNewStaffReport() {
      try {
        this.stLoading = true;

        // Validate department selection - must select a department (including "All Departments")
        if (this.staffDepID === null || this.staffDepID === undefined) {
          this.$bvToast.toast("Please select a department.", {
            title: this.$t("Error"),
            variant: "danger",
          });
          return;
        }

        // Increment list is processed via its own Vue component now

        // Build API URL with parameters for other reports
        const baseUrl = `${this.$store.state.domain}staff/LoadDataPagination`;

        // Determine status based on report type
        let status = "present"; // default
        if (this.myObj.format === "New staff list") {
          status = "present";
        } else if (this.myObj.format === "New staff left list") {
          status = "left";
        } else if (this.myObj.format === "File cover") {
          status = this.myObj.staffStatus?.value || "present"; // Use selected status for File cover
        } else {
          status = this.myObj.staffStatus?.value || "present";
        }

        // Determine sort field based on report type
        let sortBy = "rfid"; // default
        if (this.myObj.format === "New staff list") {
          sortBy = "appointedOn"; // Sort by date of appointment
        } else if (this.myObj.format === "New staff left list") {
          sortBy = "appointedOn"; // Sort by date of admission (appointedOn)
        } else if (this.myObj.format === "File cover") {
          sortBy = "rfid"; // Sort by RF ID for file cover
        }

        // Build URL parameters based on report type
        let urlParams;
        if (
          this.myObj.format === "New staff list" ||
          this.myObj.format === "New staff left list" ||
          this.myObj.format === "File cover"
        ) {
          // Simplified parameters for new staff reports
          const depID = this.staffDepID === 0 ? 0 : this.staffDepID;
          urlParams = new URLSearchParams({
            db: this.$store.state.userData.db,
            cId: this.$store.state.userData.cId,
            dptID: depID,
            status: status,
            depname: "",
            page: 1,
            pageSize: 1000,
          });
        } else {
          // Full parameters for other reports
          const depID = this.staffDepID === 0 ? 0 : this.staffDepID;
          urlParams = new URLSearchParams({
            db: this.$store.state.userData.db,
            cId: this.$store.state.userData.cId,
            dptID: depID,
            status: status,
            depname: "",
            page: 1,
            applicantStatus: "",
            appointedFrom: this.myObj.dtfrom || "",
            appointedTo: this.myObj.dtto || "",
            sortBy: sortBy,
            sortOrder: "asc",
            pageSize: 1000,
          });
        }

        const apiUrl = `${baseUrl}?${urlParams.toString()}`;

        // Make API call with URL parameters
        const response = await this.get({
          url: apiUrl,
          token: this.$store.state.userData.token,
        });

        // Process the response data
        let reportData = [];

        // Check if response is directly an array or has a data property
        let dataArray = [];
        if (Array.isArray(response)) {
          dataArray = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          dataArray = response.data;
        } else {
        }

        if (dataArray.length > 0) {
          reportData = dataArray.map((item, index) => {
            return {
              sno: index + 1,
              rfID: item.rfID || "N/A",
              staffName: item.name || "N/A",
              fatherName: item.father_name || "N/A",
              designation: item.designation || "N/A",
              department: item.department || {
                name: "Department " + (item.departmentID || "Unknown"),
              },
              salary: item.totalSalary || item.basicSalary || 0,
              musterRoll: item.status === "present" ? "Present" : "Absent",
              // Additional fields for new reports
              appointedOn: item.appointedOn || "N/A",
              currentDeposit: item.currentDeposit || 0,
              depositUpto: item.depositUpto || 0,
              year: item.appointedOn
                ? new Date(item.appointedOn).getFullYear()
                : "N/A",
              leftDate: item.leaving_date || "N/A",
              returnDeposit: item.returnDeposit || 0,
            };
          });

          // Sort by designation according to the specified sequence (only for myskoolalhameed.myskool.app domain)
          const reportDomain = this.$store.state.report.replace(/_/g, "");
          const isAlhameedDomain = reportDomain === "myskoolalhameed";

          // Fallback: Check if we're on the myskoolalhameed domain by hostname
          const hostname = window.location.hostname;
          const isAlhameedByHostname =
            hostname === "myskoolalhameed.myskool.app";

          // Enable sorting only for specific formats
          const enableSortingForFormat = [
            "Staff List Muster Roll",
            "Staff List With Salary",
            "Increment list",
          ].includes(this.myObj.format);

          if (
            (isAlhameedDomain || isAlhameedByHostname) &&
            enableSortingForFormat
          ) {
            // Check if this is a primary staff department (you can modify this condition based on your business logic)
            const isPrimaryStaffDepartment =
              this.staffDepID && this.staffDepID !== 0;

            // Check if this is Secondary Boys Staff department
            const isSecondaryBoysStaff = this.staffDeparts.find(
              (dept) =>
                dept.id === this.staffDepID &&
                dept.name &&
                dept.name.toLowerCase().includes("secondary") &&
                dept.name.toLowerCase().includes("boys")
            );

            let designationOrder;

            // Department-specific top priorities
            const currDept2 = this.staffDeparts.find(
              (d) => d.id === this.staffDepID
            );
            const deptName2 = (
              currDept2 && currDept2.name ? currDept2.name : ""
            ).toLowerCase();
            const topByDepartment2 = [];
            if (deptName2 === "secondary boys staff") {
              topByDepartment2.push("SEC. INCH.(BOYS)");
            } else if (deptName2 === "nursery staff") {
              // Nursery Staff: Dy. ADM then Incharge then Coordinators
              topByDepartment2.push(
                "Dy. ADM.",
                "NUR.INCH",
                "INCHARGE",
                "Incharge",
                "COOR",
                "COOR. NUR.",
                "COOR. KG-II",
                "COOR. KG-I",
                "COOR. CLS-II",
                "COOR. CLS-I",
                "COOR. VII-VIII",
                "COOR. IX-X"
              );
            } else if (deptName2 === "lower secondary staff") {
              topByDepartment2.push("LOW. SEC. INCH.");
            } else if (deptName2 === "primary staff") {
              topByDepartment2.push("PRI.INCH.");
            } else if (deptName2 === "secondary girls staff") {
              topByDepartment2.push("PRIN.", "SEC. INCH.(GIRLS)");
            }

            let baseOrder2 = [
              "COOR. ADM.",
              "RECEP.",
              "ASST. ACCT",
              "CSHR & ASST. ACCT",
              "CASHIER",
              "STK. INCH.",
              "ASST. STK. INCH.",
              "COMP. LAB. ATT",
              "SCI. LAB. ATT",
              "SEC. OFCR.",
              "GRA. DES",
              "ELECTRICIAN",
              "BND. MAS.",
              "Teacher",
              "Dy. ADM.",
              "INCHARGE",
              "Incharge",
              ...(isPrimaryStaffDepartment
                ? [
                    "COOR",
                    "COOR. NUR.",
                    "COOR. KG-II",
                    "COOR. KG-I",
                    "COOR. CLS-II",
                    "COOR. CLS-I",
                    "COOR. VII-VIII",
                    "COOR. IX-X",
                  ]
                : []),
              "P.P.S.T",
              "P.S.T",
              "P.P.S.T(CO)",
              "QARIA",
              "J.S.T",
              "PRIN.",
              "MED CONSL.",
              "H.S.T",
              "MALE PEON",
              "LADY PEON",
              "CLEANING STAFF",
              "D/N WATCH MAN",
              "DRIVER",
              "Co - teacher",
              "GEN. OPR",
              "MUS. TCHR.",
            ];
            // For Secondary Boys Staff, ensure key coordinators come before reception
            if (deptName2 === "secondary boys staff") {
              const coordinatorPriority = ["COOR. VII-VIII", "COOR. IX-X"];
              const filtered = baseOrder2.filter(
                (d) => !coordinatorPriority.includes(d)
              );
              baseOrder2 = [...coordinatorPriority, ...filtered];
            }
            designationOrder = [...topByDepartment2, ...baseOrder2];

            // Debug specific designations
            const incharges = reportData.filter((item) =>
              item.designation.toLowerCase().includes("incharge")
            );
            const coordinators = reportData.filter((item) =>
              item.designation.toLowerCase().includes("coordinator")
            );
            const viiViiiCoordinators = reportData.filter(
              (item) =>
                item.designation.toLowerCase().includes("coordinator") &&
                item.designation.toLowerCase().includes("vii") &&
                item.designation.toLowerCase().includes("viii")
            );

            reportData.sort((a, b) => {
              // Helper function to find the best match in designationOrder
              const findDesignationIndex = (designation) => {
                // First try exact match
                let index = designationOrder.indexOf(designation);
                if (index !== -1) return index;

                // Try case-insensitive match
                index = designationOrder.findIndex(
                  (d) => d.toLowerCase() === designation.toLowerCase()
                );
                if (index !== -1) return index;

                // Try partial matching for coordinators and incharges
                const normalizedDesignation = designation.toLowerCase().trim();
                if (normalizedDesignation.includes("incharge")) {
                  index = designationOrder.findIndex((d) =>
                    d.toLowerCase().includes("incharge")
                  );
                  if (index !== -1) return index;
                }
                if (normalizedDesignation.includes("coordinator")) {
                  // For coordinators, try to match more specifically
                  if (
                    normalizedDesignation.includes("vii") &&
                    normalizedDesignation.includes("viii")
                  ) {
                    // Check for "Coordinator VII & VIII" first (without CLASS)
                    index = designationOrder.findIndex(
                      (d) =>
                        d.toLowerCase().includes("coordinator") &&
                        d.toLowerCase().includes("vii") &&
                        d.toLowerCase().includes("viii") &&
                        !d.toLowerCase().includes("class")
                    );
                    if (index !== -1) return index;

                    // Then check for "Coordinator CLASS VII & VIII"
                    index = designationOrder.findIndex(
                      (d) =>
                        d.toLowerCase().includes("coordinator") &&
                        d.toLowerCase().includes("class") &&
                        d.toLowerCase().includes("vii") &&
                        d.toLowerCase().includes("viii")
                    );
                    if (index !== -1) return index;
                  }

                  // General coordinator matching
                  index = designationOrder.findIndex((d) =>
                    d.toLowerCase().includes("coordinator")
                  );
                  if (index !== -1) return index;
                }

                // Try to match variations (handle P.P.S.T, P.S.T, PST variations)
                const cleanDesignation = designation
                  .replace(/[().]/g, "")
                  .toLowerCase();
                index = designationOrder.findIndex(
                  (d) =>
                    d.replace(/[().]/g, "").toLowerCase() === cleanDesignation
                );
                if (index !== -1) return index;

                // Handle common typos and variations
                const commonTypos = {
                  receptionis: "receptionist",
                  coordinator: "coordinator",
                  ppst: "p.p.s.t",
                  pst: "p.s.t",
                  "ppst(co)": "p.p.s.t(co)",
                  "ppst(co)": "p.p.s.t(co)",
                  "coordinator vii & viii": "coordinator class vii & viii",
                  "coordinator vii": "coordinator class vii & viii",
                  "p.p.s.t(co)": "p.p.s.t(co)",
                  "p.p.s.t(co)": "p.p.s.t(co)",
                  "p.s.t": "p.s.t",
                  incharge: "incharge",
                  "deputy administrator": "deputy administrator",
                  "h.s.t": "h.s.t",
                };

                const normalizedInput = designation.toLowerCase().trim();
                if (commonTypos[normalizedInput]) {
                  const correctedDesignation = commonTypos[normalizedInput];
                  index = designationOrder.findIndex(
                    (d) => d.toLowerCase() === correctedDesignation
                  );
                  if (index !== -1) return index;
                }

                // Debug specific designation
                if (
                  designation.includes("VII") ||
                  designation.includes("VIII")
                ) {
                  const viiIndex = designationOrder.findIndex((d) =>
                    d.includes("VII")
                  );
                }

                // Debug P.P.S.T and P.S.T designations
                if (
                  designation.includes("P.P.S.T") ||
                  designation.includes("P.S.T") ||
                  designation.includes("PST")
                ) {
                  const ppstIndex = designationOrder.findIndex((d) =>
                    d.includes("P.P.S.T")
                  );
                  const pstIndex = designationOrder.findIndex((d) =>
                    d.includes("P.S.T")
                  );
                }

                // Debug specific problematic designations
                if (
                  designation.includes("Deputy") ||
                  designation.includes("H.S.T") ||
                  designation.includes("Incharge") ||
                  designation.includes("INCHARGE")
                ) {
                  const deputyIndex = designationOrder.findIndex((d) =>
                    d.includes("Deputy")
                  );
                  const hstIndex = designationOrder.findIndex((d) =>
                    d.includes("H.S.T")
                  );
                  const inchargeIndex = designationOrder.findIndex((d) =>
                    d.includes("Incharge")
                  );
                }

                // Try partial matching for common words
                const partialMatches = {
                  reception: "receptionist",
                  coordinator: "coordinator",
                  ppst: "p.p.s.t",
                  pst: "p.s.t",
                  "vii & viii": "coordinator class vii & viii",
                  vii: "coordinator class vii & viii",
                  "p.p.s.t": "p.p.s.t",
                  "p.s.t": "p.s.t",
                };

                for (const [partial, full] of Object.entries(partialMatches)) {
                  if (normalizedInput.includes(partial)) {
                    index = designationOrder.findIndex((d) =>
                      d.toLowerCase().includes(full)
                    );
                    if (index !== -1) return index;
                  }
                }

                return -1;
              };

              const aIndex = findDesignationIndex(a.designation);
              const bIndex = findDesignationIndex(b.designation);

              // If both designations are in the order list, sort by their position
              if (aIndex !== -1 && bIndex !== -1) {
                return aIndex - bIndex;
              }
              // If only 'a' is in the order list, it comes first
              if (aIndex !== -1 && bIndex === -1) {
                return -1;
              }
              // If only 'b' is in the order list, it comes first
              if (aIndex === -1 && bIndex !== -1) {
                return 1;
              }
              // If neither is in the order list, sort alphabetically
              return a.designation.localeCompare(b.designation);
            });
          }

          // Additional sorting for new report types by date
          if (
            this.myObj.format === "New staff list" ||
            this.myObj.format === "New staff left list"
          ) {
            reportData.sort((a, b) => {
              const dateA = new Date(a.appointedOn);
              const dateB = new Date(b.appointedOn);

              // Handle invalid dates
              if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
              if (isNaN(dateA.getTime())) return 1;
              if (isNaN(dateB.getTime())) return -1;

              // Sort in ascending order (oldest first)
              return dateA - dateB;
            });
          }

          // Update serial numbers after sorting
          reportData.forEach((item, index) => {
            item.sno = index + 1;
          });
        }

        // Create styled HTML report
        this.createStyledStaffReport(reportData);
      } catch (error) {
        console.error("Error loading staff report:", error);
        this.$bvToast.toast("Failed to load staff report.", {
          title: this.$t("Error"),
          variant: "danger",
        });
      } finally {
        this.stLoading = false;
      }
    },

    createStyledStaffReport(data) {
      const reportTitle =
        this.myObj.format === "Staff List Muster Roll"
          ? "Staff List Muster Roll"
          : this.myObj.format === "Staff List With Salary"
          ? "Staff List With Salary"
          : this.myObj.format === "New staff list"
          ? "New Staff List"
          : this.myObj.format === "New staff left list"
          ? "New Staff Left List"
          : this.myObj.format === "Increment list"
          ? "Increment List"
          : this.myObj.format === "File cover"
          ? "File Cover"
          : this.myObj.format;

      // Create content based on format
      let mainContentHtml = "";

      if (this.myObj.format === "Staff List Muster Roll") {
        // Sequential list layout for muster roll
        mainContentHtml = `
          <div class="muster-roll-list-container mt-3">
            ${data
              .map((item, index) => {
                return `
                <div class="muster-roll-list-item">
                  <span class="muster-roll-sno">${item.sno}.</span>
                  <span class="muster-roll-name"><span class="muster-rfid-inline">${item.rfID}</span> ${item.staffName}</span>
                  <span class="muster-roll-designation">${item.designation}</span>
                </div>
              `;
              })
              .join("")}
          </div>
        `;
      } else if (this.myObj.format === "Staff List With Salary") {
        // Table layout for salary report
        const tableRows = data
          .map((item) => {
            return `
            <tr>
              <td class="text-center font-weight-semibold">${item.sno}</td>
              <td class="text-center font-weight-semibold text-primary">${
                item.rfID
              }</td>
              <td class="text-center font-weight-semibold">${
                item.staffName
              }</td>
              <td class="text-center font-weight-semibold">${
                item.fatherName
              }</td>
              <td class="text-center font-weight-semibold">${
                item.designation
              }</td>
              <td class="text-center font-weight-semibold">${this.formatDate(
                item.appointedOn
              )}</td>
              <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                item.salary
              )}</td>
            </tr>
          `;
          })
          .join("");

        const tableHeaders = `
          <th class="text-center">S.NO</th>
          <th class="text-center">RFID</th>
          <th class="text-center">Staff Name</th>
          <th class="text-center">Father Name</th>
          <th class="text-center">Designation</th>
          <th class="text-center">Appointed On</th>
          <th class="text-center">Salary</th>
        `;

        mainContentHtml = `
          <div class="table-responsive mt-3">
            <table class="table table-bordered">
              <thead>
                <tr>
                  ${tableHeaders}
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
            </table>
          </div>
        `;
      } else if (this.myObj.format === "New staff list") {
        // Check if "All Departments" is selected (staffDepID === 0)
        const isAllDepartments =
          this.staffDepID === 0 ||
          (Array.isArray(this.staffDepID) && this.staffDepID[0] === 0);

        // Check if this is the Al Hameed domain
        const reportDomain = this.$store.state.report.replace(/_/g, "");
        const isAlhameedDomain = reportDomain === "myskoolalhameed";

        if (isAllDepartments && !isAlhameedDomain) {
          // Group data by department for normal domains
          const groupedData = {};
          data.forEach((item) => {
            const deptName =
              item.department && item.department.name
                ? item.department.name
                : "Unknown Department";
            if (!groupedData[deptName]) {
              groupedData[deptName] = [];
            }
            groupedData[deptName].push(item);
          });

          // Create department-wise sections
          let departmentSections = "";
          let totalRecords = 0;

          Object.keys(groupedData)
            .sort()
            .forEach((deptName) => {
              const deptData = groupedData[deptName];
              const deptCount = deptData.length;
              totalRecords += deptCount;

              // Update serial numbers for this department
              deptData.forEach((item, index) => {
                item.sno = index + 1;
              });

              // Calculate totals for this department
              const totalSalary = deptData.reduce(
                (sum, item) => sum + (item.salary || 0),
                0
              );
              const totalCurrentDeposit = deptData.reduce(
                (sum, item) => sum + (item.currentDeposit || 0),
                0
              );
              const totalDepositUpto = deptData.reduce(
                (sum, item) => sum + (item.depositUpto || 0),
                0
              );

              const tableRows = deptData
                .map((item) => {
                  return `
                <tr>
                  <td class="text-center font-weight-semibold">${item.sno}</td>
                  <td class="text-center font-weight-semibold">${
                    item.staffName
                  }</td>
                  <td class="text-center font-weight-semibold">${this.formatDate(
                    item.appointedOn
                  )}</td>
                  <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                    item.salary
                  )}</td>
                  <td class="text-center font-weight-bold text-info">${this.formatCurrency(
                    item.currentDeposit
                  )}</td>
                  <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                    item.depositUpto
                  )}</td>
                </tr>
              `;
                })
                .join("");

              const tableHeaders = `
              <th class="text-center">S.NO</th>
              <th class="text-center">Teacher Name</th>
              <th class="text-center">Date of Appointment</th>
              <th class="text-center">Salary Details</th>
              <th class="text-center">Current Deposit</th>
              <th class="text-center">Deposit Upto</th>
            `;

              departmentSections += `
              <div class="department-section mb-4">
                <div class="department-heading">
                  <h5 class="mb-0">${deptName}</h5>
                </div>
                <div class="table-responsive mt-3">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        ${tableHeaders}
                      </tr>
                    </thead>
                    <tbody>
                      ${tableRows}
                      <tr class="table-info">
                        <td colspan="3" class="text-right font-weight-bold">TOTAL:</td>
                        <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                          totalSalary
                        )}</td>
                        <td class="text-center font-weight-bold text-info">${this.formatCurrency(
                          totalCurrentDeposit
                        )}</td>
                        <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                          totalDepositUpto
                        )}</td>
                      </tr>
                      <tr class="table-secondary">
                        <td colspan="6" class="text-right font-weight-bold">Total: ${deptCount} records</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            `;
            });

          mainContentHtml = `
            ${departmentSections}
          `;
        } else {
          // Original single table layout for specific department or Al Hameed domain
          const tableRows = data
            .map((item) => {
              let rowContent = `
              <tr>
                <td class="text-center font-weight-semibold">${item.sno}</td>
                <td class="text-center font-weight-semibold">${item.staffName}</td>`;

              // Add department column only if "All Departments" is selected
              if (isAllDepartments) {
                const departmentName =
                  item.department && item.department.name
                    ? item.department.name
                    : "N/A";
                rowContent += `<td class="text-center font-weight-semibold">${departmentName}</td>`;
              }

              rowContent += `
                <td class="text-center font-weight-semibold">${this.formatDate(
                  item.appointedOn
                )}</td>
                <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                  item.salary
                )}</td>
                <td class="text-center font-weight-bold text-info">${this.formatCurrency(
                  item.currentDeposit
                )}</td>
                <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                  item.depositUpto
                )}</td>
              </tr>
            `;
              return rowContent;
            })
            .join("");

          let tableHeaders = `
            <th class="text-center">S.NO</th>
            <th class="text-center">Teacher Name</th>`;

          // Add department header only if "All Departments" is selected
          if (isAllDepartments) {
            tableHeaders += `<th class="text-center">Department</th>`;
          }

          tableHeaders += `
            <th class="text-center">Date of Appointment</th>
            <th class="text-center">Salary Details</th>
            <th class="text-center">Current Deposit</th>
            <th class="text-center">Deposit Upto</th>
          `;

          // Add department heading above table
          let departmentHeading = "";
          if (data.length > 0) {
            let departmentName = "";

            if (isAllDepartments) {
              departmentName = "All Departments";
            } else {
              const selectedDepartment = this.staffDeparts.find(
                (dept) => dept.id === this.staffDepID
              );
              departmentName = selectedDepartment
                ? selectedDepartment.name
                : data[0].department && data[0].department.name
                ? data[0].department.name
                : "Selected Department";
            }

            departmentHeading = `
              <div class="department-heading">
                <h5 class="mb-0">${departmentName}</h5>
              </div>
            `;
          }

          // Calculate totals for specific department
          const totalSalary = data.reduce(
            (sum, item) => sum + (item.salary || 0),
            0
          );
          const totalCurrentDeposit = data.reduce(
            (sum, item) => sum + (item.currentDeposit || 0),
            0
          );
          const totalDepositUpto = data.reduce(
            (sum, item) => sum + (item.depositUpto || 0),
            0
          );

          // Add totals row for specific department
          let totalsRow = "";
          if (data.length > 0) {
            let colspan = 3; // S.NO, Teacher Name, Date of Appointment
            if (isAllDepartments) {
              colspan += 1; // Department column
            }

            totalsRow = `
              <tr class="table-info">
                <td colspan="${colspan}" class="text-right font-weight-bold">TOTAL:</td>
                <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                  totalSalary
                )}</td>
                <td class="text-center font-weight-bold text-info">${this.formatCurrency(
                  totalCurrentDeposit
                )}</td>
                <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                  totalDepositUpto
                )}</td>
              </tr>
              <tr class="table-secondary">
                <td colspan="${
                  colspan + 3
                }" class="text-right font-weight-bold">Total: ${
              data.length
            } records</td>
              </tr>
            `;
          }

          mainContentHtml = `
            ${departmentHeading}
            <div class="table-responsive mt-3">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    ${tableHeaders}
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                  ${totalsRow}
                </tbody>
              </table>
            </div>
          `;
        }
      } else if (this.myObj.format === "New staff left list") {
        // Check if "All Departments" is selected (staffDepID === 0)
        const isAllDepartments =
          this.staffDepID === 0 ||
          (Array.isArray(this.staffDepID) && this.staffDepID[0] === 0);

        // Check if this is the Al Hameed domain
        const reportDomain = this.$store.state.report.replace(/_/g, "");
        const isAlhameedDomain = reportDomain === "myskoolalhameed";

        if (isAllDepartments && !isAlhameedDomain) {
          // Group data by department for normal domains
          const groupedData = {};
          data.forEach((item) => {
            const deptName =
              item.department && item.department.name
                ? item.department.name
                : "Unknown Department";
            if (!groupedData[deptName]) {
              groupedData[deptName] = [];
            }
            groupedData[deptName].push(item);
          });

          // Create department-wise sections
          let departmentSections = "";
          let totalRecords = 0;

          Object.keys(groupedData)
            .sort()
            .forEach((deptName) => {
              const deptData = groupedData[deptName];
              const deptCount = deptData.length;
              totalRecords += deptCount;

              // Update serial numbers for this department
              deptData.forEach((item, index) => {
                item.sno = index + 1;
              });

              // Calculate totals for this department
              const totalSalary = deptData.reduce(
                (sum, item) => sum + (item.salary || 0),
                0
              );
              const totalDepositUpto = deptData.reduce(
                (sum, item) => sum + (item.depositUpto || 0),
                0
              );
              const totalReturnDeposit = deptData.reduce(
                (sum, item) => sum + (item.returnDeposit || 0),
                0
              );

              const tableRows = deptData
                .map((item) => {
                  return `
                <tr>
                  <td class="text-center font-weight-semibold">${item.sno}</td>
                  <td class="text-center font-weight-semibold">${
                    item.staffName
                  }</td>
                  <td class="text-center font-weight-semibold">${this.formatDate(
                    item.appointedOn
                  )}</td>
                  <td class="text-center font-weight-semibold">${this.formatDate(
                    item.leftDate
                  )}</td>
                  <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                    item.salary
                  )}</td>
                  <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                    item.depositUpto
                  )}</td>
                  <td class="text-center font-weight-bold text-danger">${this.formatCurrency(
                    item.returnDeposit
                  )}</td>
                </tr>
              `;
                })
                .join("");

              const tableHeaders = `
              <th class="text-center">S.NO</th>
              <th class="text-center">Name</th>
              <th class="text-center">Date of Appointment</th>
              <th class="text-center">Left Date</th>
              <th class="text-center">Salary Details</th>
              <th class="text-center">Deposit Upto</th>
              <th class="text-center">Return Deposit</th>
            `;

              departmentSections += `
              <div class="department-section mb-4">
                <div class="department-heading">
                  <h5 class="mb-0">${deptName}</h5>
                </div>
                <div class="table-responsive mt-3">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        ${tableHeaders}
                      </tr>
                    </thead>
                    <tbody>
                      ${tableRows}
                      <tr class="table-info">
                        <td colspan="4" class="text-right font-weight-bold">TOTAL:</td>
                        <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                          totalSalary
                        )}</td>
                        <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                          totalDepositUpto
                        )}</td>
                        <td class="text-center font-weight-bold text-danger">${this.formatCurrency(
                          totalReturnDeposit
                        )}</td>
                      </tr>
                      <tr class="table-secondary">
                        <td colspan="7" class="text-right font-weight-bold">Total: ${deptCount} records</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            `;
            });

          mainContentHtml = `
            ${departmentSections}
          `;
        } else {
          // Original single table layout for specific department or Al Hameed domain
          const tableRows = data
            .map((item) => {
              let rowContent = `
              <tr>
                <td class="text-center font-weight-semibold">${item.sno}</td>
                <td class="text-center font-weight-semibold">${item.staffName}</td>`;

              // Add department column only if "All Departments" is selected
              if (isAllDepartments) {
                const departmentName =
                  item.department && item.department.name
                    ? item.department.name
                    : "N/A";
                rowContent += `<td class="text-center font-weight-semibold">${departmentName}</td>`;
              }

              rowContent += `
                <td class="text-center font-weight-semibold">${this.formatDate(
                  item.appointedOn
                )}</td>
                <td class="text-center font-weight-semibold">${this.formatDate(
                  item.leftDate
                )}</td>
                <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                  item.salary
                )}</td>
                <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                  item.depositUpto
                )}</td>
                <td class="text-center font-weight-bold text-danger">${this.formatCurrency(
                  item.returnDeposit
                )}</td>
              </tr>
            `;
              return rowContent;
            })
            .join("");

          let tableHeaders = `
            <th class="text-center">S.NO</th>
            <th class="text-center">Name</th>`;

          // Add department header only if "All Departments" is selected
          if (isAllDepartments) {
            tableHeaders += `<th class="text-center">Department</th>`;
          }

          tableHeaders += `
            <th class="text-center">Date of Appointment</th>
            <th class="text-center">Left Date</th>
            <th class="text-center">Salary Details</th>
            <th class="text-center">Deposit Upto</th>
            <th class="text-center">Return Deposit</th>
          `;

          // Add department heading above table
          let departmentHeading = "";
          if (data.length > 0) {
            let departmentName = "";

            if (isAllDepartments) {
              departmentName = "All Departments";
            } else {
              const selectedDepartment = this.staffDeparts.find(
                (dept) => dept.id === this.staffDepID
              );
              departmentName = selectedDepartment
                ? selectedDepartment.name
                : data[0].department && data[0].department.name
                ? data[0].department.name
                : "Selected Department";
            }

            departmentHeading = `
              <div class="department-heading">
                <h5 class="mb-0">${departmentName}</h5>
              </div>
            `;
          }

          // Calculate totals for specific department
          const totalSalary = data.reduce(
            (sum, item) => sum + (item.salary || 0),
            0
          );
          const totalDepositUpto = data.reduce(
            (sum, item) => sum + (item.depositUpto || 0),
            0
          );
          const totalReturnDeposit = data.reduce(
            (sum, item) => sum + (item.returnDeposit || 0),
            0
          );

          // Add totals row for specific department
          let totalsRow = "";
          if (data.length > 0) {
            let colspan = 4; // S.NO, Name, Date of Appointment, Left Date
            if (isAllDepartments) {
              colspan += 1; // Department column
            }

            totalsRow = `
              <tr class="table-info">
                <td colspan="${colspan}" class="text-right font-weight-bold">TOTAL:</td>
                <td class="text-center font-weight-bold text-success">${this.formatCurrency(
                  totalSalary
                )}</td>
                <td class="text-center font-weight-bold text-warning">${this.formatCurrency(
                  totalDepositUpto
                )}</td>
                <td class="text-center font-weight-bold text-danger">${this.formatCurrency(
                  totalReturnDeposit
                )}</td>
              </tr>
              <tr class="table-secondary">
                <td colspan="${
                  colspan + 3
                }" class="text-right font-weight-bold">Total: ${
              data.length
            } records</td>
              </tr>
            `;
          }

          mainContentHtml = `
            ${departmentHeading}
            <div class="table-responsive mt-3">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    ${tableHeaders}
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                  ${totalsRow}
                </tbody>
              </table>
            </div>
          `;
        }
      } else if (this.myObj.format === "Increment list") {
        // Check if "All Departments" is selected (staffDepID === 0)
        const isAllDepartments =
          this.staffDepID === 0 ||
          (Array.isArray(this.staffDepID) && this.staffDepID[0] === 0);

        // Check if this is the Al Hameed domain
        const reportDomain = this.$store.state.report.replace(/_/g, "");
        const isAlhameedDomain = reportDomain === "myskoolalhameed";
        const isStJacobDomain = reportDomain === "myskoolstjacob";

        if (isStJacobDomain) {
          // Group data by department for St Jacob
          const groupedData = {};
          data.forEach((item) => {
            const deptName =
              item.department && item.department.name
                ? item.department.name
                : "Unknown Department";
            if (!groupedData[deptName]) {
              groupedData[deptName] = [];
            }
            groupedData[deptName].push(item);
          });

          // Create department-wise sections
          let departmentSections = "";

          Object.keys(groupedData)
            .sort()
            .forEach((deptName) => {
              const deptData = groupedData[deptName];

              // Update serial numbers
              deptData.forEach((item, index) => {
                item.sno = index + 1;
              });

              const tableRows = deptData
                .map((item) => {
                  const increments = item.incrementDetails || [];
                  // Sort descending for backwards calculation
                  const sortedInc = [...increments].sort(
                    (a, b) =>
                      new Date(b.incrementDate) - new Date(a.incrementDate)
                  );

                  let currentSalary = item.basicSalary;
                  const history = [];

                  if (sortedInc.length > 0) {
                    sortedInc.forEach((inc) => {
                      let amount = 0;
                      if (typeof inc.incrementAmount === "string") {
                        amount = parseFloat(inc.incrementAmount) || 0;
                      } else {
                        amount = inc.incrementAmount || 0;
                      }

                      const prev = currentSalary - amount;
                      history.unshift({
                        date: inc.incrementDate,
                        prev: prev,
                        amount: amount,
                        new: currentSalary,
                      });
                      currentSalary = prev;
                    });
                  } else {
                    history.push({
                      date: null,
                      prev: item.basicSalary,
                      amount: 0,
                      new: item.basicSalary,
                    });
                  }

                  return history
                    .map((h, i) => {
                      const year = h.date
                        ? new Date(h.date).getFullYear()
                        : "-";
                      const showMeta = i === 0;
                      const rowSpan = history.length;

                      if (showMeta) {
                        return `
                    <tr>
                      <td class="text-center font-weight-semibold" rowspan="${rowSpan}" style="vertical-align: middle;">${
                          item.sno
                        }</td>
                      <td class="text-left font-weight-semibold" rowspan="${rowSpan}" style="vertical-align: middle;">${
                          item.staffName
                        }</td>
                      <td class="text-left font-weight-semibold" rowspan="${rowSpan}" style="vertical-align: middle;">${
                          item.designation
                        }</td>
                      <td class="text-center">${year}</td>
                      <td class="text-right">${this.formatCurrency(h.prev)}</td>
                      <td class="text-right font-weight-bold text-success">${this.formatCurrency(
                        h.amount
                      )}</td>
                      <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                        h.new
                      )}</td>
                    </tr>
                    `;
                      } else {
                        return `
                    <tr>
                      <td class="text-center">${year}</td>
                      <td class="text-right">${this.formatCurrency(h.prev)}</td>
                      <td class="text-right font-weight-bold text-success">${this.formatCurrency(
                        h.amount
                      )}</td>
                      <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                        h.new
                      )}</td>
                    </tr>
                    `;
                      }
                    })
                    .join("");
                })
                .join("");

              const tableHeaders = `
                <th class="text-center">S.NO</th>
                <th class="text-center">Staff Name</th>
                <th class="text-center">Designation</th>
                <th class="text-center">Year</th>
                <th class="text-center">Previous Salary</th>
                <th class="text-center">Increment Amount</th>
                <th class="text-center">Current Salary</th>
              `;

              departmentSections += `
                <div class="department-section mb-4">
                  <div class="department-heading">
                    <h5 class="mb-0">${deptName}</h5>
                  </div>
                  <div class="table-responsive mt-3">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          ${tableHeaders}
                        </tr>
                      </thead>
                      <tbody>
                        ${tableRows}
                        <tr class="table-secondary">
                          <td colspan="7" class="text-right font-weight-bold">Total: ${deptData.length} records</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              `;
            });

          mainContentHtml = departmentSections;
        } else if (isAllDepartments && !isAlhameedDomain) {
          // Group data by department for normal domains
          const groupedData = {};
          data.forEach((item) => {
            const deptName =
              item.department && item.department.name
                ? item.department.name
                : "Unknown Department";
            if (!groupedData[deptName]) {
              groupedData[deptName] = [];
            }
            groupedData[deptName].push(item);
          });

          // Create department-wise sections
          let departmentSections = "";
          let totalRecords = 0;

          Object.keys(groupedData)
            .sort()
            .forEach((deptName) => {
              const deptData = groupedData[deptName];
              const deptCount = deptData.length;
              totalRecords += deptCount;

              // Update serial numbers for this department
              deptData.forEach((item, index) => {
                item.sno = index + 1;
              });

              const tableRows = deptData
                .map((item) => {
                  return `
                <tr>
                  <td class="text-center font-weight-semibold">${item.sno}</td>
                  <td class="text-left font-weight-semibold">${
                    item.staffName
                  }</td>
                  <td class="text-left font-weight-semibold">${
                    item.designation
                  }</td>
                  <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                    item.basicSalary
                  )}</td>
                  <td class="text-right font-weight-bold text-warning">${
                    this.isAlhameedDomain
                      ? this.formatCurrency(item.totalIncrementAmount)
                      : typeof item.totalIncrementAmount === "string" &&
                        item.totalIncrementAmount.includes(",")
                      ? item.totalIncrementAmount
                      : this.formatCurrency(
                          typeof item.totalIncrementAmount === "string"
                            ? parseFloat(item.totalIncrementAmount) || 0
                            : item.totalIncrementAmount
                        )
                  }</td>
                  <td class="text-center font-weight-bold text-info">${
                    item.incrementCount
                  }</td>
                </tr>
              `;
                })
                .join("");

              // Calculate totals for this department
              const totalSalary = deptData.reduce(
                (sum, item) => sum + item.basicSalary,
                0
              );
              let totalIncrement, totalIncrementCount;

              if (isAlhameedDomain) {
                totalIncrement = deptData.reduce(
                  (sum, item) => sum + (item.totalIncrementAmount || 0),
                  0
                );
                totalIncrementCount = deptData.reduce(
                  (sum, item) => sum + (item.incrementCount || 0),
                  0
                );
              } else {
                // For normal domains, calculate total from incrementDetails or totalIncrementAmount
                totalIncrement = deptData.reduce((sum, item) => {
                  // First try to get from incrementDetails if available
                  if (
                    item.incrementDetails &&
                    item.incrementDetails.length > 0
                  ) {
                    return (
                      sum +
                      item.incrementDetails.reduce(
                        (detailSum, detail) =>
                          detailSum + (detail.incrementAmount || 0),
                        0
                      )
                    );
                  }
                  // Fallback to totalIncrementAmount with proper number conversion
                  if (item.totalIncrementAmount) {
                    const incrementAmount =
                      typeof item.totalIncrementAmount === "string"
                        ? parseFloat(item.totalIncrementAmount) || 0
                        : item.totalIncrementAmount;
                    return sum + incrementAmount;
                  }
                  return sum;
                }, 0);
                totalIncrementCount = deptData.reduce(
                  (sum, item) => sum + (item.incrementCount || 0),
                  0
                );
              }

              const totalsRow = `
              <tr class="table-info">
                <td colspan="3" class="text-right font-weight-bold">TOTAL:</td>
                <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                  totalSalary
                )}</td>
                <td class="text-right font-weight-bold text-warning">${
                  isAlhameedDomain
                    ? this.formatCurrency(totalIncrement)
                    : this.formatCurrency(totalIncrement)
                }</td>
                <td class="text-center font-weight-bold text-info">${totalIncrementCount}</td>
              </tr>
            `;

              const tableHeaders = `
              <th class="text-center">S.NO</th>
              <th class="text-center">Staff Name</th>
              <th class="text-center">Designation</th>
              <th class="text-center">Current Salary</th>
              <th class="text-center">Increment Amount</th>
              <th class="text-center">Increment Count</th>
            `;

              departmentSections += `
              <div class="department-section mb-4">
                <div class="department-heading">
                  <h5 class="mb-0">${deptName}</h5>
                </div>
                <div class="table-responsive mt-3">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        ${tableHeaders}
                      </tr>
                    </thead>
                    <tbody>
                      ${tableRows}
                      ${totalsRow}
                      <tr class="table-secondary">
                        <td colspan="6" class="text-right font-weight-bold">Total: ${deptCount} records</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            `;
            });

          // Add year range heading for normal domains
          let yearRangeHeading = "";
          if (!isAlhameedDomain && this.getYearRange()) {
            yearRangeHeading = `
              <div class="year-range-heading mb-3">
                <h4 class="text-center text-primary font-weight-bold">Year: ${this.getYearRange()}</h4>
              </div>
            `;
          }

          mainContentHtml = `
            ${yearRangeHeading}
            ${departmentSections}
          `;
        } else {
          // Original single table layout for specific department or Al Hameed domain
          const tableRows = data
            .map((item) => {
              let rowContent = `
              <tr>
                <td class="text-center font-weight-semibold">${item.sno}</td>`;

              // Add staff code column for Alhameed domain
              if (isAlhameedDomain) {
                rowContent += `<td class="text-center font-weight-semibold">${
                  item.staffID || "N/A"
                }</td>`;
              }

              rowContent += `
                <td class="text-center font-weight-semibold">${item.staffName}</td>
                <td class="text-center font-weight-semibold">${item.designation}</td>`;

              // Add department column only if "All Departments" is selected
              if (isAllDepartments) {
                const departmentName =
                  item.department && item.department.name
                    ? item.department.name
                    : "N/A";
                rowContent += `<td class="text-center font-weight-semibold">${departmentName}</td>`;
              }

              if (isAlhameedDomain) {
                // For Alhameed domain: show previous salary, next salary, total increment, and last increment date
                const previousSalary =
                  item.basicSalary - (item.totalIncrementAmount || 0);
                const nextSalary = item.basicSalary;
                const totalIncrement = item.totalIncrementAmount || 0;
                const lastIncrementDate =
                  item.incrementDetails && item.incrementDetails.length > 0
                    ? this.formatDate(
                        item.incrementDetails[item.incrementDetails.length - 1]
                          .incrementDate
                      )
                    : "N/A";

                rowContent += `
                <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                  previousSalary
                )}</td>
                <td class="text-right font-weight-bold text-success">${this.formatCurrency(
                  nextSalary
                )}</td>
                <td class="text-right font-weight-bold text-warning">${this.formatCurrency(
                  totalIncrement
                )}</td>
                <td class="text-center font-weight-semibold">${lastIncrementDate}</td>`;
              } else {
                // For other domains: show columns without year (year shown at top)
                rowContent += `
                <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                  item.basicSalary
                )}</td>
                <td class="text-right font-weight-bold text-warning">${
                  typeof item.totalIncrementAmount === "string" &&
                  item.totalIncrementAmount.includes(",")
                    ? item.totalIncrementAmount
                    : this.formatCurrency(
                        typeof item.totalIncrementAmount === "string"
                          ? parseFloat(item.totalIncrementAmount) || 0
                          : item.totalIncrementAmount
                      )
                }</td>
                <td class="text-center font-weight-bold text-info">${
                  item.incrementCount
                }</td>`;
              }

              rowContent += `
              </tr>
            `;
              return rowContent;
            })
            .join("");

          // Add totals row for both Alhameed and normal increment lists
          let totalsRow = "";
          if (data.length > 0) {
            if (isAlhameedDomain) {
              // Calculate totals for Alhameed domain
              const totalPreviousSalary = data.reduce((sum, item) => {
                const previousSalary =
                  item.basicSalary - (item.totalIncrementAmount || 0);
                return sum + previousSalary;
              }, 0);

              const totalNextSalary = data.reduce(
                (sum, item) => sum + item.basicSalary,
                0
              );

              const totalIncrement = data.reduce(
                (sum, item) => sum + (item.totalIncrementAmount || 0),
                0
              );

              // Count columns to determine colspan for Alhameed domain
              let colspan = 4; // S.NO, Staff Code, Staff Name, Designation
              if (isAllDepartments) {
                colspan += 1; // Department column
              }

              totalsRow = `
                <tr class="table-info">
                  <td colspan="${colspan}" class="text-right font-weight-bold">TOTAL:</td>
                  <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                    totalPreviousSalary
                  )}</td>
                  <td class="text-right font-weight-bold text-success">${this.formatCurrency(
                    totalNextSalary
                  )}</td>
                  <td class="text-right font-weight-bold text-warning">${this.formatCurrency(
                    totalIncrement
                  )}</td>
                  <td class="text-center font-weight-bold">-</td>
                </tr>
              `;
            } else {
              // Calculate totals for normal increment list
              const totalSalary = data.reduce(
                (sum, item) => sum + (item.basicSalary || 0),
                0
              );

              // Fix totalIncrement calculation to handle both string and number values
              const totalIncrement = data.reduce((sum, item) => {
                // First try to get from incrementDetails if available
                if (item.incrementDetails && item.incrementDetails.length > 0) {
                  return (
                    sum +
                    item.incrementDetails.reduce(
                      (detailSum, detail) =>
                        detailSum + (detail.incrementAmount || 0),
                      0
                    )
                  );
                }

                let incrementAmount = 0;
                if (item.totalIncrementAmount) {
                  // Convert to number if it's a string
                  incrementAmount =
                    typeof item.totalIncrementAmount === "string"
                      ? parseFloat(item.totalIncrementAmount) || 0
                      : item.totalIncrementAmount;
                }
                return sum + incrementAmount;
              }, 0);

              const totalIncrementCount = data.reduce(
                (sum, item) => sum + (item.incrementCount || 0),
                0
              );

              // Count columns to determine colspan for normal increment list
              let colspan = 3; // S.NO, Staff Name, Designation
              if (isAllDepartments) {
                colspan += 1; // Department column
              }

              totalsRow = `
                <tr class="table-info">
                  <td colspan="${colspan}" class="text-right font-weight-bold">TOTAL:</td>
                  <td class="text-right font-weight-bold text-primary">${this.formatCurrency(
                    totalSalary
                  )}</td>
                  <td class="text-right font-weight-bold text-warning">${this.formatCurrency(
                    totalIncrement
                  )}</td>
                  <td class="text-center font-weight-bold text-info">${totalIncrementCount}</td>
                </tr>
              `;
            }
          }

          let tableHeaders = `
            <th class="text-center">S.NO</th>`;

          // Add staff code header for Alhameed domain
          if (isAlhameedDomain) {
            tableHeaders += `<th class="text-center">Staff Code</th>`;
          }

          tableHeaders += `
            <th class="text-center">Staff Name</th>
            <th class="text-center">Designation</th>`;

          // Add department header only if "All Departments" is selected
          if (isAllDepartments) {
            tableHeaders += `<th class="text-center">Department</th>`;
          }

          if (isAlhameedDomain) {
            tableHeaders += `
              <th class="text-center">Previous Salary</th>
              <th class="text-center">Next Salary</th>
              <th class="text-center">Total Increment</th>
              <th class="text-center">Last Increment Date</th>
            `;
          } else {
            tableHeaders += `
            <th class="text-center">Current Salary</th>
            <th class="text-center">Increment Amount</th>
            <th class="text-center">Increment Count</th>
          `;
          }

          // Add department heading above table
          let departmentHeading = "";
          if (data.length > 0) {
            let departmentName = "";

            if (isAllDepartments) {
              departmentName = "All Departments";
            } else {
              const selectedDepartment = this.staffDeparts.find(
                (dept) => dept.id === this.staffDepID
              );
              departmentName = selectedDepartment
                ? selectedDepartment.name
                : data[0].department && data[0].department.name
                ? data[0].department.name
                : "Selected Department";
            }

            departmentHeading = `
              <div class="department-heading">
                <h5 class="mb-0">${departmentName}</h5>
              </div>
            `;
          }

          // Add year range heading for normal domains (single table)
          let yearRangeHeading = "";
          if (!isAlhameedDomain && this.getYearRange()) {
            yearRangeHeading = `
              <div class="year-range-heading mb-3">
                <h4 class="text-center text-primary font-weight-bold">Year: ${this.getYearRange()}</h4>
              </div>
            `;
          }

          mainContentHtml = `
            ${yearRangeHeading}
            ${departmentHeading}
            <div class="table-responsive mt-3">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    ${tableHeaders}
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                  ${totalsRow}
                </tbody>
              </table>
            </div>
          `;
        }
      } else if (this.myObj.format === "File cover") {
        // Individual file cover cards for each staff member - simple design
        const fileCoverCards = data
          .map((item) => {
            const departmentName =
              item.department && item.department.name
                ? item.department.name
                : "N/A";

            const joiningDate = this.formatDate(item.appointedOn);

            return `
            <div class=\"file-cover-card\" style=\"page-break-after: always; margin-bottom: 30px; max-width: 600px; margin-left: auto; margin-right: auto;\">
              <!-- Header with name and date - blue border box (same as staffGrid) -->
              <div class=\"file-cover-header\" style=\"border: 2px solid #0066cc; border-radius: 8px; padding: 20px; margin-bottom: 60px; display: flex; justify-content: space-between; align-items: center; background: white; box-shadow: 0 2px 4px rgba(0,102,204,0.1); max-width: 900px; margin-left: auto; margin-right: auto;\">
                <div style=\"display: flex; align-items: center;\">
                  <div style=\"width: 16px; height: 16px; background: #0066cc; margin-right: 12px; border-radius: 2px;\"></div>
                  <span style=\"font-weight: bold; font-size: 16px; color: #000; text-transform: uppercase;\">${item.staffName}</span>
                </div>
                <span style=\"font-weight: bold; font-size: 14px; color: #000;\">${joiningDate}</span>
              </div>

              <!-- Main content card with double-layered blue border (same as staffGrid) -->
              <div class=\"file-cover-content\" style=\"border: 3px solid #0066cc; border-radius: 15px; padding: 8px; text-align: center; background: white; position: relative; box-shadow: 0 4px 8px rgba(0,102,204,0.1); max-width: 400px; margin: 0 auto;\">
                <!-- Inner double-layered border with same curve -->
                <div style=\"border: 2px solid #0066cc; border-radius: 12px; padding: 35px 25px; background: white; margin: 0;\">
                  <div style=\"font-weight: bold; font-size: 28px; margin-bottom: 20px; text-transform: uppercase; color: #000; letter-spacing: 1px;\">${item.staffName}</div>
                  <div style=\"font-weight: bold; font-size: 20px; margin-bottom: 15px; text-transform: uppercase; color: #000; letter-spacing: 0.5px;\">(${item.designation})</div>
                  <div style=\"font-weight: bold; font-size: 22px; margin-bottom: 15px; color: #000;\">ID-${item.rfID}</div>
                  <div style=\"font-weight: bold; font-size: 20px; margin-bottom: 0; color: #000; text-transform: uppercase;\">${departmentName}</div>
                </div>
              </div>
            </div>
          `;
          })
          .join("");

        mainContentHtml = `
          <div class="file-cover-container">
            ${fileCoverCards}
          </div>
        `;
      }

      // Create the HTML content
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${reportTitle} Report</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              background-color: #f8f9fa;
              margin: 0;
              padding: 20px;
            }
            .report-container {
              background: white;
              border-radius: 8px;
              box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              overflow: hidden;
            }
            .report-header {
              background: #f8f9fa;
              color: #212529;
              padding: 30px;
              text-align: center;
              border-radius: 8px 8px 0 0;
            }
            .report-title {
              font-size: 28px;
              font-weight: 700;
              margin-bottom: 10px;
            }
            .report-subtitle {
              font-size: 16px;
              opacity: 0.9;
              margin-bottom: 20px;
            }
            .report-stats {
              display: flex;
              justify-content: center;
              gap: 40px;
              margin-top: 20px;
            }
            .stat-item {
              text-align: center;
            }
            .stat-label {
              font-size: 14px;
              opacity: 0.8;
              margin-bottom: 5px;
            }
            .stat-value {
              font-size: 24px;
              font-weight: 700;
            }
            .table-container {
              padding: 30px;
            }
            .table {
              margin-bottom: 0;
              border: 1px solid #000;
              border-collapse: collapse;
              border-radius: 0;
            }
            .table thead th {
              background-color: #fff;
              border: 1px solid #000;
              font-weight: 600;
              color: #000;
              padding: 8px 4px;
              text-align: center;
            }
            .table tbody td {
              padding: 6px 4px;
              border: 1px solid #000;
              vertical-align: middle;
              text-align: center;
              background-color: #fff;
            }
            .table tbody tr:nth-child(even) {
              background-color: #fff;
            }
            .table tbody tr:hover {
              background-color: #e9ecef;
            }
            .vertical-header {
              writing-mode: vertical-rl;
              text-orientation: mixed;
              transform: rotate(180deg);
              white-space: nowrap;
              height: 120px;
              width: 45px;
              text-align: center;
              vertical-align: middle;
              font-weight: 600;
              color: #000;
            }
            .vertical-designation {
              writing-mode: vertical-rl;
              text-orientation: mixed;
              transform: rotate(180deg);
              white-space: normal;
              word-wrap: break-word;
              word-break: break-word;
              height: 80px;
              width: 45px;
              text-align: center;
              vertical-align: middle;
              font-size: 10px;
              line-height: 1.1;
              padding: 2px;
              color: #000;
            }
            /* New styles for Muster Roll sequential list - Exactly 12 records per page */
            .muster-roll-list-container {
              padding: 6px 20px 20px 6px;
              border: none;
              border-radius: 0;
              background-color: #fff;
              max-width: 900px;
              margin: 0;
            }
            .muster-roll-list-item {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              padding: 5px 0;
              border-bottom: none;
              font-size: 14px;
              margin-bottom: 4px;
              min-height: 48px;
            }
            .muster-roll-list-item:last-child {
              border-bottom: none;
            }
            .muster-roll-sno {
              font-weight: 700;
              font-size: 16px;
              width: 30px;
              text-align: right;
              margin-right: 10px;
            }
            .muster-roll-name {
              font-weight: 700;
              font-size: 14px;
              width: 250px;
              text-align: left;
              margin-right: 3px;
              white-space: normal;
              word-wrap: break-word;
              word-break: break-word;
              line-height: 1.3;
            }
            .muster-rfid-inline {
              color: #007bff;
              font-weight: 700;
              font-size: 12px;
              margin-right: 3px;
            }
            .muster-roll-designation {
              font-weight: 700;
              color: #333;
              font-size: 12px;
              writing-mode: vertical-rl;
              text-orientation: mixed;
              transform: rotate(180deg);
              white-space: normal;
              word-wrap: break-word;
              word-break: break-word;
              height: 95px;
              width: 40px;
              text-align: center;
              vertical-align: middle;
              font-size: 14px;
              line-height: 1.3;
              padding: 5px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 0px;
            }

            /* Print-specific styles - Natural page flow */
            @media print {
              .muster-roll-list-container {
                padding: 8px 24px 24px 8px;
                max-height: none;
                overflow: visible;
                page-break-inside: auto;
              }
              .muster-roll-list-item {
                padding: 7px 0;
                margin-bottom: 5px;
                min-height: 52px;
                page-break-inside: avoid;
                break-inside: avoid;
                display: flex;
                align-items: center;
              }
              .muster-roll-designation {
                height: 100px;
                padding: 6px;
              }
              /* Remove aggressive page break rules - let it flow naturally */
              .report-container {
                overflow: visible !important;
                max-height: none !important;
              }
              .table-container {
                overflow: visible !important;
                max-height: none !important;
              }
            }
            .print-controls {
              position: fixed;
              top: 20px;
              right: 20px;
              z-index: 1000;
            }
            .print-btn {
              background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 6px;
              cursor: pointer;
              font-weight: 600;
              box-shadow: 0 2px 8px rgba(0,0,0,0.15);
            }
            .print-btn:hover {
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            }
            .department-heading {
              background: #f8f9fa;
              border: 1px solid #dee2e6;
              border-radius: 4px;
              padding: 8px 15px;
              margin: 15px 0 10px 0;
              text-align: center;
            }
            .department-heading h5 {
              margin: 0;
              color: #495057;
              font-size: 14px;
              font-weight: 600;
            }
            /* File Cover Specific Styles */
            .file-cover-card {
              max-width: 700px;
              min-height: 90vh;
              margin: 0 auto;
              background: white;
            }
            .file-cover-header {
              background: white;
              color: #000;
              border-radius: 8px;
              box-shadow: 0 2px 4px rgba(0,102,204,0.1);
              transition: box-shadow 0.3s ease;
            }
            .file-cover-header:hover {
              box-shadow: 0 4px 8px rgba(0,102,204,0.15);
            }
            .file-cover-content {
              min-height: 360px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              background: white;
              box-shadow: 0 4px 8px rgba(0,102,204,0.1);
              transition: box-shadow 0.3s ease;
              position: relative;
            }
            .file-cover-content:hover {
              box-shadow: 0 6px 12px rgba(0,102,204,0.15);
            }
            .file-cover-content::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              border: 2px solid #0066cc;
              border-radius: 12px;
              pointer-events: none;
            }
            .file-cover-container {
              padding: 30px 20px;
              background: #f8f9fa;
              min-height: 100vh;
            }
            @media print {
              .print-controls { display: none; }
              body {
                padding: 0;
                background: white;
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              }
              .report-container {
                box-shadow: none;
                background: white;
              }
              .file-cover-container {
                background: white;
                padding: 20px 0;
              }
              .file-cover-card {
                page-break-after: always;
                margin-bottom: 0;
                max-width: 100%;
                box-shadow: none;
              }
              .file-cover-card:last-child {
                page-break-after: avoid;
              }
              .file-cover-header {
                box-shadow: none;
                border: 2px solid #0066cc;
              }
              .file-cover-content {
                box-shadow: none;
                border: 3px solid #0066cc;
              }
              .file-cover-content::before {
                border: 2px solid #0066cc;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-controls">
            <button class="print-btn" onclick="window.print()">🖨️ Print Report</button>
          </div>

          <div class="report-container">
            ${
              this.myObj.format === "Staff List Muster Roll" ||
              this.myObj.format === "File cover"
                ? ""
                : `
            <div class="report-header">
              <h1 class="report-title">${reportTitle} Report</h1>
              <p class="report-subtitle">
                Generated on ${new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
                      <div class="report-stats">
                        <div class="stat-item">
                          <div class="stat-label">Total Records</div>
                          <div class="stat-value">${data.length}</div>
                        </div>
                      </div>
            </div>
            `
            }

            <div class="table-container">
              ${mainContentHtml}
            </div>
          </div>
        </body>
        </html>
      `;

      // Open in new tab (robust against popup blockers)
      try {
        const blob = new Blob([htmlContent], {
          type: "text/html;charset=utf-8",
        });
        const url = URL.createObjectURL(blob);
        const win = window.open(url, "_blank");
        if (!win || win.closed) {
          // Fallback to document.write if Blob opening was blocked
          const fallbackWin = window.open("", "_blank");
          if (fallbackWin && fallbackWin.document) {
            fallbackWin.document.write(htmlContent);
            fallbackWin.document.close();
          } else {
            console.error(
              "Unable to open report window. Popup may be blocked."
            );
          }
        }
      } catch (e) {
        console.error("Failed to open report window:", e);
        const fallbackWin = window.open("", "_blank");
        if (fallbackWin && fallbackWin.document) {
          fallbackWin.document.write(htmlContent);
          fallbackWin.document.close();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

/* Hierarchy Modal Styles */
.hierarchy-modal {
  .modal-dialog {
    max-width: 90vw;
  }
}

.hierarchy-container {
  padding: 20px;
  background: #f8f9fa;
  min-height: 400px;
}

.hierarchy-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  margin-top: 30px;
  width: 100%;
  padding: 20px;
}

.hierarchy-level-0 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

.person-card {
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 180px;
  border: 2px solid #007bff;
  position: relative;
}

.subordinates-level {
  margin-top: 25px;
  width: 100%;
  position: relative;
}

.subordinates-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 15px;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: auto;
}

.subordinate-card {
  background: white;
  border-radius: 8px;
  padding: 10px;
  margin: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 150px;
  border: 1px solid #e9ecef;
  position: relative;
  flex-shrink: 0;
}

.subordinate-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Connection lines */
.hierarchy-level-0::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 3px;
  height: 20px;
  background: #333;
  z-index: 1;
}

.subordinates-level::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 3px;
  height: 20px;
  background: #333;
  z-index: 1;
}

.subordinates-container::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 20%;
  right: 20%;
  height: 3px;
  background: #333;
  z-index: 1;
}

.subordinate-card::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 3px;
  height: 20px;
  background: #333;
  z-index: 1;
}

.person-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto 15px;
  overflow: hidden;
  background: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 24px;
  border: 3px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  color: black;
  font-weight: bold;
  border: 2px solid #dee2e6;
}

.person-info {
  text-align: center;
}

.person-name {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.person-designation {
  margin: 0 0 8px;
  color: #666;
  font-size: 16px;
  font-weight: 500;
}

.person-department {
  margin: 0;
  color: #888;
  font-size: 14px;
  background: #f8f9fa;
  padding: 4px 8px;
  border-radius: 12px;
  display: inline-block;
}

.subordinates-level {
  margin-top: 30px;
  width: 100%;
}

.subordinates-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.subordinate-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-width: 180px;
  border: 1px solid #e9ecef;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.subordinate-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.subordinate-avatar {
  width: 60px;
  height: 60px;
  font-size: 18px;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.subordinate-card .person-name {
  font-size: 16px;
  margin-bottom: 6px;
}

.subordinate-card .person-designation {
  font-size: 14px;
  margin-bottom: 6px;
}

.subordinate-card .person-department {
  font-size: 12px;
  padding: 2px 6px;
}

.connection-line {
  width: 3px;
  height: 30px;
  background: linear-gradient(to bottom, #007bff, #0056b3);
  margin: 0 auto;
  border-radius: 2px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hierarchy-container {
    padding: 10px;
  }

  .person-card {
    min-width: 200px;
    padding: 20px;
  }

  .subordinate-card {
    min-width: 150px;
    padding: 15px;
  }

  .person-avatar {
    width: 80px;
    height: 80px;
    font-size: 24px;
  }

  .subordinate-avatar {
    width: 60px;
    height: 60px;
    font-size: 18px;
  }
}

/* Staff Leaves Modal Styles - High Specificity */
.staff-leaves-modal .modal-content,
.staff-leaves-modal .modal-dialog .modal-content {
  background-color: #f8f9fa !important;
  /* Light gray background */
}

.staff-leaves-modal .modal-header,
.staff-leaves-modal .modal-dialog .modal-header {
  background-color: #f8f9fa !important;
  /* Light gray background */
  border-bottom: 1px solid #dee2e6 !important;
}

.staff-leaves-modal .modal-header .modal-title,
.staff-leaves-modal .modal-dialog .modal-header .modal-title {
  color: #212529 !important;
  /* Dark text */
  font-weight: 600 !important;
}

.staff-leaves-modal .modal-body,
.staff-leaves-modal .modal-dialog .modal-body {
  background-color: #f8f9fa !important;
  /* Light gray background */
}

.staff-leaves-modal .modal-report-header,
.staff-leaves-modal .modal-body .modal-report-header {
  background: #f8f9fa !important;
  /* Light gray background */
  color: #212529 !important;
  /* Dark text */
  border: 1px solid #dee2e6 !important;
}

.staff-leaves-modal .modal-report-header h2,
.staff-leaves-modal .modal-body .modal-report-header h2 {
  color: #212529 !important;
  /* Dark text */
}

.staff-leaves-modal .modal-report-header p,
.staff-leaves-modal .modal-body .modal-report-header p {
  color: #6c757d !important;
  /* Medium gray text */
}

.staff-leaves-modal .table,
.staff-leaves-modal .modal-body .table {
  background-color: #ffffff !important;
  /* White table background */
  border: 1px solid #dee2e6 !important;
}

.staff-leaves-modal .table th,
.staff-leaves-modal .modal-body .table th {
  background-color: #e9ecef !important;
  /* Light gray header background */
  color: #212529 !important;
  /* Dark text */
  border: 1px solid #dee2e6 !important;
}

.staff-leaves-modal .table th.bg-primary,
.staff-leaves-modal .modal-body .table th.bg-primary {
  background-color: #e9ecef !important;
  /* Light gray instead of blue */
  color: #212529 !important;
  /* Dark text */
}

.staff-leaves-modal .table th.bg-warning,
.staff-leaves-modal .modal-body .table th.bg-warning {
  background-color: #e9ecef !important;
  /* Light gray instead of yellow */
  color: #212529 !important;
  /* Dark text */
}

.staff-leaves-modal .table th.bg-success,
.staff-leaves-modal .modal-body .table th.bg-success {
  background-color: #e9ecef !important;
  /* Light gray instead of green */
  color: #212529 !important;
  /* Dark text */
}

.staff-leaves-modal .table td,
.staff-leaves-modal .modal-body .table td {
  background-color: #ffffff !important;
  /* White cell background */
  color: #212529 !important;
  /* Dark text */
  border: 1px solid #dee2e6 !important;
}

.staff-leaves-modal .table-striped tbody tr:nth-of-type(odd) td,
.staff-leaves-modal .modal-body .table-striped tbody tr:nth-of-type(odd) td {
  background-color: #f8f9fa !important;
  /* Light gray for striped rows */
}

.staff-leaves-modal .table-hover tbody tr:hover td,
.staff-leaves-modal .modal-body .table-hover tbody tr:hover td {
  background-color: #e9ecef !important;
  /* Slightly darker gray on hover */
}

/* Additional overrides for specific elements */
.staff-leaves-modal .text-white,
.staff-leaves-modal .modal-body .text-white {
  color: #212529 !important;
  /* Override white text to dark */
}

.staff-leaves-modal .bg-primary,
.staff-leaves-modal .modal-body .bg-primary {
  background-color: #e9ecef !important;
  /* Override primary background */
}

.staff-leaves-modal .bg-warning,
.staff-leaves-modal .modal-body .bg-warning {
  background-color: #e9ecef !important;
  /* Override warning background */
}

.staff-leaves-modal .bg-success,
.staff-leaves-modal .modal-body .bg-success {
  background-color: #e9ecef !important;
  /* Override success background */
}

/* Force override for any gradient backgrounds */
.staff-leaves-modal [style*="background"],
.staff-leaves-modal .modal-body [style*="background"] {
  background: #f8f9fa !important;
  /* Override any inline background styles */
}

.stats-card {
  transition: transform 0.2s ease-in-out;
  border: 1px solid rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.staff-leaves-table {
  .table {
    margin-bottom: 0;
    font-size: 0.875rem;

    thead th {
      border-top: none;
      border-bottom: 2px solid #e9ecef;
      font-weight: 600;
      color: #5e5873;
      font-size: 0.8rem;
      letter-spacing: 0.1px;
      text-transform: uppercase;
      padding: 0.75rem 0.5rem;
      background-color: #f8f9fa;
    }

    tbody td {
      vertical-align: middle;
      padding: 0.75rem 0.5rem;
      border-bottom: 1px solid #f0f0f0;
    }

    tbody tr:hover {
      background-color: #f8f9fa;
    }
  }
}

.font-weight-semibold {
  font-weight: 600;
}

.bg-light-primary {
  background-color: rgba(115, 103, 240, 0.12) !important;
}

.bg-light-success {
  background-color: rgba(40, 199, 111, 0.12) !important;
}

.bg-light-warning {
  background-color: rgba(255, 159, 67, 0.12) !important;
}

.bg-light-info {
  background-color: rgba(0, 207, 232, 0.12) !important;
}

.bg-light-secondary {
  background-color: rgba(130, 134, 139, 0.12) !important;
}

/* Student Search Styles */
.student-search-group {
  position: relative;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.clear-search-icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #ea5455;
  z-index: 5;
}

.student-search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 2px;
}

.student-search-option {
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 1px solid #f8f8f8;
}

.student-search-option:hover {
  background-color: #f8f8f8;
}

.student-search-option:last-child {
  border-bottom: none;
}

.student-option-info strong {
  display: block;
  color: #5e5873;
}

.student-search-loading {
  position: absolute;
  right: 10px;
  bottom: -20px;
  z-index: 10;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.card {
  transition: 0.4s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.my-collapsing {
  height: 55px;
  overflow: hidden;
}

.my-collapsing.adjust {
  height: 39px;
}

.my-buttons {
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
}

.premium-checkbox-group {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 15px !important;
  margin-top: 5px;
}

.premium-checkbox-group /deep/ .custom-control {
  margin-right: 15px;
  margin-bottom: 5px;
}

.premium-checkbox-group /deep/ .custom-control-label {
  font-weight: 500;
  color: #5e5873;
  cursor: pointer;
  padding-top: 2px;
}

.staff-allocation-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  width: 100%;
}

.staff-allocation-filters .staff-allocation-filter {
  flex: 1 1 170px;
  min-width: 160px;
}

.staff-allocation-filters .staff-allocation-actions {
  display: flex;
  gap: 10px;
  margin-bottom: 1rem;
}

.staff-allocation-filters .staff-allocation-action-btn {
  min-width: 110px;
}
</style>
